{
  "abi": [
    {
      "inputs": [
        {
          "internalType": "contract IWorld",
          "name": "_world",
          "type": "address"
        },
        {
          "internalType": "address",
          "name": "_components",
          "type": "address"
        }
      ],
      "stateMutability": "nonpayable",
      "type": "constructor"
    },
    {
      "anonymous": false,
      "inputs": [
        {
          "indexed": true,
          "internalType": "address",
          "name": "previousOwner",
          "type": "address"
        },
        {
          "indexed": true,
          "internalType": "address",
          "name": "newOwner",
          "type": "address"
        }
      ],
      "name": "OwnershipTransferred",
      "type": "event"
    },
    {
      "inputs": [
        {
          "components": [
            {
              "internalType": "int32",
              "name": "x",
              "type": "int32"
            },
            {
              "internalType": "int32",
              "name": "y",
              "type": "int32"
            },
            {
              "internalType": "int32",
              "name": "z",
              "type": "int32"
            }
          ],
          "internalType": "struct VoxelCoord",
          "name": "coord",
          "type": "tuple"
        }
      ],
      "name": "Bedrock",
      "outputs": [
        {
          "internalType": "uint256",
          "name": "",
          "type": "uint256"
        }
      ],
      "stateMutability": "pure",
      "type": "function"
    },
    {
      "inputs": [
        {
          "components": [
            {
              "internalType": "int32",
              "name": "x",
              "type": "int32"
            },
            {
              "internalType": "int32",
              "name": "y",
              "type": "int32"
            },
            {
              "internalType": "int32",
              "name": "z",
              "type": "int32"
            }
          ],
          "internalType": "struct VoxelCoord",
          "name": "coord",
          "type": "tuple"
        }
      ],
      "name": "BlackFlower",
      "outputs": [
        {
          "internalType": "uint256",
          "name": "",
          "type": "uint256"
        }
      ],
      "stateMutability": "pure",
      "type": "function"
    },
    {
      "inputs": [
        {
          "components": [
            {
              "internalType": "int32",
              "name": "x",
              "type": "int32"
            },
            {
              "internalType": "int32",
              "name": "y",
              "type": "int32"
            },
            {
              "internalType": "int32",
              "name": "z",
              "type": "int32"
            }
          ],
          "internalType": "struct VoxelCoord",
          "name": "coord",
          "type": "tuple"
        }
      ],
      "name": "BlueFlower",
      "outputs": [
        {
          "internalType": "uint256",
          "name": "",
          "type": "uint256"
        }
      ],
      "stateMutability": "pure",
      "type": "function"
    },
    {
      "inputs": [
        {
          "components": [
            {
              "internalType": "int32",
              "name": "x",
              "type": "int32"
            },
            {
              "internalType": "int32",
              "name": "y",
              "type": "int32"
            },
            {
              "internalType": "int32",
              "name": "z",
              "type": "int32"
            }
          ],
          "internalType": "struct VoxelCoord",
          "name": "coord",
          "type": "tuple"
        }
      ],
      "name": "Clay",
      "outputs": [
        {
          "internalType": "uint256",
          "name": "",
          "type": "uint256"
        }
      ],
      "stateMutability": "pure",
      "type": "function"
    },
    {
      "inputs": [
        {
          "components": [
            {
              "internalType": "int32",
              "name": "x",
              "type": "int32"
            },
            {
              "internalType": "int32",
              "name": "y",
              "type": "int32"
            },
            {
              "internalType": "int32",
              "name": "z",
              "type": "int32"
            }
          ],
          "internalType": "struct VoxelCoord",
          "name": "coord",
          "type": "tuple"
        }
      ],
      "name": "Coal",
      "outputs": [
        {
          "internalType": "uint256",
          "name": "",
          "type": "uint256"
        }
      ],
      "stateMutability": "pure",
      "type": "function"
    },
    {
      "inputs": [
        {
          "components": [
            {
              "internalType": "int32",
              "name": "x",
              "type": "int32"
            },
            {
              "internalType": "int32",
              "name": "y",
              "type": "int32"
            },
            {
              "internalType": "int32",
              "name": "z",
              "type": "int32"
            }
          ],
          "internalType": "struct VoxelCoord",
          "name": "coord",
          "type": "tuple"
        }
      ],
      "name": "CyanFlower",
      "outputs": [
        {
          "internalType": "uint256",
          "name": "",
          "type": "uint256"
        }
      ],
      "stateMutability": "pure",
      "type": "function"
    },
    {
      "inputs": [
        {
          "components": [
            {
              "internalType": "int32",
              "name": "x",
              "type": "int32"
            },
            {
              "internalType": "int32",
              "name": "y",
              "type": "int32"
            },
            {
              "internalType": "int32",
              "name": "z",
              "type": "int32"
            }
          ],
          "internalType": "struct VoxelCoord",
          "name": "coord",
          "type": "tuple"
        }
      ],
      "name": "Diamond",
      "outputs": [
        {
          "internalType": "uint256",
          "name": "",
          "type": "uint256"
        }
      ],
      "stateMutability": "pure",
      "type": "function"
    },
    {
      "inputs": [
        {
          "components": [
            {
              "internalType": "int32",
              "name": "x",
              "type": "int32"
            },
            {
              "internalType": "int32",
              "name": "y",
              "type": "int32"
            },
            {
              "internalType": "int32",
              "name": "z",
              "type": "int32"
            }
          ],
          "internalType": "struct VoxelCoord",
          "name": "coord",
          "type": "tuple"
        }
      ],
      "name": "Dirt",
      "outputs": [
        {
          "internalType": "uint256",
          "name": "",
          "type": "uint256"
        }
      ],
      "stateMutability": "pure",
      "type": "function"
    },
    {
      "inputs": [
        {
          "components": [
            {
              "internalType": "int32",
              "name": "x",
              "type": "int32"
            },
            {
              "internalType": "int32",
              "name": "y",
              "type": "int32"
            },
            {
              "internalType": "int32",
              "name": "z",
              "type": "int32"
            }
          ],
          "internalType": "struct VoxelCoord",
          "name": "coord",
          "type": "tuple"
        }
      ],
      "name": "Grass",
      "outputs": [
        {
          "internalType": "uint256",
          "name": "",
          "type": "uint256"
        }
      ],
      "stateMutability": "pure",
      "type": "function"
    },
    {
      "inputs": [
        {
          "components": [
            {
              "internalType": "int32",
              "name": "x",
              "type": "int32"
            },
            {
              "internalType": "int32",
              "name": "y",
              "type": "int32"
            },
            {
              "internalType": "int32",
              "name": "z",
              "type": "int32"
            }
          ],
          "internalType": "struct VoxelCoord",
          "name": "coord",
          "type": "tuple"
        }
      ],
      "name": "GrassPlant",
      "outputs": [
        {
          "internalType": "uint256",
          "name": "",
          "type": "uint256"
        }
      ],
      "stateMutability": "pure",
      "type": "function"
    },
    {
      "inputs": [
        {
          "components": [
            {
              "internalType": "int32",
              "name": "x",
              "type": "int32"
            },
            {
              "internalType": "int32",
              "name": "y",
              "type": "int32"
            },
            {
              "internalType": "int32",
              "name": "z",
              "type": "int32"
            }
          ],
          "internalType": "struct VoxelCoord",
          "name": "coord",
          "type": "tuple"
        }
      ],
      "name": "GrayFlower",
      "outputs": [
        {
          "internalType": "uint256",
          "name": "",
          "type": "uint256"
        }
      ],
      "stateMutability": "pure",
      "type": "function"
    },
    {
      "inputs": [
        {
          "components": [
            {
              "internalType": "int32",
              "name": "x",
              "type": "int32"
            },
            {
              "internalType": "int32",
              "name": "y",
              "type": "int32"
            },
            {
              "internalType": "int32",
              "name": "z",
              "type": "int32"
            }
          ],
          "internalType": "struct VoxelCoord",
          "name": "coord",
          "type": "tuple"
        }
      ],
      "name": "GreenFlower",
      "outputs": [
        {
          "internalType": "uint256",
          "name": "",
          "type": "uint256"
        }
      ],
      "stateMutability": "pure",
      "type": "function"
    },
    {
      "inputs": [
        {
          "components": [
            {
              "internalType": "int32",
              "name": "x",
              "type": "int32"
            },
            {
              "internalType": "int32",
              "name": "y",
              "type": "int32"
            },
            {
              "internalType": "int32",
              "name": "z",
              "type": "int32"
            }
          ],
          "internalType": "struct VoxelCoord",
          "name": "coord",
          "type": "tuple"
        }
      ],
      "name": "Kelp",
      "outputs": [
        {
          "internalType": "uint256",
          "name": "",
          "type": "uint256"
        }
      ],
      "stateMutability": "pure",
      "type": "function"
    },
    {
      "inputs": [
        {
          "components": [
            {
              "internalType": "int32",
              "name": "x",
              "type": "int32"
            },
            {
              "internalType": "int32",
              "name": "y",
              "type": "int32"
            },
            {
              "internalType": "int32",
              "name": "z",
              "type": "int32"
            }
          ],
          "internalType": "struct VoxelCoord",
          "name": "coord",
          "type": "tuple"
        }
      ],
      "name": "Leaves",
      "outputs": [
        {
          "internalType": "uint256",
          "name": "",
          "type": "uint256"
        }
      ],
      "stateMutability": "pure",
      "type": "function"
    },
    {
      "inputs": [
        {
          "components": [
            {
              "internalType": "int32",
              "name": "x",
              "type": "int32"
            },
            {
              "internalType": "int32",
              "name": "y",
              "type": "int32"
            },
            {
              "internalType": "int32",
              "name": "z",
              "type": "int32"
            }
          ],
          "internalType": "struct VoxelCoord",
          "name": "coord",
          "type": "tuple"
        }
      ],
      "name": "LightBlueFlower",
      "outputs": [
        {
          "internalType": "uint256",
          "name": "",
          "type": "uint256"
        }
      ],
      "stateMutability": "pure",
      "type": "function"
    },
    {
      "inputs": [
        {
          "components": [
            {
              "internalType": "int32",
              "name": "x",
              "type": "int32"
            },
            {
              "internalType": "int32",
              "name": "y",
              "type": "int32"
            },
            {
              "internalType": "int32",
              "name": "z",
              "type": "int32"
            }
          ],
          "internalType": "struct VoxelCoord",
          "name": "coord",
          "type": "tuple"
        }
      ],
      "name": "LightGrayFlower",
      "outputs": [
        {
          "internalType": "uint256",
          "name": "",
          "type": "uint256"
        }
      ],
      "stateMutability": "pure",
      "type": "function"
    },
    {
      "inputs": [
        {
          "components": [
            {
              "internalType": "int32",
              "name": "x",
              "type": "int32"
            },
            {
              "internalType": "int32",
              "name": "y",
              "type": "int32"
            },
            {
              "internalType": "int32",
              "name": "z",
              "type": "int32"
            }
          ],
          "internalType": "struct VoxelCoord",
          "name": "coord",
          "type": "tuple"
        }
      ],
      "name": "LimeFlower",
      "outputs": [
        {
          "internalType": "uint256",
          "name": "",
          "type": "uint256"
        }
      ],
      "stateMutability": "pure",
      "type": "function"
    },
    {
      "inputs": [
        {
          "components": [
            {
              "internalType": "int32",
              "name": "x",
              "type": "int32"
            },
            {
              "internalType": "int32",
              "name": "y",
              "type": "int32"
            },
            {
              "internalType": "int32",
              "name": "z",
              "type": "int32"
            }
          ],
          "internalType": "struct VoxelCoord",
          "name": "coord",
          "type": "tuple"
        }
      ],
      "name": "Log",
      "outputs": [
        {
          "internalType": "uint256",
          "name": "",
          "type": "uint256"
        }
      ],
      "stateMutability": "pure",
      "type": "function"
    },
    {
      "inputs": [
        {
          "components": [
            {
              "internalType": "int32",
              "name": "x",
              "type": "int32"
            },
            {
              "internalType": "int32",
              "name": "y",
              "type": "int32"
            },
            {
              "internalType": "int32",
              "name": "z",
              "type": "int32"
            }
          ],
          "internalType": "struct VoxelCoord",
          "name": "coord",
          "type": "tuple"
        }
      ],
      "name": "MagentaFlower",
      "outputs": [
        {
          "internalType": "uint256",
          "name": "",
          "type": "uint256"
        }
      ],
      "stateMutability": "pure",
      "type": "function"
    },
    {
      "inputs": [
        {
          "components": [
            {
              "internalType": "int32",
              "name": "x",
              "type": "int32"
            },
            {
              "internalType": "int32",
              "name": "y",
              "type": "int32"
            },
            {
              "internalType": "int32",
              "name": "z",
              "type": "int32"
            }
          ],
          "internalType": "struct VoxelCoord",
          "name": "coord",
          "type": "tuple"
        }
      ],
      "name": "OrangeFlower",
      "outputs": [
        {
          "internalType": "uint256",
          "name": "",
          "type": "uint256"
        }
      ],
      "stateMutability": "pure",
      "type": "function"
    },
    {
      "inputs": [
        {
          "components": [
            {
              "internalType": "int32",
              "name": "x",
              "type": "int32"
            },
            {
              "internalType": "int32",
              "name": "y",
              "type": "int32"
            },
            {
              "internalType": "int32",
              "name": "z",
              "type": "int32"
            }
          ],
          "internalType": "struct VoxelCoord",
          "name": "coord",
          "type": "tuple"
        }
      ],
      "name": "PinkFlower",
      "outputs": [
        {
          "internalType": "uint256",
          "name": "",
          "type": "uint256"
        }
      ],
      "stateMutability": "pure",
      "type": "function"
    },
    {
      "inputs": [
        {
          "components": [
            {
              "internalType": "int32",
              "name": "x",
              "type": "int32"
            },
            {
              "internalType": "int32",
              "name": "y",
              "type": "int32"
            },
            {
              "internalType": "int32",
              "name": "z",
              "type": "int32"
            }
          ],
          "internalType": "struct VoxelCoord",
          "name": "coord",
          "type": "tuple"
        }
      ],
      "name": "PurpleFlower",
      "outputs": [
        {
          "internalType": "uint256",
          "name": "",
          "type": "uint256"
        }
      ],
      "stateMutability": "pure",
      "type": "function"
    },
    {
      "inputs": [
        {
          "components": [
            {
              "internalType": "int32",
              "name": "x",
              "type": "int32"
            },
            {
              "internalType": "int32",
              "name": "y",
              "type": "int32"
            },
            {
              "internalType": "int32",
              "name": "z",
              "type": "int32"
            }
          ],
          "internalType": "struct VoxelCoord",
          "name": "coord",
          "type": "tuple"
        }
      ],
      "name": "RedFlower",
      "outputs": [
        {
          "internalType": "uint256",
          "name": "",
          "type": "uint256"
        }
      ],
      "stateMutability": "pure",
      "type": "function"
    },
    {
      "inputs": [
        {
          "components": [
            {
              "internalType": "int32",
              "name": "x",
              "type": "int32"
            },
            {
              "internalType": "int32",
              "name": "y",
              "type": "int32"
            },
            {
              "internalType": "int32",
              "name": "z",
              "type": "int32"
            }
          ],
          "internalType": "struct VoxelCoord",
          "name": "coord",
          "type": "tuple"
        }
      ],
      "name": "Sand",
      "outputs": [
        {
          "internalType": "uint256",
          "name": "",
          "type": "uint256"
        }
      ],
      "stateMutability": "pure",
      "type": "function"
    },
    {
      "inputs": [
        {
          "components": [
            {
              "internalType": "int32",
              "name": "x",
              "type": "int32"
            },
            {
              "internalType": "int32",
              "name": "y",
              "type": "int32"
            },
            {
              "internalType": "int32",
              "name": "z",
              "type": "int32"
            }
          ],
          "internalType": "struct VoxelCoord",
          "name": "coord",
          "type": "tuple"
        }
      ],
      "name": "Snow",
      "outputs": [
        {
          "internalType": "uint256",
          "name": "",
          "type": "uint256"
        }
      ],
      "stateMutability": "pure",
      "type": "function"
    },
    {
      "inputs": [
        {
          "components": [
            {
              "internalType": "int32",
              "name": "x",
              "type": "int32"
            },
            {
              "internalType": "int32",
              "name": "y",
              "type": "int32"
            },
            {
              "internalType": "int32",
              "name": "z",
              "type": "int32"
            }
          ],
          "internalType": "struct VoxelCoord",
          "name": "coord",
          "type": "tuple"
        }
      ],
      "name": "Stone",
      "outputs": [
        {
          "internalType": "uint256",
          "name": "",
          "type": "uint256"
        }
      ],
      "stateMutability": "pure",
      "type": "function"
    },
    {
      "inputs": [
        {
          "components": [
            {
              "internalType": "int32",
              "name": "x",
              "type": "int32"
            },
            {
              "internalType": "int32",
              "name": "y",
              "type": "int32"
            },
            {
              "internalType": "int32",
              "name": "z",
              "type": "int32"
            }
          ],
          "internalType": "struct VoxelCoord",
          "name": "coord",
          "type": "tuple"
        }
      ],
      "name": "Water",
      "outputs": [
        {
          "internalType": "uint256",
          "name": "",
          "type": "uint256"
        }
      ],
      "stateMutability": "pure",
      "type": "function"
    },
    {
      "inputs": [
        {
          "components": [
            {
              "internalType": "int32",
              "name": "x",
              "type": "int32"
            },
            {
              "internalType": "int32",
              "name": "y",
              "type": "int32"
            },
            {
              "internalType": "int32",
              "name": "z",
              "type": "int32"
            }
          ],
          "internalType": "struct VoxelCoord",
          "name": "coord",
          "type": "tuple"
        }
      ],
      "name": "Wool",
      "outputs": [
        {
          "internalType": "uint256",
          "name": "",
          "type": "uint256"
        }
      ],
      "stateMutability": "pure",
      "type": "function"
    },
    {
      "inputs": [
        {
          "internalType": "bytes",
          "name": "arguments",
          "type": "bytes"
        }
      ],
      "name": "execute",
      "outputs": [
        {
          "internalType": "bytes",
          "name": "",
          "type": "bytes"
        }
      ],
      "stateMutability": "pure",
      "type": "function"
    },
    {
      "inputs": [
        {
          "internalType": "uint256",
          "name": "blockType",
          "type": "uint256"
        },
        {
          "components": [
            {
              "internalType": "int32",
              "name": "x",
              "type": "int32"
            },
            {
              "internalType": "int32",
              "name": "y",
              "type": "int32"
            },
            {
              "internalType": "int32",
              "name": "z",
              "type": "int32"
            }
          ],
          "internalType": "struct VoxelCoord",
          "name": "coord",
          "type": "tuple"
        }
      ],
      "name": "executeTyped",
      "outputs": [
        {
          "internalType": "uint256",
          "name": "",
          "type": "uint256"
        }
      ],
      "stateMutability": "pure",
      "type": "function"
    },
    {
      "inputs": [],
      "name": "owner",
      "outputs": [
        {
          "internalType": "address",
          "name": "",
          "type": "address"
        }
      ],
      "stateMutability": "view",
      "type": "function"
    },
    {
      "inputs": [
        {
          "internalType": "address",
          "name": "newOwner",
          "type": "address"
        }
      ],
      "name": "transferOwnership",
      "outputs": [],
      "stateMutability": "nonpayable",
      "type": "function"
    }
  ],
  "bytecode": {
    "object": "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$5d39b2c9b087803e832e6bdb9414561c78$__631f92e70f610e9f8660de614766565b610eaa8660de614766565b604080517fffffffff0000000000000000000000000000000000000000000000000000000060e086901b168152600393840b60048201529190920b60248201526101bc60448201526064810191909152608401602060405180830381865af4158015610f1a573d6000803e3d6000fd5b505050506040513d601f19601f82011682018060405250810190610f3e91906147ca565b604080517fee38e4ce000000000000000000000000000000000000000000000000000000008152600386810b600483015287900b60248201526103e7604482015261014d6064820152608481019190915290915060009073__$5d39b2c9b087803e832e6bdb9414561c78$__9063ee38e4ce9060a401602060405180830381865af4158015610fd1573d6000803e3d6000fd5b505050506040513d601f19601f82011682018060405250810190610ff591906147ca565b60408051808201909152600f82810b825284900b60208201529091506110196142f2565b61105761105261104367c00000000000000061103e866110396000612199565b6122f1565b61232f565b68020000000000000000612384565b6123db565b600f0b815261107c61105261104367c00000000000000061103e866110396001612199565b600f0b60208201526110a461105261104367c00000000000000061103e866110396002612199565b600f0b60408201526110cc61105261104367c00000000000000061103e866110396003612199565b600f0b60608201529695505050505050565b60008073__$5d39b2c9b087803e832e6bdb9414561c78$__631f92e70f611107610226886146a3565b61111387610226614766565b604080517fffffffff0000000000000000000000000000000000000000000000000000000060e086901b168152600393840b60048201529190920b60248201526103e760448201526064810191909152608401602060405180830381865af4158015611183573d6000803e3d6000fd5b505050506040513d601f19601f820116820180604052508101906111a791906147ca565b905060006111b4826123f5565b905060006111cb83680a0000000000000000612384565b604080517f1f92e70f00000000000000000000000000000000000000000000000000000000815260038a810b600483015289900b602482015260316044820152606481019190915290915060009073__$5d39b2c9b087803e832e6bdb9414561c78$__90631f92e70f90608401602060405180830381865af4158015611255573d6000803e3d6000fd5b505050506040513d601f19601f8201168201806040525081019061127991906147ca565b9050611297826112928368050000000000000000612384565b612511565b604080517f1f92e70f00000000000000000000000000000000000000000000000000000000815260038b810b60048301528a900b6024820152600d6044820152606481019190915290925061134890839073__$5d39b2c9b087803e832e6bdb9414561c78$__90631f92e70f90608401602060405180830381865af4158015611324573d6000803e3d6000fd5b505050506040513d601f19601f8201168201806040525081019061129291906147ca565b915061135d8268100000000000000000612565565b865190925060009061137790611372856125dd565b612384565b9050611392816112928960015b60200201516113728761272f565b90506113ac816112928960026020020151611372876127ed565b90506113bd81611292896003611384565b9050611409816114046113f56113ed6113e58c600060200201518d60015b6020020151612511565b8c60026113db565b8b60036113db565b68010000000000000000612511565b612565565b9050611422846112928368020000000000000000612565565b604080517f1f92e70f00000000000000000000000000000000000000000000000000000000815260038c810b60048301528b900b602482015261014d604482015260648101919091529091506000906114fb906114f6906114e7906114e19073__$5d39b2c9b087803e832e6bdb9414561c78$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$5d39b2c9b087803e832e6bdb9414561c78$__9063da55540f90606401602060405180830381865af4158015613ff9573d6000803e3d6000fd5b505050506040513d601f19601f82011682018060405250810190610b4d91906147ca565b60008160000361402f57506000610367565b600083600f0b121561404057600080fd5b600f83900b6fffffffffffffffffffffffffffffffff8316810260401c90608084901c0277ffffffffffffffffffffffffffffffffffffffffffffffff81111561408957600080fd5b60401b811981111561409a57600080fd5b019392505050565b6000806140af83856148fd565b90506000808560030b12806140c7575060008460030b125b80156140e6575060008560030b1280156140e4575060008460030b125b155b80156140fd57506140f78486614a32565b60030b15155b61410857600061410b565b60015b9050610b4d81836146a3565b60008181602002015160ff1660030b836000015160030b14801561414e5750816001602002015160ff1660030b836020015160030b145b80156109a7575050604090810151910151600390810b60ff909216900b1490565b60008160000361418157506000919050565b81600170010000000000000000000000000000000082106141a75760809190911c9060401b5b6801000000000000000082106141c25760409190911c9060201b5b64010000000082106141d95760209190911c9060101b5b6201000082106141ee5760109190911c9060081b5b61010082106142025760089190911c9060041b5b601082106142155760049190911c9060021b5b600482106142215760011b5b600181858161423257614232614899565b048201901c9050600181858161424a5761424a614899565b048201901c9050600181858161426257614262614899565b048201901c9050600181858161427a5761427a614899565b048201901c9050600181858161429257614292614899565b048201901c905060018185816142aa576142aa614899565b048201901c905060018185816142c2576142c2614899565b048201901c905060008185816142da576142da614899565b0490508082106142ea5780610b4d565b509392505050565b60405180608001604052806004906020820280368337509192915050565b60405180604001604052806002905b604080518082019091526000808252602082015281526020019060019003908161431f5790505090565b7f4e487b7100000000000000000000000000000000000000000000000000000000600052604160045260246000fd5b6040516060810167ffffffffffffffff8111828210171561439b5761439b614349565b60405290565b8060030b81146143b057600080fd5b50565b6000606082840312156143c557600080fd5b6143cd614378565b905081356143da816143a1565b815260208201356143ea816143a1565b602082015260408201356143fd816143a1565b604082015292915050565b60006060828403121561441a57600080fd5b6109a783836143b3565b60006020828403121561443657600080fd5b813567ffffffffffffffff8082111561444e57600080fd5b818401915084601f83011261446257600080fd5b81358181111561447457614474614349565b604051601f82017fffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffe0908116603f011681019083821181831017156144ba576144ba614349565b816040528281528760208487010111156144d357600080fd5b826020860160208301376000928101602001929092525095945050505050565b600060208083528351808285015260005b8181101561452057858101830151858201604001528201614504565b81811115614532576000604083870101525b50601f017fffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffe016929092016040019392505050565b6000806080838503121561457957600080fd5b8235915061458a84602085016143b3565b90509250929050565b6000602082840312156145a557600080fd5b813573ffffffffffffffffffffffffffffffffffffffff811681146109a757600080fd5b60008082840360808112156145dd57600080fd5b8351925060607fffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffe08201121561461157600080fd5b5061461a614378565b6020840151614628816143a1565b81526040840151614638816143a1565b6020820152606084015161464b816143a1565b6040820152919491935090915050565b60006020828403121561466d57600080fd5b5051919050565b7f4e487b7100000000000000000000000000000000000000000000000000000000600052601160045260246000fd5b60008160030b8360030b60008112817fffffffffffffffffffffffffffffffffffffffffffffffffffffffff80000000018312811516156146e6576146e6614674565b81637fffffff0183138116156146fe576146fe614674565b5090039392505050565b7f4e487b7100000000000000000000000000000000000000000000000000000000600052602160045260246000fd5b7f4e487b7100000000000000000000000000000000000000000000000000000000600052603260045260246000fd5b60008160030b8360030b6000821282637fffffff0382138115161561478d5761478d614674565b827fffffffffffffffffffffffffffffffffffffffffffffffffffffffff800000000382128116156147c1576147c1614674565b50019392505050565b6000602082840312156147dc57600080fd5b815180600f0b81146109a757600080fd5b6000808312837f80000000000000000000000000000000000000000000000000000000000000000183128115161561482757614827614674565b837f7fffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffff01831381161561485b5761485b614674565b50500390565b60007fffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffff820361489257614892614674565b5060010190565b7f4e487b7100000000000000000000000000000000000000000000000000000000600052601260045260246000fd5b600061ffff808416806148dd576148dd614899565b92169190910492915050565b6000826148f8576148f8614899565b500690565b60008160030b8360030b8061491457614914614899565b7fffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffff81147fffffffffffffffffffffffffffffffffffffffffffffffffffffffff800000008314161561496857614968614674565b90059392505050565b60008160030b8360030b637fffffff60008213600084138383048511828216161561499e5761499e614674565b7fffffffffffffffffffffffffffffffffffffffffffffffffffffffff8000000060008512868205861281841616156149d9576149d9614674565b600087129250858205871284841616156149f5576149f5614674565b85850587128184161615614a0b57614a0b614674565b5050509290910295945050505050565b600082821015614a2d57614a2d614674565b500390565b60008260030b80614a4557614a45614899565b808360030b079150509291505056fea2646970667358221220a40c95485ba15af1d65400f3fd381597dff5e90fe2408a34421c80566d21701364736f6c634300080d0033",
    "sourceMap": "1295:5864:84:-:0;;;1335:78;;;;;;;;;;;;;;;;;;;;;;;;;;;;:::i;:::-;512:6:7;:19;;-1:-1:-1;;;;;;512:19:7;521:10;512:19;;;1390:6:84;1398:11;-1:-1:-1;;;;;550:25:7;;;:80;;618:11;550:80;;;578:6;-1:-1:-1;;;;;578:17:7;;:19;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;:::i;:::-;537:10;:93;;-1:-1:-1;;;;;537:93:7;;;-1:-1:-1;;;;;;537:93:7;;;;;;;;636:14;;;;;;;;;;;;;;;-1:-1:-1;1295:5864:84;;-1:-1:-1;;1295:5864:84;14:139:101;-1:-1:-1;;;;;97:31:101;;87:42;;77:70;;143:1;140;133:12;77:70;14:139;:::o;158:416::-;252:6;260;313:2;301:9;292:7;288:23;284:32;281:52;;;329:1;326;319:12;281:52;361:9;355:16;380:39;413:5;380:39;:::i;:::-;488:2;473:18;;467:25;438:5;;-1:-1:-1;501:41:101;467:25;501:41;:::i;:::-;561:7;551:17;;;158:416;;;;;:::o;579:285::-;675:6;728:2;716:9;707:7;703:23;699:32;696:52;;;744:1;741;734:12;696:52;776:9;770:16;795:39;828:5;795:39;:::i;:::-;853:5;579:285;-1:-1:-1;;;579:285:101:o;:::-;1295:5864:84;;;;;;",
    "linkReferences": {
      "../../node_modules/@latticexyz/noise/contracts/Perlin.sol": {
        "Perlin": [
          {
            "start": 4105,
            "length": 20
          },
          {
            "start": 4388,
            "length": 20
          },
          {
            "start": 4720,
            "length": 20
          },
          {
            "start": 5032,
            "length": 20
          },
          {
            "start": 5239,
            "length": 20
          },
          {
            "start": 5648,
            "length": 20
          },
          {
            "start": 16716,
            "length": 20
          }
        ]
      }
    }
  },
  "deployedBytecode": {
    "object": "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__$5d39b2c9b087803e832e6bdb9414561c78$__631f92e70f610e9f8660de614766565b610eaa8660de614766565b604080517fffffffff0000000000000000000000000000000000000000000000000000000060e086901b168152600393840b60048201529190920b60248201526101bc60448201526064810191909152608401602060405180830381865af4158015610f1a573d6000803e3d6000fd5b505050506040513d601f19601f82011682018060405250810190610f3e91906147ca565b604080517fee38e4ce000000000000000000000000000000000000000000000000000000008152600386810b600483015287900b60248201526103e7604482015261014d6064820152608481019190915290915060009073__$5d39b2c9b087803e832e6bdb9414561c78$__9063ee38e4ce9060a401602060405180830381865af4158015610fd1573d6000803e3d6000fd5b505050506040513d601f19601f82011682018060405250810190610ff591906147ca565b60408051808201909152600f82810b825284900b60208201529091506110196142f2565b61105761105261104367c00000000000000061103e866110396000612199565b6122f1565b61232f565b68020000000000000000612384565b6123db565b600f0b815261107c61105261104367c00000000000000061103e866110396001612199565b600f0b60208201526110a461105261104367c00000000000000061103e866110396002612199565b600f0b60408201526110cc61105261104367c00000000000000061103e866110396003612199565b600f0b60608201529695505050505050565b60008073__$5d39b2c9b087803e832e6bdb9414561c78$__631f92e70f611107610226886146a3565b61111387610226614766565b604080517fffffffff0000000000000000000000000000000000000000000000000000000060e086901b168152600393840b60048201529190920b60248201526103e760448201526064810191909152608401602060405180830381865af4158015611183573d6000803e3d6000fd5b505050506040513d601f19601f820116820180604052508101906111a791906147ca565b905060006111b4826123f5565b905060006111cb83680a0000000000000000612384565b604080517f1f92e70f00000000000000000000000000000000000000000000000000000000815260038a810b600483015289900b602482015260316044820152606481019190915290915060009073__$5d39b2c9b087803e832e6bdb9414561c78$__90631f92e70f90608401602060405180830381865af4158015611255573d6000803e3d6000fd5b505050506040513d601f19601f8201168201806040525081019061127991906147ca565b9050611297826112928368050000000000000000612384565b612511565b604080517f1f92e70f00000000000000000000000000000000000000000000000000000000815260038b810b60048301528a900b6024820152600d6044820152606481019190915290925061134890839073__$5d39b2c9b087803e832e6bdb9414561c78$__90631f92e70f90608401602060405180830381865af4158015611324573d6000803e3d6000fd5b505050506040513d601f19601f8201168201806040525081019061129291906147ca565b915061135d8268100000000000000000612565565b865190925060009061137790611372856125dd565b612384565b9050611392816112928960015b60200201516113728761272f565b90506113ac816112928960026020020151611372876127ed565b90506113bd81611292896003611384565b9050611409816114046113f56113ed6113e58c600060200201518d60015b6020020151612511565b8c60026113db565b8b60036113db565b68010000000000000000612511565b612565565b9050611422846112928368020000000000000000612565565b604080517f1f92e70f00000000000000000000000000000000000000000000000000000000815260038c810b60048301528b900b602482015261014d604482015260648101919091529091506000906114fb906114f6906114e7906114e19073__$5d39b2c9b087803e832e6bdb9414561c78$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$5d39b2c9b087803e832e6bdb9414561c78$__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",
    "sourceMap": "1295:5864:84:-:0;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;5570:121;;;;;;:::i;:::-;;:::i;:::-;;;1526:25:101;;;1514:2;1499:18;5570:121:84;;;;;;;;6929:109;;;;;;:::i;:::-;;:::i;3771:111::-;;;;;;:::i;:::-;;:::i;1417:2146::-;;;;;;:::i;:::-;;:::i;:::-;;;;;;;:::i;4459:115::-;;;;;;:::i;:::-;;:::i;7042:::-;;;;;;:::i;:::-;;:::i;6816:109::-;;;;;;:::i;:::-;;:::i;4116:111::-;;;;;;:::i;:::-;;:::i;3567:174::-;;;;;;:::i;:::-;;:::i;659:80:7:-;728:6;;659:80;;728:6;;;;3659:74:101;;3647:2;3632:18;659:80:7;3513:226:101;4691:116:84;;;;;;:::i;:::-;;:::i;4344:111::-;;;;;;:::i;:::-;;:::i;3886:109::-;;;;;;:::i;:::-;;:::i;4231:::-;;;;;;:::i;:::-;;:::i;743:148:7:-;;;;;;:::i;:::-;;:::i;:::-;;4578:109:84;;;;;;:::i;:::-;;:::i;5570:121::-;5636:7;5658:28;5680:5;5658:21;:28::i;:::-;5651:35;5570:121;-1:-1:-1;;5570:121:84:o;6929:109::-;6989:7;7011:22;7027:5;7011:15;:22::i;3771:111::-;3832:7;3854:23;3871:5;3854:16;:23::i;1417:2146::-;1479:12;1500:17;1519:23;1557:9;1546:44;;;;;;;;;;;;:::i;:::-;1499:91;;-1:-1:-1;1499:91:84;-1:-1:-1;1601:20:84;;;1597:57;;1641:12;1647:5;1641;:12::i;:::-;1630:24;;;;;;1526:25:101;;1514:2;1499:18;;1380:177;1630:24:84;;;;;;;;;;;;;1623:31;;;;1417:2146;;;:::o;1597:57::-;1664:19;;;1660:55;;1703:11;1708:5;1703:4;:11::i;1660:55::-;1725:18;;;1721:53;;1763:10;1767:5;1763:3;:10::i;1721:53::-;1784:20;;;1780:57;;1824:12;1830:5;1824;:12::i;1780:57::-;1847:19;;;1843:55;;1886:11;1891:5;1886:4;:11::i;1843:55::-;1908:20;;;1904:57;;1948:12;1954:5;1948;:12::i;1904:57::-;1971:22;;;1967:61;;2013:14;2021:5;2013:7;:14::i;1967:61::-;2038:19;;;2034:55;;2077:11;2082:5;2077:4;:11::i;2034:55::-;2099:21;;;2095:59;;2140:13;2147:5;2140:6;:13::i;2095:59::-;2164:24;;;2160:65;;2208:16;2218:5;2208:9;:16::i;2160:65::-;2235:25;;;2231:67;;2280:17;2291:5;2280:10;:17::i;2231:67::-;2308:27;;;2304:71;;2355:19;2368:5;2355:12;:19::i;2304:71::-;2385:28;;;2381:73;;2433:20;2447:5;2433:13;:20::i;2381:73::-;2464:30;;;2460:77;;2514:22;2530:5;2514:15;:22::i;2460:77::-;2547:25;;;2543:67;;2592:17;2603:5;2592:10;:17::i;2543:67::-;2620:25;;;2616:67;;2665:17;2676:5;2665:10;:17::i;2616:67::-;2693:25;;;2689:67;;2738:17;2749:5;2738:10;:17::i;2689:67::-;2766:30;;;2762:77;;2816:22;2832:5;2816:15;:22::i;2762:77::-;2849:25;;;2845:67;;2894:17;2905:5;2894:10;:17::i;2845:67::-;2922:27;;;2918:71;;2969:19;2982:5;2969:12;:19::i;2918:71::-;2999:25;;;2995:67;;3044:17;3055:5;3044:10;:17::i;2995:67::-;3072:26;;;3068:69;;3118:18;3130:5;3118:11;:18::i;3068:69::-;3147:26;;;3143:69;;3193:18;3205:5;3193:11;:18::i;3143:69::-;3222:19;;;3218:55;;3261:11;3266:5;3261:4;:11::i;3218:55::-;3283:19;;;3279:55;;3322:11;3327:5;3322:4;:11::i;3279:55::-;3344:19;;;3340:55;;3383:11;3388:5;3383:4;:11::i;3340:55::-;3405:19;;;3401:55;;3444:11;3449:5;3444:4;:11::i;3401:55::-;3466:22;;;3462:61;;3508:14;3516:5;3508:7;:14::i;3462:61::-;3536:22;;;3555:1;3536:22;;;1526:25:101;1499:18;3536:22:84;1380:177:101;4459:115:84;4522:7;4544:25;4563:5;4544:18;:25::i;7042:115::-;7105:7;7127:25;7146:5;7127:18;:25::i;6816:109::-;6876:7;6898:22;6914:5;6898:15;:22::i;4116:111::-;4177:7;4199:23;4216:5;4199:16;:23::i;3567:174::-;3695:28;;;;;;;5103:25:101;;;5178:13;;5175:1;5164:28;;;5144:18;;;5137:56;5249:15;;;5243:22;5229:37;;5209:18;;;5202:65;5323:15;;;5317:22;5303:37;;;5090:3;5283:18;;5276:65;3654:7:84;;3687:37;;5075:19:101;;3695:28:84;;;;;;;;;;;;3687:7;:37::i;:::-;3676:60;;;;;;;;;;;;:::i;:::-;3669:67;3567:174;-1:-1:-1;;;3567:174:84:o;4691:116::-;4753:7;4775:27;4796:5;4775:20;:27::i;4344:111::-;4405:7;4427:23;4444:5;4427:16;:23::i;3886:109::-;3946:7;3968:22;3984:5;3968:15;:22::i;4231:109::-;4291:7;4313:22;4329:5;4313:15;:22::i;743:148:7:-;421:6;;;;407:10;:20;399:43;;;;;;;5743:2:101;399:43:7;;;5725:21:101;5782:2;5762:18;;;5755:30;5821:12;5801:18;;;5794:40;5851:18;;399:43:7;;;;;;;;;846:6:::1;::::0;825:38:::1;::::0;::::1;::::0;;::::1;::::0;846:6:::1;::::0;825:38:::1;::::0;846:6:::1;::::0;825:38:::1;869:6;:17:::0;;;::::1;;::::0;;;::::1;::::0;;;::::1;::::0;;743:148::o;4578:109:84:-;4638:7;4660:22;4676:5;4660:15;:22::i;18072:315:69:-;18140:7;18155:28;18186:26;18195:5;:7;;;18204:5;:7;;;18186:8;:26::i;:::-;18155:57;;18218:12;18233:40;18243:5;:7;;;18252:5;:7;;;18261:11;18233:9;:40::i;:::-;18218:55;;18279:11;18293:24;18305:11;18293;:24::i;:::-;18279:38;;18330:52;18341:5;:7;;;18350:5;:7;;;18359:5;:7;;;18368:6;18376:5;18330:10;:52::i;:::-;18323:59;18072:315;-1:-1:-1;;;;;18072:315:69:o;16344:303::-;16406:7;16421:28;16452:26;16461:5;:7;;;16470:5;:7;;;16452:8;:26::i;:::-;16421:57;;16484:12;16499:40;16509:5;:7;;;16518:5;:7;;;16527:11;16499:9;:40::i;:::-;16484:55;;16545:11;16559:24;16571:11;16559;:24::i;:::-;16601:7;;;;16545:38;;-1:-1:-1;16596:46:69;;16610:6;16545:38;16625:16;16601:7;16610:6;16625:16;:::i;:::-;16596:4;:46::i;16909:287::-;16972:7;16987:28;17018:26;17027:5;:7;;;17036:5;:7;;;17018:8;:26::i;:::-;16987:57;;17050:12;17065:40;17075:5;:7;;;17084:5;:7;;;17093:11;17065:9;:40::i;:::-;17050:55;;17111:11;17125:24;17137:11;17125;:24::i;:::-;17111:38;;17162:29;17168:5;:7;;;17177:6;17185:5;17162;:29::i;13734:309::-;13799:7;13814:28;13845:26;13854:5;:7;;;13863:5;:7;;;13845:8;:26::i;:::-;13814:57;;13877:12;13892:40;13902:5;:7;;;13911:5;:7;;;13920:11;13892:9;:40::i;:::-;13877:55;;13938:11;13952:24;13964:11;13952;:24::i;:::-;13938:38;;13989:49;13997:5;:7;;;14006:5;:7;;;14015:5;:7;;;14024:6;14032:5;13989:7;:49::i;12789:108::-;12854:7;12876:16;12884:5;:7;;;12876;:16::i;15261:271::-;15323:7;15338:28;15369:26;15378:5;:7;;;15387:5;:7;;;15369:8;:26::i;:::-;15338:57;;15401:12;15416:40;15426:5;:7;;;15435:5;:7;;;15444:11;15416:9;:40::i;:::-;15474:7;;;;15491:35;;15401:55;;-1:-1:-1;15469:58:69;;15401:55;;15469:4;:58::i;:::-;15462:65;15261:271;-1:-1:-1;;;;15261:271:69:o;15759:287::-;15822:7;15837:28;15868:26;15877:5;:7;;;15886:5;:7;;;15868:8;:26::i;:::-;15837:57;;15900:12;15915:40;15925:5;:7;;;15934:5;:7;;;15943:11;15915:9;:40::i;:::-;15900:55;;15961:11;15975:24;15987:11;15975;:24::i;:::-;15961:38;;16012:29;16018:5;:7;;;16027:6;16035:5;16012;:29::i;19507:313::-;19574:7;19589:28;19620:26;19629:5;:7;;;19638:5;:7;;;19620:8;:26::i;:::-;19589:57;;19652:12;19667:40;19677:5;:7;;;19686:5;:7;;;19695:11;19667:9;:40::i;:::-;19652:55;;19713:11;19727:24;19739:11;19727;:24::i;:::-;19713:38;;19764:51;19774:5;:7;;;19783:5;:7;;;19792:5;:7;;;19801:6;19809:5;19764:9;:51::i;12424:236::-;12487:7;12502:28;12533:26;12542:5;:7;;;12551:5;:7;;;12533:8;:26::i;:::-;12502:57;;12565:12;12580:40;12590:5;:7;;;12599:5;:7;;;12608:11;12580:9;:40::i;:::-;12565:55;;12633:22;12639:5;:7;;;12648:6;12633:5;:22::i;17559:285::-;17621:7;17636:28;17667:26;17676:5;:7;;;17685:5;:7;;;17667:8;:26::i;:::-;17636:57;;17699:12;17714:40;17724:5;:7;;;17733:5;:7;;;17742:11;17714:9;:40::i;:::-;17699:55;;17760:11;17774:24;17786:11;17774;:24::i;:::-;17760:38;;17811:28;17816:5;:7;;;17825:6;17833:5;17811:4;:28::i;13004:303::-;13066:7;13081:28;13112:26;13121:5;:7;;;13130:5;:7;;;13112:8;:26::i;:::-;13081:57;;13144:12;13159:40;13169:5;:7;;;13178:5;:7;;;13187:11;13159:9;:40::i;:::-;13144:55;;13205:11;13219:24;13231:11;13219;:24::i;:::-;13261:7;;;;13205:38;;-1:-1:-1;13256:46:69;;13270:6;13205:38;13285:16;13261:7;13270:6;13285:16;:::i;:::-;13256:4;:46::i;14490:303::-;14552:7;14567:28;14598:26;14607:5;:7;;;14616:5;:7;;;14598:8;:26::i;:::-;14567:57;;14630:12;14645:40;14655:5;:7;;;14664:5;:7;;;14673:11;14645:9;:40::i;:::-;14630:55;;14691:11;14705:24;14717:11;14705;:24::i;:::-;14691:38;;14742:46;14747:5;:7;;;14756:5;:7;;;14765:5;:7;;;14774:6;14782:5;14742:4;:46::i;5844:859::-;5901:16;;:::i;:::-;5925:11;5939:6;:14;5954:7;:1;5958:3;5954:7;:::i;:::-;5963;:1;5967:3;5963:7;:::i;:::-;5977:2;5939:41;;;;;;;;;;7529:1:101;7518:21;;;5939:41:69;;;7500:40:101;7576:21;;;;7556:18;;;7549:49;5972:3:69;7614:18:101;;;7607:34;7657:18;;;7650:45;;;;7472:19;;5939:41:69;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;:::i;:::-;6033:2;6004:32;;;;;8305:1:101;8294:21;;;6004:32:69;;;8276:40:101;8352:21;;;8332:18;;;8325:49;6023:3:69;8390:18:101;;;8383:34;6028:3:69;8433:18:101;;;8426:34;8476:19;;;8469:46;;;;5925:55:69;;-1:-1:-1;5986:15:69;;6004:6;;:12;;8248:19:101;;6004:32:69;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;:::i;:::-;6070:21;;;;;;;;;;;;;;;;;;;;;;5986:50;;-1:-1:-1;6097:22:69;;:::i;:::-;6160:103;6171:86;6180:72;1459:20;6196:55;6206:11;6219:31;6234:15;6219:14;:31::i;:::-;6196:9;:55::i;:::-;6180:8;:72::i;:::-;1666:9;6171:8;:86::i;:::-;6160:3;:103::i;:::-;6126:137;;;;6301:100;6312:83;6321:69;1459:20;6337:52;6347:11;6360:28;6375:12;6360:14;:28::i;6301:100::-;6270:131;;:28;;;:131;6439:100;6450:83;6459:69;1459:20;6475:52;6485:11;6498:28;6513:12;6498:14;:28::i;6439:100::-;6408:131;;:28;;;:131;6578:101;6589:84;6598:70;1459:20;6614:53;6624:11;6637:29;6652:13;6637:14;:29::i;6578:101::-;6546:133;;:29;;;:133;:5;6693;-1:-1:-1;;;;;;5844:859:69:o;4456:1384::-;4554:5;;4615:6;:14;4630:7;4634:3;4630:1;:7;:::i;:::-;4639;:1;4643:3;4639:7;:::i;:::-;4653:2;4615:41;;;;;;;;;;7529:1:101;7518:21;;;4615:41:69;;;7500:40:101;7576:21;;;;7556:18;;;7549:49;4648:3:69;7614:18:101;;;7607:34;7657:18;;;7650:45;;;;7472:19;;4615:41:69;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;:::i;:::-;4596:60;;4662:24;4689:26;4705:9;4689:15;:26::i;:::-;4662:53;;4721:20;4744:24;4753:9;1795:10;4744:8;:24::i;:::-;4817:2;4792:28;;;;;7529:1:101;7518:21;;;4792:28:69;;;7500:40:101;7576:21;;;7556:18;;;7549:49;4813:2:69;7614:18:101;;;7607:34;7657:18;;;7650:45;;;;4721:47:69;;-1:-1:-1;4774:15:69;;4792:6;;:14;;7472:19:101;;4792:28:69;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;:::i;:::-;4774:46;;4842:47;4851:13;4866:22;4875:8;1762:9;4866:8;:22::i;:::-;4842:8;:47::i;:::-;4960:2;4935:28;;;;;7529:1:101;7518:21;;;4935:28:69;;;7500:40:101;7576:21;;;7556:18;;;7549:49;4956:2:69;7614:18:101;;;7607:34;7657:18;;;7650:45;;;;4826:63:69;;-1:-1:-1;4911:53:69;;4826:63;;4935:6;;:14;;7472:19:101;;4935:28:69;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;:::i;4911:53::-;4895:69;;4986:28;4995:13;1829:10;4986:8;:28::i;:::-;5074:31;;4970:44;;-1:-1:-1;5049:13:69;;5065:67;;5107:24;4970:44;5107:9;:24::i;:::-;5065:8;:67::i;:::-;5049:83;-1:-1:-1;5147:79:69;5049:83;5164:61;5173:5;5187:12;5173:28;;;;;5203:21;5210:13;5203:6;:21::i;5147:79::-;5138:88;-1:-1:-1;5241:79:69;5138:88;5258:61;5267:5;5281:12;5267:28;;;;5297:21;5304:13;5297:6;:21::i;5241:79::-;5232:88;-1:-1:-1;5335:81:69;5232:88;5352:63;5361:5;5375:13;5361:29;;5335:81;5326:90;-1:-1:-1;5431:100:69;5326:90;5448:82;5457:68;5466:48;5475:28;5484:5;5490:1;5484:8;;;;5494:5;5500:1;5494:8;;;;;5475;:28::i;:::-;5505:5;5511:1;5505:8;;5466:48;5516:5;5522:1;5516:8;;5457:68;1638:5;5448:8;:82::i;:::-;5431:8;:100::i;:::-;5422:109;;5547:49;5556:17;5575:20;5584:6;1666:9;5575:8;:20::i;5547:49::-;5702:2;5676:29;;;;;7529:1:101;7518:21;;;5676:29:69;;;7500:40:101;7576:21;;;7556:18;;;7549:49;5697:3:69;7614:18:101;;;7607:34;7657:18;;;7650:45;;;;5538:58:69;;-1:-1:-1;5625:13:69;;5641:86;;5649:77;;5658:63;;5667:43;;5676:6;;:14;;7472:19:101;;5676:29:69;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;:::i;5667:43::-;5712:8;5658;:63::i;:::-;1698:9;5649:8;:77::i;:::-;5641:7;:86::i;:::-;5625:102;;5742:24;5751:6;5759;5742:8;:24::i;:::-;5733:33;;5831:3;5806:22;5816:6;5824:3;5806:9;:22::i;:::-;:28;;;;:::i;:::-;5793:42;4456:1384;-1:-1:-1;;;;;;;;;;4456:1384:69:o;6707:276::-;6779:11;6798:15;6824:9;6819:160;6839:18;6835:1;:22;6819:160;;;6893:8;6876:25;;:11;6888:1;6876:14;;;;;;;:::i;:::-;;;;;:25;;;6872:101;;;6924:11;6936:1;6924:14;;;;;;;:::i;:::-;;;;;6913:25;;6962:1;6948:16;;6872:101;6859:3;;;;:::i;:::-;;;;6819:160;;;;6792:191;6707:276;;;:::o;18391:1112::-;18512:7;18536:6;18531:11;;:1;:11;;;18527:25;;-1:-1:-1;18551:1:69;18544:8;;18527:25;18559:11;18573:18;18586:1;18589;18573:12;:18::i;:::-;18559:32;-1:-1:-1;18602:28:69;;;;;18598:120;;18651:1;18644:4;:8;;;18640:34;;;-1:-1:-1;2545:30:70;;-1:-1:-1;18654:20:69;;18640:34;18693:3;18686:4;:10;;;18682:29;;;-1:-1:-1;2686:23:70;;-1:-1:-1;18698:13:69;;18682:29;18728;;;;;18724:385;;18778:1;18771:4;:8;;;18767:32;;;-1:-1:-1;1647:28:70;;-1:-1:-1;18781:18:69;;18767:32;18818:2;18811:4;:9;;;18807:36;;;-1:-1:-1;1792:31:70;;-1:-1:-1;18822:21:69;;18807:36;18862:2;18855:4;:9;;;18851:37;;;-1:-1:-1;1869:32:70;;-1:-1:-1;18866:22:69;;18851:37;18907:2;18900:4;:9;;;18896:34;;;-1:-1:-1;2026:29:70;;-1:-1:-1;18911:19:69;;18896:34;18949:2;18942:4;:9;;;18938:34;;;-1:-1:-1;2098:29:70;;-1:-1:-1;18953:19:69;;18938:34;18991:2;18984:4;:9;;;18980:34;;;-1:-1:-1;2324:29:70;;-1:-1:-1;18995:19:69;;18980:34;19033:2;19026:4;:9;;;19022:36;;;-1:-1:-1;2398:31:70;;-1:-1:-1;19037:21:69;;19022:36;19078:3;19070:4;:11;;;19066:36;;-1:-1:-1;1718:29:70;;-1:-1:-1;19083:19:69;;19066:36;19119:28;;;;;19115:171;;19168:1;19161:4;:8;;;19157:33;;;-1:-1:-1;2472:29:70;;-1:-1:-1;19171:19:69;;19157:33;19209:2;19202:4;:9;;;19198:39;;;-1:-1:-1;2247:34:70;;-1:-1:-1;19213:24:69;;19198:39;19256:2;19249:4;:9;;;19245:34;;;-1:-1:-1;1718:29:70;;-1:-1:-1;19260:19:69;;19245:34;19296:31;;;19292:207;;19345:2;19341:1;:6;;;:18;;;;;19358:1;19351:4;:8;;;19341:18;19337:43;;;-1:-1:-1;2170:29:70;;-1:-1:-1;19361:19:69;;19337:43;19397:2;19392:1;:7;;;;:20;;;;;19410:2;19403:4;:9;;;19392:20;19388:50;;;-1:-1:-1;1949:34:70;;-1:-1:-1;19414:24:69;;19388:50;19455:2;19450:1;:7;;;;:20;;;;;19468:2;19461:4;:9;;;19450:20;19446:46;;;-1:-1:-1;2619:30:70;;-1:-1:-1;19472:20:69;;19446:46;18521:982;18391:1112;;;;;;;:::o;16651:254::-;16770:7;16794:6;16789:11;;:1;:11;;;16785:25;;-1:-1:-1;16809:1:69;16802:8;;16785:25;16820:29;;;16835:13;16820:29;:38;;;;;16857:1;16853;:5;;;16820:38;:65;;;;;16884:1;16862:18;:23;;;;16820:65;16816:84;;;-1:-1:-1;3992:23:70;16651:254:69;;;;;;:::o;17200:355::-;17290:7;17314:6;17309:11;;:1;:11;;;17305:25;;-1:-1:-1;17329:1:69;17322:8;;17305:25;17344:1;17340;:5;;;17336:19;;;-1:-1:-1;17354:1:69;17347:8;;17336:19;17367:29;;;17382:13;17367:29;;:61;;-1:-1:-1;17400:28:69;;;17415:12;17400:28;17367:61;17366:82;;;;-1:-1:-1;17438:10:69;17447:1;17438:6;:10;:::i;:::-;17433:15;;:1;:15;;;17366:82;17362:102;;;-1:-1:-1;617:24:70;17450:14:69;;17362:102;17474:31;;;;:41;;;;;17513:2;17509:1;:6;;;17474:41;:60;;;;-1:-1:-1;17524:10:69;17533:1;17524:6;:10;:::i;:::-;17519:15;;:1;:15;;;17474:60;17470:80;;;-1:-1:-1;617:24:70;17536:14:69;;14047:439;14165:7;14189:6;14184:11;;:1;:11;;;14180:25;;-1:-1:-1;14204:1:69;14197:8;;14180:25;14217:29;;;14232:13;14217:29;;:61;;-1:-1:-1;14250:28:69;;;14265:12;14250:28;14217:61;:93;;;-1:-1:-1;14282:28:69;;;14297:12;14282:28;14217:93;14216:107;;;;;14320:3;14315:1;:8;;;;14216:107;14212:127;;;-1:-1:-1;14338:1:69;14331:8;;14212:127;14346:11;14360:18;14373:1;14376;14360:12;:18::i;:::-;14346:32;;14395:2;14388:4;:9;;;14384:23;;;14406:1;14399:8;;;;;14384:23;14421:22;14434:1;14437:5;14441:1;14437;:5;:::i;:::-;14421:12;:22::i;:::-;14414:29;;14461:2;14453:4;:10;;;14449:32;;-1:-1:-1;1451:26:70;;-1:-1:-1;14465:16:69;;12901:99;12950:7;12974:3;12969:1;:8;;;12965:30;;-1:-1:-1;4055:26:70;;12901:99:69;-1:-1:-1;12901:99:69:o;12965:30::-;12901:99;;;:::o;15536:219::-;15634:7;15658:6;15653:11;;:1;:11;;;15649:25;;-1:-1:-1;15673:1:69;15666:8;;15649:25;15689:2;15685:1;:6;;;:30;;;-1:-1:-1;1398:20:69;15695;;;;;15685:30;15684:51;;;;-1:-1:-1;15725:10:69;15734:1;15725:6;:10;:::i;:::-;15720:15;;:1;:15;;;15684:51;15680:70;;;-1:-1:-1;3932:23:70;15737:13:69;;16050:290;16140:7;16164:6;16159:11;;:1;:11;;;16155:25;;-1:-1:-1;16179:1:69;16172:8;;16155:25;16192:29;;;16207:13;16192:29;;:61;;-1:-1:-1;16225:28:69;;;16240:12;16225:28;16192:61;:93;;;-1:-1:-1;16257:28:69;;;16272:12;16257:28;16192:93;16191:107;;;;;16295:3;16290:1;:8;;;;16191:107;16187:127;;;-1:-1:-1;16313:1:69;16306:8;;16187:127;-1:-1:-1;797:24:70;16050:290:69;;;;;:::o;19824:1010::-;19944:7;19967:6;19963:10;;:1;:10;;;:19;;;;19981:1;19977;:5;;;19963:19;19959:33;;;-1:-1:-1;19991:1:69;19984:8;;19959:33;20003:31;;;;;:63;;-1:-1:-1;20038:28:69;;;20053:12;20038:28;20003:63;19999:77;;;-1:-1:-1;20075:1:69;20068:8;;19999:77;20084:12;20098;20114:19;20128:1;20131;20114:13;:19::i;:::-;20083:50;;;;20139:11;20153:28;20166:6;20174;20153:12;:28::i;:::-;20139:42;-1:-1:-1;20192:29:69;;;20207:13;20192:29;:42;;;;;20232:2;20225:4;:9;;;20192:42;20188:318;;;20245:17;20264:29;20297:32;20321:1;20324;20327;20297:23;:32::i;:::-;20244:85;;;;20356:1;20341:11;:16;;;20337:30;;20366:1;20359:8;;;;;;;;;20337:30;20375:16;20394:25;20407:1;20410;20413:5;20394:12;:25::i;:::-;20375:44;-1:-1:-1;20441:14:69;20453:2;20375:44;20441:14;:::i;:::-;20434:21;;:4;:21;;;:65;;20482:17;20487:11;20482:4;:17::i;:::-;20434:65;;;20458:21;20467:11;20458:8;:21::i;:::-;20427:72;;;;;;;;;;20188:318;20516:28;;;20531:12;20516:28;:42;;;;;20555:3;20548:4;:10;;;20516:42;20512:318;;;20569:17;20588:29;20621:32;20645:1;20648;20651;20621:23;:32::i;:::-;20568:85;;;;20680:1;20665:11;:16;;;20661:30;;20690:1;20683:8;;;;;;;;;20661:30;20699:16;20718:25;20731:1;20734;20737:5;20718:12;:25::i;:::-;20699:44;-1:-1:-1;20765:14:69;20777:2;20699:44;20765:14;:::i;20512:318::-;19953:881;;;19824:1010;;;;;;;:::o;12664:121::-;12725:7;12748:1;12744;:5;;;:20;;;;;12758:6;12753:11;;:1;:11;;;;12744:20;12740:40;;;-1:-1:-1;981:24:70;12766:14:69;;17848:220;17937:7;17961:6;17956:11;;:1;:11;;;17952:25;;-1:-1:-1;17976:1:69;17969:8;;17952:25;17987:29;;;18002:13;17987:29;;:61;;-1:-1:-1;18020:28:69;;;18035:12;18020:28;17987:61;17983:80;;;-1:-1:-1;678:23:70;18050:13:69;;13311:419;13430:7;13454:6;13449:11;;:1;:11;;;13445:25;;-1:-1:-1;13469:1:69;13462:8;;13445:25;13481:28;;;13496:12;13481:28;:40;;;;;13518:3;13513:1;:8;;;;13481:40;13477:59;;;-1:-1:-1;858:23:70;13523:13:69;;13477:59;13552:1;13547;:6;;;13543:20;;-1:-1:-1;13562:1:69;13555:8;;13543:20;13574:29;;;13589:13;13574:29;:56;;;;;13629:1;13607:18;:23;;;;13574:56;13570:75;;;-1:-1:-1;858:23:70;13632:13:69;;13570:75;13655:28;;;13670:12;13655:28;:55;;;;;13709:1;13687:18;:23;;;;13655:55;13651:74;;;-1:-1:-1;858:23:70;13712:13:69;;14797:460;14912:7;14936:6;14931:11;;:1;:11;;;14927:25;;-1:-1:-1;14951:1:69;14944:8;;14927:25;14964:29;;;14979:13;14964:29;;:61;;-1:-1:-1;14997:28:69;;;15012:12;14997:28;14964:61;:93;;;-1:-1:-1;15029:28:69;;;15044:12;15029:28;14964:93;14963:107;;;;;15067:3;15062:1;:8;;;;14963:107;14959:127;;;-1:-1:-1;15085:1:69;15078:8;;14959:127;15093:11;15107:18;15120:1;15123;15107:12;:18::i;:::-;15093:32;;15143:2;15135:4;:10;;;;:23;;;;15156:2;15149:4;:9;;;15135:23;15131:37;;;15167:1;15160:8;;;;;15131:37;15182:22;15195:1;15198:5;15202:1;15198;:5;:::i;15182:22::-;15175:29;;15221:2;15214:4;:9;;;:23;;;;;15235:2;15227:4;:10;;;;15214:23;15210:42;;;-1:-1:-1;1200:23:70;;-1:-1:-1;15239:13:69;;6987:324;-1:-1:-1;;;;;;;;;;;;;;;;;7080:15:69;7071:5;:24;;;;;;;;:::i;:::-;;7067:50;;-1:-1:-1;;7104:13:69;;;;;;;;;-1:-1:-1;7104:13:69;;;;;;;;6987:324::o;7067:50::-;7136:12;7127:5;:21;;;;;;;;:::i;:::-;;7123:47;;-1:-1:-1;;7157:13:69;;;;;;;;;-1:-1:-1;7157:13:69;;1638:5;7157:13;;;;;6987:324::o;7123:47::-;7189:12;7180:5;:21;;;;;;;;:::i;:::-;;7176:47;;-1:-1:-1;;7210:13:69;;;;;;;;;1638:5;7210:13;;-1:-1:-1;7210:13:69;;;;;6987:324::o;7176:47::-;7242:13;7233:5;:22;;;;;;;;:::i;:::-;;7229:48;;-1:-1:-1;;7264:13:69;;;;;;;;;1638:5;7264:13;;;;;;;;6987:324::o;7229:48::-;7283:23;;;;;11501:2:101;7283:23:69;;;11483:21:101;11540:2;11520:18;;;11513:30;11579:15;11559:18;;;11552:43;11612:18;;7283:23:69;11299:337:101;8656:183:69;8728:6;8749:85;8759:74;8768:31;8777:18;8786:1;:3;;;8791:1;:3;;;8777:8;:18::i;:::-;8797:1;8768:8;:31::i;:::-;8801;8810:18;8819:1;:3;;;8824:1;:3;;;8810:8;:18::i;8759:74::-;8749:9;:85::i;3949:219:30:-;4006:6;4054:13;;;;:9;;;;:13;805:35;4084:19;;;;;:42;;-1:-1:-1;958:34:30;4107:19;;;4084:42;4075:52;;;;;4395:225;4452:6;4500:13;:9;;;:13;;;;;4517:2;4500:19;805:35;4536:19;;;;;:42;;-1:-1:-1;958:34:30;4559:19;;;4527:52;;;;;9177:93:69;9223:6;9248:1;9244;:5;;;:21;;9264:1;9244:21;;;9259:1;9237:28;9177:93;-1:-1:-1;;9177:93:69:o;10241:252::-;10336:14;;;10348:1;10336:14;;;;;;;;;10297:6;;;;10336:14;;;;;-1:-1:-1;;;;;;;;;;;;;;;;;10336:14:69;;;;;;;;;;;;;;;10311:39;;10369:13;;;;;;;;811:1;10369:13;;;;;;811:1;10369:13;;;;;10356:7;10364:1;10356:10;;;;;;;;:::i;:::-;;;;;;:26;;;;10401:17;;;;;;;;1216:19;10401:17;;;;;;1216:19;10401:17;;;;;10388:7;10396:1;10388:10;;;;;;;;:::i;:::-;;;;;;:30;;;;10437:15;;;;;;;;1638:5;10437:15;;;;;;1216:19;10437:15;;;;;10424:7;10432:1;10424:10;;;;;;;;:::i;:::-;;;;;;:28;;;;10465:23;10477:1;10480:7;10465:11;:23::i;3517:219:30:-;3574:6;3622:13;:9;;;:13;;;;;805:35;3652:19;;;;;:42;;-1:-1:-1;958:34:30;3675:19;;;3643:52;;;;;7038:252;7095:6;7136:1;:6;;7141:1;7136:6;7127:16;;;;;;7151:13;7188:1;7167:22;;7182:2;7176:1;7168:10;;:16;;7167:22;;;;;:::i;:::-;;;-1:-1:-1;805:35:30;7206:19;;;;;:42;;-1:-1:-1;958:34:30;7229:19;;;7197:52;;;;;10497:278:69;10586:14;;;10598:1;10586:14;;;;;;;;;10547:6;;;;10586:14;;;;;-1:-1:-1;;;;;;;;;;;;;;;;;10586:14:69;;;;;;;;;;;;;;;10561:39;;10619:13;;;;;;;;811:1;10619:13;;;;;;811:1;10619:13;;;;;10606:7;10614:1;10606:10;;;;;;;;:::i;:::-;;;;;;:26;;;;10651:17;;;;;;;;850:19;10651:17;;;;;;909:19;10651:17;;;;;10638:7;10646:1;10638:10;;;;;;;;:::i;:::-;;;;;;:30;;;;10687:15;;;;;;;;1398:20;10687:15;;;;;;1666:9;10687:15;;;;;10674:7;10682:1;10674:10;;;;;;;;:::i;:::-;;;;;;:28;;;;10721:13;;;;;;;;1638:5;10721:13;;;;;;1730:9;10721:13;;;;;10708:7;10716:1;10708:10;;;;;;;;:::i;10779:207::-;10865:14;;;10877:1;10865:14;;;;;;;;;10826:6;;;;10865:14;;;;;-1:-1:-1;;;;;;;;;;;;;;;;;10865:14:69;;;;;;;;;;;;;;;10840:39;;10898:13;;;;;;;;811:1;10898:13;;;;;;811:1;10898:13;;;;;10885:7;10893:1;10885:10;;;;;;;;:::i;:::-;;;;;;:26;;;;10930:15;;;;;;;;1638:5;10930:15;;;;;;909:19;10930:15;;;;;10917:7;10925:1;10917:10;;;;;;;;:::i;10990:207::-;11076:14;;;11088:1;11076:14;;;;;;;;;11037:6;;;;11076:14;;;;;-1:-1:-1;;;;;;;;;;;;;;;;;11076:14:69;;;;;;;;;;;;;;;11051:39;;11109:13;;;;;;;;811:1;11109:13;;;;;;811:1;11109:13;;;;;11096:7;11104:1;11096:10;;;;;;;;:::i;:::-;;;;;;:26;;;;11141:15;;;;;;;;1638:5;11141:15;;;;;;1216:19;11141:15;;;;;11128:7;11136:1;11128:10;;;;;;;;:::i;11413:426::-;11500:14;;;11512:1;11500:14;;;;;;;;;11461:6;;;;11500:14;;;;;-1:-1:-1;;;;;;;;;;;;;;;;;11500:14:69;;;;;;;;;;;;;;;11475:39;;11533:13;;;;;;;;811:1;11533:13;;;;;;1638:5;11533:13;;;;;11520:7;11528:1;11520:10;;;;;;;;:::i;:::-;;;;;;:26;;;;11565:16;;;;;;;;969:19;11565:16;;;;;;1638:5;11565:16;;;;;11552:7;11560:1;11552:10;;;;;;;;:::i;:::-;;;;;;:29;;;;11600:18;;;;;;;;1030:19;11600:18;;;;;;1580:20;11600:18;;;;;11587:7;11595:1;11587:10;;;;;;;;:::i;:::-;;;;;;:31;;;;11637:19;;;;;;;;1092;11637;;;;;;1520:20;11637:19;;;;;11624:7;11632:1;11624:10;;;;;;;;:::i;:::-;;;;;;:32;;;;11675:19;;;;;;;;1155;11675;;;;;;1520:20;11675:19;;;;;11662:7;11670:1;11662:10;;;;;;;;:::i;:::-;;;;;;:32;;;;11713:18;;;;;;;;1276:19;11713:18;;;;;;1580:20;11713:18;;;;;11700:7;11708:1;11700:10;;;;;;;;:::i;:::-;;;;;;:31;;;;11750:16;;;;;;;;1337:20;11750:16;;;;;;1638:5;11750:16;;;;;11737:7;11745:1;11737:10;;;;;;;;:::i;:::-;;;;;;:29;;;;11785:13;;;;;;;;1638:5;11785:13;;;;;;1638:5;11785:13;;;;;11772:7;11780:1;11772:10;;;;;;;;:::i;4927:1035:30:-;4985:6;5021:14;;;;;;5017:935;;5061:51;5056:1;:56;;:126;;;;;5131:51;5126:1;:56;;5056:126;5047:136;;;;;;-1:-1:-1;5200:2:30;;;;5206;5200:8;5193:15;;5017:935;5233:19;5278:1;5274;:5;;;5270:73;;;5298:1;5297:2;;5293:6;;5328:4;5311:21;;5270:73;5360:1;5356;:5;5352:121;;;5379:2;;;;;;5447:15;5352:121;5482:22;5507:21;5513:1;5525;5507:4;:21::i;:::-;5482:46;;5542:14;5538:406;;;5609:66;5579:14;:96;;5570:106;;;;;;5695:24;;;-1:-1:-1;5688:31:30;;-1:-1:-1;5688:31:30;5538:406;5824:66;5794:14;:96;;5785:106;;;;;;5918:14;-1:-1:-1;5903:30:30;;-1:-1:-1;5903:30:30;7315:163:69;7376:6;7390:12;7434:1;7437;7423:16;;;;;;;;11836:1:101;11825:21;;;11807:40;;11883:21;;11878:2;11863:18;;11856:49;11795:2;11780:18;;11641:270;7423:16:69;;;;;;;;;;;;;;7413:27;;7423:16;7413:27;;;;;-1:-1:-1;7461:11:69;7468:4;7413:27;7461:11;:::i;7482:144::-;7544:5;7551;7572:23;7576:1;198::67;7572:3:69;:23::i;:::-;7597;7601:1;198::67;7597:3:69;:23::i;:::-;7564:57;;;;7482:144;;;;;:::o;7630:575::-;-1:-1:-1;;;;;;;;7729:12:69;-1:-1:-1;;;;;;;;;;;;;;;7776:12:69;7790;7806:19;7820:1;7823;7806:13;:19::i;:::-;7775:50;;-1:-1:-1;7775:50:69;-1:-1:-1;7831:18:69;241:19:67;259:1;198;241:19;:::i;:::-;:23;;263:1;241:23;:::i;:::-;7852:24:69;198:1:67;7852:6:69;:24;:::i;:::-;:49;;;;:::i;:::-;7831:70;-1:-1:-1;7907:18:69;241:19:67;259:1;198;241:19;:::i;:::-;:23;;263:1;241:23;:::i;:::-;7928:24:69;198:1:67;7928:6:69;:24;:::i;:::-;:49;;;;:::i;:::-;7907:70;;7983:22;8008:36;8017:12;8031;8008:8;:36::i;:::-;7983:61;;8059:44;8069:12;8083;8097:5;8059:9;:44::i;:::-;8050:53;;8118:82;;;;;;;;198:1:67;8133:6:69;:24;;;;:::i;:::-;8129:28;;:1;:28;:::i;:::-;8118:82;;;;;;8159:10;8163:6;8159:1;:10;:::i;:::-;8118:82;;;;;;8175:24;198:1:67;8175:6:69;:24;:::i;:::-;8171:28;;:1;:28;:::i;:::-;8118:82;;;;;8109:91;;7769:436;;;;;7630:575;;;;;;:::o;8209:177::-;8299:6;8320:61;8347:11;8351:1;8354:3;8347;:11::i;:::-;8333;8337:1;8340:3;8333;:11::i;:::-;:25;;;;:::i;:::-;8373:5;8366:13;;8320:12;:61::i;20838:1009::-;20933:26;;;;;;;;20950:1;20933:26;;;20901:7;20933:26;;;;;;;;;;;;20941:6;;20933:7;:26::i;:::-;20929:44;;;-1:-1:-1;737:22:70;;20838:1009:69;-1:-1:-1;20838:1009:69:o;20929:44::-;20983:26;;;;;;;;21000:1;20983:26;;;21003:1;20983:26;;;;;;;;;;;;;20991:6;;20983:7;:26::i;:::-;20979:44;;;-1:-1:-1;737:22:70;;20838:1009:69;-1:-1:-1;20838:1009:69:o;20979:44::-;21033:26;;;;;;;;21050:1;21033:26;;;21053:1;21033:26;;;;;;;;;;;;;21041:6;;21033:7;:26::i;:::-;21029:44;;;-1:-1:-1;737:22:70;;20838:1009:69;-1:-1:-1;20838:1009:69:o;21029:44::-;21083:26;;;;;;;;21100:1;21083:26;;;;;;;;;;;;;;;;;;21091:6;;21083:7;:26::i;:::-;21079:44;;;-1:-1:-1;737:22:70;;20838:1009:69;-1:-1:-1;20838:1009:69:o;21079:44::-;21149:26;;;;;;;;21166:1;21149:26;;21169:1;21149:26;;;;;;;;;;;;;;;21157:6;;21149:7;:26::i;:::-;21145:47;;;-1:-1:-1;1516:25:70;;20838:1009:69;-1:-1:-1;20838:1009:69:o;21145:47::-;21202:26;;;;;;;;21219:1;21202:26;;;;;;;21225:1;21202:26;;;;;;;;;21210:6;;21202:7;:26::i;:::-;21198:47;;;-1:-1:-1;1516:25:70;;20838:1009:69;-1:-1:-1;20838:1009:69:o;21198:47::-;21255:26;;;;;;;;21272:1;21255:26;;21275:1;21255:26;;;;;;;;;;;;;;;21263:6;;21255:7;:26::i;:::-;21251:47;;;-1:-1:-1;1516:25:70;;20838:1009:69;-1:-1:-1;20838:1009:69:o;21251:47::-;21308:26;;;;;;;;21325:1;21308:26;;;;;;;21331:1;21308:26;;;;;;;;;21316:6;;21308:7;:26::i;:::-;21304:47;;;-1:-1:-1;1516:25:70;;20838:1009:69;-1:-1:-1;20838:1009:69:o;21304:47::-;21361:26;;;;;;;;21378:1;21361:26;;;21381:1;21361:26;;;;;;;;;;;;;21369:6;;21361:7;:26::i;:::-;21357:47;;;-1:-1:-1;1516:25:70;;20838:1009:69;-1:-1:-1;20838:1009:69:o;21357:47::-;21414:26;;;;;;;;21431:1;21414:26;;;21434:1;21414:26;;;;;;;;;;;;;21422:6;;21414:7;:26::i;:::-;21410:47;;;-1:-1:-1;1516:25:70;;20838:1009:69;-1:-1:-1;20838:1009:69:o;21410:47::-;21467:26;;;;;;;;21484:1;21467:26;;21487:1;21467:26;;;;21490:1;21467:26;;;;;;;;;21475:6;;21467:7;:26::i;:::-;21463:47;;;-1:-1:-1;1516:25:70;;20838:1009:69;-1:-1:-1;20838:1009:69:o;21463:47::-;21520:26;;;;;;;;21537:1;21520:26;;21540:1;21520:26;;;;21543:1;21520:26;;;;;;;;;21528:6;;21520:7;:26::i;:::-;21516:47;;;-1:-1:-1;1516:25:70;;20838:1009:69;-1:-1:-1;20838:1009:69:o;21516:47::-;21573:26;;;;;;;;21590:1;21573:26;;21593:1;21573:26;;;;21596:1;21573:26;;;;;;;;;21581:6;;21573:7;:26::i;:::-;21569:47;;;-1:-1:-1;1516:25:70;;20838:1009:69;-1:-1:-1;20838:1009:69:o;21569:47::-;21626:26;;;;;;;;21643:1;21626:26;;21646:1;21626:26;;;;21649:1;21626:26;;;;;;;;;21634:6;;21626:7;:26::i;:::-;21622:47;;;-1:-1:-1;1516:25:70;;20838:1009:69;-1:-1:-1;20838:1009:69:o;21622:47::-;21679:26;;;;;;;;21696:1;21679:26;;;;;;;21702:1;21679:26;;;;;;;;;21687:6;;21679:7;:26::i;:::-;21675:47;;;-1:-1:-1;1516:25:70;;20838:1009:69;-1:-1:-1;20838:1009:69:o;21675:47::-;21732:26;;;;;;;;21749:1;21732:26;;21752:1;21732:26;;;;;;;;;;;;;;;21740:6;;21732:7;:26::i;:::-;21728:47;;;-1:-1:-1;1516:25:70;;20838:1009:69;-1:-1:-1;20838:1009:69:o;21728:47::-;21785:26;;;;;;;;21802:1;21785:26;;;21805:1;21785:26;;;;;;;;;;;;;21793:6;;21785:7;:26::i;:::-;21781:47;;;-1:-1:-1;1516:25:70;;20838:1009:69;-1:-1:-1;20838:1009:69:o;21851:1191::-;21950:26;;;;;;;;21967:1;21950:26;;;21918:7;21950:26;;;;;;;;;;;;21958:6;;21950:7;:26::i;:::-;21946:44;;;-1:-1:-1;737:22:70;;21851:1191:69;-1:-1:-1;21851:1191:69:o;21946:44::-;22000:26;;;;;;;;22017:1;22000:26;;;22020:1;22000:26;;;;;;;;;;;;;22008:6;;22000:7;:26::i;:::-;21996:44;;;-1:-1:-1;737:22:70;;21851:1191:69;-1:-1:-1;21851:1191:69:o;21996:44::-;22050:26;;;;;;;;22067:1;22050:26;;;22070:1;22050:26;;;;;;;;;;;;;22058:6;;22050:7;:26::i;:::-;22046:44;;;-1:-1:-1;737:22:70;;21851:1191:69;-1:-1:-1;21851:1191:69:o;22046:44::-;22100:26;;;;;;;;22117:1;22100:26;;;;;;;;;;;;;;;;;;22108:6;;22100:7;:26::i;:::-;22096:44;;;-1:-1:-1;737:22:70;;21851:1191:69;-1:-1:-1;21851:1191:69:o;22096:44::-;22165:26;;;;;;;;22182:1;22165:26;;;;;;;22188:1;22165:26;;;;;;;;;22173:6;;22165:7;:26::i;:::-;22161:45;;;-1:-1:-1;2746:23:70;;21851:1191:69;-1:-1:-1;21851:1191:69:o;22161:45::-;22216:26;;;;;;;;22233:1;22216:26;;22236:1;22216:26;;;;;;;;;;;;;;;22224:6;;22216:7;:26::i;:::-;22212:45;;;-1:-1:-1;2746:23:70;;21851:1191:69;-1:-1:-1;21851:1191:69:o;22212:45::-;22267:26;;;;;;;;22284:1;22267:26;;22287:1;22267:26;;;;22290:1;22267:26;;;;;;;;;22275:6;;22267:7;:26::i;:::-;22263:45;;;-1:-1:-1;2746:23:70;;21851:1191:69;-1:-1:-1;21851:1191:69:o;22263:45::-;22318:26;;;;;;;;22335:1;22318:26;;22338:1;22318:26;;;;22341:1;22318:26;;;;;;;;;22326:6;;22318:7;:26::i;:::-;22314:45;;;-1:-1:-1;2746:23:70;;21851:1191:69;-1:-1:-1;21851:1191:69:o;22314:45::-;22369:26;;;;;;;;22386:1;22369:26;;22389:1;22369:26;;;;;;;;;;;;;;;22377:6;;22369:7;:26::i;:::-;22365:45;;;-1:-1:-1;2746:23:70;;21851:1191:69;-1:-1:-1;21851:1191:69:o;22365:45::-;22420:26;;;;;;;;22437:1;22420:26;;;;;;;22443:1;22420:26;;;;;;;;;22428:6;;22420:7;:26::i;:::-;22416:45;;;-1:-1:-1;2746:23:70;;21851:1191:69;-1:-1:-1;21851:1191:69:o;22416:45::-;22471:26;;;;;;;;22488:1;22471:26;;22491:1;22471:26;;;;;;;;;;;;;;;22479:6;;22471:7;:26::i;:::-;22467:45;;;-1:-1:-1;2746:23:70;;21851:1191:69;-1:-1:-1;21851:1191:69:o;22467:45::-;22522:26;;;;;;;;22539:1;22522:26;;;;;;;22545:1;22522:26;;;;;;;;;22530:6;;22522:7;:26::i;:::-;22518:45;;;-1:-1:-1;2746:23:70;;21851:1191:69;-1:-1:-1;21851:1191:69:o;22518:45::-;22573:26;;;;;;;;22590:1;22573:26;;;22593:1;22573:26;;;;;;;;;;;;;22581:6;;22573:7;:26::i;:::-;22569:45;;;-1:-1:-1;2746:23:70;;21851:1191:69;-1:-1:-1;21851:1191:69:o;22569:45::-;22624:26;;;;;;;;22641:1;22624:26;;;22644:1;22624:26;;;;;;;;;;;;;22632:6;;22624:7;:26::i;:::-;22620:45;;;-1:-1:-1;2746:23:70;;21851:1191:69;-1:-1:-1;21851:1191:69:o;22620:45::-;22675:26;;;;;;;;22692:1;22675:26;;22695:1;22675:26;;;;22698:1;22675:26;;;;;;;;;22683:6;;22675:7;:26::i;:::-;22671:45;;;-1:-1:-1;2746:23:70;;21851:1191:69;-1:-1:-1;21851:1191:69:o;22671:45::-;22726:26;;;;;;;;22743:1;22726:26;;22746:1;22726:26;;;;22749:1;22726:26;;;;;;;;;22734:6;;22726:7;:26::i;:::-;22722:45;;;-1:-1:-1;2746:23:70;;21851:1191:69;-1:-1:-1;21851:1191:69:o;22722:45::-;22777:26;;;;;;;;22794:1;22777:26;;22797:1;22777:26;;;;22800:1;22777:26;;;;;;;;;22785:6;;22777:7;:26::i;:::-;22773:45;;;-1:-1:-1;2746:23:70;;21851:1191:69;-1:-1:-1;21851:1191:69:o;22773:45::-;22828:26;;;;;;;;22845:1;22828:26;;22848:1;22828:26;;;;22851:1;22828:26;;;;;;;;;22836:6;;22828:7;:26::i;:::-;22824:45;;;-1:-1:-1;2746:23:70;;21851:1191:69;-1:-1:-1;21851:1191:69:o;22824:45::-;22879:26;;;;;;;;22896:1;22879:26;;;;;;;22902:1;22879:26;;;;;;;;;22887:6;;22879:7;:26::i;:::-;22875:45;;;-1:-1:-1;2746:23:70;;21851:1191:69;-1:-1:-1;21851:1191:69:o;22875:45::-;22930:26;;;;;;;;22947:1;22930:26;;22950:1;22930:26;;;;;;;;;;;;;;;22938:6;;22930:7;:26::i;:::-;22926:45;;;-1:-1:-1;2746:23:70;;21851:1191:69;-1:-1:-1;21851:1191:69:o;22926:45::-;22981:26;;;;;;;;22998:1;22981:26;;;23001:1;22981:26;;;;;;;;;;;;;22989:6;;22981:7;:26::i;:::-;22977:45;;;-1:-1:-1;2746:23:70;;21851:1191:69;-1:-1:-1;21851:1191:69:o;11287:2328:30:-;11345:6;11377:13;11397:1;11393;:5;;;:19;;;;;11402:1;11406;11402:5;11411:1;11402:10;11393:19;11377:35;;11421:12;11449:1;11445;:5;;;:14;;11458:1;11445:14;;;11454:1;11453:2;;11445:14;11421:39;;;-1:-1:-1;11505:35:30;11561:19;11553:27;;11549:1891;;11601:2;11592:11;;;;;11613:561;11620:6;;11613:561;;11648:3;11644:7;;:12;11640:80;;11684:16;;11704:3;11684:23;11640:80;11738:11;;;11753:3;11738:18;;11777:3;11773:7;;:12;11769:80;;11813:16;;11833:3;11813:23;11769:80;11867:11;;;11882:3;11867:18;;11906:3;11902:7;;:12;11898:80;;11942:16;;11962:3;11942:23;11898:80;11996:11;;;12011:3;11996:18;;12035:3;12031:7;;:12;12027:80;;12071:16;;12091:3;12071:23;12027:80;12162:1;12156:7;;;;;12125:11;;;12140:3;12125:18;;11613:561;;;12198:2;12184:16;11549:1891;;;12245:2;12268:27;12261:34;;12257:73;;;12308:2;12299:11;;;;;12312:15;;12257:73;12350:31;12343:4;:38;12339:77;;;12394:2;12385:11;;;;;12398:15;;12339:77;12436:33;12429:4;:40;12425:77;;;12482:1;12473:10;;;;;12485:14;;12425:77;12522:34;12515:4;:41;12511:78;;;12569:1;12560:10;;;;;12572:14;;12511:78;12609:34;12602:4;:41;12598:78;;;12656:1;12647:10;;;;;12659:14;;12598:78;12696:34;12689:4;:41;12685:78;;;12743:1;12734:10;;;;;12746:14;;12685:78;12773:19;12806:549;12813:6;;12806:549;;12854:2;12842:9;:14;12833:24;;;;;;12878:3;12874:7;;:12;12870:262;;12914:16;;;12934:3;12914:23;;12951:24;;13005:35;12993:47;;12989:131;;;13072:1;13058:15;;;;13089:16;12989:131;13150:11;;;13165:3;13150:18;;13194:1;13180:15;;;;;13219:35;13211:43;;13207:118;;13281:1;13272:10;;;;13298:14;;;;;13207:118;13343:1;13337:7;;;;;12806:549;;;13388:2;13374:11;:16;13365:26;;;;;;13415:2;:16;13401:30;;;;;-1:-1:-1;11549:1891:30;13447:13;13463:8;:51;;13504:9;13463:51;;;13483:9;13474:19;;13463:51;13447:67;-1:-1:-1;805:35:30;13531:19;;;;;:42;;-1:-1:-1;958:34:30;13554:19;;;13531:42;13522:52;;;;;;13597:6;11287:2328;-1:-1:-1;;;;;;11287:2328:30:o;13792:165::-;13840:6;13886:1;13881;:6;;;;13872:16;;;;;;13911:34;13942:2;13935:1;13927:10;;13918:26;;13911:5;:34::i;9669:568:69:-;9747:6;9761:22;;:::i;:::-;9820:7;:14;9838:1;9820:19;9816:276;;9849:33;;;;;;;;9859:7;9867:1;9859:10;;;;;;;;:::i;:::-;;;;;;;9849:33;;;;9871:7;9879:1;9871:10;;;;;;;;:::i;:::-;;;;;;;9849:33;;;;;9816:276;;;9908:13;9903:183;9931:7;:14;9923:5;:22;9903:183;;;9990:1;9970:21;;:7;9978:5;9970:14;;;;;;;;:::i;:::-;;;;;;;:16;;;:21;;;9966:112;;10005:45;;;;;;;;10015:7;10031:1;10023:5;:9;;;;:::i;:::-;10015:18;;;;;;;;:::i;:::-;;;;;;;10005:45;;;;10035:7;10043:5;10035:14;;;;;;;;:::i;:::-;;;;;;;10005:45;;;;;10062:5;;9966:112;9947:7;;;;:::i;:::-;;;;9903:183;;;;9816:276;10098:8;10109:70;10118:24;10127:1;10130:6;10098:8;10130:9;;;;;:11;10118:8;:24::i;:::-;10153:9;;;;:11;10144:34;;10153:6;:11;10166:9;;10109:70;10207:9;;;:11;;;;10220:9;;;;:11;;;;10192:40;;;;;13493:2:101;13482:22;;;10192:40:69;;;13464:41:101;13541:22;;;13521:18;;;13514:50;13600:22;;13580:18;;;13573:50;10098:81:69;;-1:-1:-1;10192:6:69;;:11;;13437:18:101;;10192:40:69;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;:::i;6267:513:30:-;6326:7;6363:1;6368;6363:6;6359:20;;-1:-1:-1;6378:1:30;6371:8;;6359:20;6402:1;6397;:6;;;;6388:16;;;;;;6436:10;;;;6455:34;6451:38;;6427:63;;6495:2;6426:71;;6547:3;6542:8;;;6518:33;6575:50;6569:56;;;6560:66;;;;;;6641:2;6634:9;6675:71;;6661:85;;;6652:95;;;;;;6762:7;;6267:513;-1:-1:-1;;;6267:513:30:o;230:197:100:-;275:5;;301;305:1;301;:5;:::i;:::-;286:20;;310:11;329:1;325;:5;;;:14;;;;338:1;334;:5;;;325:14;324:37;;;;;350:1;346;:5;;;:14;;;;;359:1;355;:5;;;346:14;344:17;324:37;:53;;;;-1:-1:-1;366:5:100;370:1;366;:5;:::i;:::-;:10;;;;324:53;:75;;397:1;324:75;;;386:1;324:75;310:89;-1:-1:-1;410:14:100;310:89;410:6;:14;:::i;9274:190:69:-;9354:4;9393:1;9354:4;9393;;;;9386:12;;9373:26;;:1;:3;;;:26;;;:56;;;;-1:-1:-1;9423:1:69;9425;9423:4;;;;9416:12;;9403:26;;:1;:3;;;:26;;;9373:56;:86;;;;-1:-1:-1;;9453:4:69;;;;;9433:3;;;:26;;;;9446:12;;;;9433:26;;;;9274:190::o;24667:881:30:-;24716:7;24753:1;24758;24753:6;24749:789;;-1:-1:-1;24768:1:30;;24667:881;-1:-1:-1;24667:881:30:o;24749:789::-;24805:1;24828;24849:35;24843:41;;24839:72;;24895:3;24888:10;;;;;24906:2;24900:8;24839:72;24930:19;24924:2;:25;24920:55;;24960:2;24953:9;;;;;24970:2;24964:8;24920:55;24994:11;24988:2;:17;24984:47;;25016:2;25009:9;;;;;25026:2;25020:8;24984:47;25050:7;25044:2;:13;25040:42;;25068:2;25061:9;;;;;25078:1;25072:7;25040:42;25101:5;25095:2;:11;25091:39;;25117:1;25110:8;;;;;25126:1;25120:7;25091:39;25149:4;25143:2;:10;25139:38;;25164:1;25157:8;;;;;25173:1;25167:7;25139:38;25196:3;25190:2;:9;25186:27;;25209:1;25203:7;25186:27;25241:1;25235;25231;:5;;;;;:::i;:::-;;25227:1;:9;25226:16;;25222:20;;25271:1;25265;25261;:5;;;;;:::i;:::-;;25257:1;:9;25256:16;;25252:20;;25301:1;25295;25291;:5;;;;;:::i;:::-;;25287:1;:9;25286:16;;25282:20;;25331:1;25325;25321;:5;;;;;:::i;:::-;;25317:1;:9;25316:16;;25312:20;;25361:1;25355;25351;:5;;;;;:::i;:::-;;25347:1;:9;25346:16;;25342:20;;25391:1;25385;25381;:5;;;;;:::i;:::-;;25377:1;:9;25376:16;;25372:20;;25421:1;25415;25411;:5;;;;;:::i;:::-;;25407:1;:9;25406:16;;25402:20;;25469:10;25486:1;25482;:5;;;;;:::i;:::-;;25469:18;;25517:2;25513:1;:6;:15;;25526:2;25513:15;;;-1:-1:-1;25522:1:30;25497:32;-1:-1:-1;;;24667:881:30:o;-1:-1:-1:-;;;;;;;;;;;;;;;;;;;;;;;;:::o;:::-;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;:::o;14:184:101:-;66:77;63:1;56:88;163:4;160:1;153:15;187:4;184:1;177:15;203:248;270:2;264:9;312:4;300:17;;347:18;332:34;;368:22;;;329:62;326:88;;;394:18;;:::i;:::-;430:2;423:22;203:248;:::o;456:118::-;543:5;540:1;529:20;522:5;519:31;509:59;;564:1;561;554:12;509:59;456:118;:::o;579:558::-;636:5;684:4;672:9;667:3;663:19;659:30;656:50;;;702:1;699;692:12;656:50;724:17;;:::i;:::-;715:26;;778:9;765:23;797:31;820:7;797:31;:::i;:::-;837:22;;911:2;896:18;;883:32;924:31;883:32;924:31;:::i;:::-;982:2;971:14;;964:31;1047:2;1032:18;;1019:32;1060:31;1019:32;1060:31;:::i;:::-;1118:2;1107:14;;1100:31;1111:5;579:558;-1:-1:-1;;579:558:101:o;1142:233::-;1229:6;1282:2;1270:9;1261:7;1257:23;1253:32;1250:52;;;1298:1;1295;1288:12;1250:52;1321:48;1361:7;1350:9;1321:48;:::i;1562:980::-;1630:6;1683:2;1671:9;1662:7;1658:23;1654:32;1651:52;;;1699:1;1696;1689:12;1651:52;1739:9;1726:23;1768:18;1809:2;1801:6;1798:14;1795:34;;;1825:1;1822;1815:12;1795:34;1863:6;1852:9;1848:22;1838:32;;1908:7;1901:4;1897:2;1893:13;1889:27;1879:55;;1930:1;1927;1920:12;1879:55;1966:2;1953:16;1988:2;1984;1981:10;1978:36;;;1994:18;;:::i;:::-;2128:2;2122:9;2190:4;2182:13;;2033:66;2178:22;;;2202:2;2174:31;2170:40;2158:53;;;2226:18;;;2246:22;;;2223:46;2220:72;;;2272:18;;:::i;:::-;2312:10;2308:2;2301:22;2347:2;2339:6;2332:18;2387:7;2382:2;2377;2373;2369:11;2365:20;2362:33;2359:53;;;2408:1;2405;2398:12;2359:53;2464:2;2459;2455;2451:11;2446:2;2438:6;2434:15;2421:46;2509:1;2487:15;;;2504:2;2483:24;2476:35;;;;-1:-1:-1;2491:6:101;1562:980;-1:-1:-1;;;;;1562:980:101:o;2547:654::-;2657:4;2686:2;2715;2704:9;2697:21;2747:6;2741:13;2790:6;2785:2;2774:9;2770:18;2763:34;2815:1;2825:140;2839:6;2836:1;2833:13;2825:140;;;2934:14;;;2930:23;;2924:30;2900:17;;;2919:2;2896:26;2889:66;2854:10;;2825:140;;;2983:6;2980:1;2977:13;2974:91;;;3053:1;3048:2;3039:6;3028:9;3024:22;3020:31;3013:42;2974:91;-1:-1:-1;3117:2:101;3105:15;3122:66;3101:88;3086:104;;;;3192:2;3082:113;;2547:654;-1:-1:-1;;;2547:654:101:o;3206:302::-;3302:6;3310;3363:3;3351:9;3342:7;3338:23;3334:33;3331:53;;;3380:1;3377;3370:12;3331:53;3416:9;3403:23;3393:33;;3445:57;3494:7;3489:2;3478:9;3474:18;3445:57;:::i;:::-;3435:67;;3206:302;;;;;:::o;3744:309::-;3803:6;3856:2;3844:9;3835:7;3831:23;3827:32;3824:52;;;3872:1;3869;3862:12;3824:52;3911:9;3898:23;3961:42;3954:5;3950:54;3943:5;3940:65;3930:93;;4019:1;4016;4009:12;4058:809;4165:6;4173;4217:9;4208:7;4204:23;4247:3;4243:2;4239:12;4236:32;;;4264:1;4261;4254:12;4236:32;4293:9;4287:16;4277:26;;4396:4;4327:66;4323:2;4319:75;4315:86;4312:106;;;4414:1;4411;4404:12;4312:106;;4440:17;;:::i;:::-;4502:2;4491:9;4487:18;4481:25;4515:31;4538:7;4515:31;:::i;:::-;4555:22;;4622:2;4607:18;;4601:25;4635:31;4601:25;4635:31;:::i;:::-;4693:2;4682:14;;4675:31;4751:4;4736:20;;4730:27;4766:31;4730:27;4766:31;:::i;:::-;4824:2;4813:14;;4806:31;4058:809;;4817:5;;-1:-1:-1;4058:809:101;;-1:-1:-1;;4058:809:101:o;5352:184::-;5422:6;5475:2;5463:9;5454:7;5450:23;5446:32;5443:52;;;5491:1;5488;5481:12;5443:52;-1:-1:-1;5514:16:101;;5352:184;-1:-1:-1;5352:184:101:o;5880:::-;5932:77;5929:1;5922:88;6029:4;6026:1;6019:15;6053:4;6050:1;6043:15;6069:398;6107:4;6151:1;6148;6137:16;6187:1;6184;6173:16;6217:1;6212:3;6208:11;6328:3;6260:66;6256:76;6251:3;6247:86;6242:2;6235:10;6231:103;6228:129;;;6337:18;;:::i;:::-;6402:3;6390:10;6386:20;6381:3;6377:30;6373:2;6369:39;6366:65;;;6411:18;;:::i;:::-;-1:-1:-1;6448:13:101;;;6069:398;-1:-1:-1;;;6069:398:101:o;6472:184::-;6524:77;6521:1;6514:88;6621:4;6618:1;6611:15;6645:4;6642:1;6635:15;6661:184;6713:77;6710:1;6703:88;6810:4;6807:1;6800:15;6834:4;6831:1;6824:15;6850:396;6888:3;6931:1;6928;6917:16;6967:1;6964;6953:16;6997:1;6992:3;6988:11;7052:3;7040:10;7036:20;7031:3;7027:30;7022:2;7015:10;7011:47;7008:73;;;7061:18;;:::i;:::-;7182:3;7114:66;7110:76;7105:3;7101:86;7097:2;7093:95;7090:121;;;7191:18;;:::i;:::-;-1:-1:-1;7227:13:101;;6850:396;-1:-1:-1;;;6850:396:101:o;7706:279::-;7775:6;7828:2;7816:9;7807:7;7803:23;7799:32;7796:52;;;7844:1;7841;7834:12;7796:52;7876:9;7870:16;7930:5;7926:2;7915:21;7908:5;7905:32;7895:60;;7951:1;7948;7941:12;10344:369;10383:4;10419:1;10416;10412:9;10528:1;10460:66;10456:74;10453:1;10449:82;10444:2;10437:10;10433:99;10430:125;;;10535:18;;:::i;:::-;10654:1;10586:66;10582:74;10579:1;10575:82;10571:2;10567:91;10564:117;;;10661:18;;:::i;:::-;-1:-1:-1;;10698:9:101;;10344:369::o;10718:195::-;10757:3;10788:66;10781:5;10778:77;10775:103;;10858:18;;:::i;:::-;-1:-1:-1;10905:1:101;10894:13;;10718:195::o;10918:184::-;10970:77;10967:1;10960:88;11067:4;11064:1;11057:15;11091:4;11088:1;11081:15;11107:187;11146:1;11172:6;11205:2;11202:1;11198:10;11227:3;11217:37;;11234:18;;:::i;:::-;11272:10;;11268:20;;;;;11107:187;-1:-1:-1;;11107:187:101:o;11916:112::-;11948:1;11974;11964:35;;11979:18;;:::i;:::-;-1:-1:-1;12013:9:101;;11916:112::o;12033:389::-;12071:1;12112;12109;12098:16;12148:1;12145;12134:16;12169:3;12159:37;;12176:18;;:::i;:::-;12297:66;12292:3;12289:75;12220:66;12215:3;12212:75;12208:157;12205:183;;;12368:18;;:::i;:::-;12402:14;;;12033:389;-1:-1:-1;;;12033:389:101:o;12427:698::-;12465:7;12512:1;12509;12498:16;12548:1;12545;12534:16;12569:10;12607:1;12602:3;12598:11;12637:1;12632:3;12628:11;12684:3;12680:2;12676:12;12671:3;12668:21;12663:2;12659;12655:11;12651:39;12648:65;;;12693:18;;:::i;:::-;12732:66;12826:1;12821:3;12817:11;12875:3;12871:2;12866:13;12861:3;12857:23;12852:2;12848;12844:11;12840:41;12837:67;;;12884:18;;:::i;:::-;12932:1;12927:3;12923:11;12913:21;;12981:3;12977:2;12972:13;12967:3;12963:23;12958:2;12954;12950:11;12946:41;12943:67;;;12990:18;;:::i;:::-;13057:3;13053:2;13048:13;13043:3;13039:23;13034:2;13030;13026:11;13022:41;13019:67;;;13066:18;;:::i;:::-;-1:-1:-1;;;13106:13:101;;;;;12427:698;-1:-1:-1;;;;;12427:698:101:o;13130:125::-;13170:4;13198:1;13195;13192:8;13189:34;;;13203:18;;:::i;:::-;-1:-1:-1;13240:9:101;;13130:125::o;13634:166::-;13664:1;13705;13702;13691:16;13726:3;13716:37;;13733:18;;:::i;:::-;13790:3;13786:1;13783;13772:16;13767:27;13762:32;;;13634:166;;;;:::o",
    "linkReferences": {
      "../../node_modules/@latticexyz/noise/contracts/Perlin.sol": {
        "Perlin": [
          {
            "start": 3708,
            "length": 20
          },
          {
            "start": 3991,
            "length": 20
          },
          {
            "start": 4323,
            "length": 20
          },
          {
            "start": 4635,
            "length": 20
          },
          {
            "start": 4842,
            "length": 20
          },
          {
            "start": 5251,
            "length": 20
          },
          {
            "start": 16319,
            "length": 20
          }
        ]
      }
    }
  },
  "methodIdentifiers": {
    "Bedrock((int32,int32,int32))": "1c1f4ce2",
    "BlackFlower((int32,int32,int32))": "302edc21",
    "BlueFlower((int32,int32,int32))": "cabbf69d",
    "Clay((int32,int32,int32))": "05d5d596",
    "Coal((int32,int32,int32))": "f4363c64",
    "CyanFlower((int32,int32,int32))": "810effe2",
    "Diamond((int32,int32,int32))": "17ab6daf",
    "Dirt((int32,int32,int32))": "d7170261",
    "Grass((int32,int32,int32))": "096d22b1",
    "GrassPlant((int32,int32,int32))": "55b97448",
    "GrayFlower((int32,int32,int32))": "c072d8b8",
    "GreenFlower((int32,int32,int32))": "fa6b73bd",
    "Kelp((int32,int32,int32))": "7183fcce",
    "Leaves((int32,int32,int32))": "94d6c851",
    "LightBlueFlower((int32,int32,int32))": "627b74cd",
    "LightGrayFlower((int32,int32,int32))": "87792459",
    "LimeFlower((int32,int32,int32))": "e99252bf",
    "Log((int32,int32,int32))": "e46d4664",
    "MagentaFlower((int32,int32,int32))": "5ebd349c",
    "OrangeFlower((int32,int32,int32))": "ed7eec3b",
    "PinkFlower((int32,int32,int32))": "033351ae",
    "PurpleFlower((int32,int32,int32))": "e0ce03f7",
    "RedFlower((int32,int32,int32))": "f41d4a58",
    "Sand((int32,int32,int32))": "eca4c278",
    "Snow((int32,int32,int32))": "25cd4d47",
    "Stone((int32,int32,int32))": "35e69f35",
    "Water((int32,int32,int32))": "ae763fa8",
    "Wool((int32,int32,int32))": "b2f30942",
    "execute(bytes)": "09c5eabe",
    "executeTyped(uint256,(int32,int32,int32))": "86bcb2ec",
    "owner()": "8da5cb5b",
    "transferOwnership(address)": "f2fde38b"
  },
  "rawMetadata": "{\"compiler\":{\"version\":\"0.8.13+commit.abaa5c0e\"},\"language\":\"Solidity\",\"output\":{\"abi\":[{\"inputs\":[{\"internalType\":\"contract IWorld\",\"name\":\"_world\",\"type\":\"address\"},{\"internalType\":\"address\",\"name\":\"_components\",\"type\":\"address\"}],\"stateMutability\":\"nonpayable\",\"type\":\"constructor\"},{\"anonymous\":false,\"inputs\":[{\"indexed\":true,\"internalType\":\"address\",\"name\":\"previousOwner\",\"type\":\"address\"},{\"indexed\":true,\"internalType\":\"address\",\"name\":\"newOwner\",\"type\":\"address\"}],\"name\":\"OwnershipTransferred\",\"type\":\"event\"},{\"inputs\":[{\"components\":[{\"internalType\":\"int32\",\"name\":\"x\",\"type\":\"int32\"},{\"internalType\":\"int32\",\"name\":\"y\",\"type\":\"int32\"},{\"internalType\":\"int32\",\"name\":\"z\",\"type\":\"int32\"}],\"internalType\":\"struct VoxelCoord\",\"name\":\"coord\",\"type\":\"tuple\"}],\"name\":\"Bedrock\",\"outputs\":[{\"internalType\":\"uint256\",\"name\":\"\",\"type\":\"uint256\"}],\"stateMutability\":\"pure\",\"type\":\"function\"},{\"inputs\":[{\"components\":[{\"internalType\":\"int32\",\"name\":\"x\",\"type\":\"int32\"},{\"internalType\":\"int32\",\"name\":\"y\",\"type\":\"int32\"},{\"internalType\":\"int32\",\"name\":\"z\",\"type\":\"int32\"}],\"internalType\":\"struct VoxelCoord\",\"name\":\"coord\",\"type\":\"tuple\"}],\"name\":\"BlackFlower\",\"outputs\":[{\"internalType\":\"uint256\",\"name\":\"\",\"type\":\"uint256\"}],\"stateMutability\":\"pure\",\"type\":\"function\"},{\"inputs\":[{\"components\":[{\"internalType\":\"int32\",\"name\":\"x\",\"type\":\"int32\"},{\"internalType\":\"int32\",\"name\":\"y\",\"type\":\"int32\"},{\"internalType\":\"int32\",\"name\":\"z\",\"type\":\"int32\"}],\"internalType\":\"struct VoxelCoord\",\"name\":\"coord\",\"type\":\"tuple\"}],\"name\":\"BlueFlower\",\"outputs\":[{\"internalType\":\"uint256\",\"name\":\"\",\"type\":\"uint256\"}],\"stateMutability\":\"pure\",\"type\":\"function\"},{\"inputs\":[{\"components\":[{\"internalType\":\"int32\",\"name\":\"x\",\"type\":\"int32\"},{\"internalType\":\"int32\",\"name\":\"y\",\"type\":\"int32\"},{\"internalType\":\"int32\",\"name\":\"z\",\"type\":\"int32\"}],\"internalType\":\"struct VoxelCoord\",\"name\":\"coord\",\"type\":\"tuple\"}],\"name\":\"Clay\",\"outputs\":[{\"internalType\":\"uint256\",\"name\":\"\",\"type\":\"uint256\"}],\"stateMutability\":\"pure\",\"type\":\"function\"},{\"inputs\":[{\"components\":[{\"internalType\":\"int32\",\"name\":\"x\",\"type\":\"int32\"},{\"internalType\":\"int32\",\"name\":\"y\",\"type\":\"int32\"},{\"internalType\":\"int32\",\"name\":\"z\",\"type\":\"int32\"}],\"internalType\":\"struct VoxelCoord\",\"name\":\"coord\",\"type\":\"tuple\"}],\"name\":\"Coal\",\"outputs\":[{\"internalType\":\"uint256\",\"name\":\"\",\"type\":\"uint256\"}],\"stateMutability\":\"pure\",\"type\":\"function\"},{\"inputs\":[{\"components\":[{\"internalType\":\"int32\",\"name\":\"x\",\"type\":\"int32\"},{\"internalType\":\"int32\",\"name\":\"y\",\"type\":\"int32\"},{\"internalType\":\"int32\",\"name\":\"z\",\"type\":\"int32\"}],\"internalType\":\"struct VoxelCoord\",\"name\":\"coord\",\"type\":\"tuple\"}],\"name\":\"CyanFlower\",\"outputs\":[{\"internalType\":\"uint256\",\"name\":\"\",\"type\":\"uint256\"}],\"stateMutability\":\"pure\",\"type\":\"function\"},{\"inputs\":[{\"components\":[{\"internalType\":\"int32\",\"name\":\"x\",\"type\":\"int32\"},{\"internalType\":\"int32\",\"name\":\"y\",\"type\":\"int32\"},{\"internalType\":\"int32\",\"name\":\"z\",\"type\":\"int32\"}],\"internalType\":\"struct VoxelCoord\",\"name\":\"coord\",\"type\":\"tuple\"}],\"name\":\"Diamond\",\"outputs\":[{\"internalType\":\"uint256\",\"name\":\"\",\"type\":\"uint256\"}],\"stateMutability\":\"pure\",\"type\":\"function\"},{\"inputs\":[{\"components\":[{\"internalType\":\"int32\",\"name\":\"x\",\"type\":\"int32\"},{\"internalType\":\"int32\",\"name\":\"y\",\"type\":\"int32\"},{\"internalType\":\"int32\",\"name\":\"z\",\"type\":\"int32\"}],\"internalType\":\"struct VoxelCoord\",\"name\":\"coord\",\"type\":\"tuple\"}],\"name\":\"Dirt\",\"outputs\":[{\"internalType\":\"uint256\",\"name\":\"\",\"type\":\"uint256\"}],\"stateMutability\":\"pure\",\"type\":\"function\"},{\"inputs\":[{\"components\":[{\"internalType\":\"int32\",\"name\":\"x\",\"type\":\"int32\"},{\"internalType\":\"int32\",\"name\":\"y\",\"type\":\"int32\"},{\"internalType\":\"int32\",\"name\":\"z\",\"type\":\"int32\"}],\"internalType\":\"struct VoxelCoord\",\"name\":\"coord\",\"type\":\"tuple\"}],\"name\":\"Grass\",\"outputs\":[{\"internalType\":\"uint256\",\"name\":\"\",\"type\":\"uint256\"}],\"stateMutability\":\"pure\",\"type\":\"function\"},{\"inputs\":[{\"components\":[{\"internalType\":\"int32\",\"name\":\"x\",\"type\":\"int32\"},{\"internalType\":\"int32\",\"name\":\"y\",\"type\":\"int32\"},{\"internalType\":\"int32\",\"name\":\"z\",\"type\":\"int32\"}],\"internalType\":\"struct VoxelCoord\",\"name\":\"coord\",\"type\":\"tuple\"}],\"name\":\"GrassPlant\",\"outputs\":[{\"internalType\":\"uint256\",\"name\":\"\",\"type\":\"uint256\"}],\"stateMutability\":\"pure\",\"type\":\"function\"},{\"inputs\":[{\"components\":[{\"internalType\":\"int32\",\"name\":\"x\",\"type\":\"int32\"},{\"internalType\":\"int32\",\"name\":\"y\",\"type\":\"int32\"},{\"internalType\":\"int32\",\"name\":\"z\",\"type\":\"int32\"}],\"internalType\":\"struct VoxelCoord\",\"name\":\"coord\",\"type\":\"tuple\"}],\"name\":\"GrayFlower\",\"outputs\":[{\"internalType\":\"uint256\",\"name\":\"\",\"type\":\"uint256\"}],\"stateMutability\":\"pure\",\"type\":\"function\"},{\"inputs\":[{\"components\":[{\"internalType\":\"int32\",\"name\":\"x\",\"type\":\"int32\"},{\"internalType\":\"int32\",\"name\":\"y\",\"type\":\"int32\"},{\"internalType\":\"int32\",\"name\":\"z\",\"type\":\"int32\"}],\"internalType\":\"struct VoxelCoord\",\"name\":\"coord\",\"type\":\"tuple\"}],\"name\":\"GreenFlower\",\"outputs\":[{\"internalType\":\"uint256\",\"name\":\"\",\"type\":\"uint256\"}],\"stateMutability\":\"pure\",\"type\":\"function\"},{\"inputs\":[{\"components\":[{\"internalType\":\"int32\",\"name\":\"x\",\"type\":\"int32\"},{\"internalType\":\"int32\",\"name\":\"y\",\"type\":\"int32\"},{\"internalType\":\"int32\",\"name\":\"z\",\"type\":\"int32\"}],\"internalType\":\"struct VoxelCoord\",\"name\":\"coord\",\"type\":\"tuple\"}],\"name\":\"Kelp\",\"outputs\":[{\"internalType\":\"uint256\",\"name\":\"\",\"type\":\"uint256\"}],\"stateMutability\":\"pure\",\"type\":\"function\"},{\"inputs\":[{\"components\":[{\"internalType\":\"int32\",\"name\":\"x\",\"type\":\"int32\"},{\"internalType\":\"int32\",\"name\":\"y\",\"type\":\"int32\"},{\"internalType\":\"int32\",\"name\":\"z\",\"type\":\"int32\"}],\"internalType\":\"struct VoxelCoord\",\"name\":\"coord\",\"type\":\"tuple\"}],\"name\":\"Leaves\",\"outputs\":[{\"internalType\":\"uint256\",\"name\":\"\",\"type\":\"uint256\"}],\"stateMutability\":\"pure\",\"type\":\"function\"},{\"inputs\":[{\"components\":[{\"internalType\":\"int32\",\"name\":\"x\",\"type\":\"int32\"},{\"internalType\":\"int32\",\"name\":\"y\",\"type\":\"int32\"},{\"internalType\":\"int32\",\"name\":\"z\",\"type\":\"int32\"}],\"internalType\":\"struct VoxelCoord\",\"name\":\"coord\",\"type\":\"tuple\"}],\"name\":\"LightBlueFlower\",\"outputs\":[{\"internalType\":\"uint256\",\"name\":\"\",\"type\":\"uint256\"}],\"stateMutability\":\"pure\",\"type\":\"function\"},{\"inputs\":[{\"components\":[{\"internalType\":\"int32\",\"name\":\"x\",\"type\":\"int32\"},{\"internalType\":\"int32\",\"name\":\"y\",\"type\":\"int32\"},{\"internalType\":\"int32\",\"name\":\"z\",\"type\":\"int32\"}],\"internalType\":\"struct VoxelCoord\",\"name\":\"coord\",\"type\":\"tuple\"}],\"name\":\"LightGrayFlower\",\"outputs\":[{\"internalType\":\"uint256\",\"name\":\"\",\"type\":\"uint256\"}],\"stateMutability\":\"pure\",\"type\":\"function\"},{\"inputs\":[{\"components\":[{\"internalType\":\"int32\",\"name\":\"x\",\"type\":\"int32\"},{\"internalType\":\"int32\",\"name\":\"y\",\"type\":\"int32\"},{\"internalType\":\"int32\",\"name\":\"z\",\"type\":\"int32\"}],\"internalType\":\"struct VoxelCoord\",\"name\":\"coord\",\"type\":\"tuple\"}],\"name\":\"LimeFlower\",\"outputs\":[{\"internalType\":\"uint256\",\"name\":\"\",\"type\":\"uint256\"}],\"stateMutability\":\"pure\",\"type\":\"function\"},{\"inputs\":[{\"components\":[{\"internalType\":\"int32\",\"name\":\"x\",\"type\":\"int32\"},{\"internalType\":\"int32\",\"name\":\"y\",\"type\":\"int32\"},{\"internalType\":\"int32\",\"name\":\"z\",\"type\":\"int32\"}],\"internalType\":\"struct VoxelCoord\",\"name\":\"coord\",\"type\":\"tuple\"}],\"name\":\"Log\",\"outputs\":[{\"internalType\":\"uint256\",\"name\":\"\",\"type\":\"uint256\"}],\"stateMutability\":\"pure\",\"type\":\"function\"},{\"inputs\":[{\"components\":[{\"internalType\":\"int32\",\"name\":\"x\",\"type\":\"int32\"},{\"internalType\":\"int32\",\"name\":\"y\",\"type\":\"int32\"},{\"internalType\":\"int32\",\"name\":\"z\",\"type\":\"int32\"}],\"internalType\":\"struct VoxelCoord\",\"name\":\"coord\",\"type\":\"tuple\"}],\"name\":\"MagentaFlower\",\"outputs\":[{\"internalType\":\"uint256\",\"name\":\"\",\"type\":\"uint256\"}],\"stateMutability\":\"pure\",\"type\":\"function\"},{\"inputs\":[{\"components\":[{\"internalType\":\"int32\",\"name\":\"x\",\"type\":\"int32\"},{\"internalType\":\"int32\",\"name\":\"y\",\"type\":\"int32\"},{\"internalType\":\"int32\",\"name\":\"z\",\"type\":\"int32\"}],\"internalType\":\"struct VoxelCoord\",\"name\":\"coord\",\"type\":\"tuple\"}],\"name\":\"OrangeFlower\",\"outputs\":[{\"internalType\":\"uint256\",\"name\":\"\",\"type\":\"uint256\"}],\"stateMutability\":\"pure\",\"type\":\"function\"},{\"inputs\":[{\"components\":[{\"internalType\":\"int32\",\"name\":\"x\",\"type\":\"int32\"},{\"internalType\":\"int32\",\"name\":\"y\",\"type\":\"int32\"},{\"internalType\":\"int32\",\"name\":\"z\",\"type\":\"int32\"}],\"internalType\":\"struct VoxelCoord\",\"name\":\"coord\",\"type\":\"tuple\"}],\"name\":\"PinkFlower\",\"outputs\":[{\"internalType\":\"uint256\",\"name\":\"\",\"type\":\"uint256\"}],\"stateMutability\":\"pure\",\"type\":\"function\"},{\"inputs\":[{\"components\":[{\"internalType\":\"int32\",\"name\":\"x\",\"type\":\"int32\"},{\"internalType\":\"int32\",\"name\":\"y\",\"type\":\"int32\"},{\"internalType\":\"int32\",\"name\":\"z\",\"type\":\"int32\"}],\"internalType\":\"struct VoxelCoord\",\"name\":\"coord\",\"type\":\"tuple\"}],\"name\":\"PurpleFlower\",\"outputs\":[{\"internalType\":\"uint256\",\"name\":\"\",\"type\":\"uint256\"}],\"stateMutability\":\"pure\",\"type\":\"function\"},{\"inputs\":[{\"components\":[{\"internalType\":\"int32\",\"name\":\"x\",\"type\":\"int32\"},{\"internalType\":\"int32\",\"name\":\"y\",\"type\":\"int32\"},{\"internalType\":\"int32\",\"name\":\"z\",\"type\":\"int32\"}],\"internalType\":\"struct VoxelCoord\",\"name\":\"coord\",\"type\":\"tuple\"}],\"name\":\"RedFlower\",\"outputs\":[{\"internalType\":\"uint256\",\"name\":\"\",\"type\":\"uint256\"}],\"stateMutability\":\"pure\",\"type\":\"function\"},{\"inputs\":[{\"components\":[{\"internalType\":\"int32\",\"name\":\"x\",\"type\":\"int32\"},{\"internalType\":\"int32\",\"name\":\"y\",\"type\":\"int32\"},{\"internalType\":\"int32\",\"name\":\"z\",\"type\":\"int32\"}],\"internalType\":\"struct VoxelCoord\",\"name\":\"coord\",\"type\":\"tuple\"}],\"name\":\"Sand\",\"outputs\":[{\"internalType\":\"uint256\",\"name\":\"\",\"type\":\"uint256\"}],\"stateMutability\":\"pure\",\"type\":\"function\"},{\"inputs\":[{\"components\":[{\"internalType\":\"int32\",\"name\":\"x\",\"type\":\"int32\"},{\"internalType\":\"int32\",\"name\":\"y\",\"type\":\"int32\"},{\"internalType\":\"int32\",\"name\":\"z\",\"type\":\"int32\"}],\"internalType\":\"struct VoxelCoord\",\"name\":\"coord\",\"type\":\"tuple\"}],\"name\":\"Snow\",\"outputs\":[{\"internalType\":\"uint256\",\"name\":\"\",\"type\":\"uint256\"}],\"stateMutability\":\"pure\",\"type\":\"function\"},{\"inputs\":[{\"components\":[{\"internalType\":\"int32\",\"name\":\"x\",\"type\":\"int32\"},{\"internalType\":\"int32\",\"name\":\"y\",\"type\":\"int32\"},{\"internalType\":\"int32\",\"name\":\"z\",\"type\":\"int32\"}],\"internalType\":\"struct VoxelCoord\",\"name\":\"coord\",\"type\":\"tuple\"}],\"name\":\"Stone\",\"outputs\":[{\"internalType\":\"uint256\",\"name\":\"\",\"type\":\"uint256\"}],\"stateMutability\":\"pure\",\"type\":\"function\"},{\"inputs\":[{\"components\":[{\"internalType\":\"int32\",\"name\":\"x\",\"type\":\"int32\"},{\"internalType\":\"int32\",\"name\":\"y\",\"type\":\"int32\"},{\"internalType\":\"int32\",\"name\":\"z\",\"type\":\"int32\"}],\"internalType\":\"struct VoxelCoord\",\"name\":\"coord\",\"type\":\"tuple\"}],\"name\":\"Water\",\"outputs\":[{\"internalType\":\"uint256\",\"name\":\"\",\"type\":\"uint256\"}],\"stateMutability\":\"pure\",\"type\":\"function\"},{\"inputs\":[{\"components\":[{\"internalType\":\"int32\",\"name\":\"x\",\"type\":\"int32\"},{\"internalType\":\"int32\",\"name\":\"y\",\"type\":\"int32\"},{\"internalType\":\"int32\",\"name\":\"z\",\"type\":\"int32\"}],\"internalType\":\"struct VoxelCoord\",\"name\":\"coord\",\"type\":\"tuple\"}],\"name\":\"Wool\",\"outputs\":[{\"internalType\":\"uint256\",\"name\":\"\",\"type\":\"uint256\"}],\"stateMutability\":\"pure\",\"type\":\"function\"},{\"inputs\":[{\"internalType\":\"bytes\",\"name\":\"arguments\",\"type\":\"bytes\"}],\"name\":\"execute\",\"outputs\":[{\"internalType\":\"bytes\",\"name\":\"\",\"type\":\"bytes\"}],\"stateMutability\":\"pure\",\"type\":\"function\"},{\"inputs\":[{\"internalType\":\"uint256\",\"name\":\"blockType\",\"type\":\"uint256\"},{\"components\":[{\"internalType\":\"int32\",\"name\":\"x\",\"type\":\"int32\"},{\"internalType\":\"int32\",\"name\":\"y\",\"type\":\"int32\"},{\"internalType\":\"int32\",\"name\":\"z\",\"type\":\"int32\"}],\"internalType\":\"struct VoxelCoord\",\"name\":\"coord\",\"type\":\"tuple\"}],\"name\":\"executeTyped\",\"outputs\":[{\"internalType\":\"uint256\",\"name\":\"\",\"type\":\"uint256\"}],\"stateMutability\":\"pure\",\"type\":\"function\"},{\"inputs\":[],\"name\":\"owner\",\"outputs\":[{\"internalType\":\"address\",\"name\":\"\",\"type\":\"address\"}],\"stateMutability\":\"view\",\"type\":\"function\"},{\"inputs\":[{\"internalType\":\"address\",\"name\":\"newOwner\",\"type\":\"address\"}],\"name\":\"transferOwnership\",\"outputs\":[],\"stateMutability\":\"nonpayable\",\"type\":\"function\"}],\"devdoc\":{\"kind\":\"dev\",\"methods\":{\"owner()\":{\"returns\":{\"_0\":\"The address of the owner.\"}}},\"version\":1},\"userdoc\":{\"kind\":\"user\",\"methods\":{\"owner()\":{\"notice\":\"Get the address of the owner\"}},\"version\":1}},\"settings\":{\"compilationTarget\":{\"src/systems/OccurrenceSystem.sol\":\"OccurrenceSystem\"},\"evmVersion\":\"london\",\"libraries\":{},\"metadata\":{\"bytecodeHash\":\"ipfs\"},\"optimizer\":{\"enabled\":true,\"runs\":1000000},\"remappings\":[\":@latticexyz/=../../node_modules/@latticexyz/\",\":@manifoldxyz/=../../node_modules/@manifoldxyz/\",\":@opengsn/=../../node_modules/@opengsn/\",\":@openzeppelin/=../../node_modules/openzeppelin-solidity/\",\":@rari-capital/=../../node_modules/@rari-capital/\",\":abdk-libraries-solidity/=../../node_modules/abdk-libraries-solidity/\",\":base64-sol/=../../node_modules/base64-sol/\",\":base64/=../../node_modules/base64-sol/\",\":components/=src/components/\",\":ds-test/=../../node_modules/ds-test/src/\",\":forge-std/=../../node_modules/forge-std/src/\",\":gsn/=../../node_modules/@opengsn/contracts/src/\",\":hardhat-deploy/=../../node_modules/hardhat-deploy/\",\":hardhat/=../../node_modules/hardhat/\",\":libraries/=src/libraries/\",\":memmove/=../../node_modules/memmove/src/\",\":noise/=../../node_modules/@latticexyz/noise/contracts/\",\":openzeppelin-solidity/=../../node_modules/openzeppelin-solidity/\",\":persona/=../../node_modules/@latticexyz/persona/src/\",\":royalty-registry/=../../node_modules/@manifoldxyz/royalty-registry-solidity/contracts/\",\":solecs/=../../node_modules/@latticexyz/solecs/src/\",\":solmate/=../../node_modules/@rari-capital/solmate/src/\",\":std-contracts/=../../node_modules/@latticexyz/std-contracts/src/\",\":systems/=src/systems/\"]},\"sources\":{\"../../node_modules/@latticexyz/noise/contracts/Perlin.sol\":{\"keccak256\":\"0xe11773108f221ecffb6644f7ca0dee4b02ce34d4a09f6614bbd62ac375f894db\",\"license\":\"MIT\",\"urls\":[\"bzz-raw://ace8d328d7e31bd9b0197b609d3d50c343f63214fe8a0c76c15e448b33a7f60c\",\"dweb:/ipfs/QmdyYqmv3JL82GV8qBUipLriv2u7TcjWKr2xK7nxo9ZBgG\"]},\"../../node_modules/@latticexyz/solecs/src/BareComponent.sol\":{\"keccak256\":\"0xba9ac6f0758cc098046c74ad02b520e0e45c27e35aa6865b4ec806981c6be786\",\"license\":\"MIT\",\"urls\":[\"bzz-raw://0f53e408345b49f552468bb3958e7699898595856effb1355e053abe9b77f671\",\"dweb:/ipfs/QmcP9DPKdc97Si8CvymPz6bUfjcNmhiQytAdQ7xPF5EV9g\"]},\"../../node_modules/@latticexyz/solecs/src/Component.sol\":{\"keccak256\":\"0x40085c2f86bf6be7a756015025477aa46308b1618083ece93ae13093881a6874\",\"license\":\"MIT\",\"urls\":[\"bzz-raw://ca8653540b5674e50abfd4b4898009b472fc7fd2fba456146c1a1c44b615d83a\",\"dweb:/ipfs/QmSqbRng5fHuGUKgkFuNw3BfoefNteYU95sYi4g9QjCCNh\"]},\"../../node_modules/@latticexyz/solecs/src/LibTypes.sol\":{\"keccak256\":\"0xa3898035fd9fa865bcfc9861e3b5ecce36be3196fb27705e50a02fed9831f102\",\"license\":\"MIT\",\"urls\":[\"bzz-raw://273284a35a950f6d0bc4223d345cf46c59972a00510ddbc4ba695ede38714798\",\"dweb:/ipfs/QmdqzKMaAfKWfBzUsrzsDMWnyxSKJRuEvrc6VTR5VarQaH\"]},\"../../node_modules/@latticexyz/solecs/src/MapSet.sol\":{\"keccak256\":\"0x903c895b873785da7c3f8e17ebe0c176bb4a0987ff2f70f7b4df8872a7d1bd99\",\"license\":\"MIT\",\"urls\":[\"bzz-raw://37a91b47ec383af7462368a29e8c01532e87eaa3c56077dab1f73e00c2fe25d5\",\"dweb:/ipfs/QmaukFM1GkNxMhK4LiCCWouJxzHpq2mznM8jLvr19o8ukr\"]},\"../../node_modules/@latticexyz/solecs/src/Set.sol\":{\"keccak256\":\"0xd4e1ac0608efb071ee64b15cdaec8c83e684d305d673702cacab98a2721d210d\",\"license\":\"MIT\",\"urls\":[\"bzz-raw://1f083400292163c7b0c717d66f2d200ac38995019d695ba5c0568547f7f96051\",\"dweb:/ipfs/QmSGp7TeKHi5eb2ELU1qH7Qfjs4kjyMGfTTXUw9iPaq6UE\"]},\"../../node_modules/@latticexyz/solecs/src/System.sol\":{\"keccak256\":\"0x5ff430169885d31cb4d41ccf5ba8ac1f0815d3bb1b9dc9afcf9afd6a7203e7c7\",\"license\":\"MIT\",\"urls\":[\"bzz-raw://59892068a9b62d8c01d272ea5de2e8f2932a7ea87acce9b6eaccfae00dad8e66\",\"dweb:/ipfs/QmfEdTjYkdHfueS527ibx3Ni8X3yqgQHtbRB1anDTsMGBN\"]},\"../../node_modules/@latticexyz/solecs/src/constants.sol\":{\"keccak256\":\"0x024a3ff3077a272339b7baa96b826fd75f040d7cd2c6e13b9c8cf7ad16f789b8\",\"license\":\"MIT\",\"urls\":[\"bzz-raw://1ddcb26a7703e9b03b34d5465010a4ae5ced137021c94987053544ad1156a644\",\"dweb:/ipfs/QmYue4gnb8noyoxxTchs5chZji7DKynKMp2x33RgRW6xqZ\"]},\"../../node_modules/@latticexyz/solecs/src/interfaces/IComponent.sol\":{\"keccak256\":\"0x4513448bb0d45050f8af0a2ead426b27a5d5ca73d38c6874e909f852ad2232e6\",\"license\":\"MIT\",\"urls\":[\"bzz-raw://e5c215b87500c80ffb525142b753a4f3454a69cf11b9b68f6a29f1a4dd4a2ced\",\"dweb:/ipfs/Qmd4YYoYJTrgyQU8zcfJFDdYQA29DarkdL8k5obyGgbp2K\"]},\"../../node_modules/@latticexyz/solecs/src/interfaces/IERC173.sol\":{\"keccak256\":\"0xc8fa875a59c2010265d7fc5663d9d37e6b5f9b556b6bfdeeb7ec9355ee3169c7\",\"license\":\"MIT\",\"urls\":[\"bzz-raw://33d944c6ff71c7afe4d21db8f4077e419f165100bbfd8b6c8d4b975015ec6c82\",\"dweb:/ipfs/QmY461W1TtyjkkcUuxPHUtJ3LxzD1iaU422FkFhtHHuRQh\"]},\"../../node_modules/@latticexyz/solecs/src/interfaces/IEntityContainer.sol\":{\"keccak256\":\"0x4506db1dcbdbe68a397107a57bfa3da888a889f14181a90eb728cfecc60700b8\",\"license\":\"MIT\",\"urls\":[\"bzz-raw://23f5c02d110f5abf6340a08a2a8b7e0b5668f211fe6baf41213e6c4f69dece10\",\"dweb:/ipfs/QmYfKeZMeEUNExsxjkCF5nGdw8KRyPe1t5tcGFTEkP7CkV\"]},\"../../node_modules/@latticexyz/solecs/src/interfaces/IEntityIndexer.sol\":{\"keccak256\":\"0xd89023b2a5e9961be3c9d49d9f7f9ac7dcc416e3f43a8758dc058d1db2eea6b5\",\"license\":\"MIT\",\"urls\":[\"bzz-raw://3266ea1dd5a7f372f8814db24ac4981730f66fba8e6f90f614246ca5cec529b4\",\"dweb:/ipfs/QmQ71BtaBsDjfke46dndaTBVhyXAHxs5qs7d9GHJwVXuvw\"]},\"../../node_modules/@latticexyz/solecs/src/interfaces/ISystem.sol\":{\"keccak256\":\"0x62af78f49b90c7c23ad677e4090c5c916e1c2e36b13be07887b371ba732294c9\",\"license\":\"MIT\",\"urls\":[\"bzz-raw://c8c0849bc60d65a4578a66b8d0052b584e8b43838b78bc2c2579113f625cd05a\",\"dweb:/ipfs/Qma8pxGUAupCkTJYjXeHV9i4qvjnMP9s8zi5rs6FDrDuy7\"]},\"../../node_modules/@latticexyz/solecs/src/interfaces/IUint256Component.sol\":{\"keccak256\":\"0x12e2eaa4c5663048343e43a1994c446baacb16a4aacbe314ed5202d878751be9\",\"license\":\"MIT\",\"urls\":[\"bzz-raw://2d78184a1b1868773f2d5a7cf54bb42bccc666dc75cea14eeed15b8573fd000f\",\"dweb:/ipfs/QmemXPHPB7V8StWR8kZcKt3eDxB78sZFZW4Dp7TcEFTxx9\"]},\"../../node_modules/@latticexyz/solecs/src/interfaces/IWorld.sol\":{\"keccak256\":\"0x319806cf4ed67acdd9f444ac581486e157ea06bceb8e727c6d745c165e0d9aae\",\"license\":\"MIT\",\"urls\":[\"bzz-raw://9b2cb8ec879279c74b384f169595e50fd1850ce63275447748d9150dfa9a85be\",\"dweb:/ipfs/QmNPQBfqVg3iDF2qE8KTJWx1zbpJjnzteNYiqGxtBye2q2\"]},\"../../node_modules/@latticexyz/solecs/src/interfaces/Query.sol\":{\"keccak256\":\"0xd11a3268514fceac97995d481017e49b18835e31ce3540e5f21c24df33e4bc2c\",\"license\":\"MIT\",\"urls\":[\"bzz-raw://841dd95a4f5e89f0451a72544a47eb16be41b8005dadfe98a82054db3eb41ab7\",\"dweb:/ipfs/QmScv2neVyCeoCmMZyRyYcqD5QwauuoWmkixyxw4qftEeR\"]},\"../../node_modules/@latticexyz/solecs/src/utils.sol\":{\"keccak256\":\"0x17f7831c03bdd77f0c7d98c94931d830fbbfa1878c365f54b12841c85611e24e\",\"license\":\"MIT\",\"urls\":[\"bzz-raw://6ae566ee03c5050b239277ef4184b9e5dcb332c8cc65b032f8e0d9e46408ea6d\",\"dweb:/ipfs/QmetdhxahRf7FJk1kn8KgDmizU2zYk3jjt9qo6Gwz2M5YP\"]},\"../../node_modules/@latticexyz/std-contracts/src/components/BoolBareComponent.sol\":{\"keccak256\":\"0x7975dfdab87f3287fff86dd7e4e9366ad69c7660d1859c32c053a88f9a0cd1d6\",\"license\":\"MIT\",\"urls\":[\"bzz-raw://05070aeb4b877427a8f28c12b3885cfac1ea9ed5c38f10be141dea96d1fe0fd5\",\"dweb:/ipfs/QmcsRU2bW6FrerGkq7uESKZwgKKUPxyMHTtTvY9rz62i3j\"]},\"../../node_modules/@latticexyz/std-contracts/src/components/FunctionBareComponent.sol\":{\"keccak256\":\"0x2b6a34415d2cae3bc82cc3933785939d3fdf70804f740080bb8cd66533c383be\",\"license\":\"MIT\",\"urls\":[\"bzz-raw://1e846a49c4e2bf2684d8ef42faaad6ac5a6260da2d23da86ba4aa26ba4f7bea4\",\"dweb:/ipfs/QmZM4nRE6iGdwrPYZjigKvaFB7dqStAtm7s6PoBmQ23oCS\"]},\"../../node_modules/@latticexyz/std-contracts/src/components/Uint256BareComponent.sol\":{\"keccak256\":\"0x3c1174880052b94f112dab23e77afde149254c1ad3749d82c7fd81bf4d09483d\",\"license\":\"MIT\",\"urls\":[\"bzz-raw://734c3d8d09e5788bdc3a6133abe3789600afe8d896d2909e9526841bc4992ec4\",\"dweb:/ipfs/QmUgtiKgFit3StevWYBQe3k3woWm4uvwoWZmuSDvV1kRwJ\"]},\"../../node_modules/@latticexyz/std-contracts/src/components/VoxelCoordComponent.sol\":{\"keccak256\":\"0x55024a280a54e1d6b08f66b3f6ff19c7571cc62f87e4b4eedcef3dd1e2cae3bb\",\"license\":\"MIT\",\"urls\":[\"bzz-raw://baa31b72a6ea57c6707d9480390675f38de35386ba4df5f4835e90d563d9bad3\",\"dweb:/ipfs/QmbuE9dQPZAJKBUFhWq3wayPjDehEwDbiZB9ZAsrkM1k49\"]},\"../../node_modules/abdk-libraries-solidity/ABDKMath64x64.sol\":{\"keccak256\":\"0x089b21db72314836305ba36b1773c3f0c2d5ac3a0f418820557c17c0e57c3c50\",\"license\":\"BSD-4-Clause\",\"urls\":[\"bzz-raw://730ce8d750b0a6588f0d0724ace1c4d6dd90cf6dc0d2805b775b065fce147dfa\",\"dweb:/ipfs/Qmdx7xRKvhXu1JtAVs25bER3LN2oGj2ZjW8jEvJpzQyXhc\"]},\"../../node_modules/memmove/src/Array.sol\":{\"keccak256\":\"0x0d7681d3392c34f811cebc9598c5e8f4eef6aba431dca9e1fa87267ba51a4515\",\"license\":\"MIT\",\"urls\":[\"bzz-raw://0ffb5179dd40ccacadc2cb26ac99e9ea5148796f6d21413d7e0f37913831bea1\",\"dweb:/ipfs/QmfJogaoqook5JgnUZKib6w6khzViUag3EQb1EZ8aUEasQ\"]},\"../../node_modules/memmove/src/LinkedList.sol\":{\"keccak256\":\"0x2374863d39689178dda92b841e77b835ba8fa550561be23b7861d2e52c0fe8c1\",\"license\":\"MIT\",\"urls\":[\"bzz-raw://8538ec6ca6be4e1b25b74dfd2139586fa2b9dab8d49d91428ed64dc683884598\",\"dweb:/ipfs/Qma7Z6urenqG5Dzqwe8ouGiFH37mbsJEX83tqjSq1PTnRc\"]},\"src/components/ItemPrototypeComponent.sol\":{\"keccak256\":\"0xd7a6edf35347a3ad9ef77b92a0c2c3122d538053afe11b571337b7404b64be6c\",\"license\":\"GPL-3.0\",\"urls\":[\"bzz-raw://bb7cf1c63ad2836bdd5638315e98818ffb93e20529c5c89b086de12ed225943f\",\"dweb:/ipfs/QmYJiJjogbFtQNd3JTk8PRhvf4nfbuhUkWf1i8tmREBhWA\"]},\"src/components/OccurrenceComponent.sol\":{\"keccak256\":\"0x9a9d6234d30ecd32929174f621a5e71eab23d38a66ebe6f2bc513a1323d1e297\",\"license\":\"GPL-3.0\",\"urls\":[\"bzz-raw://fd1327f13d2169ed0b837042567b11cf3b1287f2db280bac4fb52fd0b28afcec\",\"dweb:/ipfs/QmXe5XXUET6j9GTaBLAanDefZCadhv9zTZ98CP5j5N3j2T\"]},\"src/components/OwnedByComponent.sol\":{\"keccak256\":\"0xbf8d484a1a6c899e84d323cb56ab1a2333553127fba6362afd70c9378e0c096b\",\"license\":\"GPL-3.0\",\"urls\":[\"bzz-raw://2aab28cdb05f2df8e687e3476cfc23af34d1694a2dc79101f6432c08c1061b73\",\"dweb:/ipfs/QmXyxNBiZtQCkeMfrDp4QaWTTfZAZJREkjyD78UcWoKbXC\"]},\"src/components/PositionComponent.sol\":{\"keccak256\":\"0x0ae081da9ef2fd83c3357069f8374b9bac7777c5039c8fdb59587a03a18f0750\",\"license\":\"GPL-3.0\",\"urls\":[\"bzz-raw://b71c9fa9a2986cce99998b0dd9f832f8efbc3cb268947b7469babf5034945f79\",\"dweb:/ipfs/QmTuhRaJ28ybUDzPmnGrCR6C3pTX92ju9PR2irGzcg3ZFe\"]},\"src/constants.sol\":{\"keccak256\":\"0x35eb483ffb1e928e2a26ca67f6a3e3cc98792359bfc99ef4bcd3a2b836d0b1a3\",\"license\":\"GPL-3.0\",\"urls\":[\"bzz-raw://1c3d3786deef6309fb787f811b6391a82f3ba02a6c0ec023b1e678c7687e423c\",\"dweb:/ipfs/QmbqwxPtREMtQzXVcGc6kVtXEw2G4dv2PwEt3UEFUoTcye\"]},\"src/libraries/LibTerrain.sol\":{\"keccak256\":\"0xe286c3732b881855e8080a24398eaa02ff4364f8574c2f973fca058dc098c452\",\"license\":\"GPL-3.0\",\"urls\":[\"bzz-raw://264eb1f42edaac6aecfd4268c7d372785be5207b88e4a3fe40669fa4d08fb7b5\",\"dweb:/ipfs/QmWeBB9cJnxzB8Ngx9Bq78HhffnMPwGuYmoi3xtP3nko6F\"]},\"src/prototypes/Blocks.sol\":{\"keccak256\":\"0xf821df99f1ca0c6324aeb045a8f53f1882d36814fcc31a6966854bd4b574e18e\",\"license\":\"GPL-3.0\",\"urls\":[\"bzz-raw://4822d779117ba4d1f225b9d403e85da58af510a0e82036c4b0d83a4dfb42c953\",\"dweb:/ipfs/QmX8rkSi7qLRmju1B42SvFfvdQYuUf2uciSXLTu5iPzJoT\"]},\"src/systems/OccurrenceSystem.sol\":{\"keccak256\":\"0xa69b89c653832ee79f63d8842c0d82cfe504c698be289c6bba3c8f83dc21a7ac\",\"license\":\"GPL-3.0\",\"urls\":[\"bzz-raw://86a32bc09883b3870ed28444141ec1d1bbaee708a711519f6c33243b1b981eea\",\"dweb:/ipfs/QmWcRc9SDFguHVhnxpXwsWxx2Pck6ZkANfV6ds6iTq12pU\"]},\"src/types.sol\":{\"keccak256\":\"0xc48370d149f4f0a4952ddffda8e118745983e39bb60d450e29302fa2f95971cb\",\"license\":\"GPL-3.0\",\"urls\":[\"bzz-raw://03344f454cc70f6892e2a07b51dcf429c02e735e310afa3e898ca922c4269a0d\",\"dweb:/ipfs/QmY4ayc12HsF2stK59eS4kze4zrmKUawBkRzcoAz5oA5ZJ\"]},\"src/utils.sol\":{\"keccak256\":\"0x5316f98d298dc325f5c08c343f8f511f8811df141cc39c52d8ac8b073ea80f3f\",\"license\":\"GPL-3.0\",\"urls\":[\"bzz-raw://523e0a631648bb7c08772511df199b931d689d678f1e2b8eb4d54704b80efc88\",\"dweb:/ipfs/QmSh7MEz4ZwL3KWUgTsDc1ke3NAhoHutL8uir58bT9APm1\"]}},\"version\":1}",
  "metadata": {
    "compiler": {
      "version": "0.8.13+commit.abaa5c0e"
    },
    "language": "Solidity",
    "output": {
      "abi": [
        {
          "inputs": [
            {
              "internalType": "contract IWorld",
              "name": "_world",
              "type": "address"
            },
            {
              "internalType": "address",
              "name": "_components",
              "type": "address"
            }
          ],
          "stateMutability": "nonpayable",
          "type": "constructor"
        },
        {
          "inputs": [
            {
              "internalType": "address",
              "name": "previousOwner",
              "type": "address",
              "indexed": true
            },
            {
              "internalType": "address",
              "name": "newOwner",
              "type": "address",
              "indexed": true
            }
          ],
          "type": "event",
          "name": "OwnershipTransferred",
          "anonymous": false
        },
        {
          "inputs": [
            {
              "internalType": "struct VoxelCoord",
              "name": "coord",
              "type": "tuple",
              "components": [
                {
                  "internalType": "int32",
                  "name": "x",
                  "type": "int32"
                },
                {
                  "internalType": "int32",
                  "name": "y",
                  "type": "int32"
                },
                {
                  "internalType": "int32",
                  "name": "z",
                  "type": "int32"
                }
              ]
            }
          ],
          "stateMutability": "pure",
          "type": "function",
          "name": "Bedrock",
          "outputs": [
            {
              "internalType": "uint256",
              "name": "",
              "type": "uint256"
            }
          ]
        },
        {
          "inputs": [
            {
              "internalType": "struct VoxelCoord",
              "name": "coord",
              "type": "tuple",
              "components": [
                {
                  "internalType": "int32",
                  "name": "x",
                  "type": "int32"
                },
                {
                  "internalType": "int32",
                  "name": "y",
                  "type": "int32"
                },
                {
                  "internalType": "int32",
                  "name": "z",
                  "type": "int32"
                }
              ]
            }
          ],
          "stateMutability": "pure",
          "type": "function",
          "name": "BlackFlower",
          "outputs": [
            {
              "internalType": "uint256",
              "name": "",
              "type": "uint256"
            }
          ]
        },
        {
          "inputs": [
            {
              "internalType": "struct VoxelCoord",
              "name": "coord",
              "type": "tuple",
              "components": [
                {
                  "internalType": "int32",
                  "name": "x",
                  "type": "int32"
                },
                {
                  "internalType": "int32",
                  "name": "y",
                  "type": "int32"
                },
                {
                  "internalType": "int32",
                  "name": "z",
                  "type": "int32"
                }
              ]
            }
          ],
          "stateMutability": "pure",
          "type": "function",
          "name": "BlueFlower",
          "outputs": [
            {
              "internalType": "uint256",
              "name": "",
              "type": "uint256"
            }
          ]
        },
        {
          "inputs": [
            {
              "internalType": "struct VoxelCoord",
              "name": "coord",
              "type": "tuple",
              "components": [
                {
                  "internalType": "int32",
                  "name": "x",
                  "type": "int32"
                },
                {
                  "internalType": "int32",
                  "name": "y",
                  "type": "int32"
                },
                {
                  "internalType": "int32",
                  "name": "z",
                  "type": "int32"
                }
              ]
            }
          ],
          "stateMutability": "pure",
          "type": "function",
          "name": "Clay",
          "outputs": [
            {
              "internalType": "uint256",
              "name": "",
              "type": "uint256"
            }
          ]
        },
        {
          "inputs": [
            {
              "internalType": "struct VoxelCoord",
              "name": "coord",
              "type": "tuple",
              "components": [
                {
                  "internalType": "int32",
                  "name": "x",
                  "type": "int32"
                },
                {
                  "internalType": "int32",
                  "name": "y",
                  "type": "int32"
                },
                {
                  "internalType": "int32",
                  "name": "z",
                  "type": "int32"
                }
              ]
            }
          ],
          "stateMutability": "pure",
          "type": "function",
          "name": "Coal",
          "outputs": [
            {
              "internalType": "uint256",
              "name": "",
              "type": "uint256"
            }
          ]
        },
        {
          "inputs": [
            {
              "internalType": "struct VoxelCoord",
              "name": "coord",
              "type": "tuple",
              "components": [
                {
                  "internalType": "int32",
                  "name": "x",
                  "type": "int32"
                },
                {
                  "internalType": "int32",
                  "name": "y",
                  "type": "int32"
                },
                {
                  "internalType": "int32",
                  "name": "z",
                  "type": "int32"
                }
              ]
            }
          ],
          "stateMutability": "pure",
          "type": "function",
          "name": "CyanFlower",
          "outputs": [
            {
              "internalType": "uint256",
              "name": "",
              "type": "uint256"
            }
          ]
        },
        {
          "inputs": [
            {
              "internalType": "struct VoxelCoord",
              "name": "coord",
              "type": "tuple",
              "components": [
                {
                  "internalType": "int32",
                  "name": "x",
                  "type": "int32"
                },
                {
                  "internalType": "int32",
                  "name": "y",
                  "type": "int32"
                },
                {
                  "internalType": "int32",
                  "name": "z",
                  "type": "int32"
                }
              ]
            }
          ],
          "stateMutability": "pure",
          "type": "function",
          "name": "Diamond",
          "outputs": [
            {
              "internalType": "uint256",
              "name": "",
              "type": "uint256"
            }
          ]
        },
        {
          "inputs": [
            {
              "internalType": "struct VoxelCoord",
              "name": "coord",
              "type": "tuple",
              "components": [
                {
                  "internalType": "int32",
                  "name": "x",
                  "type": "int32"
                },
                {
                  "internalType": "int32",
                  "name": "y",
                  "type": "int32"
                },
                {
                  "internalType": "int32",
                  "name": "z",
                  "type": "int32"
                }
              ]
            }
          ],
          "stateMutability": "pure",
          "type": "function",
          "name": "Dirt",
          "outputs": [
            {
              "internalType": "uint256",
              "name": "",
              "type": "uint256"
            }
          ]
        },
        {
          "inputs": [
            {
              "internalType": "struct VoxelCoord",
              "name": "coord",
              "type": "tuple",
              "components": [
                {
                  "internalType": "int32",
                  "name": "x",
                  "type": "int32"
                },
                {
                  "internalType": "int32",
                  "name": "y",
                  "type": "int32"
                },
                {
                  "internalType": "int32",
                  "name": "z",
                  "type": "int32"
                }
              ]
            }
          ],
          "stateMutability": "pure",
          "type": "function",
          "name": "Grass",
          "outputs": [
            {
              "internalType": "uint256",
              "name": "",
              "type": "uint256"
            }
          ]
        },
        {
          "inputs": [
            {
              "internalType": "struct VoxelCoord",
              "name": "coord",
              "type": "tuple",
              "components": [
                {
                  "internalType": "int32",
                  "name": "x",
                  "type": "int32"
                },
                {
                  "internalType": "int32",
                  "name": "y",
                  "type": "int32"
                },
                {
                  "internalType": "int32",
                  "name": "z",
                  "type": "int32"
                }
              ]
            }
          ],
          "stateMutability": "pure",
          "type": "function",
          "name": "GrassPlant",
          "outputs": [
            {
              "internalType": "uint256",
              "name": "",
              "type": "uint256"
            }
          ]
        },
        {
          "inputs": [
            {
              "internalType": "struct VoxelCoord",
              "name": "coord",
              "type": "tuple",
              "components": [
                {
                  "internalType": "int32",
                  "name": "x",
                  "type": "int32"
                },
                {
                  "internalType": "int32",
                  "name": "y",
                  "type": "int32"
                },
                {
                  "internalType": "int32",
                  "name": "z",
                  "type": "int32"
                }
              ]
            }
          ],
          "stateMutability": "pure",
          "type": "function",
          "name": "GrayFlower",
          "outputs": [
            {
              "internalType": "uint256",
              "name": "",
              "type": "uint256"
            }
          ]
        },
        {
          "inputs": [
            {
              "internalType": "struct VoxelCoord",
              "name": "coord",
              "type": "tuple",
              "components": [
                {
                  "internalType": "int32",
                  "name": "x",
                  "type": "int32"
                },
                {
                  "internalType": "int32",
                  "name": "y",
                  "type": "int32"
                },
                {
                  "internalType": "int32",
                  "name": "z",
                  "type": "int32"
                }
              ]
            }
          ],
          "stateMutability": "pure",
          "type": "function",
          "name": "GreenFlower",
          "outputs": [
            {
              "internalType": "uint256",
              "name": "",
              "type": "uint256"
            }
          ]
        },
        {
          "inputs": [
            {
              "internalType": "struct VoxelCoord",
              "name": "coord",
              "type": "tuple",
              "components": [
                {
                  "internalType": "int32",
                  "name": "x",
                  "type": "int32"
                },
                {
                  "internalType": "int32",
                  "name": "y",
                  "type": "int32"
                },
                {
                  "internalType": "int32",
                  "name": "z",
                  "type": "int32"
                }
              ]
            }
          ],
          "stateMutability": "pure",
          "type": "function",
          "name": "Kelp",
          "outputs": [
            {
              "internalType": "uint256",
              "name": "",
              "type": "uint256"
            }
          ]
        },
        {
          "inputs": [
            {
              "internalType": "struct VoxelCoord",
              "name": "coord",
              "type": "tuple",
              "components": [
                {
                  "internalType": "int32",
                  "name": "x",
                  "type": "int32"
                },
                {
                  "internalType": "int32",
                  "name": "y",
                  "type": "int32"
                },
                {
                  "internalType": "int32",
                  "name": "z",
                  "type": "int32"
                }
              ]
            }
          ],
          "stateMutability": "pure",
          "type": "function",
          "name": "Leaves",
          "outputs": [
            {
              "internalType": "uint256",
              "name": "",
              "type": "uint256"
            }
          ]
        },
        {
          "inputs": [
            {
              "internalType": "struct VoxelCoord",
              "name": "coord",
              "type": "tuple",
              "components": [
                {
                  "internalType": "int32",
                  "name": "x",
                  "type": "int32"
                },
                {
                  "internalType": "int32",
                  "name": "y",
                  "type": "int32"
                },
                {
                  "internalType": "int32",
                  "name": "z",
                  "type": "int32"
                }
              ]
            }
          ],
          "stateMutability": "pure",
          "type": "function",
          "name": "LightBlueFlower",
          "outputs": [
            {
              "internalType": "uint256",
              "name": "",
              "type": "uint256"
            }
          ]
        },
        {
          "inputs": [
            {
              "internalType": "struct VoxelCoord",
              "name": "coord",
              "type": "tuple",
              "components": [
                {
                  "internalType": "int32",
                  "name": "x",
                  "type": "int32"
                },
                {
                  "internalType": "int32",
                  "name": "y",
                  "type": "int32"
                },
                {
                  "internalType": "int32",
                  "name": "z",
                  "type": "int32"
                }
              ]
            }
          ],
          "stateMutability": "pure",
          "type": "function",
          "name": "LightGrayFlower",
          "outputs": [
            {
              "internalType": "uint256",
              "name": "",
              "type": "uint256"
            }
          ]
        },
        {
          "inputs": [
            {
              "internalType": "struct VoxelCoord",
              "name": "coord",
              "type": "tuple",
              "components": [
                {
                  "internalType": "int32",
                  "name": "x",
                  "type": "int32"
                },
                {
                  "internalType": "int32",
                  "name": "y",
                  "type": "int32"
                },
                {
                  "internalType": "int32",
                  "name": "z",
                  "type": "int32"
                }
              ]
            }
          ],
          "stateMutability": "pure",
          "type": "function",
          "name": "LimeFlower",
          "outputs": [
            {
              "internalType": "uint256",
              "name": "",
              "type": "uint256"
            }
          ]
        },
        {
          "inputs": [
            {
              "internalType": "struct VoxelCoord",
              "name": "coord",
              "type": "tuple",
              "components": [
                {
                  "internalType": "int32",
                  "name": "x",
                  "type": "int32"
                },
                {
                  "internalType": "int32",
                  "name": "y",
                  "type": "int32"
                },
                {
                  "internalType": "int32",
                  "name": "z",
                  "type": "int32"
                }
              ]
            }
          ],
          "stateMutability": "pure",
          "type": "function",
          "name": "Log",
          "outputs": [
            {
              "internalType": "uint256",
              "name": "",
              "type": "uint256"
            }
          ]
        },
        {
          "inputs": [
            {
              "internalType": "struct VoxelCoord",
              "name": "coord",
              "type": "tuple",
              "components": [
                {
                  "internalType": "int32",
                  "name": "x",
                  "type": "int32"
                },
                {
                  "internalType": "int32",
                  "name": "y",
                  "type": "int32"
                },
                {
                  "internalType": "int32",
                  "name": "z",
                  "type": "int32"
                }
              ]
            }
          ],
          "stateMutability": "pure",
          "type": "function",
          "name": "MagentaFlower",
          "outputs": [
            {
              "internalType": "uint256",
              "name": "",
              "type": "uint256"
            }
          ]
        },
        {
          "inputs": [
            {
              "internalType": "struct VoxelCoord",
              "name": "coord",
              "type": "tuple",
              "components": [
                {
                  "internalType": "int32",
                  "name": "x",
                  "type": "int32"
                },
                {
                  "internalType": "int32",
                  "name": "y",
                  "type": "int32"
                },
                {
                  "internalType": "int32",
                  "name": "z",
                  "type": "int32"
                }
              ]
            }
          ],
          "stateMutability": "pure",
          "type": "function",
          "name": "OrangeFlower",
          "outputs": [
            {
              "internalType": "uint256",
              "name": "",
              "type": "uint256"
            }
          ]
        },
        {
          "inputs": [
            {
              "internalType": "struct VoxelCoord",
              "name": "coord",
              "type": "tuple",
              "components": [
                {
                  "internalType": "int32",
                  "name": "x",
                  "type": "int32"
                },
                {
                  "internalType": "int32",
                  "name": "y",
                  "type": "int32"
                },
                {
                  "internalType": "int32",
                  "name": "z",
                  "type": "int32"
                }
              ]
            }
          ],
          "stateMutability": "pure",
          "type": "function",
          "name": "PinkFlower",
          "outputs": [
            {
              "internalType": "uint256",
              "name": "",
              "type": "uint256"
            }
          ]
        },
        {
          "inputs": [
            {
              "internalType": "struct VoxelCoord",
              "name": "coord",
              "type": "tuple",
              "components": [
                {
                  "internalType": "int32",
                  "name": "x",
                  "type": "int32"
                },
                {
                  "internalType": "int32",
                  "name": "y",
                  "type": "int32"
                },
                {
                  "internalType": "int32",
                  "name": "z",
                  "type": "int32"
                }
              ]
            }
          ],
          "stateMutability": "pure",
          "type": "function",
          "name": "PurpleFlower",
          "outputs": [
            {
              "internalType": "uint256",
              "name": "",
              "type": "uint256"
            }
          ]
        },
        {
          "inputs": [
            {
              "internalType": "struct VoxelCoord",
              "name": "coord",
              "type": "tuple",
              "components": [
                {
                  "internalType": "int32",
                  "name": "x",
                  "type": "int32"
                },
                {
                  "internalType": "int32",
                  "name": "y",
                  "type": "int32"
                },
                {
                  "internalType": "int32",
                  "name": "z",
                  "type": "int32"
                }
              ]
            }
          ],
          "stateMutability": "pure",
          "type": "function",
          "name": "RedFlower",
          "outputs": [
            {
              "internalType": "uint256",
              "name": "",
              "type": "uint256"
            }
          ]
        },
        {
          "inputs": [
            {
              "internalType": "struct VoxelCoord",
              "name": "coord",
              "type": "tuple",
              "components": [
                {
                  "internalType": "int32",
                  "name": "x",
                  "type": "int32"
                },
                {
                  "internalType": "int32",
                  "name": "y",
                  "type": "int32"
                },
                {
                  "internalType": "int32",
                  "name": "z",
                  "type": "int32"
                }
              ]
            }
          ],
          "stateMutability": "pure",
          "type": "function",
          "name": "Sand",
          "outputs": [
            {
              "internalType": "uint256",
              "name": "",
              "type": "uint256"
            }
          ]
        },
        {
          "inputs": [
            {
              "internalType": "struct VoxelCoord",
              "name": "coord",
              "type": "tuple",
              "components": [
                {
                  "internalType": "int32",
                  "name": "x",
                  "type": "int32"
                },
                {
                  "internalType": "int32",
                  "name": "y",
                  "type": "int32"
                },
                {
                  "internalType": "int32",
                  "name": "z",
                  "type": "int32"
                }
              ]
            }
          ],
          "stateMutability": "pure",
          "type": "function",
          "name": "Snow",
          "outputs": [
            {
              "internalType": "uint256",
              "name": "",
              "type": "uint256"
            }
          ]
        },
        {
          "inputs": [
            {
              "internalType": "struct VoxelCoord",
              "name": "coord",
              "type": "tuple",
              "components": [
                {
                  "internalType": "int32",
                  "name": "x",
                  "type": "int32"
                },
                {
                  "internalType": "int32",
                  "name": "y",
                  "type": "int32"
                },
                {
                  "internalType": "int32",
                  "name": "z",
                  "type": "int32"
                }
              ]
            }
          ],
          "stateMutability": "pure",
          "type": "function",
          "name": "Stone",
          "outputs": [
            {
              "internalType": "uint256",
              "name": "",
              "type": "uint256"
            }
          ]
        },
        {
          "inputs": [
            {
              "internalType": "struct VoxelCoord",
              "name": "coord",
              "type": "tuple",
              "components": [
                {
                  "internalType": "int32",
                  "name": "x",
                  "type": "int32"
                },
                {
                  "internalType": "int32",
                  "name": "y",
                  "type": "int32"
                },
                {
                  "internalType": "int32",
                  "name": "z",
                  "type": "int32"
                }
              ]
            }
          ],
          "stateMutability": "pure",
          "type": "function",
          "name": "Water",
          "outputs": [
            {
              "internalType": "uint256",
              "name": "",
              "type": "uint256"
            }
          ]
        },
        {
          "inputs": [
            {
              "internalType": "struct VoxelCoord",
              "name": "coord",
              "type": "tuple",
              "components": [
                {
                  "internalType": "int32",
                  "name": "x",
                  "type": "int32"
                },
                {
                  "internalType": "int32",
                  "name": "y",
                  "type": "int32"
                },
                {
                  "internalType": "int32",
                  "name": "z",
                  "type": "int32"
                }
              ]
            }
          ],
          "stateMutability": "pure",
          "type": "function",
          "name": "Wool",
          "outputs": [
            {
              "internalType": "uint256",
              "name": "",
              "type": "uint256"
            }
          ]
        },
        {
          "inputs": [
            {
              "internalType": "bytes",
              "name": "arguments",
              "type": "bytes"
            }
          ],
          "stateMutability": "pure",
          "type": "function",
          "name": "execute",
          "outputs": [
            {
              "internalType": "bytes",
              "name": "",
              "type": "bytes"
            }
          ]
        },
        {
          "inputs": [
            {
              "internalType": "uint256",
              "name": "blockType",
              "type": "uint256"
            },
            {
              "internalType": "struct VoxelCoord",
              "name": "coord",
              "type": "tuple",
              "components": [
                {
                  "internalType": "int32",
                  "name": "x",
                  "type": "int32"
                },
                {
                  "internalType": "int32",
                  "name": "y",
                  "type": "int32"
                },
                {
                  "internalType": "int32",
                  "name": "z",
                  "type": "int32"
                }
              ]
            }
          ],
          "stateMutability": "pure",
          "type": "function",
          "name": "executeTyped",
          "outputs": [
            {
              "internalType": "uint256",
              "name": "",
              "type": "uint256"
            }
          ]
        },
        {
          "inputs": [],
          "stateMutability": "view",
          "type": "function",
          "name": "owner",
          "outputs": [
            {
              "internalType": "address",
              "name": "",
              "type": "address"
            }
          ]
        },
        {
          "inputs": [
            {
              "internalType": "address",
              "name": "newOwner",
              "type": "address"
            }
          ],
          "stateMutability": "nonpayable",
          "type": "function",
          "name": "transferOwnership"
        }
      ],
      "devdoc": {
        "kind": "dev",
        "methods": {
          "owner()": {
            "returns": {
              "_0": "The address of the owner."
            }
          }
        },
        "version": 1
      },
      "userdoc": {
        "kind": "user",
        "methods": {
          "owner()": {
            "notice": "Get the address of the owner"
          }
        },
        "version": 1
      }
    },
    "settings": {
      "remappings": [
        ":@latticexyz/=../../node_modules/@latticexyz/",
        ":@manifoldxyz/=../../node_modules/@manifoldxyz/",
        ":@opengsn/=../../node_modules/@opengsn/",
        ":@openzeppelin/=../../node_modules/openzeppelin-solidity/",
        ":@rari-capital/=../../node_modules/@rari-capital/",
        ":abdk-libraries-solidity/=../../node_modules/abdk-libraries-solidity/",
        ":base64-sol/=../../node_modules/base64-sol/",
        ":base64/=../../node_modules/base64-sol/",
        ":components/=src/components/",
        ":ds-test/=../../node_modules/ds-test/src/",
        ":forge-std/=../../node_modules/forge-std/src/",
        ":gsn/=../../node_modules/@opengsn/contracts/src/",
        ":hardhat-deploy/=../../node_modules/hardhat-deploy/",
        ":hardhat/=../../node_modules/hardhat/",
        ":libraries/=src/libraries/",
        ":memmove/=../../node_modules/memmove/src/",
        ":noise/=../../node_modules/@latticexyz/noise/contracts/",
        ":openzeppelin-solidity/=../../node_modules/openzeppelin-solidity/",
        ":persona/=../../node_modules/@latticexyz/persona/src/",
        ":royalty-registry/=../../node_modules/@manifoldxyz/royalty-registry-solidity/contracts/",
        ":solecs/=../../node_modules/@latticexyz/solecs/src/",
        ":solmate/=../../node_modules/@rari-capital/solmate/src/",
        ":std-contracts/=../../node_modules/@latticexyz/std-contracts/src/",
        ":systems/=src/systems/"
      ],
      "optimizer": {
        "enabled": true,
        "runs": 1000000
      },
      "metadata": {
        "bytecodeHash": "ipfs"
      },
      "compilationTarget": {
        "src/systems/OccurrenceSystem.sol": "OccurrenceSystem"
      },
      "libraries": {}
    },
    "sources": {
      "../../node_modules/@latticexyz/noise/contracts/Perlin.sol": {
        "keccak256": "0xe11773108f221ecffb6644f7ca0dee4b02ce34d4a09f6614bbd62ac375f894db",
        "urls": [
          "bzz-raw://ace8d328d7e31bd9b0197b609d3d50c343f63214fe8a0c76c15e448b33a7f60c",
          "dweb:/ipfs/QmdyYqmv3JL82GV8qBUipLriv2u7TcjWKr2xK7nxo9ZBgG"
        ],
        "license": "MIT"
      },
      "../../node_modules/@latticexyz/solecs/src/BareComponent.sol": {
        "keccak256": "0xba9ac6f0758cc098046c74ad02b520e0e45c27e35aa6865b4ec806981c6be786",
        "urls": [
          "bzz-raw://0f53e408345b49f552468bb3958e7699898595856effb1355e053abe9b77f671",
          "dweb:/ipfs/QmcP9DPKdc97Si8CvymPz6bUfjcNmhiQytAdQ7xPF5EV9g"
        ],
        "license": "MIT"
      },
      "../../node_modules/@latticexyz/solecs/src/Component.sol": {
        "keccak256": "0x40085c2f86bf6be7a756015025477aa46308b1618083ece93ae13093881a6874",
        "urls": [
          "bzz-raw://ca8653540b5674e50abfd4b4898009b472fc7fd2fba456146c1a1c44b615d83a",
          "dweb:/ipfs/QmSqbRng5fHuGUKgkFuNw3BfoefNteYU95sYi4g9QjCCNh"
        ],
        "license": "MIT"
      },
      "../../node_modules/@latticexyz/solecs/src/LibTypes.sol": {
        "keccak256": "0xa3898035fd9fa865bcfc9861e3b5ecce36be3196fb27705e50a02fed9831f102",
        "urls": [
          "bzz-raw://273284a35a950f6d0bc4223d345cf46c59972a00510ddbc4ba695ede38714798",
          "dweb:/ipfs/QmdqzKMaAfKWfBzUsrzsDMWnyxSKJRuEvrc6VTR5VarQaH"
        ],
        "license": "MIT"
      },
      "../../node_modules/@latticexyz/solecs/src/MapSet.sol": {
        "keccak256": "0x903c895b873785da7c3f8e17ebe0c176bb4a0987ff2f70f7b4df8872a7d1bd99",
        "urls": [
          "bzz-raw://37a91b47ec383af7462368a29e8c01532e87eaa3c56077dab1f73e00c2fe25d5",
          "dweb:/ipfs/QmaukFM1GkNxMhK4LiCCWouJxzHpq2mznM8jLvr19o8ukr"
        ],
        "license": "MIT"
      },
      "../../node_modules/@latticexyz/solecs/src/Set.sol": {
        "keccak256": "0xd4e1ac0608efb071ee64b15cdaec8c83e684d305d673702cacab98a2721d210d",
        "urls": [
          "bzz-raw://1f083400292163c7b0c717d66f2d200ac38995019d695ba5c0568547f7f96051",
          "dweb:/ipfs/QmSGp7TeKHi5eb2ELU1qH7Qfjs4kjyMGfTTXUw9iPaq6UE"
        ],
        "license": "MIT"
      },
      "../../node_modules/@latticexyz/solecs/src/System.sol": {
        "keccak256": "0x5ff430169885d31cb4d41ccf5ba8ac1f0815d3bb1b9dc9afcf9afd6a7203e7c7",
        "urls": [
          "bzz-raw://59892068a9b62d8c01d272ea5de2e8f2932a7ea87acce9b6eaccfae00dad8e66",
          "dweb:/ipfs/QmfEdTjYkdHfueS527ibx3Ni8X3yqgQHtbRB1anDTsMGBN"
        ],
        "license": "MIT"
      },
      "../../node_modules/@latticexyz/solecs/src/constants.sol": {
        "keccak256": "0x024a3ff3077a272339b7baa96b826fd75f040d7cd2c6e13b9c8cf7ad16f789b8",
        "urls": [
          "bzz-raw://1ddcb26a7703e9b03b34d5465010a4ae5ced137021c94987053544ad1156a644",
          "dweb:/ipfs/QmYue4gnb8noyoxxTchs5chZji7DKynKMp2x33RgRW6xqZ"
        ],
        "license": "MIT"
      },
      "../../node_modules/@latticexyz/solecs/src/interfaces/IComponent.sol": {
        "keccak256": "0x4513448bb0d45050f8af0a2ead426b27a5d5ca73d38c6874e909f852ad2232e6",
        "urls": [
          "bzz-raw://e5c215b87500c80ffb525142b753a4f3454a69cf11b9b68f6a29f1a4dd4a2ced",
          "dweb:/ipfs/Qmd4YYoYJTrgyQU8zcfJFDdYQA29DarkdL8k5obyGgbp2K"
        ],
        "license": "MIT"
      },
      "../../node_modules/@latticexyz/solecs/src/interfaces/IERC173.sol": {
        "keccak256": "0xc8fa875a59c2010265d7fc5663d9d37e6b5f9b556b6bfdeeb7ec9355ee3169c7",
        "urls": [
          "bzz-raw://33d944c6ff71c7afe4d21db8f4077e419f165100bbfd8b6c8d4b975015ec6c82",
          "dweb:/ipfs/QmY461W1TtyjkkcUuxPHUtJ3LxzD1iaU422FkFhtHHuRQh"
        ],
        "license": "MIT"
      },
      "../../node_modules/@latticexyz/solecs/src/interfaces/IEntityContainer.sol": {
        "keccak256": "0x4506db1dcbdbe68a397107a57bfa3da888a889f14181a90eb728cfecc60700b8",
        "urls": [
          "bzz-raw://23f5c02d110f5abf6340a08a2a8b7e0b5668f211fe6baf41213e6c4f69dece10",
          "dweb:/ipfs/QmYfKeZMeEUNExsxjkCF5nGdw8KRyPe1t5tcGFTEkP7CkV"
        ],
        "license": "MIT"
      },
      "../../node_modules/@latticexyz/solecs/src/interfaces/IEntityIndexer.sol": {
        "keccak256": "0xd89023b2a5e9961be3c9d49d9f7f9ac7dcc416e3f43a8758dc058d1db2eea6b5",
        "urls": [
          "bzz-raw://3266ea1dd5a7f372f8814db24ac4981730f66fba8e6f90f614246ca5cec529b4",
          "dweb:/ipfs/QmQ71BtaBsDjfke46dndaTBVhyXAHxs5qs7d9GHJwVXuvw"
        ],
        "license": "MIT"
      },
      "../../node_modules/@latticexyz/solecs/src/interfaces/ISystem.sol": {
        "keccak256": "0x62af78f49b90c7c23ad677e4090c5c916e1c2e36b13be07887b371ba732294c9",
        "urls": [
          "bzz-raw://c8c0849bc60d65a4578a66b8d0052b584e8b43838b78bc2c2579113f625cd05a",
          "dweb:/ipfs/Qma8pxGUAupCkTJYjXeHV9i4qvjnMP9s8zi5rs6FDrDuy7"
        ],
        "license": "MIT"
      },
      "../../node_modules/@latticexyz/solecs/src/interfaces/IUint256Component.sol": {
        "keccak256": "0x12e2eaa4c5663048343e43a1994c446baacb16a4aacbe314ed5202d878751be9",
        "urls": [
          "bzz-raw://2d78184a1b1868773f2d5a7cf54bb42bccc666dc75cea14eeed15b8573fd000f",
          "dweb:/ipfs/QmemXPHPB7V8StWR8kZcKt3eDxB78sZFZW4Dp7TcEFTxx9"
        ],
        "license": "MIT"
      },
      "../../node_modules/@latticexyz/solecs/src/interfaces/IWorld.sol": {
        "keccak256": "0x319806cf4ed67acdd9f444ac581486e157ea06bceb8e727c6d745c165e0d9aae",
        "urls": [
          "bzz-raw://9b2cb8ec879279c74b384f169595e50fd1850ce63275447748d9150dfa9a85be",
          "dweb:/ipfs/QmNPQBfqVg3iDF2qE8KTJWx1zbpJjnzteNYiqGxtBye2q2"
        ],
        "license": "MIT"
      },
      "../../node_modules/@latticexyz/solecs/src/interfaces/Query.sol": {
        "keccak256": "0xd11a3268514fceac97995d481017e49b18835e31ce3540e5f21c24df33e4bc2c",
        "urls": [
          "bzz-raw://841dd95a4f5e89f0451a72544a47eb16be41b8005dadfe98a82054db3eb41ab7",
          "dweb:/ipfs/QmScv2neVyCeoCmMZyRyYcqD5QwauuoWmkixyxw4qftEeR"
        ],
        "license": "MIT"
      },
      "../../node_modules/@latticexyz/solecs/src/utils.sol": {
        "keccak256": "0x17f7831c03bdd77f0c7d98c94931d830fbbfa1878c365f54b12841c85611e24e",
        "urls": [
          "bzz-raw://6ae566ee03c5050b239277ef4184b9e5dcb332c8cc65b032f8e0d9e46408ea6d",
          "dweb:/ipfs/QmetdhxahRf7FJk1kn8KgDmizU2zYk3jjt9qo6Gwz2M5YP"
        ],
        "license": "MIT"
      },
      "../../node_modules/@latticexyz/std-contracts/src/components/BoolBareComponent.sol": {
        "keccak256": "0x7975dfdab87f3287fff86dd7e4e9366ad69c7660d1859c32c053a88f9a0cd1d6",
        "urls": [
          "bzz-raw://05070aeb4b877427a8f28c12b3885cfac1ea9ed5c38f10be141dea96d1fe0fd5",
          "dweb:/ipfs/QmcsRU2bW6FrerGkq7uESKZwgKKUPxyMHTtTvY9rz62i3j"
        ],
        "license": "MIT"
      },
      "../../node_modules/@latticexyz/std-contracts/src/components/FunctionBareComponent.sol": {
        "keccak256": "0x2b6a34415d2cae3bc82cc3933785939d3fdf70804f740080bb8cd66533c383be",
        "urls": [
          "bzz-raw://1e846a49c4e2bf2684d8ef42faaad6ac5a6260da2d23da86ba4aa26ba4f7bea4",
          "dweb:/ipfs/QmZM4nRE6iGdwrPYZjigKvaFB7dqStAtm7s6PoBmQ23oCS"
        ],
        "license": "MIT"
      },
      "../../node_modules/@latticexyz/std-contracts/src/components/Uint256BareComponent.sol": {
        "keccak256": "0x3c1174880052b94f112dab23e77afde149254c1ad3749d82c7fd81bf4d09483d",
        "urls": [
          "bzz-raw://734c3d8d09e5788bdc3a6133abe3789600afe8d896d2909e9526841bc4992ec4",
          "dweb:/ipfs/QmUgtiKgFit3StevWYBQe3k3woWm4uvwoWZmuSDvV1kRwJ"
        ],
        "license": "MIT"
      },
      "../../node_modules/@latticexyz/std-contracts/src/components/VoxelCoordComponent.sol": {
        "keccak256": "0x55024a280a54e1d6b08f66b3f6ff19c7571cc62f87e4b4eedcef3dd1e2cae3bb",
        "urls": [
          "bzz-raw://baa31b72a6ea57c6707d9480390675f38de35386ba4df5f4835e90d563d9bad3",
          "dweb:/ipfs/QmbuE9dQPZAJKBUFhWq3wayPjDehEwDbiZB9ZAsrkM1k49"
        ],
        "license": "MIT"
      },
      "../../node_modules/abdk-libraries-solidity/ABDKMath64x64.sol": {
        "keccak256": "0x089b21db72314836305ba36b1773c3f0c2d5ac3a0f418820557c17c0e57c3c50",
        "urls": [
          "bzz-raw://730ce8d750b0a6588f0d0724ace1c4d6dd90cf6dc0d2805b775b065fce147dfa",
          "dweb:/ipfs/Qmdx7xRKvhXu1JtAVs25bER3LN2oGj2ZjW8jEvJpzQyXhc"
        ],
        "license": "BSD-4-Clause"
      },
      "../../node_modules/memmove/src/Array.sol": {
        "keccak256": "0x0d7681d3392c34f811cebc9598c5e8f4eef6aba431dca9e1fa87267ba51a4515",
        "urls": [
          "bzz-raw://0ffb5179dd40ccacadc2cb26ac99e9ea5148796f6d21413d7e0f37913831bea1",
          "dweb:/ipfs/QmfJogaoqook5JgnUZKib6w6khzViUag3EQb1EZ8aUEasQ"
        ],
        "license": "MIT"
      },
      "../../node_modules/memmove/src/LinkedList.sol": {
        "keccak256": "0x2374863d39689178dda92b841e77b835ba8fa550561be23b7861d2e52c0fe8c1",
        "urls": [
          "bzz-raw://8538ec6ca6be4e1b25b74dfd2139586fa2b9dab8d49d91428ed64dc683884598",
          "dweb:/ipfs/Qma7Z6urenqG5Dzqwe8ouGiFH37mbsJEX83tqjSq1PTnRc"
        ],
        "license": "MIT"
      },
      "src/components/ItemPrototypeComponent.sol": {
        "keccak256": "0xd7a6edf35347a3ad9ef77b92a0c2c3122d538053afe11b571337b7404b64be6c",
        "urls": [
          "bzz-raw://bb7cf1c63ad2836bdd5638315e98818ffb93e20529c5c89b086de12ed225943f",
          "dweb:/ipfs/QmYJiJjogbFtQNd3JTk8PRhvf4nfbuhUkWf1i8tmREBhWA"
        ],
        "license": "GPL-3.0"
      },
      "src/components/OccurrenceComponent.sol": {
        "keccak256": "0x9a9d6234d30ecd32929174f621a5e71eab23d38a66ebe6f2bc513a1323d1e297",
        "urls": [
          "bzz-raw://fd1327f13d2169ed0b837042567b11cf3b1287f2db280bac4fb52fd0b28afcec",
          "dweb:/ipfs/QmXe5XXUET6j9GTaBLAanDefZCadhv9zTZ98CP5j5N3j2T"
        ],
        "license": "GPL-3.0"
      },
      "src/components/OwnedByComponent.sol": {
        "keccak256": "0xbf8d484a1a6c899e84d323cb56ab1a2333553127fba6362afd70c9378e0c096b",
        "urls": [
          "bzz-raw://2aab28cdb05f2df8e687e3476cfc23af34d1694a2dc79101f6432c08c1061b73",
          "dweb:/ipfs/QmXyxNBiZtQCkeMfrDp4QaWTTfZAZJREkjyD78UcWoKbXC"
        ],
        "license": "GPL-3.0"
      },
      "src/components/PositionComponent.sol": {
        "keccak256": "0x0ae081da9ef2fd83c3357069f8374b9bac7777c5039c8fdb59587a03a18f0750",
        "urls": [
          "bzz-raw://b71c9fa9a2986cce99998b0dd9f832f8efbc3cb268947b7469babf5034945f79",
          "dweb:/ipfs/QmTuhRaJ28ybUDzPmnGrCR6C3pTX92ju9PR2irGzcg3ZFe"
        ],
        "license": "GPL-3.0"
      },
      "src/constants.sol": {
        "keccak256": "0x35eb483ffb1e928e2a26ca67f6a3e3cc98792359bfc99ef4bcd3a2b836d0b1a3",
        "urls": [
          "bzz-raw://1c3d3786deef6309fb787f811b6391a82f3ba02a6c0ec023b1e678c7687e423c",
          "dweb:/ipfs/QmbqwxPtREMtQzXVcGc6kVtXEw2G4dv2PwEt3UEFUoTcye"
        ],
        "license": "GPL-3.0"
      },
      "src/libraries/LibTerrain.sol": {
        "keccak256": "0xe286c3732b881855e8080a24398eaa02ff4364f8574c2f973fca058dc098c452",
        "urls": [
          "bzz-raw://264eb1f42edaac6aecfd4268c7d372785be5207b88e4a3fe40669fa4d08fb7b5",
          "dweb:/ipfs/QmWeBB9cJnxzB8Ngx9Bq78HhffnMPwGuYmoi3xtP3nko6F"
        ],
        "license": "GPL-3.0"
      },
      "src/prototypes/Blocks.sol": {
        "keccak256": "0xf821df99f1ca0c6324aeb045a8f53f1882d36814fcc31a6966854bd4b574e18e",
        "urls": [
          "bzz-raw://4822d779117ba4d1f225b9d403e85da58af510a0e82036c4b0d83a4dfb42c953",
          "dweb:/ipfs/QmX8rkSi7qLRmju1B42SvFfvdQYuUf2uciSXLTu5iPzJoT"
        ],
        "license": "GPL-3.0"
      },
      "src/systems/OccurrenceSystem.sol": {
        "keccak256": "0xa69b89c653832ee79f63d8842c0d82cfe504c698be289c6bba3c8f83dc21a7ac",
        "urls": [
          "bzz-raw://86a32bc09883b3870ed28444141ec1d1bbaee708a711519f6c33243b1b981eea",
          "dweb:/ipfs/QmWcRc9SDFguHVhnxpXwsWxx2Pck6ZkANfV6ds6iTq12pU"
        ],
        "license": "GPL-3.0"
      },
      "src/types.sol": {
        "keccak256": "0xc48370d149f4f0a4952ddffda8e118745983e39bb60d450e29302fa2f95971cb",
        "urls": [
          "bzz-raw://03344f454cc70f6892e2a07b51dcf429c02e735e310afa3e898ca922c4269a0d",
          "dweb:/ipfs/QmY4ayc12HsF2stK59eS4kze4zrmKUawBkRzcoAz5oA5ZJ"
        ],
        "license": "GPL-3.0"
      },
      "src/utils.sol": {
        "keccak256": "0x5316f98d298dc325f5c08c343f8f511f8811df141cc39c52d8ac8b073ea80f3f",
        "urls": [
          "bzz-raw://523e0a631648bb7c08772511df199b931d689d678f1e2b8eb4d54704b80efc88",
          "dweb:/ipfs/QmSh7MEz4ZwL3KWUgTsDc1ke3NAhoHutL8uir58bT9APm1"
        ],
        "license": "GPL-3.0"
      }
    },
    "version": 1
  },
  "ast": {
    "absolutePath": "src/systems/OccurrenceSystem.sol",
    "id": 33975,
    "exportedSymbols": {
      "AirID": [
        28895
      ],
      "BedrockID": [
        29303
      ],
      "BlackFlowerID": [
        29135
      ],
      "BlueFlowerID": [
        29119
      ],
      "ClayID": [
        29295
      ],
      "CoalID": [
        28975
      ],
      "CobblestoneID": [
        28959
      ],
      "CraftingID": [
        28983
      ],
      "CyanFlowerID": [
        29103
      ],
      "DiamondID": [
        29007
      ],
      "DirtID": [
        28911
      ],
      "GoldID": [
        28999
      ],
      "GrassID": [
        28903
      ],
      "GrassPlantID": [
        29039
      ],
      "GrayFlowerID": [
        29087
      ],
      "GreenFlowerID": [
        29127
      ],
      "ID": [
        33203
      ],
      "ISystem": [
        4954
      ],
      "IUint256Component": [
        4983
      ],
      "IWorld": [
        5096
      ],
      "IronID": [
        28991
      ],
      "KelpID": [
        29143
      ],
      "LeavesID": [
        29015
      ],
      "LibTerrain": [
        28871
      ],
      "LightBlueFlowerID": [
        29063
      ],
      "LightGrayFlowerID": [
        29095
      ],
      "LimeFlowerID": [
        29071
      ],
      "LogID": [
        28919
      ],
      "MagentaFlowerID": [
        29055
      ],
      "OccurrenceSystem": [
        33974
      ],
      "OrangeFlowerID": [
        29047
      ],
      "OwnedByComponent": [
        23685
      ],
      "OwnedByComponentID": [
        23672
      ],
      "PinkFlowerID": [
        29079
      ],
      "PlanksID": [
        29023
      ],
      "PositionComponent": [
        23709
      ],
      "PositionComponentID": [
        23696
      ],
      "PurpleFlowerID": [
        29111
      ],
      "RedFlowerID": [
        29031
      ],
      "SandID": [
        28935
      ],
      "SnowID": [
        29287
      ],
      "StoneID": [
        28927
      ],
      "System": [
        4204
      ],
      "VoxelCoord": [
        5927
      ],
      "WaterID": [
        28951
      ],
      "WoolID": [
        29151
      ],
      "addressToEntity": [
        5140
      ],
      "getAddressById": [
        5176
      ]
    },
    "nodeType": "SourceUnit",
    "src": "36:7124:84",
    "nodes": [
      {
        "id": 33144,
        "nodeType": "PragmaDirective",
        "src": "36:24:84",
        "nodes": [],
        "literals": [
          "solidity",
          ">=",
          "0.8",
          ".0"
        ]
      },
      {
        "id": 33145,
        "nodeType": "ImportDirective",
        "src": "61:27:84",
        "nodes": [],
        "absolutePath": "../../node_modules/@latticexyz/solecs/src/System.sol",
        "file": "solecs/System.sol",
        "nameLocation": "-1:-1:-1",
        "scope": 33975,
        "sourceUnit": 4205,
        "symbolAliases": [],
        "unitAlias": ""
      },
      {
        "id": 33147,
        "nodeType": "ImportDirective",
        "src": "89:54:84",
        "nodes": [],
        "absolutePath": "../../node_modules/@latticexyz/solecs/src/interfaces/IWorld.sol",
        "file": "solecs/interfaces/IWorld.sol",
        "nameLocation": "-1:-1:-1",
        "scope": 33975,
        "sourceUnit": 5097,
        "symbolAliases": [
          {
            "foreign": {
              "id": 33146,
              "name": "IWorld",
              "nodeType": "Identifier",
              "overloadedDeclarations": [],
              "referencedDeclaration": 5096,
              "src": "98:6:84",
              "typeDescriptions": {}
            },
            "nameLocation": "-1:-1:-1"
          }
        ],
        "unitAlias": ""
      },
      {
        "id": 33150,
        "nodeType": "ImportDirective",
        "src": "144:67:84",
        "nodes": [],
        "absolutePath": "../../node_modules/@latticexyz/solecs/src/utils.sol",
        "file": "solecs/utils.sol",
        "nameLocation": "-1:-1:-1",
        "scope": 33975,
        "sourceUnit": 5364,
        "symbolAliases": [
          {
            "foreign": {
              "id": 33148,
              "name": "getAddressById",
              "nodeType": "Identifier",
              "overloadedDeclarations": [],
              "referencedDeclaration": 5176,
              "src": "153:14:84",
              "typeDescriptions": {}
            },
            "nameLocation": "-1:-1:-1"
          },
          {
            "foreign": {
              "id": 33149,
              "name": "addressToEntity",
              "nodeType": "Identifier",
              "overloadedDeclarations": [],
              "referencedDeclaration": 5140,
              "src": "169:15:84",
              "typeDescriptions": {}
            },
            "nameLocation": "-1:-1:-1"
          }
        ],
        "unitAlias": ""
      },
      {
        "id": 33153,
        "nodeType": "ImportDirective",
        "src": "212:99:84",
        "nodes": [],
        "absolutePath": "src/components/PositionComponent.sol",
        "file": "../components/PositionComponent.sol",
        "nameLocation": "-1:-1:-1",
        "scope": 33975,
        "sourceUnit": 23710,
        "symbolAliases": [
          {
            "foreign": {
              "id": 33151,
              "name": "PositionComponent",
              "nodeType": "Identifier",
              "overloadedDeclarations": [],
              "referencedDeclaration": 23709,
              "src": "221:17:84",
              "typeDescriptions": {}
            },
            "nameLocation": "-1:-1:-1"
          },
          {
            "foreign": {
              "id": 33152,
              "name": "ID",
              "nodeType": "Identifier",
              "overloadedDeclarations": [],
              "referencedDeclaration": 23696,
              "src": "240:2:84",
              "typeDescriptions": {}
            },
            "local": "PositionComponentID",
            "nameLocation": "-1:-1:-1"
          }
        ],
        "unitAlias": ""
      },
      {
        "id": 33156,
        "nodeType": "ImportDirective",
        "src": "312:96:84",
        "nodes": [],
        "absolutePath": "src/components/OwnedByComponent.sol",
        "file": "../components/OwnedByComponent.sol",
        "nameLocation": "-1:-1:-1",
        "scope": 33975,
        "sourceUnit": 23686,
        "symbolAliases": [
          {
            "foreign": {
              "id": 33154,
              "name": "OwnedByComponent",
              "nodeType": "Identifier",
              "overloadedDeclarations": [],
              "referencedDeclaration": 23685,
              "src": "321:16:84",
              "typeDescriptions": {}
            },
            "nameLocation": "-1:-1:-1"
          },
          {
            "foreign": {
              "id": 33155,
              "name": "ID",
              "nodeType": "Identifier",
              "overloadedDeclarations": [],
              "referencedDeclaration": 23672,
              "src": "339:2:84",
              "typeDescriptions": {}
            },
            "local": "OwnedByComponentID",
            "nameLocation": "-1:-1:-1"
          }
        ],
        "unitAlias": ""
      },
      {
        "id": 33158,
        "nodeType": "ImportDirective",
        "src": "409:57:84",
        "nodes": [],
        "absolutePath": "src/libraries/LibTerrain.sol",
        "file": "../libraries/LibTerrain.sol",
        "nameLocation": "-1:-1:-1",
        "scope": 33975,
        "sourceUnit": 28872,
        "symbolAliases": [
          {
            "foreign": {
              "id": 33157,
              "name": "LibTerrain",
              "nodeType": "Identifier",
              "overloadedDeclarations": [],
              "referencedDeclaration": 28871,
              "src": "418:10:84",
              "typeDescriptions": {}
            },
            "nameLocation": "-1:-1:-1"
          }
        ],
        "unitAlias": ""
      },
      {
        "id": 33193,
        "nodeType": "ImportDirective",
        "src": "467:438:84",
        "nodes": [],
        "absolutePath": "src/prototypes/Blocks.sol",
        "file": "../prototypes/Blocks.sol",
        "nameLocation": "-1:-1:-1",
        "scope": 33975,
        "sourceUnit": 30057,
        "symbolAliases": [
          {
            "foreign": {
              "id": 33159,
              "name": "AirID",
              "nodeType": "Identifier",
              "overloadedDeclarations": [],
              "referencedDeclaration": 28895,
              "src": "476:5:84",
              "typeDescriptions": {}
            },
            "nameLocation": "-1:-1:-1"
          },
          {
            "foreign": {
              "id": 33160,
              "name": "GrassID",
              "nodeType": "Identifier",
              "overloadedDeclarations": [],
              "referencedDeclaration": 28903,
              "src": "483:7:84",
              "typeDescriptions": {}
            },
            "nameLocation": "-1:-1:-1"
          },
          {
            "foreign": {
              "id": 33161,
              "name": "DirtID",
              "nodeType": "Identifier",
              "overloadedDeclarations": [],
              "referencedDeclaration": 28911,
              "src": "492:6:84",
              "typeDescriptions": {}
            },
            "nameLocation": "-1:-1:-1"
          },
          {
            "foreign": {
              "id": 33162,
              "name": "LogID",
              "nodeType": "Identifier",
              "overloadedDeclarations": [],
              "referencedDeclaration": 28919,
              "src": "500:5:84",
              "typeDescriptions": {}
            },
            "nameLocation": "-1:-1:-1"
          },
          {
            "foreign": {
              "id": 33163,
              "name": "StoneID",
              "nodeType": "Identifier",
              "overloadedDeclarations": [],
              "referencedDeclaration": 28927,
              "src": "507:7:84",
              "typeDescriptions": {}
            },
            "nameLocation": "-1:-1:-1"
          },
          {
            "foreign": {
              "id": 33164,
              "name": "SandID",
              "nodeType": "Identifier",
              "overloadedDeclarations": [],
              "referencedDeclaration": 28935,
              "src": "516:6:84",
              "typeDescriptions": {}
            },
            "nameLocation": "-1:-1:-1"
          },
          {
            "foreign": {
              "id": 33165,
              "name": "WaterID",
              "nodeType": "Identifier",
              "overloadedDeclarations": [],
              "referencedDeclaration": 28951,
              "src": "524:7:84",
              "typeDescriptions": {}
            },
            "nameLocation": "-1:-1:-1"
          },
          {
            "foreign": {
              "id": 33166,
              "name": "CobblestoneID",
              "nodeType": "Identifier",
              "overloadedDeclarations": [],
              "referencedDeclaration": 28959,
              "src": "533:13:84",
              "typeDescriptions": {}
            },
            "nameLocation": "-1:-1:-1"
          },
          {
            "foreign": {
              "id": 33167,
              "name": "CoalID",
              "nodeType": "Identifier",
              "overloadedDeclarations": [],
              "referencedDeclaration": 28975,
              "src": "548:6:84",
              "typeDescriptions": {}
            },
            "nameLocation": "-1:-1:-1"
          },
          {
            "foreign": {
              "id": 33168,
              "name": "CraftingID",
              "nodeType": "Identifier",
              "overloadedDeclarations": [],
              "referencedDeclaration": 28983,
              "src": "556:10:84",
              "typeDescriptions": {}
            },
            "nameLocation": "-1:-1:-1"
          },
          {
            "foreign": {
              "id": 33169,
              "name": "IronID",
              "nodeType": "Identifier",
              "overloadedDeclarations": [],
              "referencedDeclaration": 28991,
              "src": "568:6:84",
              "typeDescriptions": {}
            },
            "nameLocation": "-1:-1:-1"
          },
          {
            "foreign": {
              "id": 33170,
              "name": "GoldID",
              "nodeType": "Identifier",
              "overloadedDeclarations": [],
              "referencedDeclaration": 28999,
              "src": "576:6:84",
              "typeDescriptions": {}
            },
            "nameLocation": "-1:-1:-1"
          },
          {
            "foreign": {
              "id": 33171,
              "name": "DiamondID",
              "nodeType": "Identifier",
              "overloadedDeclarations": [],
              "referencedDeclaration": 29007,
              "src": "584:9:84",
              "typeDescriptions": {}
            },
            "nameLocation": "-1:-1:-1"
          },
          {
            "foreign": {
              "id": 33172,
              "name": "LeavesID",
              "nodeType": "Identifier",
              "overloadedDeclarations": [],
              "referencedDeclaration": 29015,
              "src": "595:8:84",
              "typeDescriptions": {}
            },
            "nameLocation": "-1:-1:-1"
          },
          {
            "foreign": {
              "id": 33173,
              "name": "PlanksID",
              "nodeType": "Identifier",
              "overloadedDeclarations": [],
              "referencedDeclaration": 29023,
              "src": "605:8:84",
              "typeDescriptions": {}
            },
            "nameLocation": "-1:-1:-1"
          },
          {
            "foreign": {
              "id": 33174,
              "name": "RedFlowerID",
              "nodeType": "Identifier",
              "overloadedDeclarations": [],
              "referencedDeclaration": 29031,
              "src": "615:11:84",
              "typeDescriptions": {}
            },
            "nameLocation": "-1:-1:-1"
          },
          {
            "foreign": {
              "id": 33175,
              "name": "GrassPlantID",
              "nodeType": "Identifier",
              "overloadedDeclarations": [],
              "referencedDeclaration": 29039,
              "src": "628:12:84",
              "typeDescriptions": {}
            },
            "nameLocation": "-1:-1:-1"
          },
          {
            "foreign": {
              "id": 33176,
              "name": "OrangeFlowerID",
              "nodeType": "Identifier",
              "overloadedDeclarations": [],
              "referencedDeclaration": 29047,
              "src": "642:14:84",
              "typeDescriptions": {}
            },
            "nameLocation": "-1:-1:-1"
          },
          {
            "foreign": {
              "id": 33177,
              "name": "MagentaFlowerID",
              "nodeType": "Identifier",
              "overloadedDeclarations": [],
              "referencedDeclaration": 29055,
              "src": "658:15:84",
              "typeDescriptions": {}
            },
            "nameLocation": "-1:-1:-1"
          },
          {
            "foreign": {
              "id": 33178,
              "name": "LightBlueFlowerID",
              "nodeType": "Identifier",
              "overloadedDeclarations": [],
              "referencedDeclaration": 29063,
              "src": "675:17:84",
              "typeDescriptions": {}
            },
            "nameLocation": "-1:-1:-1"
          },
          {
            "foreign": {
              "id": 33179,
              "name": "LimeFlowerID",
              "nodeType": "Identifier",
              "overloadedDeclarations": [],
              "referencedDeclaration": 29071,
              "src": "694:12:84",
              "typeDescriptions": {}
            },
            "nameLocation": "-1:-1:-1"
          },
          {
            "foreign": {
              "id": 33180,
              "name": "PinkFlowerID",
              "nodeType": "Identifier",
              "overloadedDeclarations": [],
              "referencedDeclaration": 29079,
              "src": "708:12:84",
              "typeDescriptions": {}
            },
            "nameLocation": "-1:-1:-1"
          },
          {
            "foreign": {
              "id": 33181,
              "name": "GrayFlowerID",
              "nodeType": "Identifier",
              "overloadedDeclarations": [],
              "referencedDeclaration": 29087,
              "src": "722:12:84",
              "typeDescriptions": {}
            },
            "nameLocation": "-1:-1:-1"
          },
          {
            "foreign": {
              "id": 33182,
              "name": "LightGrayFlowerID",
              "nodeType": "Identifier",
              "overloadedDeclarations": [],
              "referencedDeclaration": 29095,
              "src": "736:17:84",
              "typeDescriptions": {}
            },
            "nameLocation": "-1:-1:-1"
          },
          {
            "foreign": {
              "id": 33183,
              "name": "CyanFlowerID",
              "nodeType": "Identifier",
              "overloadedDeclarations": [],
              "referencedDeclaration": 29103,
              "src": "755:12:84",
              "typeDescriptions": {}
            },
            "nameLocation": "-1:-1:-1"
          },
          {
            "foreign": {
              "id": 33184,
              "name": "PurpleFlowerID",
              "nodeType": "Identifier",
              "overloadedDeclarations": [],
              "referencedDeclaration": 29111,
              "src": "769:14:84",
              "typeDescriptions": {}
            },
            "nameLocation": "-1:-1:-1"
          },
          {
            "foreign": {
              "id": 33185,
              "name": "BlueFlowerID",
              "nodeType": "Identifier",
              "overloadedDeclarations": [],
              "referencedDeclaration": 29119,
              "src": "785:12:84",
              "typeDescriptions": {}
            },
            "nameLocation": "-1:-1:-1"
          },
          {
            "foreign": {
              "id": 33186,
              "name": "GreenFlowerID",
              "nodeType": "Identifier",
              "overloadedDeclarations": [],
              "referencedDeclaration": 29127,
              "src": "799:13:84",
              "typeDescriptions": {}
            },
            "nameLocation": "-1:-1:-1"
          },
          {
            "foreign": {
              "id": 33187,
              "name": "BlackFlowerID",
              "nodeType": "Identifier",
              "overloadedDeclarations": [],
              "referencedDeclaration": 29135,
              "src": "814:13:84",
              "typeDescriptions": {}
            },
            "nameLocation": "-1:-1:-1"
          },
          {
            "foreign": {
              "id": 33188,
              "name": "KelpID",
              "nodeType": "Identifier",
              "overloadedDeclarations": [],
              "referencedDeclaration": 29143,
              "src": "829:6:84",
              "typeDescriptions": {}
            },
            "nameLocation": "-1:-1:-1"
          },
          {
            "foreign": {
              "id": 33189,
              "name": "WoolID",
              "nodeType": "Identifier",
              "overloadedDeclarations": [],
              "referencedDeclaration": 29151,
              "src": "837:6:84",
              "typeDescriptions": {}
            },
            "nameLocation": "-1:-1:-1"
          },
          {
            "foreign": {
              "id": 33190,
              "name": "SnowID",
              "nodeType": "Identifier",
              "overloadedDeclarations": [],
              "referencedDeclaration": 29287,
              "src": "845:6:84",
              "typeDescriptions": {}
            },
            "nameLocation": "-1:-1:-1"
          },
          {
            "foreign": {
              "id": 33191,
              "name": "ClayID",
              "nodeType": "Identifier",
              "overloadedDeclarations": [],
              "referencedDeclaration": 29295,
              "src": "853:6:84",
              "typeDescriptions": {}
            },
            "nameLocation": "-1:-1:-1"
          },
          {
            "foreign": {
              "id": 33192,
              "name": "BedrockID",
              "nodeType": "Identifier",
              "overloadedDeclarations": [],
              "referencedDeclaration": 29303,
              "src": "861:9:84",
              "typeDescriptions": {}
            },
            "nameLocation": "-1:-1:-1"
          }
        ],
        "unitAlias": ""
      },
      {
        "id": 33195,
        "nodeType": "ImportDirective",
        "src": "906:42:84",
        "nodes": [],
        "absolutePath": "src/utils.sol",
        "file": "../utils.sol",
        "nameLocation": "-1:-1:-1",
        "scope": 33975,
        "sourceUnit": 37773,
        "symbolAliases": [
          {
            "foreign": {
              "id": 33194,
              "name": "VoxelCoord",
              "nodeType": "Identifier",
              "overloadedDeclarations": [],
              "referencedDeclaration": 5927,
              "src": "915:10:84",
              "typeDescriptions": {}
            },
            "nameLocation": "-1:-1:-1"
          }
        ],
        "unitAlias": ""
      },
      {
        "id": 33203,
        "nodeType": "VariableDeclaration",
        "src": "950:61:84",
        "nodes": [],
        "constant": true,
        "mutability": "constant",
        "name": "ID",
        "nameLocation": "967:2:84",
        "scope": 33975,
        "stateVariable": false,
        "storageLocation": "default",
        "typeDescriptions": {
          "typeIdentifier": "t_uint256",
          "typeString": "uint256"
        },
        "typeName": {
          "id": 33196,
          "name": "uint256",
          "nodeType": "ElementaryTypeName",
          "src": "950:7:84",
          "typeDescriptions": {
            "typeIdentifier": "t_uint256",
            "typeString": "uint256"
          }
        },
        "value": {
          "arguments": [
            {
              "arguments": [
                {
                  "hexValue": "73797374656d2e4f6363757272656e6365",
                  "id": 33200,
                  "isConstant": false,
                  "isLValue": false,
                  "isPure": true,
                  "kind": "string",
                  "lValueRequested": false,
                  "nodeType": "Literal",
                  "src": "990:19:84",
                  "typeDescriptions": {
                    "typeIdentifier": "t_stringliteral_3f538547796fd5b66bb5ef6f2a3af7e6b66c2fe7b5491ad64b3d5502f8af1b78",
                    "typeString": "literal_string \"system.Occurrence\""
                  },
                  "value": "system.Occurrence"
                }
              ],
              "expression": {
                "argumentTypes": [
                  {
                    "typeIdentifier": "t_stringliteral_3f538547796fd5b66bb5ef6f2a3af7e6b66c2fe7b5491ad64b3d5502f8af1b78",
                    "typeString": "literal_string \"system.Occurrence\""
                  }
                ],
                "id": 33199,
                "name": "keccak256",
                "nodeType": "Identifier",
                "overloadedDeclarations": [],
                "referencedDeclaration": -8,
                "src": "980:9:84",
                "typeDescriptions": {
                  "typeIdentifier": "t_function_keccak256_pure$_t_bytes_memory_ptr_$returns$_t_bytes32_$",
                  "typeString": "function (bytes memory) pure returns (bytes32)"
                }
              },
              "id": 33201,
              "isConstant": false,
              "isLValue": false,
              "isPure": true,
              "kind": "functionCall",
              "lValueRequested": false,
              "names": [],
              "nodeType": "FunctionCall",
              "src": "980:30:84",
              "tryCall": false,
              "typeDescriptions": {
                "typeIdentifier": "t_bytes32",
                "typeString": "bytes32"
              }
            }
          ],
          "expression": {
            "argumentTypes": [
              {
                "typeIdentifier": "t_bytes32",
                "typeString": "bytes32"
              }
            ],
            "id": 33198,
            "isConstant": false,
            "isLValue": false,
            "isPure": true,
            "lValueRequested": false,
            "nodeType": "ElementaryTypeNameExpression",
            "src": "972:7:84",
            "typeDescriptions": {
              "typeIdentifier": "t_type$_t_uint256_$",
              "typeString": "type(uint256)"
            },
            "typeName": {
              "id": 33197,
              "name": "uint256",
              "nodeType": "ElementaryTypeName",
              "src": "972:7:84",
              "typeDescriptions": {}
            }
          },
          "id": 33202,
          "isConstant": false,
          "isLValue": false,
          "isPure": true,
          "kind": "typeConversion",
          "lValueRequested": false,
          "names": [],
          "nodeType": "FunctionCall",
          "src": "972:39:84",
          "tryCall": false,
          "typeDescriptions": {
            "typeIdentifier": "t_uint256",
            "typeString": "uint256"
          }
        },
        "visibility": "internal"
      },
      {
        "id": 33974,
        "nodeType": "ContractDefinition",
        "src": "1295:5864:84",
        "nodes": [
          {
            "id": 33218,
            "nodeType": "FunctionDefinition",
            "src": "1335:78:84",
            "nodes": [],
            "body": {
              "id": 33217,
              "nodeType": "Block",
              "src": "1411:2:84",
              "nodes": [],
              "statements": []
            },
            "implemented": true,
            "kind": "constructor",
            "modifiers": [
              {
                "arguments": [
                  {
                    "id": 33213,
                    "name": "_world",
                    "nodeType": "Identifier",
                    "overloadedDeclarations": [],
                    "referencedDeclaration": 33208,
                    "src": "1390:6:84",
                    "typeDescriptions": {
                      "typeIdentifier": "t_contract$_IWorld_$5096",
                      "typeString": "contract IWorld"
                    }
                  },
                  {
                    "id": 33214,
                    "name": "_components",
                    "nodeType": "Identifier",
                    "overloadedDeclarations": [],
                    "referencedDeclaration": 33210,
                    "src": "1398:11:84",
                    "typeDescriptions": {
                      "typeIdentifier": "t_address",
                      "typeString": "address"
                    }
                  }
                ],
                "id": 33215,
                "kind": "baseConstructorSpecifier",
                "modifierName": {
                  "id": 33212,
                  "name": "System",
                  "nodeType": "IdentifierPath",
                  "referencedDeclaration": 4204,
                  "src": "1383:6:84"
                },
                "nodeType": "ModifierInvocation",
                "src": "1383:27:84"
              }
            ],
            "name": "",
            "nameLocation": "-1:-1:-1",
            "parameters": {
              "id": 33211,
              "nodeType": "ParameterList",
              "parameters": [
                {
                  "constant": false,
                  "id": 33208,
                  "mutability": "mutable",
                  "name": "_world",
                  "nameLocation": "1354:6:84",
                  "nodeType": "VariableDeclaration",
                  "scope": 33218,
                  "src": "1347:13:84",
                  "stateVariable": false,
                  "storageLocation": "default",
                  "typeDescriptions": {
                    "typeIdentifier": "t_contract$_IWorld_$5096",
                    "typeString": "contract IWorld"
                  },
                  "typeName": {
                    "id": 33207,
                    "nodeType": "UserDefinedTypeName",
                    "pathNode": {
                      "id": 33206,
                      "name": "IWorld",
                      "nodeType": "IdentifierPath",
                      "referencedDeclaration": 5096,
                      "src": "1347:6:84"
                    },
                    "referencedDeclaration": 5096,
                    "src": "1347:6:84",
                    "typeDescriptions": {
                      "typeIdentifier": "t_contract$_IWorld_$5096",
                      "typeString": "contract IWorld"
                    }
                  },
                  "visibility": "internal"
                },
                {
                  "constant": false,
                  "id": 33210,
                  "mutability": "mutable",
                  "name": "_components",
                  "nameLocation": "1370:11:84",
                  "nodeType": "VariableDeclaration",
                  "scope": 33218,
                  "src": "1362:19:84",
                  "stateVariable": false,
                  "storageLocation": "default",
                  "typeDescriptions": {
                    "typeIdentifier": "t_address",
                    "typeString": "address"
                  },
                  "typeName": {
                    "id": 33209,
                    "name": "address",
                    "nodeType": "ElementaryTypeName",
                    "src": "1362:7:84",
                    "stateMutability": "nonpayable",
                    "typeDescriptions": {
                      "typeIdentifier": "t_address",
                      "typeString": "address"
                    }
                  },
                  "visibility": "internal"
                }
              ],
              "src": "1346:36:84"
            },
            "returnParameters": {
              "id": 33216,
              "nodeType": "ParameterList",
              "parameters": [],
              "src": "1411:0:84"
            },
            "scope": 33974,
            "stateMutability": "nonpayable",
            "virtual": false,
            "visibility": "public"
          },
          {
            "id": 33556,
            "nodeType": "FunctionDefinition",
            "src": "1417:2146:84",
            "nodes": [],
            "body": {
              "id": 33555,
              "nodeType": "Block",
              "src": "1493:2070:84",
              "nodes": [],
              "statements": [
                {
                  "assignments": [
                    33226,
                    33229
                  ],
                  "declarations": [
                    {
                      "constant": false,
                      "id": 33226,
                      "mutability": "mutable",
                      "name": "blockType",
                      "nameLocation": "1508:9:84",
                      "nodeType": "VariableDeclaration",
                      "scope": 33555,
                      "src": "1500:17:84",
                      "stateVariable": false,
                      "storageLocation": "default",
                      "typeDescriptions": {
                        "typeIdentifier": "t_uint256",
                        "typeString": "uint256"
                      },
                      "typeName": {
                        "id": 33225,
                        "name": "uint256",
                        "nodeType": "ElementaryTypeName",
                        "src": "1500:7:84",
                        "typeDescriptions": {
                          "typeIdentifier": "t_uint256",
                          "typeString": "uint256"
                        }
                      },
                      "visibility": "internal"
                    },
                    {
                      "constant": false,
                      "id": 33229,
                      "mutability": "mutable",
                      "name": "coord",
                      "nameLocation": "1537:5:84",
                      "nodeType": "VariableDeclaration",
                      "scope": 33555,
                      "src": "1519:23:84",
                      "stateVariable": false,
                      "storageLocation": "memory",
                      "typeDescriptions": {
                        "typeIdentifier": "t_struct$_VoxelCoord_$5927_memory_ptr",
                        "typeString": "struct VoxelCoord"
                      },
                      "typeName": {
                        "id": 33228,
                        "nodeType": "UserDefinedTypeName",
                        "pathNode": {
                          "id": 33227,
                          "name": "VoxelCoord",
                          "nodeType": "IdentifierPath",
                          "referencedDeclaration": 5927,
                          "src": "1519:10:84"
                        },
                        "referencedDeclaration": 5927,
                        "src": "1519:10:84",
                        "typeDescriptions": {
                          "typeIdentifier": "t_struct$_VoxelCoord_$5927_storage_ptr",
                          "typeString": "struct VoxelCoord"
                        }
                      },
                      "visibility": "internal"
                    }
                  ],
                  "id": 33238,
                  "initialValue": {
                    "arguments": [
                      {
                        "id": 33232,
                        "name": "arguments",
                        "nodeType": "Identifier",
                        "overloadedDeclarations": [],
                        "referencedDeclaration": 33220,
                        "src": "1557:9:84",
                        "typeDescriptions": {
                          "typeIdentifier": "t_bytes_memory_ptr",
                          "typeString": "bytes memory"
                        }
                      },
                      {
                        "components": [
                          {
                            "id": 33234,
                            "isConstant": false,
                            "isLValue": false,
                            "isPure": true,
                            "lValueRequested": false,
                            "nodeType": "ElementaryTypeNameExpression",
                            "src": "1569:7:84",
                            "typeDescriptions": {
                              "typeIdentifier": "t_type$_t_uint256_$",
                              "typeString": "type(uint256)"
                            },
                            "typeName": {
                              "id": 33233,
                              "name": "uint256",
                              "nodeType": "ElementaryTypeName",
                              "src": "1569:7:84",
                              "typeDescriptions": {}
                            }
                          },
                          {
                            "id": 33235,
                            "name": "VoxelCoord",
                            "nodeType": "Identifier",
                            "overloadedDeclarations": [],
                            "referencedDeclaration": 5927,
                            "src": "1578:10:84",
                            "typeDescriptions": {
                              "typeIdentifier": "t_type$_t_struct$_VoxelCoord_$5927_storage_ptr_$",
                              "typeString": "type(struct VoxelCoord storage pointer)"
                            }
                          }
                        ],
                        "id": 33236,
                        "isConstant": false,
                        "isInlineArray": false,
                        "isLValue": false,
                        "isPure": true,
                        "lValueRequested": false,
                        "nodeType": "TupleExpression",
                        "src": "1568:21:84",
                        "typeDescriptions": {
                          "typeIdentifier": "t_tuple$_t_type$_t_uint256_$_$_t_type$_t_struct$_VoxelCoord_$5927_storage_ptr_$_$",
                          "typeString": "tuple(type(uint256),type(struct VoxelCoord storage pointer))"
                        }
                      }
                    ],
                    "expression": {
                      "argumentTypes": [
                        {
                          "typeIdentifier": "t_bytes_memory_ptr",
                          "typeString": "bytes memory"
                        },
                        {
                          "typeIdentifier": "t_tuple$_t_type$_t_uint256_$_$_t_type$_t_struct$_VoxelCoord_$5927_storage_ptr_$_$",
                          "typeString": "tuple(type(uint256),type(struct VoxelCoord storage pointer))"
                        }
                      ],
                      "expression": {
                        "id": 33230,
                        "name": "abi",
                        "nodeType": "Identifier",
                        "overloadedDeclarations": [],
                        "referencedDeclaration": -1,
                        "src": "1546:3:84",
                        "typeDescriptions": {
                          "typeIdentifier": "t_magic_abi",
                          "typeString": "abi"
                        }
                      },
                      "id": 33231,
                      "isConstant": false,
                      "isLValue": false,
                      "isPure": true,
                      "lValueRequested": false,
                      "memberName": "decode",
                      "nodeType": "MemberAccess",
                      "src": "1546:10:84",
                      "typeDescriptions": {
                        "typeIdentifier": "t_function_abidecode_pure$__$returns$__$",
                        "typeString": "function () pure"
                      }
                    },
                    "id": 33237,
                    "isConstant": false,
                    "isLValue": false,
                    "isPure": false,
                    "kind": "functionCall",
                    "lValueRequested": false,
                    "names": [],
                    "nodeType": "FunctionCall",
                    "src": "1546:44:84",
                    "tryCall": false,
                    "typeDescriptions": {
                      "typeIdentifier": "t_tuple$_t_uint256_$_t_struct$_VoxelCoord_$5927_memory_ptr_$",
                      "typeString": "tuple(uint256,struct VoxelCoord memory)"
                    }
                  },
                  "nodeType": "VariableDeclarationStatement",
                  "src": "1499:91:84"
                },
                {
                  "condition": {
                    "commonType": {
                      "typeIdentifier": "t_uint256",
                      "typeString": "uint256"
                    },
                    "id": 33241,
                    "isConstant": false,
                    "isLValue": false,
                    "isPure": false,
                    "lValueRequested": false,
                    "leftExpression": {
                      "id": 33239,
                      "name": "blockType",
                      "nodeType": "Identifier",
                      "overloadedDeclarations": [],
                      "referencedDeclaration": 33226,
                      "src": "1601:9:84",
                      "typeDescriptions": {
                        "typeIdentifier": "t_uint256",
                        "typeString": "uint256"
                      }
                    },
                    "nodeType": "BinaryOperation",
                    "operator": "==",
                    "rightExpression": {
                      "id": 33240,
                      "name": "GrassID",
                      "nodeType": "Identifier",
                      "overloadedDeclarations": [],
                      "referencedDeclaration": 28903,
                      "src": "1614:7:84",
                      "typeDescriptions": {
                        "typeIdentifier": "t_uint256",
                        "typeString": "uint256"
                      }
                    },
                    "src": "1601:20:84",
                    "typeDescriptions": {
                      "typeIdentifier": "t_bool",
                      "typeString": "bool"
                    }
                  },
                  "id": 33249,
                  "nodeType": "IfStatement",
                  "src": "1597:57:84",
                  "trueBody": {
                    "expression": {
                      "arguments": [
                        {
                          "arguments": [
                            {
                              "id": 33245,
                              "name": "coord",
                              "nodeType": "Identifier",
                              "overloadedDeclarations": [],
                              "referencedDeclaration": 33229,
                              "src": "1647:5:84",
                              "typeDescriptions": {
                                "typeIdentifier": "t_struct$_VoxelCoord_$5927_memory_ptr",
                                "typeString": "struct VoxelCoord memory"
                              }
                            }
                          ],
                          "expression": {
                            "argumentTypes": [
                              {
                                "typeIdentifier": "t_struct$_VoxelCoord_$5927_memory_ptr",
                                "typeString": "struct VoxelCoord memory"
                              }
                            ],
                            "id": 33244,
                            "name": "Grass",
                            "nodeType": "Identifier",
                            "overloadedDeclarations": [],
                            "referencedDeclaration": 33595,
                            "src": "1641:5:84",
                            "typeDescriptions": {
                              "typeIdentifier": "t_function_internal_pure$_t_struct$_VoxelCoord_$5927_memory_ptr_$returns$_t_uint256_$",
                              "typeString": "function (struct VoxelCoord memory) pure returns (uint256)"
                            }
                          },
                          "id": 33246,
                          "isConstant": false,
                          "isLValue": false,
                          "isPure": false,
                          "kind": "functionCall",
                          "lValueRequested": false,
                          "names": [],
                          "nodeType": "FunctionCall",
                          "src": "1641:12:84",
                          "tryCall": false,
                          "typeDescriptions": {
                            "typeIdentifier": "t_uint256",
                            "typeString": "uint256"
                          }
                        }
                      ],
                      "expression": {
                        "argumentTypes": [
                          {
                            "typeIdentifier": "t_uint256",
                            "typeString": "uint256"
                          }
                        ],
                        "expression": {
                          "id": 33242,
                          "name": "abi",
                          "nodeType": "Identifier",
                          "overloadedDeclarations": [],
                          "referencedDeclaration": -1,
                          "src": "1630:3:84",
                          "typeDescriptions": {
                            "typeIdentifier": "t_magic_abi",
                            "typeString": "abi"
                          }
                        },
                        "id": 33243,
                        "isConstant": false,
                        "isLValue": false,
                        "isPure": true,
                        "lValueRequested": false,
                        "memberName": "encode",
                        "nodeType": "MemberAccess",
                        "src": "1630:10:84",
                        "typeDescriptions": {
                          "typeIdentifier": "t_function_abiencode_pure$__$returns$_t_bytes_memory_ptr_$",
                          "typeString": "function () pure returns (bytes memory)"
                        }
                      },
                      "id": 33247,
                      "isConstant": false,
                      "isLValue": false,
                      "isPure": false,
                      "kind": "functionCall",
                      "lValueRequested": false,
                      "names": [],
                      "nodeType": "FunctionCall",
                      "src": "1630:24:84",
                      "tryCall": false,
                      "typeDescriptions": {
                        "typeIdentifier": "t_bytes_memory_ptr",
                        "typeString": "bytes memory"
                      }
                    },
                    "functionReturnParameters": 33224,
                    "id": 33248,
                    "nodeType": "Return",
                    "src": "1623:31:84"
                  }
                },
                {
                  "condition": {
                    "commonType": {
                      "typeIdentifier": "t_uint256",
                      "typeString": "uint256"
                    },
                    "id": 33252,
                    "isConstant": false,
                    "isLValue": false,
                    "isPure": false,
                    "lValueRequested": false,
                    "leftExpression": {
                      "id": 33250,
                      "name": "blockType",
                      "nodeType": "Identifier",
                      "overloadedDeclarations": [],
                      "referencedDeclaration": 33226,
                      "src": "1664:9:84",
                      "typeDescriptions": {
                        "typeIdentifier": "t_uint256",
                        "typeString": "uint256"
                      }
                    },
                    "nodeType": "BinaryOperation",
                    "operator": "==",
                    "rightExpression": {
                      "id": 33251,
                      "name": "DirtID",
                      "nodeType": "Identifier",
                      "overloadedDeclarations": [],
                      "referencedDeclaration": 28911,
                      "src": "1677:6:84",
                      "typeDescriptions": {
                        "typeIdentifier": "t_uint256",
                        "typeString": "uint256"
                      }
                    },
                    "src": "1664:19:84",
                    "typeDescriptions": {
                      "typeIdentifier": "t_bool",
                      "typeString": "bool"
                    }
                  },
                  "id": 33260,
                  "nodeType": "IfStatement",
                  "src": "1660:55:84",
                  "trueBody": {
                    "expression": {
                      "arguments": [
                        {
                          "arguments": [
                            {
                              "id": 33256,
                              "name": "coord",
                              "nodeType": "Identifier",
                              "overloadedDeclarations": [],
                              "referencedDeclaration": 33229,
                              "src": "1708:5:84",
                              "typeDescriptions": {
                                "typeIdentifier": "t_struct$_VoxelCoord_$5927_memory_ptr",
                                "typeString": "struct VoxelCoord memory"
                              }
                            }
                          ],
                          "expression": {
                            "argumentTypes": [
                              {
                                "typeIdentifier": "t_struct$_VoxelCoord_$5927_memory_ptr",
                                "typeString": "struct VoxelCoord memory"
                              }
                            ],
                            "id": 33255,
                            "name": "Dirt",
                            "nodeType": "Identifier",
                            "overloadedDeclarations": [],
                            "referencedDeclaration": 33609,
                            "src": "1703:4:84",
                            "typeDescriptions": {
                              "typeIdentifier": "t_function_internal_pure$_t_struct$_VoxelCoord_$5927_memory_ptr_$returns$_t_uint256_$",
                              "typeString": "function (struct VoxelCoord memory) pure returns (uint256)"
                            }
                          },
                          "id": 33257,
                          "isConstant": false,
                          "isLValue": false,
                          "isPure": false,
                          "kind": "functionCall",
                          "lValueRequested": false,
                          "names": [],
                          "nodeType": "FunctionCall",
                          "src": "1703:11:84",
                          "tryCall": false,
                          "typeDescriptions": {
                            "typeIdentifier": "t_uint256",
                            "typeString": "uint256"
                          }
                        }
                      ],
                      "expression": {
                        "argumentTypes": [
                          {
                            "typeIdentifier": "t_uint256",
                            "typeString": "uint256"
                          }
                        ],
                        "expression": {
                          "id": 33253,
                          "name": "abi",
                          "nodeType": "Identifier",
                          "overloadedDeclarations": [],
                          "referencedDeclaration": -1,
                          "src": "1692:3:84",
                          "typeDescriptions": {
                            "typeIdentifier": "t_magic_abi",
                            "typeString": "abi"
                          }
                        },
                        "id": 33254,
                        "isConstant": false,
                        "isLValue": false,
                        "isPure": true,
                        "lValueRequested": false,
                        "memberName": "encode",
                        "nodeType": "MemberAccess",
                        "src": "1692:10:84",
                        "typeDescriptions": {
                          "typeIdentifier": "t_function_abiencode_pure$__$returns$_t_bytes_memory_ptr_$",
                          "typeString": "function () pure returns (bytes memory)"
                        }
                      },
                      "id": 33258,
                      "isConstant": false,
                      "isLValue": false,
                      "isPure": false,
                      "kind": "functionCall",
                      "lValueRequested": false,
                      "names": [],
                      "nodeType": "FunctionCall",
                      "src": "1692:23:84",
                      "tryCall": false,
                      "typeDescriptions": {
                        "typeIdentifier": "t_bytes_memory_ptr",
                        "typeString": "bytes memory"
                      }
                    },
                    "functionReturnParameters": 33224,
                    "id": 33259,
                    "nodeType": "Return",
                    "src": "1685:30:84"
                  }
                },
                {
                  "condition": {
                    "commonType": {
                      "typeIdentifier": "t_uint256",
                      "typeString": "uint256"
                    },
                    "id": 33263,
                    "isConstant": false,
                    "isLValue": false,
                    "isPure": false,
                    "lValueRequested": false,
                    "leftExpression": {
                      "id": 33261,
                      "name": "blockType",
                      "nodeType": "Identifier",
                      "overloadedDeclarations": [],
                      "referencedDeclaration": 33226,
                      "src": "1725:9:84",
                      "typeDescriptions": {
                        "typeIdentifier": "t_uint256",
                        "typeString": "uint256"
                      }
                    },
                    "nodeType": "BinaryOperation",
                    "operator": "==",
                    "rightExpression": {
                      "id": 33262,
                      "name": "LogID",
                      "nodeType": "Identifier",
                      "overloadedDeclarations": [],
                      "referencedDeclaration": 28919,
                      "src": "1738:5:84",
                      "typeDescriptions": {
                        "typeIdentifier": "t_uint256",
                        "typeString": "uint256"
                      }
                    },
                    "src": "1725:18:84",
                    "typeDescriptions": {
                      "typeIdentifier": "t_bool",
                      "typeString": "bool"
                    }
                  },
                  "id": 33271,
                  "nodeType": "IfStatement",
                  "src": "1721:53:84",
                  "trueBody": {
                    "expression": {
                      "arguments": [
                        {
                          "arguments": [
                            {
                              "id": 33267,
                              "name": "coord",
                              "nodeType": "Identifier",
                              "overloadedDeclarations": [],
                              "referencedDeclaration": 33229,
                              "src": "1767:5:84",
                              "typeDescriptions": {
                                "typeIdentifier": "t_struct$_VoxelCoord_$5927_memory_ptr",
                                "typeString": "struct VoxelCoord memory"
                              }
                            }
                          ],
                          "expression": {
                            "argumentTypes": [
                              {
                                "typeIdentifier": "t_struct$_VoxelCoord_$5927_memory_ptr",
                                "typeString": "struct VoxelCoord memory"
                              }
                            ],
                            "id": 33266,
                            "name": "Log",
                            "nodeType": "Identifier",
                            "overloadedDeclarations": [],
                            "referencedDeclaration": 33623,
                            "src": "1763:3:84",
                            "typeDescriptions": {
                              "typeIdentifier": "t_function_internal_pure$_t_struct$_VoxelCoord_$5927_memory_ptr_$returns$_t_uint256_$",
                              "typeString": "function (struct VoxelCoord memory) pure returns (uint256)"
                            }
                          },
                          "id": 33268,
                          "isConstant": false,
                          "isLValue": false,
                          "isPure": false,
                          "kind": "functionCall",
                          "lValueRequested": false,
                          "names": [],
                          "nodeType": "FunctionCall",
                          "src": "1763:10:84",
                          "tryCall": false,
                          "typeDescriptions": {
                            "typeIdentifier": "t_uint256",
                            "typeString": "uint256"
                          }
                        }
                      ],
                      "expression": {
                        "argumentTypes": [
                          {
                            "typeIdentifier": "t_uint256",
                            "typeString": "uint256"
                          }
                        ],
                        "expression": {
                          "id": 33264,
                          "name": "abi",
                          "nodeType": "Identifier",
                          "overloadedDeclarations": [],
                          "referencedDeclaration": -1,
                          "src": "1752:3:84",
                          "typeDescriptions": {
                            "typeIdentifier": "t_magic_abi",
                            "typeString": "abi"
                          }
                        },
                        "id": 33265,
                        "isConstant": false,
                        "isLValue": false,
                        "isPure": true,
                        "lValueRequested": false,
                        "memberName": "encode",
                        "nodeType": "MemberAccess",
                        "src": "1752:10:84",
                        "typeDescriptions": {
                          "typeIdentifier": "t_function_abiencode_pure$__$returns$_t_bytes_memory_ptr_$",
                          "typeString": "function () pure returns (bytes memory)"
                        }
                      },
                      "id": 33269,
                      "isConstant": false,
                      "isLValue": false,
                      "isPure": false,
                      "kind": "functionCall",
                      "lValueRequested": false,
                      "names": [],
                      "nodeType": "FunctionCall",
                      "src": "1752:22:84",
                      "tryCall": false,
                      "typeDescriptions": {
                        "typeIdentifier": "t_bytes_memory_ptr",
                        "typeString": "bytes memory"
                      }
                    },
                    "functionReturnParameters": 33224,
                    "id": 33270,
                    "nodeType": "Return",
                    "src": "1745:29:84"
                  }
                },
                {
                  "condition": {
                    "commonType": {
                      "typeIdentifier": "t_uint256",
                      "typeString": "uint256"
                    },
                    "id": 33274,
                    "isConstant": false,
                    "isLValue": false,
                    "isPure": false,
                    "lValueRequested": false,
                    "leftExpression": {
                      "id": 33272,
                      "name": "blockType",
                      "nodeType": "Identifier",
                      "overloadedDeclarations": [],
                      "referencedDeclaration": 33226,
                      "src": "1784:9:84",
                      "typeDescriptions": {
                        "typeIdentifier": "t_uint256",
                        "typeString": "uint256"
                      }
                    },
                    "nodeType": "BinaryOperation",
                    "operator": "==",
                    "rightExpression": {
                      "id": 33273,
                      "name": "StoneID",
                      "nodeType": "Identifier",
                      "overloadedDeclarations": [],
                      "referencedDeclaration": 28927,
                      "src": "1797:7:84",
                      "typeDescriptions": {
                        "typeIdentifier": "t_uint256",
                        "typeString": "uint256"
                      }
                    },
                    "src": "1784:20:84",
                    "typeDescriptions": {
                      "typeIdentifier": "t_bool",
                      "typeString": "bool"
                    }
                  },
                  "id": 33282,
                  "nodeType": "IfStatement",
                  "src": "1780:57:84",
                  "trueBody": {
                    "expression": {
                      "arguments": [
                        {
                          "arguments": [
                            {
                              "id": 33278,
                              "name": "coord",
                              "nodeType": "Identifier",
                              "overloadedDeclarations": [],
                              "referencedDeclaration": 33229,
                              "src": "1830:5:84",
                              "typeDescriptions": {
                                "typeIdentifier": "t_struct$_VoxelCoord_$5927_memory_ptr",
                                "typeString": "struct VoxelCoord memory"
                              }
                            }
                          ],
                          "expression": {
                            "argumentTypes": [
                              {
                                "typeIdentifier": "t_struct$_VoxelCoord_$5927_memory_ptr",
                                "typeString": "struct VoxelCoord memory"
                              }
                            ],
                            "id": 33277,
                            "name": "Stone",
                            "nodeType": "Identifier",
                            "overloadedDeclarations": [],
                            "referencedDeclaration": 33637,
                            "src": "1824:5:84",
                            "typeDescriptions": {
                              "typeIdentifier": "t_function_internal_pure$_t_struct$_VoxelCoord_$5927_memory_ptr_$returns$_t_uint256_$",
                              "typeString": "function (struct VoxelCoord memory) pure returns (uint256)"
                            }
                          },
                          "id": 33279,
                          "isConstant": false,
                          "isLValue": false,
                          "isPure": false,
                          "kind": "functionCall",
                          "lValueRequested": false,
                          "names": [],
                          "nodeType": "FunctionCall",
                          "src": "1824:12:84",
                          "tryCall": false,
                          "typeDescriptions": {
                            "typeIdentifier": "t_uint256",
                            "typeString": "uint256"
                          }
                        }
                      ],
                      "expression": {
                        "argumentTypes": [
                          {
                            "typeIdentifier": "t_uint256",
                            "typeString": "uint256"
                          }
                        ],
                        "expression": {
                          "id": 33275,
                          "name": "abi",
                          "nodeType": "Identifier",
                          "overloadedDeclarations": [],
                          "referencedDeclaration": -1,
                          "src": "1813:3:84",
                          "typeDescriptions": {
                            "typeIdentifier": "t_magic_abi",
                            "typeString": "abi"
                          }
                        },
                        "id": 33276,
                        "isConstant": false,
                        "isLValue": false,
                        "isPure": true,
                        "lValueRequested": false,
                        "memberName": "encode",
                        "nodeType": "MemberAccess",
                        "src": "1813:10:84",
                        "typeDescriptions": {
                          "typeIdentifier": "t_function_abiencode_pure$__$returns$_t_bytes_memory_ptr_$",
                          "typeString": "function () pure returns (bytes memory)"
                        }
                      },
                      "id": 33280,
                      "isConstant": false,
                      "isLValue": false,
                      "isPure": false,
                      "kind": "functionCall",
                      "lValueRequested": false,
                      "names": [],
                      "nodeType": "FunctionCall",
                      "src": "1813:24:84",
                      "tryCall": false,
                      "typeDescriptions": {
                        "typeIdentifier": "t_bytes_memory_ptr",
                        "typeString": "bytes memory"
                      }
                    },
                    "functionReturnParameters": 33224,
                    "id": 33281,
                    "nodeType": "Return",
                    "src": "1806:31:84"
                  }
                },
                {
                  "condition": {
                    "commonType": {
                      "typeIdentifier": "t_uint256",
                      "typeString": "uint256"
                    },
                    "id": 33285,
                    "isConstant": false,
                    "isLValue": false,
                    "isPure": false,
                    "lValueRequested": false,
                    "leftExpression": {
                      "id": 33283,
                      "name": "blockType",
                      "nodeType": "Identifier",
                      "overloadedDeclarations": [],
                      "referencedDeclaration": 33226,
                      "src": "1847:9:84",
                      "typeDescriptions": {
                        "typeIdentifier": "t_uint256",
                        "typeString": "uint256"
                      }
                    },
                    "nodeType": "BinaryOperation",
                    "operator": "==",
                    "rightExpression": {
                      "id": 33284,
                      "name": "SandID",
                      "nodeType": "Identifier",
                      "overloadedDeclarations": [],
                      "referencedDeclaration": 28935,
                      "src": "1860:6:84",
                      "typeDescriptions": {
                        "typeIdentifier": "t_uint256",
                        "typeString": "uint256"
                      }
                    },
                    "src": "1847:19:84",
                    "typeDescriptions": {
                      "typeIdentifier": "t_bool",
                      "typeString": "bool"
                    }
                  },
                  "id": 33293,
                  "nodeType": "IfStatement",
                  "src": "1843:55:84",
                  "trueBody": {
                    "expression": {
                      "arguments": [
                        {
                          "arguments": [
                            {
                              "id": 33289,
                              "name": "coord",
                              "nodeType": "Identifier",
                              "overloadedDeclarations": [],
                              "referencedDeclaration": 33229,
                              "src": "1891:5:84",
                              "typeDescriptions": {
                                "typeIdentifier": "t_struct$_VoxelCoord_$5927_memory_ptr",
                                "typeString": "struct VoxelCoord memory"
                              }
                            }
                          ],
                          "expression": {
                            "argumentTypes": [
                              {
                                "typeIdentifier": "t_struct$_VoxelCoord_$5927_memory_ptr",
                                "typeString": "struct VoxelCoord memory"
                              }
                            ],
                            "id": 33288,
                            "name": "Sand",
                            "nodeType": "Identifier",
                            "overloadedDeclarations": [],
                            "referencedDeclaration": 33651,
                            "src": "1886:4:84",
                            "typeDescriptions": {
                              "typeIdentifier": "t_function_internal_pure$_t_struct$_VoxelCoord_$5927_memory_ptr_$returns$_t_uint256_$",
                              "typeString": "function (struct VoxelCoord memory) pure returns (uint256)"
                            }
                          },
                          "id": 33290,
                          "isConstant": false,
                          "isLValue": false,
                          "isPure": false,
                          "kind": "functionCall",
                          "lValueRequested": false,
                          "names": [],
                          "nodeType": "FunctionCall",
                          "src": "1886:11:84",
                          "tryCall": false,
                          "typeDescriptions": {
                            "typeIdentifier": "t_uint256",
                            "typeString": "uint256"
                          }
                        }
                      ],
                      "expression": {
                        "argumentTypes": [
                          {
                            "typeIdentifier": "t_uint256",
                            "typeString": "uint256"
                          }
                        ],
                        "expression": {
                          "id": 33286,
                          "name": "abi",
                          "nodeType": "Identifier",
                          "overloadedDeclarations": [],
                          "referencedDeclaration": -1,
                          "src": "1875:3:84",
                          "typeDescriptions": {
                            "typeIdentifier": "t_magic_abi",
                            "typeString": "abi"
                          }
                        },
                        "id": 33287,
                        "isConstant": false,
                        "isLValue": false,
                        "isPure": true,
                        "lValueRequested": false,
                        "memberName": "encode",
                        "nodeType": "MemberAccess",
                        "src": "1875:10:84",
                        "typeDescriptions": {
                          "typeIdentifier": "t_function_abiencode_pure$__$returns$_t_bytes_memory_ptr_$",
                          "typeString": "function () pure returns (bytes memory)"
                        }
                      },
                      "id": 33291,
                      "isConstant": false,
                      "isLValue": false,
                      "isPure": false,
                      "kind": "functionCall",
                      "lValueRequested": false,
                      "names": [],
                      "nodeType": "FunctionCall",
                      "src": "1875:23:84",
                      "tryCall": false,
                      "typeDescriptions": {
                        "typeIdentifier": "t_bytes_memory_ptr",
                        "typeString": "bytes memory"
                      }
                    },
                    "functionReturnParameters": 33224,
                    "id": 33292,
                    "nodeType": "Return",
                    "src": "1868:30:84"
                  }
                },
                {
                  "condition": {
                    "commonType": {
                      "typeIdentifier": "t_uint256",
                      "typeString": "uint256"
                    },
                    "id": 33296,
                    "isConstant": false,
                    "isLValue": false,
                    "isPure": false,
                    "lValueRequested": false,
                    "leftExpression": {
                      "id": 33294,
                      "name": "blockType",
                      "nodeType": "Identifier",
                      "overloadedDeclarations": [],
                      "referencedDeclaration": 33226,
                      "src": "1908:9:84",
                      "typeDescriptions": {
                        "typeIdentifier": "t_uint256",
                        "typeString": "uint256"
                      }
                    },
                    "nodeType": "BinaryOperation",
                    "operator": "==",
                    "rightExpression": {
                      "id": 33295,
                      "name": "WaterID",
                      "nodeType": "Identifier",
                      "overloadedDeclarations": [],
                      "referencedDeclaration": 28951,
                      "src": "1921:7:84",
                      "typeDescriptions": {
                        "typeIdentifier": "t_uint256",
                        "typeString": "uint256"
                      }
                    },
                    "src": "1908:20:84",
                    "typeDescriptions": {
                      "typeIdentifier": "t_bool",
                      "typeString": "bool"
                    }
                  },
                  "id": 33304,
                  "nodeType": "IfStatement",
                  "src": "1904:57:84",
                  "trueBody": {
                    "expression": {
                      "arguments": [
                        {
                          "arguments": [
                            {
                              "id": 33300,
                              "name": "coord",
                              "nodeType": "Identifier",
                              "overloadedDeclarations": [],
                              "referencedDeclaration": 33229,
                              "src": "1954:5:84",
                              "typeDescriptions": {
                                "typeIdentifier": "t_struct$_VoxelCoord_$5927_memory_ptr",
                                "typeString": "struct VoxelCoord memory"
                              }
                            }
                          ],
                          "expression": {
                            "argumentTypes": [
                              {
                                "typeIdentifier": "t_struct$_VoxelCoord_$5927_memory_ptr",
                                "typeString": "struct VoxelCoord memory"
                              }
                            ],
                            "id": 33299,
                            "name": "Water",
                            "nodeType": "Identifier",
                            "overloadedDeclarations": [],
                            "referencedDeclaration": 33665,
                            "src": "1948:5:84",
                            "typeDescriptions": {
                              "typeIdentifier": "t_function_internal_pure$_t_struct$_VoxelCoord_$5927_memory_ptr_$returns$_t_uint256_$",
                              "typeString": "function (struct VoxelCoord memory) pure returns (uint256)"
                            }
                          },
                          "id": 33301,
                          "isConstant": false,
                          "isLValue": false,
                          "isPure": false,
                          "kind": "functionCall",
                          "lValueRequested": false,
                          "names": [],
                          "nodeType": "FunctionCall",
                          "src": "1948:12:84",
                          "tryCall": false,
                          "typeDescriptions": {
                            "typeIdentifier": "t_uint256",
                            "typeString": "uint256"
                          }
                        }
                      ],
                      "expression": {
                        "argumentTypes": [
                          {
                            "typeIdentifier": "t_uint256",
                            "typeString": "uint256"
                          }
                        ],
                        "expression": {
                          "id": 33297,
                          "name": "abi",
                          "nodeType": "Identifier",
                          "overloadedDeclarations": [],
                          "referencedDeclaration": -1,
                          "src": "1937:3:84",
                          "typeDescriptions": {
                            "typeIdentifier": "t_magic_abi",
                            "typeString": "abi"
                          }
                        },
                        "id": 33298,
                        "isConstant": false,
                        "isLValue": false,
                        "isPure": true,
                        "lValueRequested": false,
                        "memberName": "encode",
                        "nodeType": "MemberAccess",
                        "src": "1937:10:84",
                        "typeDescriptions": {
                          "typeIdentifier": "t_function_abiencode_pure$__$returns$_t_bytes_memory_ptr_$",
                          "typeString": "function () pure returns (bytes memory)"
                        }
                      },
                      "id": 33302,
                      "isConstant": false,
                      "isLValue": false,
                      "isPure": false,
                      "kind": "functionCall",
                      "lValueRequested": false,
                      "names": [],
                      "nodeType": "FunctionCall",
                      "src": "1937:24:84",
                      "tryCall": false,
                      "typeDescriptions": {
                        "typeIdentifier": "t_bytes_memory_ptr",
                        "typeString": "bytes memory"
                      }
                    },
                    "functionReturnParameters": 33224,
                    "id": 33303,
                    "nodeType": "Return",
                    "src": "1930:31:84"
                  }
                },
                {
                  "condition": {
                    "commonType": {
                      "typeIdentifier": "t_uint256",
                      "typeString": "uint256"
                    },
                    "id": 33307,
                    "isConstant": false,
                    "isLValue": false,
                    "isPure": false,
                    "lValueRequested": false,
                    "leftExpression": {
                      "id": 33305,
                      "name": "blockType",
                      "nodeType": "Identifier",
                      "overloadedDeclarations": [],
                      "referencedDeclaration": 33226,
                      "src": "1971:9:84",
                      "typeDescriptions": {
                        "typeIdentifier": "t_uint256",
                        "typeString": "uint256"
                      }
                    },
                    "nodeType": "BinaryOperation",
                    "operator": "==",
                    "rightExpression": {
                      "id": 33306,
                      "name": "DiamondID",
                      "nodeType": "Identifier",
                      "overloadedDeclarations": [],
                      "referencedDeclaration": 29007,
                      "src": "1984:9:84",
                      "typeDescriptions": {
                        "typeIdentifier": "t_uint256",
                        "typeString": "uint256"
                      }
                    },
                    "src": "1971:22:84",
                    "typeDescriptions": {
                      "typeIdentifier": "t_bool",
                      "typeString": "bool"
                    }
                  },
                  "id": 33315,
                  "nodeType": "IfStatement",
                  "src": "1967:61:84",
                  "trueBody": {
                    "expression": {
                      "arguments": [
                        {
                          "arguments": [
                            {
                              "id": 33311,
                              "name": "coord",
                              "nodeType": "Identifier",
                              "overloadedDeclarations": [],
                              "referencedDeclaration": 33229,
                              "src": "2021:5:84",
                              "typeDescriptions": {
                                "typeIdentifier": "t_struct$_VoxelCoord_$5927_memory_ptr",
                                "typeString": "struct VoxelCoord memory"
                              }
                            }
                          ],
                          "expression": {
                            "argumentTypes": [
                              {
                                "typeIdentifier": "t_struct$_VoxelCoord_$5927_memory_ptr",
                                "typeString": "struct VoxelCoord memory"
                              }
                            ],
                            "id": 33310,
                            "name": "Diamond",
                            "nodeType": "Identifier",
                            "overloadedDeclarations": [],
                            "referencedDeclaration": 33679,
                            "src": "2013:7:84",
                            "typeDescriptions": {
                              "typeIdentifier": "t_function_internal_pure$_t_struct$_VoxelCoord_$5927_memory_ptr_$returns$_t_uint256_$",
                              "typeString": "function (struct VoxelCoord memory) pure returns (uint256)"
                            }
                          },
                          "id": 33312,
                          "isConstant": false,
                          "isLValue": false,
                          "isPure": false,
                          "kind": "functionCall",
                          "lValueRequested": false,
                          "names": [],
                          "nodeType": "FunctionCall",
                          "src": "2013:14:84",
                          "tryCall": false,
                          "typeDescriptions": {
                            "typeIdentifier": "t_uint256",
                            "typeString": "uint256"
                          }
                        }
                      ],
                      "expression": {
                        "argumentTypes": [
                          {
                            "typeIdentifier": "t_uint256",
                            "typeString": "uint256"
                          }
                        ],
                        "expression": {
                          "id": 33308,
                          "name": "abi",
                          "nodeType": "Identifier",
                          "overloadedDeclarations": [],
                          "referencedDeclaration": -1,
                          "src": "2002:3:84",
                          "typeDescriptions": {
                            "typeIdentifier": "t_magic_abi",
                            "typeString": "abi"
                          }
                        },
                        "id": 33309,
                        "isConstant": false,
                        "isLValue": false,
                        "isPure": true,
                        "lValueRequested": false,
                        "memberName": "encode",
                        "nodeType": "MemberAccess",
                        "src": "2002:10:84",
                        "typeDescriptions": {
                          "typeIdentifier": "t_function_abiencode_pure$__$returns$_t_bytes_memory_ptr_$",
                          "typeString": "function () pure returns (bytes memory)"
                        }
                      },
                      "id": 33313,
                      "isConstant": false,
                      "isLValue": false,
                      "isPure": false,
                      "kind": "functionCall",
                      "lValueRequested": false,
                      "names": [],
                      "nodeType": "FunctionCall",
                      "src": "2002:26:84",
                      "tryCall": false,
                      "typeDescriptions": {
                        "typeIdentifier": "t_bytes_memory_ptr",
                        "typeString": "bytes memory"
                      }
                    },
                    "functionReturnParameters": 33224,
                    "id": 33314,
                    "nodeType": "Return",
                    "src": "1995:33:84"
                  }
                },
                {
                  "condition": {
                    "commonType": {
                      "typeIdentifier": "t_uint256",
                      "typeString": "uint256"
                    },
                    "id": 33318,
                    "isConstant": false,
                    "isLValue": false,
                    "isPure": false,
                    "lValueRequested": false,
                    "leftExpression": {
                      "id": 33316,
                      "name": "blockType",
                      "nodeType": "Identifier",
                      "overloadedDeclarations": [],
                      "referencedDeclaration": 33226,
                      "src": "2038:9:84",
                      "typeDescriptions": {
                        "typeIdentifier": "t_uint256",
                        "typeString": "uint256"
                      }
                    },
                    "nodeType": "BinaryOperation",
                    "operator": "==",
                    "rightExpression": {
                      "id": 33317,
                      "name": "CoalID",
                      "nodeType": "Identifier",
                      "overloadedDeclarations": [],
                      "referencedDeclaration": 28975,
                      "src": "2051:6:84",
                      "typeDescriptions": {
                        "typeIdentifier": "t_uint256",
                        "typeString": "uint256"
                      }
                    },
                    "src": "2038:19:84",
                    "typeDescriptions": {
                      "typeIdentifier": "t_bool",
                      "typeString": "bool"
                    }
                  },
                  "id": 33326,
                  "nodeType": "IfStatement",
                  "src": "2034:55:84",
                  "trueBody": {
                    "expression": {
                      "arguments": [
                        {
                          "arguments": [
                            {
                              "id": 33322,
                              "name": "coord",
                              "nodeType": "Identifier",
                              "overloadedDeclarations": [],
                              "referencedDeclaration": 33229,
                              "src": "2082:5:84",
                              "typeDescriptions": {
                                "typeIdentifier": "t_struct$_VoxelCoord_$5927_memory_ptr",
                                "typeString": "struct VoxelCoord memory"
                              }
                            }
                          ],
                          "expression": {
                            "argumentTypes": [
                              {
                                "typeIdentifier": "t_struct$_VoxelCoord_$5927_memory_ptr",
                                "typeString": "struct VoxelCoord memory"
                              }
                            ],
                            "id": 33321,
                            "name": "Coal",
                            "nodeType": "Identifier",
                            "overloadedDeclarations": [],
                            "referencedDeclaration": 33693,
                            "src": "2077:4:84",
                            "typeDescriptions": {
                              "typeIdentifier": "t_function_internal_pure$_t_struct$_VoxelCoord_$5927_memory_ptr_$returns$_t_uint256_$",
                              "typeString": "function (struct VoxelCoord memory) pure returns (uint256)"
                            }
                          },
                          "id": 33323,
                          "isConstant": false,
                          "isLValue": false,
                          "isPure": false,
                          "kind": "functionCall",
                          "lValueRequested": false,
                          "names": [],
                          "nodeType": "FunctionCall",
                          "src": "2077:11:84",
                          "tryCall": false,
                          "typeDescriptions": {
                            "typeIdentifier": "t_uint256",
                            "typeString": "uint256"
                          }
                        }
                      ],
                      "expression": {
                        "argumentTypes": [
                          {
                            "typeIdentifier": "t_uint256",
                            "typeString": "uint256"
                          }
                        ],
                        "expression": {
                          "id": 33319,
                          "name": "abi",
                          "nodeType": "Identifier",
                          "overloadedDeclarations": [],
                          "referencedDeclaration": -1,
                          "src": "2066:3:84",
                          "typeDescriptions": {
                            "typeIdentifier": "t_magic_abi",
                            "typeString": "abi"
                          }
                        },
                        "id": 33320,
                        "isConstant": false,
                        "isLValue": false,
                        "isPure": true,
                        "lValueRequested": false,
                        "memberName": "encode",
                        "nodeType": "MemberAccess",
                        "src": "2066:10:84",
                        "typeDescriptions": {
                          "typeIdentifier": "t_function_abiencode_pure$__$returns$_t_bytes_memory_ptr_$",
                          "typeString": "function () pure returns (bytes memory)"
                        }
                      },
                      "id": 33324,
                      "isConstant": false,
                      "isLValue": false,
                      "isPure": false,
                      "kind": "functionCall",
                      "lValueRequested": false,
                      "names": [],
                      "nodeType": "FunctionCall",
                      "src": "2066:23:84",
                      "tryCall": false,
                      "typeDescriptions": {
                        "typeIdentifier": "t_bytes_memory_ptr",
                        "typeString": "bytes memory"
                      }
                    },
                    "functionReturnParameters": 33224,
                    "id": 33325,
                    "nodeType": "Return",
                    "src": "2059:30:84"
                  }
                },
                {
                  "condition": {
                    "commonType": {
                      "typeIdentifier": "t_uint256",
                      "typeString": "uint256"
                    },
                    "id": 33329,
                    "isConstant": false,
                    "isLValue": false,
                    "isPure": false,
                    "lValueRequested": false,
                    "leftExpression": {
                      "id": 33327,
                      "name": "blockType",
                      "nodeType": "Identifier",
                      "overloadedDeclarations": [],
                      "referencedDeclaration": 33226,
                      "src": "2099:9:84",
                      "typeDescriptions": {
                        "typeIdentifier": "t_uint256",
                        "typeString": "uint256"
                      }
                    },
                    "nodeType": "BinaryOperation",
                    "operator": "==",
                    "rightExpression": {
                      "id": 33328,
                      "name": "LeavesID",
                      "nodeType": "Identifier",
                      "overloadedDeclarations": [],
                      "referencedDeclaration": 29015,
                      "src": "2112:8:84",
                      "typeDescriptions": {
                        "typeIdentifier": "t_uint256",
                        "typeString": "uint256"
                      }
                    },
                    "src": "2099:21:84",
                    "typeDescriptions": {
                      "typeIdentifier": "t_bool",
                      "typeString": "bool"
                    }
                  },
                  "id": 33337,
                  "nodeType": "IfStatement",
                  "src": "2095:59:84",
                  "trueBody": {
                    "expression": {
                      "arguments": [
                        {
                          "arguments": [
                            {
                              "id": 33333,
                              "name": "coord",
                              "nodeType": "Identifier",
                              "overloadedDeclarations": [],
                              "referencedDeclaration": 33229,
                              "src": "2147:5:84",
                              "typeDescriptions": {
                                "typeIdentifier": "t_struct$_VoxelCoord_$5927_memory_ptr",
                                "typeString": "struct VoxelCoord memory"
                              }
                            }
                          ],
                          "expression": {
                            "argumentTypes": [
                              {
                                "typeIdentifier": "t_struct$_VoxelCoord_$5927_memory_ptr",
                                "typeString": "struct VoxelCoord memory"
                              }
                            ],
                            "id": 33332,
                            "name": "Leaves",
                            "nodeType": "Identifier",
                            "overloadedDeclarations": [],
                            "referencedDeclaration": 33707,
                            "src": "2140:6:84",
                            "typeDescriptions": {
                              "typeIdentifier": "t_function_internal_pure$_t_struct$_VoxelCoord_$5927_memory_ptr_$returns$_t_uint256_$",
                              "typeString": "function (struct VoxelCoord memory) pure returns (uint256)"
                            }
                          },
                          "id": 33334,
                          "isConstant": false,
                          "isLValue": false,
                          "isPure": false,
                          "kind": "functionCall",
                          "lValueRequested": false,
                          "names": [],
                          "nodeType": "FunctionCall",
                          "src": "2140:13:84",
                          "tryCall": false,
                          "typeDescriptions": {
                            "typeIdentifier": "t_uint256",
                            "typeString": "uint256"
                          }
                        }
                      ],
                      "expression": {
                        "argumentTypes": [
                          {
                            "typeIdentifier": "t_uint256",
                            "typeString": "uint256"
                          }
                        ],
                        "expression": {
                          "id": 33330,
                          "name": "abi",
                          "nodeType": "Identifier",
                          "overloadedDeclarations": [],
                          "referencedDeclaration": -1,
                          "src": "2129:3:84",
                          "typeDescriptions": {
                            "typeIdentifier": "t_magic_abi",
                            "typeString": "abi"
                          }
                        },
                        "id": 33331,
                        "isConstant": false,
                        "isLValue": false,
                        "isPure": true,
                        "lValueRequested": false,
                        "memberName": "encode",
                        "nodeType": "MemberAccess",
                        "src": "2129:10:84",
                        "typeDescriptions": {
                          "typeIdentifier": "t_function_abiencode_pure$__$returns$_t_bytes_memory_ptr_$",
                          "typeString": "function () pure returns (bytes memory)"
                        }
                      },
                      "id": 33335,
                      "isConstant": false,
                      "isLValue": false,
                      "isPure": false,
                      "kind": "functionCall",
                      "lValueRequested": false,
                      "names": [],
                      "nodeType": "FunctionCall",
                      "src": "2129:25:84",
                      "tryCall": false,
                      "typeDescriptions": {
                        "typeIdentifier": "t_bytes_memory_ptr",
                        "typeString": "bytes memory"
                      }
                    },
                    "functionReturnParameters": 33224,
                    "id": 33336,
                    "nodeType": "Return",
                    "src": "2122:32:84"
                  }
                },
                {
                  "condition": {
                    "commonType": {
                      "typeIdentifier": "t_uint256",
                      "typeString": "uint256"
                    },
                    "id": 33340,
                    "isConstant": false,
                    "isLValue": false,
                    "isPure": false,
                    "lValueRequested": false,
                    "leftExpression": {
                      "id": 33338,
                      "name": "blockType",
                      "nodeType": "Identifier",
                      "overloadedDeclarations": [],
                      "referencedDeclaration": 33226,
                      "src": "2164:9:84",
                      "typeDescriptions": {
                        "typeIdentifier": "t_uint256",
                        "typeString": "uint256"
                      }
                    },
                    "nodeType": "BinaryOperation",
                    "operator": "==",
                    "rightExpression": {
                      "id": 33339,
                      "name": "RedFlowerID",
                      "nodeType": "Identifier",
                      "overloadedDeclarations": [],
                      "referencedDeclaration": 29031,
                      "src": "2177:11:84",
                      "typeDescriptions": {
                        "typeIdentifier": "t_uint256",
                        "typeString": "uint256"
                      }
                    },
                    "src": "2164:24:84",
                    "typeDescriptions": {
                      "typeIdentifier": "t_bool",
                      "typeString": "bool"
                    }
                  },
                  "id": 33348,
                  "nodeType": "IfStatement",
                  "src": "2160:65:84",
                  "trueBody": {
                    "expression": {
                      "arguments": [
                        {
                          "arguments": [
                            {
                              "id": 33344,
                              "name": "coord",
                              "nodeType": "Identifier",
                              "overloadedDeclarations": [],
                              "referencedDeclaration": 33229,
                              "src": "2218:5:84",
                              "typeDescriptions": {
                                "typeIdentifier": "t_struct$_VoxelCoord_$5927_memory_ptr",
                                "typeString": "struct VoxelCoord memory"
                              }
                            }
                          ],
                          "expression": {
                            "argumentTypes": [
                              {
                                "typeIdentifier": "t_struct$_VoxelCoord_$5927_memory_ptr",
                                "typeString": "struct VoxelCoord memory"
                              }
                            ],
                            "id": 33343,
                            "name": "RedFlower",
                            "nodeType": "Identifier",
                            "overloadedDeclarations": [],
                            "referencedDeclaration": 33721,
                            "src": "2208:9:84",
                            "typeDescriptions": {
                              "typeIdentifier": "t_function_internal_pure$_t_struct$_VoxelCoord_$5927_memory_ptr_$returns$_t_uint256_$",
                              "typeString": "function (struct VoxelCoord memory) pure returns (uint256)"
                            }
                          },
                          "id": 33345,
                          "isConstant": false,
                          "isLValue": false,
                          "isPure": false,
                          "kind": "functionCall",
                          "lValueRequested": false,
                          "names": [],
                          "nodeType": "FunctionCall",
                          "src": "2208:16:84",
                          "tryCall": false,
                          "typeDescriptions": {
                            "typeIdentifier": "t_uint256",
                            "typeString": "uint256"
                          }
                        }
                      ],
                      "expression": {
                        "argumentTypes": [
                          {
                            "typeIdentifier": "t_uint256",
                            "typeString": "uint256"
                          }
                        ],
                        "expression": {
                          "id": 33341,
                          "name": "abi",
                          "nodeType": "Identifier",
                          "overloadedDeclarations": [],
                          "referencedDeclaration": -1,
                          "src": "2197:3:84",
                          "typeDescriptions": {
                            "typeIdentifier": "t_magic_abi",
                            "typeString": "abi"
                          }
                        },
                        "id": 33342,
                        "isConstant": false,
                        "isLValue": false,
                        "isPure": true,
                        "lValueRequested": false,
                        "memberName": "encode",
                        "nodeType": "MemberAccess",
                        "src": "2197:10:84",
                        "typeDescriptions": {
                          "typeIdentifier": "t_function_abiencode_pure$__$returns$_t_bytes_memory_ptr_$",
                          "typeString": "function () pure returns (bytes memory)"
                        }
                      },
                      "id": 33346,
                      "isConstant": false,
                      "isLValue": false,
                      "isPure": false,
                      "kind": "functionCall",
                      "lValueRequested": false,
                      "names": [],
                      "nodeType": "FunctionCall",
                      "src": "2197:28:84",
                      "tryCall": false,
                      "typeDescriptions": {
                        "typeIdentifier": "t_bytes_memory_ptr",
                        "typeString": "bytes memory"
                      }
                    },
                    "functionReturnParameters": 33224,
                    "id": 33347,
                    "nodeType": "Return",
                    "src": "2190:35:84"
                  }
                },
                {
                  "condition": {
                    "commonType": {
                      "typeIdentifier": "t_uint256",
                      "typeString": "uint256"
                    },
                    "id": 33351,
                    "isConstant": false,
                    "isLValue": false,
                    "isPure": false,
                    "lValueRequested": false,
                    "leftExpression": {
                      "id": 33349,
                      "name": "blockType",
                      "nodeType": "Identifier",
                      "overloadedDeclarations": [],
                      "referencedDeclaration": 33226,
                      "src": "2235:9:84",
                      "typeDescriptions": {
                        "typeIdentifier": "t_uint256",
                        "typeString": "uint256"
                      }
                    },
                    "nodeType": "BinaryOperation",
                    "operator": "==",
                    "rightExpression": {
                      "id": 33350,
                      "name": "GrassPlantID",
                      "nodeType": "Identifier",
                      "overloadedDeclarations": [],
                      "referencedDeclaration": 29039,
                      "src": "2248:12:84",
                      "typeDescriptions": {
                        "typeIdentifier": "t_uint256",
                        "typeString": "uint256"
                      }
                    },
                    "src": "2235:25:84",
                    "typeDescriptions": {
                      "typeIdentifier": "t_bool",
                      "typeString": "bool"
                    }
                  },
                  "id": 33359,
                  "nodeType": "IfStatement",
                  "src": "2231:67:84",
                  "trueBody": {
                    "expression": {
                      "arguments": [
                        {
                          "arguments": [
                            {
                              "id": 33355,
                              "name": "coord",
                              "nodeType": "Identifier",
                              "overloadedDeclarations": [],
                              "referencedDeclaration": 33229,
                              "src": "2291:5:84",
                              "typeDescriptions": {
                                "typeIdentifier": "t_struct$_VoxelCoord_$5927_memory_ptr",
                                "typeString": "struct VoxelCoord memory"
                              }
                            }
                          ],
                          "expression": {
                            "argumentTypes": [
                              {
                                "typeIdentifier": "t_struct$_VoxelCoord_$5927_memory_ptr",
                                "typeString": "struct VoxelCoord memory"
                              }
                            ],
                            "id": 33354,
                            "name": "GrassPlant",
                            "nodeType": "Identifier",
                            "overloadedDeclarations": [],
                            "referencedDeclaration": 33735,
                            "src": "2280:10:84",
                            "typeDescriptions": {
                              "typeIdentifier": "t_function_internal_pure$_t_struct$_VoxelCoord_$5927_memory_ptr_$returns$_t_uint256_$",
                              "typeString": "function (struct VoxelCoord memory) pure returns (uint256)"
                            }
                          },
                          "id": 33356,
                          "isConstant": false,
                          "isLValue": false,
                          "isPure": false,
                          "kind": "functionCall",
                          "lValueRequested": false,
                          "names": [],
                          "nodeType": "FunctionCall",
                          "src": "2280:17:84",
                          "tryCall": false,
                          "typeDescriptions": {
                            "typeIdentifier": "t_uint256",
                            "typeString": "uint256"
                          }
                        }
                      ],
                      "expression": {
                        "argumentTypes": [
                          {
                            "typeIdentifier": "t_uint256",
                            "typeString": "uint256"
                          }
                        ],
                        "expression": {
                          "id": 33352,
                          "name": "abi",
                          "nodeType": "Identifier",
                          "overloadedDeclarations": [],
                          "referencedDeclaration": -1,
                          "src": "2269:3:84",
                          "typeDescriptions": {
                            "typeIdentifier": "t_magic_abi",
                            "typeString": "abi"
                          }
                        },
                        "id": 33353,
                        "isConstant": false,
                        "isLValue": false,
                        "isPure": true,
                        "lValueRequested": false,
                        "memberName": "encode",
                        "nodeType": "MemberAccess",
                        "src": "2269:10:84",
                        "typeDescriptions": {
                          "typeIdentifier": "t_function_abiencode_pure$__$returns$_t_bytes_memory_ptr_$",
                          "typeString": "function () pure returns (bytes memory)"
                        }
                      },
                      "id": 33357,
                      "isConstant": false,
                      "isLValue": false,
                      "isPure": false,
                      "kind": "functionCall",
                      "lValueRequested": false,
                      "names": [],
                      "nodeType": "FunctionCall",
                      "src": "2269:29:84",
                      "tryCall": false,
                      "typeDescriptions": {
                        "typeIdentifier": "t_bytes_memory_ptr",
                        "typeString": "bytes memory"
                      }
                    },
                    "functionReturnParameters": 33224,
                    "id": 33358,
                    "nodeType": "Return",
                    "src": "2262:36:84"
                  }
                },
                {
                  "condition": {
                    "commonType": {
                      "typeIdentifier": "t_uint256",
                      "typeString": "uint256"
                    },
                    "id": 33362,
                    "isConstant": false,
                    "isLValue": false,
                    "isPure": false,
                    "lValueRequested": false,
                    "leftExpression": {
                      "id": 33360,
                      "name": "blockType",
                      "nodeType": "Identifier",
                      "overloadedDeclarations": [],
                      "referencedDeclaration": 33226,
                      "src": "2308:9:84",
                      "typeDescriptions": {
                        "typeIdentifier": "t_uint256",
                        "typeString": "uint256"
                      }
                    },
                    "nodeType": "BinaryOperation",
                    "operator": "==",
                    "rightExpression": {
                      "id": 33361,
                      "name": "OrangeFlowerID",
                      "nodeType": "Identifier",
                      "overloadedDeclarations": [],
                      "referencedDeclaration": 29047,
                      "src": "2321:14:84",
                      "typeDescriptions": {
                        "typeIdentifier": "t_uint256",
                        "typeString": "uint256"
                      }
                    },
                    "src": "2308:27:84",
                    "typeDescriptions": {
                      "typeIdentifier": "t_bool",
                      "typeString": "bool"
                    }
                  },
                  "id": 33370,
                  "nodeType": "IfStatement",
                  "src": "2304:71:84",
                  "trueBody": {
                    "expression": {
                      "arguments": [
                        {
                          "arguments": [
                            {
                              "id": 33366,
                              "name": "coord",
                              "nodeType": "Identifier",
                              "overloadedDeclarations": [],
                              "referencedDeclaration": 33229,
                              "src": "2368:5:84",
                              "typeDescriptions": {
                                "typeIdentifier": "t_struct$_VoxelCoord_$5927_memory_ptr",
                                "typeString": "struct VoxelCoord memory"
                              }
                            }
                          ],
                          "expression": {
                            "argumentTypes": [
                              {
                                "typeIdentifier": "t_struct$_VoxelCoord_$5927_memory_ptr",
                                "typeString": "struct VoxelCoord memory"
                              }
                            ],
                            "id": 33365,
                            "name": "OrangeFlower",
                            "nodeType": "Identifier",
                            "overloadedDeclarations": [],
                            "referencedDeclaration": 33749,
                            "src": "2355:12:84",
                            "typeDescriptions": {
                              "typeIdentifier": "t_function_internal_pure$_t_struct$_VoxelCoord_$5927_memory_ptr_$returns$_t_uint256_$",
                              "typeString": "function (struct VoxelCoord memory) pure returns (uint256)"
                            }
                          },
                          "id": 33367,
                          "isConstant": false,
                          "isLValue": false,
                          "isPure": false,
                          "kind": "functionCall",
                          "lValueRequested": false,
                          "names": [],
                          "nodeType": "FunctionCall",
                          "src": "2355:19:84",
                          "tryCall": false,
                          "typeDescriptions": {
                            "typeIdentifier": "t_uint256",
                            "typeString": "uint256"
                          }
                        }
                      ],
                      "expression": {
                        "argumentTypes": [
                          {
                            "typeIdentifier": "t_uint256",
                            "typeString": "uint256"
                          }
                        ],
                        "expression": {
                          "id": 33363,
                          "name": "abi",
                          "nodeType": "Identifier",
                          "overloadedDeclarations": [],
                          "referencedDeclaration": -1,
                          "src": "2344:3:84",
                          "typeDescriptions": {
                            "typeIdentifier": "t_magic_abi",
                            "typeString": "abi"
                          }
                        },
                        "id": 33364,
                        "isConstant": false,
                        "isLValue": false,
                        "isPure": true,
                        "lValueRequested": false,
                        "memberName": "encode",
                        "nodeType": "MemberAccess",
                        "src": "2344:10:84",
                        "typeDescriptions": {
                          "typeIdentifier": "t_function_abiencode_pure$__$returns$_t_bytes_memory_ptr_$",
                          "typeString": "function () pure returns (bytes memory)"
                        }
                      },
                      "id": 33368,
                      "isConstant": false,
                      "isLValue": false,
                      "isPure": false,
                      "kind": "functionCall",
                      "lValueRequested": false,
                      "names": [],
                      "nodeType": "FunctionCall",
                      "src": "2344:31:84",
                      "tryCall": false,
                      "typeDescriptions": {
                        "typeIdentifier": "t_bytes_memory_ptr",
                        "typeString": "bytes memory"
                      }
                    },
                    "functionReturnParameters": 33224,
                    "id": 33369,
                    "nodeType": "Return",
                    "src": "2337:38:84"
                  }
                },
                {
                  "condition": {
                    "commonType": {
                      "typeIdentifier": "t_uint256",
                      "typeString": "uint256"
                    },
                    "id": 33373,
                    "isConstant": false,
                    "isLValue": false,
                    "isPure": false,
                    "lValueRequested": false,
                    "leftExpression": {
                      "id": 33371,
                      "name": "blockType",
                      "nodeType": "Identifier",
                      "overloadedDeclarations": [],
                      "referencedDeclaration": 33226,
                      "src": "2385:9:84",
                      "typeDescriptions": {
                        "typeIdentifier": "t_uint256",
                        "typeString": "uint256"
                      }
                    },
                    "nodeType": "BinaryOperation",
                    "operator": "==",
                    "rightExpression": {
                      "id": 33372,
                      "name": "MagentaFlowerID",
                      "nodeType": "Identifier",
                      "overloadedDeclarations": [],
                      "referencedDeclaration": 29055,
                      "src": "2398:15:84",
                      "typeDescriptions": {
                        "typeIdentifier": "t_uint256",
                        "typeString": "uint256"
                      }
                    },
                    "src": "2385:28:84",
                    "typeDescriptions": {
                      "typeIdentifier": "t_bool",
                      "typeString": "bool"
                    }
                  },
                  "id": 33381,
                  "nodeType": "IfStatement",
                  "src": "2381:73:84",
                  "trueBody": {
                    "expression": {
                      "arguments": [
                        {
                          "arguments": [
                            {
                              "id": 33377,
                              "name": "coord",
                              "nodeType": "Identifier",
                              "overloadedDeclarations": [],
                              "referencedDeclaration": 33229,
                              "src": "2447:5:84",
                              "typeDescriptions": {
                                "typeIdentifier": "t_struct$_VoxelCoord_$5927_memory_ptr",
                                "typeString": "struct VoxelCoord memory"
                              }
                            }
                          ],
                          "expression": {
                            "argumentTypes": [
                              {
                                "typeIdentifier": "t_struct$_VoxelCoord_$5927_memory_ptr",
                                "typeString": "struct VoxelCoord memory"
                              }
                            ],
                            "id": 33376,
                            "name": "MagentaFlower",
                            "nodeType": "Identifier",
                            "overloadedDeclarations": [],
                            "referencedDeclaration": 33763,
                            "src": "2433:13:84",
                            "typeDescriptions": {
                              "typeIdentifier": "t_function_internal_pure$_t_struct$_VoxelCoord_$5927_memory_ptr_$returns$_t_uint256_$",
                              "typeString": "function (struct VoxelCoord memory) pure returns (uint256)"
                            }
                          },
                          "id": 33378,
                          "isConstant": false,
                          "isLValue": false,
                          "isPure": false,
                          "kind": "functionCall",
                          "lValueRequested": false,
                          "names": [],
                          "nodeType": "FunctionCall",
                          "src": "2433:20:84",
                          "tryCall": false,
                          "typeDescriptions": {
                            "typeIdentifier": "t_uint256",
                            "typeString": "uint256"
                          }
                        }
                      ],
                      "expression": {
                        "argumentTypes": [
                          {
                            "typeIdentifier": "t_uint256",
                            "typeString": "uint256"
                          }
                        ],
                        "expression": {
                          "id": 33374,
                          "name": "abi",
                          "nodeType": "Identifier",
                          "overloadedDeclarations": [],
                          "referencedDeclaration": -1,
                          "src": "2422:3:84",
                          "typeDescriptions": {
                            "typeIdentifier": "t_magic_abi",
                            "typeString": "abi"
                          }
                        },
                        "id": 33375,
                        "isConstant": false,
                        "isLValue": false,
                        "isPure": true,
                        "lValueRequested": false,
                        "memberName": "encode",
                        "nodeType": "MemberAccess",
                        "src": "2422:10:84",
                        "typeDescriptions": {
                          "typeIdentifier": "t_function_abiencode_pure$__$returns$_t_bytes_memory_ptr_$",
                          "typeString": "function () pure returns (bytes memory)"
                        }
                      },
                      "id": 33379,
                      "isConstant": false,
                      "isLValue": false,
                      "isPure": false,
                      "kind": "functionCall",
                      "lValueRequested": false,
                      "names": [],
                      "nodeType": "FunctionCall",
                      "src": "2422:32:84",
                      "tryCall": false,
                      "typeDescriptions": {
                        "typeIdentifier": "t_bytes_memory_ptr",
                        "typeString": "bytes memory"
                      }
                    },
                    "functionReturnParameters": 33224,
                    "id": 33380,
                    "nodeType": "Return",
                    "src": "2415:39:84"
                  }
                },
                {
                  "condition": {
                    "commonType": {
                      "typeIdentifier": "t_uint256",
                      "typeString": "uint256"
                    },
                    "id": 33384,
                    "isConstant": false,
                    "isLValue": false,
                    "isPure": false,
                    "lValueRequested": false,
                    "leftExpression": {
                      "id": 33382,
                      "name": "blockType",
                      "nodeType": "Identifier",
                      "overloadedDeclarations": [],
                      "referencedDeclaration": 33226,
                      "src": "2464:9:84",
                      "typeDescriptions": {
                        "typeIdentifier": "t_uint256",
                        "typeString": "uint256"
                      }
                    },
                    "nodeType": "BinaryOperation",
                    "operator": "==",
                    "rightExpression": {
                      "id": 33383,
                      "name": "LightBlueFlowerID",
                      "nodeType": "Identifier",
                      "overloadedDeclarations": [],
                      "referencedDeclaration": 29063,
                      "src": "2477:17:84",
                      "typeDescriptions": {
                        "typeIdentifier": "t_uint256",
                        "typeString": "uint256"
                      }
                    },
                    "src": "2464:30:84",
                    "typeDescriptions": {
                      "typeIdentifier": "t_bool",
                      "typeString": "bool"
                    }
                  },
                  "id": 33392,
                  "nodeType": "IfStatement",
                  "src": "2460:77:84",
                  "trueBody": {
                    "expression": {
                      "arguments": [
                        {
                          "arguments": [
                            {
                              "id": 33388,
                              "name": "coord",
                              "nodeType": "Identifier",
                              "overloadedDeclarations": [],
                              "referencedDeclaration": 33229,
                              "src": "2530:5:84",
                              "typeDescriptions": {
                                "typeIdentifier": "t_struct$_VoxelCoord_$5927_memory_ptr",
                                "typeString": "struct VoxelCoord memory"
                              }
                            }
                          ],
                          "expression": {
                            "argumentTypes": [
                              {
                                "typeIdentifier": "t_struct$_VoxelCoord_$5927_memory_ptr",
                                "typeString": "struct VoxelCoord memory"
                              }
                            ],
                            "id": 33387,
                            "name": "LightBlueFlower",
                            "nodeType": "Identifier",
                            "overloadedDeclarations": [],
                            "referencedDeclaration": 33777,
                            "src": "2514:15:84",
                            "typeDescriptions": {
                              "typeIdentifier": "t_function_internal_pure$_t_struct$_VoxelCoord_$5927_memory_ptr_$returns$_t_uint256_$",
                              "typeString": "function (struct VoxelCoord memory) pure returns (uint256)"
                            }
                          },
                          "id": 33389,
                          "isConstant": false,
                          "isLValue": false,
                          "isPure": false,
                          "kind": "functionCall",
                          "lValueRequested": false,
                          "names": [],
                          "nodeType": "FunctionCall",
                          "src": "2514:22:84",
                          "tryCall": false,
                          "typeDescriptions": {
                            "typeIdentifier": "t_uint256",
                            "typeString": "uint256"
                          }
                        }
                      ],
                      "expression": {
                        "argumentTypes": [
                          {
                            "typeIdentifier": "t_uint256",
                            "typeString": "uint256"
                          }
                        ],
                        "expression": {
                          "id": 33385,
                          "name": "abi",
                          "nodeType": "Identifier",
                          "overloadedDeclarations": [],
                          "referencedDeclaration": -1,
                          "src": "2503:3:84",
                          "typeDescriptions": {
                            "typeIdentifier": "t_magic_abi",
                            "typeString": "abi"
                          }
                        },
                        "id": 33386,
                        "isConstant": false,
                        "isLValue": false,
                        "isPure": true,
                        "lValueRequested": false,
                        "memberName": "encode",
                        "nodeType": "MemberAccess",
                        "src": "2503:10:84",
                        "typeDescriptions": {
                          "typeIdentifier": "t_function_abiencode_pure$__$returns$_t_bytes_memory_ptr_$",
                          "typeString": "function () pure returns (bytes memory)"
                        }
                      },
                      "id": 33390,
                      "isConstant": false,
                      "isLValue": false,
                      "isPure": false,
                      "kind": "functionCall",
                      "lValueRequested": false,
                      "names": [],
                      "nodeType": "FunctionCall",
                      "src": "2503:34:84",
                      "tryCall": false,
                      "typeDescriptions": {
                        "typeIdentifier": "t_bytes_memory_ptr",
                        "typeString": "bytes memory"
                      }
                    },
                    "functionReturnParameters": 33224,
                    "id": 33391,
                    "nodeType": "Return",
                    "src": "2496:41:84"
                  }
                },
                {
                  "condition": {
                    "commonType": {
                      "typeIdentifier": "t_uint256",
                      "typeString": "uint256"
                    },
                    "id": 33395,
                    "isConstant": false,
                    "isLValue": false,
                    "isPure": false,
                    "lValueRequested": false,
                    "leftExpression": {
                      "id": 33393,
                      "name": "blockType",
                      "nodeType": "Identifier",
                      "overloadedDeclarations": [],
                      "referencedDeclaration": 33226,
                      "src": "2547:9:84",
                      "typeDescriptions": {
                        "typeIdentifier": "t_uint256",
                        "typeString": "uint256"
                      }
                    },
                    "nodeType": "BinaryOperation",
                    "operator": "==",
                    "rightExpression": {
                      "id": 33394,
                      "name": "LimeFlowerID",
                      "nodeType": "Identifier",
                      "overloadedDeclarations": [],
                      "referencedDeclaration": 29071,
                      "src": "2560:12:84",
                      "typeDescriptions": {
                        "typeIdentifier": "t_uint256",
                        "typeString": "uint256"
                      }
                    },
                    "src": "2547:25:84",
                    "typeDescriptions": {
                      "typeIdentifier": "t_bool",
                      "typeString": "bool"
                    }
                  },
                  "id": 33403,
                  "nodeType": "IfStatement",
                  "src": "2543:67:84",
                  "trueBody": {
                    "expression": {
                      "arguments": [
                        {
                          "arguments": [
                            {
                              "id": 33399,
                              "name": "coord",
                              "nodeType": "Identifier",
                              "overloadedDeclarations": [],
                              "referencedDeclaration": 33229,
                              "src": "2603:5:84",
                              "typeDescriptions": {
                                "typeIdentifier": "t_struct$_VoxelCoord_$5927_memory_ptr",
                                "typeString": "struct VoxelCoord memory"
                              }
                            }
                          ],
                          "expression": {
                            "argumentTypes": [
                              {
                                "typeIdentifier": "t_struct$_VoxelCoord_$5927_memory_ptr",
                                "typeString": "struct VoxelCoord memory"
                              }
                            ],
                            "id": 33398,
                            "name": "LimeFlower",
                            "nodeType": "Identifier",
                            "overloadedDeclarations": [],
                            "referencedDeclaration": 33791,
                            "src": "2592:10:84",
                            "typeDescriptions": {
                              "typeIdentifier": "t_function_internal_pure$_t_struct$_VoxelCoord_$5927_memory_ptr_$returns$_t_uint256_$",
                              "typeString": "function (struct VoxelCoord memory) pure returns (uint256)"
                            }
                          },
                          "id": 33400,
                          "isConstant": false,
                          "isLValue": false,
                          "isPure": false,
                          "kind": "functionCall",
                          "lValueRequested": false,
                          "names": [],
                          "nodeType": "FunctionCall",
                          "src": "2592:17:84",
                          "tryCall": false,
                          "typeDescriptions": {
                            "typeIdentifier": "t_uint256",
                            "typeString": "uint256"
                          }
                        }
                      ],
                      "expression": {
                        "argumentTypes": [
                          {
                            "typeIdentifier": "t_uint256",
                            "typeString": "uint256"
                          }
                        ],
                        "expression": {
                          "id": 33396,
                          "name": "abi",
                          "nodeType": "Identifier",
                          "overloadedDeclarations": [],
                          "referencedDeclaration": -1,
                          "src": "2581:3:84",
                          "typeDescriptions": {
                            "typeIdentifier": "t_magic_abi",
                            "typeString": "abi"
                          }
                        },
                        "id": 33397,
                        "isConstant": false,
                        "isLValue": false,
                        "isPure": true,
                        "lValueRequested": false,
                        "memberName": "encode",
                        "nodeType": "MemberAccess",
                        "src": "2581:10:84",
                        "typeDescriptions": {
                          "typeIdentifier": "t_function_abiencode_pure$__$returns$_t_bytes_memory_ptr_$",
                          "typeString": "function () pure returns (bytes memory)"
                        }
                      },
                      "id": 33401,
                      "isConstant": false,
                      "isLValue": false,
                      "isPure": false,
                      "kind": "functionCall",
                      "lValueRequested": false,
                      "names": [],
                      "nodeType": "FunctionCall",
                      "src": "2581:29:84",
                      "tryCall": false,
                      "typeDescriptions": {
                        "typeIdentifier": "t_bytes_memory_ptr",
                        "typeString": "bytes memory"
                      }
                    },
                    "functionReturnParameters": 33224,
                    "id": 33402,
                    "nodeType": "Return",
                    "src": "2574:36:84"
                  }
                },
                {
                  "condition": {
                    "commonType": {
                      "typeIdentifier": "t_uint256",
                      "typeString": "uint256"
                    },
                    "id": 33406,
                    "isConstant": false,
                    "isLValue": false,
                    "isPure": false,
                    "lValueRequested": false,
                    "leftExpression": {
                      "id": 33404,
                      "name": "blockType",
                      "nodeType": "Identifier",
                      "overloadedDeclarations": [],
                      "referencedDeclaration": 33226,
                      "src": "2620:9:84",
                      "typeDescriptions": {
                        "typeIdentifier": "t_uint256",
                        "typeString": "uint256"
                      }
                    },
                    "nodeType": "BinaryOperation",
                    "operator": "==",
                    "rightExpression": {
                      "id": 33405,
                      "name": "PinkFlowerID",
                      "nodeType": "Identifier",
                      "overloadedDeclarations": [],
                      "referencedDeclaration": 29079,
                      "src": "2633:12:84",
                      "typeDescriptions": {
                        "typeIdentifier": "t_uint256",
                        "typeString": "uint256"
                      }
                    },
                    "src": "2620:25:84",
                    "typeDescriptions": {
                      "typeIdentifier": "t_bool",
                      "typeString": "bool"
                    }
                  },
                  "id": 33414,
                  "nodeType": "IfStatement",
                  "src": "2616:67:84",
                  "trueBody": {
                    "expression": {
                      "arguments": [
                        {
                          "arguments": [
                            {
                              "id": 33410,
                              "name": "coord",
                              "nodeType": "Identifier",
                              "overloadedDeclarations": [],
                              "referencedDeclaration": 33229,
                              "src": "2676:5:84",
                              "typeDescriptions": {
                                "typeIdentifier": "t_struct$_VoxelCoord_$5927_memory_ptr",
                                "typeString": "struct VoxelCoord memory"
                              }
                            }
                          ],
                          "expression": {
                            "argumentTypes": [
                              {
                                "typeIdentifier": "t_struct$_VoxelCoord_$5927_memory_ptr",
                                "typeString": "struct VoxelCoord memory"
                              }
                            ],
                            "id": 33409,
                            "name": "PinkFlower",
                            "nodeType": "Identifier",
                            "overloadedDeclarations": [],
                            "referencedDeclaration": 33805,
                            "src": "2665:10:84",
                            "typeDescriptions": {
                              "typeIdentifier": "t_function_internal_pure$_t_struct$_VoxelCoord_$5927_memory_ptr_$returns$_t_uint256_$",
                              "typeString": "function (struct VoxelCoord memory) pure returns (uint256)"
                            }
                          },
                          "id": 33411,
                          "isConstant": false,
                          "isLValue": false,
                          "isPure": false,
                          "kind": "functionCall",
                          "lValueRequested": false,
                          "names": [],
                          "nodeType": "FunctionCall",
                          "src": "2665:17:84",
                          "tryCall": false,
                          "typeDescriptions": {
                            "typeIdentifier": "t_uint256",
                            "typeString": "uint256"
                          }
                        }
                      ],
                      "expression": {
                        "argumentTypes": [
                          {
                            "typeIdentifier": "t_uint256",
                            "typeString": "uint256"
                          }
                        ],
                        "expression": {
                          "id": 33407,
                          "name": "abi",
                          "nodeType": "Identifier",
                          "overloadedDeclarations": [],
                          "referencedDeclaration": -1,
                          "src": "2654:3:84",
                          "typeDescriptions": {
                            "typeIdentifier": "t_magic_abi",
                            "typeString": "abi"
                          }
                        },
                        "id": 33408,
                        "isConstant": false,
                        "isLValue": false,
                        "isPure": true,
                        "lValueRequested": false,
                        "memberName": "encode",
                        "nodeType": "MemberAccess",
                        "src": "2654:10:84",
                        "typeDescriptions": {
                          "typeIdentifier": "t_function_abiencode_pure$__$returns$_t_bytes_memory_ptr_$",
                          "typeString": "function () pure returns (bytes memory)"
                        }
                      },
                      "id": 33412,
                      "isConstant": false,
                      "isLValue": false,
                      "isPure": false,
                      "kind": "functionCall",
                      "lValueRequested": false,
                      "names": [],
                      "nodeType": "FunctionCall",
                      "src": "2654:29:84",
                      "tryCall": false,
                      "typeDescriptions": {
                        "typeIdentifier": "t_bytes_memory_ptr",
                        "typeString": "bytes memory"
                      }
                    },
                    "functionReturnParameters": 33224,
                    "id": 33413,
                    "nodeType": "Return",
                    "src": "2647:36:84"
                  }
                },
                {
                  "condition": {
                    "commonType": {
                      "typeIdentifier": "t_uint256",
                      "typeString": "uint256"
                    },
                    "id": 33417,
                    "isConstant": false,
                    "isLValue": false,
                    "isPure": false,
                    "lValueRequested": false,
                    "leftExpression": {
                      "id": 33415,
                      "name": "blockType",
                      "nodeType": "Identifier",
                      "overloadedDeclarations": [],
                      "referencedDeclaration": 33226,
                      "src": "2693:9:84",
                      "typeDescriptions": {
                        "typeIdentifier": "t_uint256",
                        "typeString": "uint256"
                      }
                    },
                    "nodeType": "BinaryOperation",
                    "operator": "==",
                    "rightExpression": {
                      "id": 33416,
                      "name": "GrayFlowerID",
                      "nodeType": "Identifier",
                      "overloadedDeclarations": [],
                      "referencedDeclaration": 29087,
                      "src": "2706:12:84",
                      "typeDescriptions": {
                        "typeIdentifier": "t_uint256",
                        "typeString": "uint256"
                      }
                    },
                    "src": "2693:25:84",
                    "typeDescriptions": {
                      "typeIdentifier": "t_bool",
                      "typeString": "bool"
                    }
                  },
                  "id": 33425,
                  "nodeType": "IfStatement",
                  "src": "2689:67:84",
                  "trueBody": {
                    "expression": {
                      "arguments": [
                        {
                          "arguments": [
                            {
                              "id": 33421,
                              "name": "coord",
                              "nodeType": "Identifier",
                              "overloadedDeclarations": [],
                              "referencedDeclaration": 33229,
                              "src": "2749:5:84",
                              "typeDescriptions": {
                                "typeIdentifier": "t_struct$_VoxelCoord_$5927_memory_ptr",
                                "typeString": "struct VoxelCoord memory"
                              }
                            }
                          ],
                          "expression": {
                            "argumentTypes": [
                              {
                                "typeIdentifier": "t_struct$_VoxelCoord_$5927_memory_ptr",
                                "typeString": "struct VoxelCoord memory"
                              }
                            ],
                            "id": 33420,
                            "name": "GrayFlower",
                            "nodeType": "Identifier",
                            "overloadedDeclarations": [],
                            "referencedDeclaration": 33819,
                            "src": "2738:10:84",
                            "typeDescriptions": {
                              "typeIdentifier": "t_function_internal_pure$_t_struct$_VoxelCoord_$5927_memory_ptr_$returns$_t_uint256_$",
                              "typeString": "function (struct VoxelCoord memory) pure returns (uint256)"
                            }
                          },
                          "id": 33422,
                          "isConstant": false,
                          "isLValue": false,
                          "isPure": false,
                          "kind": "functionCall",
                          "lValueRequested": false,
                          "names": [],
                          "nodeType": "FunctionCall",
                          "src": "2738:17:84",
                          "tryCall": false,
                          "typeDescriptions": {
                            "typeIdentifier": "t_uint256",
                            "typeString": "uint256"
                          }
                        }
                      ],
                      "expression": {
                        "argumentTypes": [
                          {
                            "typeIdentifier": "t_uint256",
                            "typeString": "uint256"
                          }
                        ],
                        "expression": {
                          "id": 33418,
                          "name": "abi",
                          "nodeType": "Identifier",
                          "overloadedDeclarations": [],
                          "referencedDeclaration": -1,
                          "src": "2727:3:84",
                          "typeDescriptions": {
                            "typeIdentifier": "t_magic_abi",
                            "typeString": "abi"
                          }
                        },
                        "id": 33419,
                        "isConstant": false,
                        "isLValue": false,
                        "isPure": true,
                        "lValueRequested": false,
                        "memberName": "encode",
                        "nodeType": "MemberAccess",
                        "src": "2727:10:84",
                        "typeDescriptions": {
                          "typeIdentifier": "t_function_abiencode_pure$__$returns$_t_bytes_memory_ptr_$",
                          "typeString": "function () pure returns (bytes memory)"
                        }
                      },
                      "id": 33423,
                      "isConstant": false,
                      "isLValue": false,
                      "isPure": false,
                      "kind": "functionCall",
                      "lValueRequested": false,
                      "names": [],
                      "nodeType": "FunctionCall",
                      "src": "2727:29:84",
                      "tryCall": false,
                      "typeDescriptions": {
                        "typeIdentifier": "t_bytes_memory_ptr",
                        "typeString": "bytes memory"
                      }
                    },
                    "functionReturnParameters": 33224,
                    "id": 33424,
                    "nodeType": "Return",
                    "src": "2720:36:84"
                  }
                },
                {
                  "condition": {
                    "commonType": {
                      "typeIdentifier": "t_uint256",
                      "typeString": "uint256"
                    },
                    "id": 33428,
                    "isConstant": false,
                    "isLValue": false,
                    "isPure": false,
                    "lValueRequested": false,
                    "leftExpression": {
                      "id": 33426,
                      "name": "blockType",
                      "nodeType": "Identifier",
                      "overloadedDeclarations": [],
                      "referencedDeclaration": 33226,
                      "src": "2766:9:84",
                      "typeDescriptions": {
                        "typeIdentifier": "t_uint256",
                        "typeString": "uint256"
                      }
                    },
                    "nodeType": "BinaryOperation",
                    "operator": "==",
                    "rightExpression": {
                      "id": 33427,
                      "name": "LightGrayFlowerID",
                      "nodeType": "Identifier",
                      "overloadedDeclarations": [],
                      "referencedDeclaration": 29095,
                      "src": "2779:17:84",
                      "typeDescriptions": {
                        "typeIdentifier": "t_uint256",
                        "typeString": "uint256"
                      }
                    },
                    "src": "2766:30:84",
                    "typeDescriptions": {
                      "typeIdentifier": "t_bool",
                      "typeString": "bool"
                    }
                  },
                  "id": 33436,
                  "nodeType": "IfStatement",
                  "src": "2762:77:84",
                  "trueBody": {
                    "expression": {
                      "arguments": [
                        {
                          "arguments": [
                            {
                              "id": 33432,
                              "name": "coord",
                              "nodeType": "Identifier",
                              "overloadedDeclarations": [],
                              "referencedDeclaration": 33229,
                              "src": "2832:5:84",
                              "typeDescriptions": {
                                "typeIdentifier": "t_struct$_VoxelCoord_$5927_memory_ptr",
                                "typeString": "struct VoxelCoord memory"
                              }
                            }
                          ],
                          "expression": {
                            "argumentTypes": [
                              {
                                "typeIdentifier": "t_struct$_VoxelCoord_$5927_memory_ptr",
                                "typeString": "struct VoxelCoord memory"
                              }
                            ],
                            "id": 33431,
                            "name": "LightGrayFlower",
                            "nodeType": "Identifier",
                            "overloadedDeclarations": [],
                            "referencedDeclaration": 33833,
                            "src": "2816:15:84",
                            "typeDescriptions": {
                              "typeIdentifier": "t_function_internal_pure$_t_struct$_VoxelCoord_$5927_memory_ptr_$returns$_t_uint256_$",
                              "typeString": "function (struct VoxelCoord memory) pure returns (uint256)"
                            }
                          },
                          "id": 33433,
                          "isConstant": false,
                          "isLValue": false,
                          "isPure": false,
                          "kind": "functionCall",
                          "lValueRequested": false,
                          "names": [],
                          "nodeType": "FunctionCall",
                          "src": "2816:22:84",
                          "tryCall": false,
                          "typeDescriptions": {
                            "typeIdentifier": "t_uint256",
                            "typeString": "uint256"
                          }
                        }
                      ],
                      "expression": {
                        "argumentTypes": [
                          {
                            "typeIdentifier": "t_uint256",
                            "typeString": "uint256"
                          }
                        ],
                        "expression": {
                          "id": 33429,
                          "name": "abi",
                          "nodeType": "Identifier",
                          "overloadedDeclarations": [],
                          "referencedDeclaration": -1,
                          "src": "2805:3:84",
                          "typeDescriptions": {
                            "typeIdentifier": "t_magic_abi",
                            "typeString": "abi"
                          }
                        },
                        "id": 33430,
                        "isConstant": false,
                        "isLValue": false,
                        "isPure": true,
                        "lValueRequested": false,
                        "memberName": "encode",
                        "nodeType": "MemberAccess",
                        "src": "2805:10:84",
                        "typeDescriptions": {
                          "typeIdentifier": "t_function_abiencode_pure$__$returns$_t_bytes_memory_ptr_$",
                          "typeString": "function () pure returns (bytes memory)"
                        }
                      },
                      "id": 33434,
                      "isConstant": false,
                      "isLValue": false,
                      "isPure": false,
                      "kind": "functionCall",
                      "lValueRequested": false,
                      "names": [],
                      "nodeType": "FunctionCall",
                      "src": "2805:34:84",
                      "tryCall": false,
                      "typeDescriptions": {
                        "typeIdentifier": "t_bytes_memory_ptr",
                        "typeString": "bytes memory"
                      }
                    },
                    "functionReturnParameters": 33224,
                    "id": 33435,
                    "nodeType": "Return",
                    "src": "2798:41:84"
                  }
                },
                {
                  "condition": {
                    "commonType": {
                      "typeIdentifier": "t_uint256",
                      "typeString": "uint256"
                    },
                    "id": 33439,
                    "isConstant": false,
                    "isLValue": false,
                    "isPure": false,
                    "lValueRequested": false,
                    "leftExpression": {
                      "id": 33437,
                      "name": "blockType",
                      "nodeType": "Identifier",
                      "overloadedDeclarations": [],
                      "referencedDeclaration": 33226,
                      "src": "2849:9:84",
                      "typeDescriptions": {
                        "typeIdentifier": "t_uint256",
                        "typeString": "uint256"
                      }
                    },
                    "nodeType": "BinaryOperation",
                    "operator": "==",
                    "rightExpression": {
                      "id": 33438,
                      "name": "CyanFlowerID",
                      "nodeType": "Identifier",
                      "overloadedDeclarations": [],
                      "referencedDeclaration": 29103,
                      "src": "2862:12:84",
                      "typeDescriptions": {
                        "typeIdentifier": "t_uint256",
                        "typeString": "uint256"
                      }
                    },
                    "src": "2849:25:84",
                    "typeDescriptions": {
                      "typeIdentifier": "t_bool",
                      "typeString": "bool"
                    }
                  },
                  "id": 33447,
                  "nodeType": "IfStatement",
                  "src": "2845:67:84",
                  "trueBody": {
                    "expression": {
                      "arguments": [
                        {
                          "arguments": [
                            {
                              "id": 33443,
                              "name": "coord",
                              "nodeType": "Identifier",
                              "overloadedDeclarations": [],
                              "referencedDeclaration": 33229,
                              "src": "2905:5:84",
                              "typeDescriptions": {
                                "typeIdentifier": "t_struct$_VoxelCoord_$5927_memory_ptr",
                                "typeString": "struct VoxelCoord memory"
                              }
                            }
                          ],
                          "expression": {
                            "argumentTypes": [
                              {
                                "typeIdentifier": "t_struct$_VoxelCoord_$5927_memory_ptr",
                                "typeString": "struct VoxelCoord memory"
                              }
                            ],
                            "id": 33442,
                            "name": "CyanFlower",
                            "nodeType": "Identifier",
                            "overloadedDeclarations": [],
                            "referencedDeclaration": 33847,
                            "src": "2894:10:84",
                            "typeDescriptions": {
                              "typeIdentifier": "t_function_internal_pure$_t_struct$_VoxelCoord_$5927_memory_ptr_$returns$_t_uint256_$",
                              "typeString": "function (struct VoxelCoord memory) pure returns (uint256)"
                            }
                          },
                          "id": 33444,
                          "isConstant": false,
                          "isLValue": false,
                          "isPure": false,
                          "kind": "functionCall",
                          "lValueRequested": false,
                          "names": [],
                          "nodeType": "FunctionCall",
                          "src": "2894:17:84",
                          "tryCall": false,
                          "typeDescriptions": {
                            "typeIdentifier": "t_uint256",
                            "typeString": "uint256"
                          }
                        }
                      ],
                      "expression": {
                        "argumentTypes": [
                          {
                            "typeIdentifier": "t_uint256",
                            "typeString": "uint256"
                          }
                        ],
                        "expression": {
                          "id": 33440,
                          "name": "abi",
                          "nodeType": "Identifier",
                          "overloadedDeclarations": [],
                          "referencedDeclaration": -1,
                          "src": "2883:3:84",
                          "typeDescriptions": {
                            "typeIdentifier": "t_magic_abi",
                            "typeString": "abi"
                          }
                        },
                        "id": 33441,
                        "isConstant": false,
                        "isLValue": false,
                        "isPure": true,
                        "lValueRequested": false,
                        "memberName": "encode",
                        "nodeType": "MemberAccess",
                        "src": "2883:10:84",
                        "typeDescriptions": {
                          "typeIdentifier": "t_function_abiencode_pure$__$returns$_t_bytes_memory_ptr_$",
                          "typeString": "function () pure returns (bytes memory)"
                        }
                      },
                      "id": 33445,
                      "isConstant": false,
                      "isLValue": false,
                      "isPure": false,
                      "kind": "functionCall",
                      "lValueRequested": false,
                      "names": [],
                      "nodeType": "FunctionCall",
                      "src": "2883:29:84",
                      "tryCall": false,
                      "typeDescriptions": {
                        "typeIdentifier": "t_bytes_memory_ptr",
                        "typeString": "bytes memory"
                      }
                    },
                    "functionReturnParameters": 33224,
                    "id": 33446,
                    "nodeType": "Return",
                    "src": "2876:36:84"
                  }
                },
                {
                  "condition": {
                    "commonType": {
                      "typeIdentifier": "t_uint256",
                      "typeString": "uint256"
                    },
                    "id": 33450,
                    "isConstant": false,
                    "isLValue": false,
                    "isPure": false,
                    "lValueRequested": false,
                    "leftExpression": {
                      "id": 33448,
                      "name": "blockType",
                      "nodeType": "Identifier",
                      "overloadedDeclarations": [],
                      "referencedDeclaration": 33226,
                      "src": "2922:9:84",
                      "typeDescriptions": {
                        "typeIdentifier": "t_uint256",
                        "typeString": "uint256"
                      }
                    },
                    "nodeType": "BinaryOperation",
                    "operator": "==",
                    "rightExpression": {
                      "id": 33449,
                      "name": "PurpleFlowerID",
                      "nodeType": "Identifier",
                      "overloadedDeclarations": [],
                      "referencedDeclaration": 29111,
                      "src": "2935:14:84",
                      "typeDescriptions": {
                        "typeIdentifier": "t_uint256",
                        "typeString": "uint256"
                      }
                    },
                    "src": "2922:27:84",
                    "typeDescriptions": {
                      "typeIdentifier": "t_bool",
                      "typeString": "bool"
                    }
                  },
                  "id": 33458,
                  "nodeType": "IfStatement",
                  "src": "2918:71:84",
                  "trueBody": {
                    "expression": {
                      "arguments": [
                        {
                          "arguments": [
                            {
                              "id": 33454,
                              "name": "coord",
                              "nodeType": "Identifier",
                              "overloadedDeclarations": [],
                              "referencedDeclaration": 33229,
                              "src": "2982:5:84",
                              "typeDescriptions": {
                                "typeIdentifier": "t_struct$_VoxelCoord_$5927_memory_ptr",
                                "typeString": "struct VoxelCoord memory"
                              }
                            }
                          ],
                          "expression": {
                            "argumentTypes": [
                              {
                                "typeIdentifier": "t_struct$_VoxelCoord_$5927_memory_ptr",
                                "typeString": "struct VoxelCoord memory"
                              }
                            ],
                            "id": 33453,
                            "name": "PurpleFlower",
                            "nodeType": "Identifier",
                            "overloadedDeclarations": [],
                            "referencedDeclaration": 33861,
                            "src": "2969:12:84",
                            "typeDescriptions": {
                              "typeIdentifier": "t_function_internal_pure$_t_struct$_VoxelCoord_$5927_memory_ptr_$returns$_t_uint256_$",
                              "typeString": "function (struct VoxelCoord memory) pure returns (uint256)"
                            }
                          },
                          "id": 33455,
                          "isConstant": false,
                          "isLValue": false,
                          "isPure": false,
                          "kind": "functionCall",
                          "lValueRequested": false,
                          "names": [],
                          "nodeType": "FunctionCall",
                          "src": "2969:19:84",
                          "tryCall": false,
                          "typeDescriptions": {
                            "typeIdentifier": "t_uint256",
                            "typeString": "uint256"
                          }
                        }
                      ],
                      "expression": {
                        "argumentTypes": [
                          {
                            "typeIdentifier": "t_uint256",
                            "typeString": "uint256"
                          }
                        ],
                        "expression": {
                          "id": 33451,
                          "name": "abi",
                          "nodeType": "Identifier",
                          "overloadedDeclarations": [],
                          "referencedDeclaration": -1,
                          "src": "2958:3:84",
                          "typeDescriptions": {
                            "typeIdentifier": "t_magic_abi",
                            "typeString": "abi"
                          }
                        },
                        "id": 33452,
                        "isConstant": false,
                        "isLValue": false,
                        "isPure": true,
                        "lValueRequested": false,
                        "memberName": "encode",
                        "nodeType": "MemberAccess",
                        "src": "2958:10:84",
                        "typeDescriptions": {
                          "typeIdentifier": "t_function_abiencode_pure$__$returns$_t_bytes_memory_ptr_$",
                          "typeString": "function () pure returns (bytes memory)"
                        }
                      },
                      "id": 33456,
                      "isConstant": false,
                      "isLValue": false,
                      "isPure": false,
                      "kind": "functionCall",
                      "lValueRequested": false,
                      "names": [],
                      "nodeType": "FunctionCall",
                      "src": "2958:31:84",
                      "tryCall": false,
                      "typeDescriptions": {
                        "typeIdentifier": "t_bytes_memory_ptr",
                        "typeString": "bytes memory"
                      }
                    },
                    "functionReturnParameters": 33224,
                    "id": 33457,
                    "nodeType": "Return",
                    "src": "2951:38:84"
                  }
                },
                {
                  "condition": {
                    "commonType": {
                      "typeIdentifier": "t_uint256",
                      "typeString": "uint256"
                    },
                    "id": 33461,
                    "isConstant": false,
                    "isLValue": false,
                    "isPure": false,
                    "lValueRequested": false,
                    "leftExpression": {
                      "id": 33459,
                      "name": "blockType",
                      "nodeType": "Identifier",
                      "overloadedDeclarations": [],
                      "referencedDeclaration": 33226,
                      "src": "2999:9:84",
                      "typeDescriptions": {
                        "typeIdentifier": "t_uint256",
                        "typeString": "uint256"
                      }
                    },
                    "nodeType": "BinaryOperation",
                    "operator": "==",
                    "rightExpression": {
                      "id": 33460,
                      "name": "BlueFlowerID",
                      "nodeType": "Identifier",
                      "overloadedDeclarations": [],
                      "referencedDeclaration": 29119,
                      "src": "3012:12:84",
                      "typeDescriptions": {
                        "typeIdentifier": "t_uint256",
                        "typeString": "uint256"
                      }
                    },
                    "src": "2999:25:84",
                    "typeDescriptions": {
                      "typeIdentifier": "t_bool",
                      "typeString": "bool"
                    }
                  },
                  "id": 33469,
                  "nodeType": "IfStatement",
                  "src": "2995:67:84",
                  "trueBody": {
                    "expression": {
                      "arguments": [
                        {
                          "arguments": [
                            {
                              "id": 33465,
                              "name": "coord",
                              "nodeType": "Identifier",
                              "overloadedDeclarations": [],
                              "referencedDeclaration": 33229,
                              "src": "3055:5:84",
                              "typeDescriptions": {
                                "typeIdentifier": "t_struct$_VoxelCoord_$5927_memory_ptr",
                                "typeString": "struct VoxelCoord memory"
                              }
                            }
                          ],
                          "expression": {
                            "argumentTypes": [
                              {
                                "typeIdentifier": "t_struct$_VoxelCoord_$5927_memory_ptr",
                                "typeString": "struct VoxelCoord memory"
                              }
                            ],
                            "id": 33464,
                            "name": "BlueFlower",
                            "nodeType": "Identifier",
                            "overloadedDeclarations": [],
                            "referencedDeclaration": 33875,
                            "src": "3044:10:84",
                            "typeDescriptions": {
                              "typeIdentifier": "t_function_internal_pure$_t_struct$_VoxelCoord_$5927_memory_ptr_$returns$_t_uint256_$",
                              "typeString": "function (struct VoxelCoord memory) pure returns (uint256)"
                            }
                          },
                          "id": 33466,
                          "isConstant": false,
                          "isLValue": false,
                          "isPure": false,
                          "kind": "functionCall",
                          "lValueRequested": false,
                          "names": [],
                          "nodeType": "FunctionCall",
                          "src": "3044:17:84",
                          "tryCall": false,
                          "typeDescriptions": {
                            "typeIdentifier": "t_uint256",
                            "typeString": "uint256"
                          }
                        }
                      ],
                      "expression": {
                        "argumentTypes": [
                          {
                            "typeIdentifier": "t_uint256",
                            "typeString": "uint256"
                          }
                        ],
                        "expression": {
                          "id": 33462,
                          "name": "abi",
                          "nodeType": "Identifier",
                          "overloadedDeclarations": [],
                          "referencedDeclaration": -1,
                          "src": "3033:3:84",
                          "typeDescriptions": {
                            "typeIdentifier": "t_magic_abi",
                            "typeString": "abi"
                          }
                        },
                        "id": 33463,
                        "isConstant": false,
                        "isLValue": false,
                        "isPure": true,
                        "lValueRequested": false,
                        "memberName": "encode",
                        "nodeType": "MemberAccess",
                        "src": "3033:10:84",
                        "typeDescriptions": {
                          "typeIdentifier": "t_function_abiencode_pure$__$returns$_t_bytes_memory_ptr_$",
                          "typeString": "function () pure returns (bytes memory)"
                        }
                      },
                      "id": 33467,
                      "isConstant": false,
                      "isLValue": false,
                      "isPure": false,
                      "kind": "functionCall",
                      "lValueRequested": false,
                      "names": [],
                      "nodeType": "FunctionCall",
                      "src": "3033:29:84",
                      "tryCall": false,
                      "typeDescriptions": {
                        "typeIdentifier": "t_bytes_memory_ptr",
                        "typeString": "bytes memory"
                      }
                    },
                    "functionReturnParameters": 33224,
                    "id": 33468,
                    "nodeType": "Return",
                    "src": "3026:36:84"
                  }
                },
                {
                  "condition": {
                    "commonType": {
                      "typeIdentifier": "t_uint256",
                      "typeString": "uint256"
                    },
                    "id": 33472,
                    "isConstant": false,
                    "isLValue": false,
                    "isPure": false,
                    "lValueRequested": false,
                    "leftExpression": {
                      "id": 33470,
                      "name": "blockType",
                      "nodeType": "Identifier",
                      "overloadedDeclarations": [],
                      "referencedDeclaration": 33226,
                      "src": "3072:9:84",
                      "typeDescriptions": {
                        "typeIdentifier": "t_uint256",
                        "typeString": "uint256"
                      }
                    },
                    "nodeType": "BinaryOperation",
                    "operator": "==",
                    "rightExpression": {
                      "id": 33471,
                      "name": "GreenFlowerID",
                      "nodeType": "Identifier",
                      "overloadedDeclarations": [],
                      "referencedDeclaration": 29127,
                      "src": "3085:13:84",
                      "typeDescriptions": {
                        "typeIdentifier": "t_uint256",
                        "typeString": "uint256"
                      }
                    },
                    "src": "3072:26:84",
                    "typeDescriptions": {
                      "typeIdentifier": "t_bool",
                      "typeString": "bool"
                    }
                  },
                  "id": 33480,
                  "nodeType": "IfStatement",
                  "src": "3068:69:84",
                  "trueBody": {
                    "expression": {
                      "arguments": [
                        {
                          "arguments": [
                            {
                              "id": 33476,
                              "name": "coord",
                              "nodeType": "Identifier",
                              "overloadedDeclarations": [],
                              "referencedDeclaration": 33229,
                              "src": "3130:5:84",
                              "typeDescriptions": {
                                "typeIdentifier": "t_struct$_VoxelCoord_$5927_memory_ptr",
                                "typeString": "struct VoxelCoord memory"
                              }
                            }
                          ],
                          "expression": {
                            "argumentTypes": [
                              {
                                "typeIdentifier": "t_struct$_VoxelCoord_$5927_memory_ptr",
                                "typeString": "struct VoxelCoord memory"
                              }
                            ],
                            "id": 33475,
                            "name": "GreenFlower",
                            "nodeType": "Identifier",
                            "overloadedDeclarations": [],
                            "referencedDeclaration": 33889,
                            "src": "3118:11:84",
                            "typeDescriptions": {
                              "typeIdentifier": "t_function_internal_pure$_t_struct$_VoxelCoord_$5927_memory_ptr_$returns$_t_uint256_$",
                              "typeString": "function (struct VoxelCoord memory) pure returns (uint256)"
                            }
                          },
                          "id": 33477,
                          "isConstant": false,
                          "isLValue": false,
                          "isPure": false,
                          "kind": "functionCall",
                          "lValueRequested": false,
                          "names": [],
                          "nodeType": "FunctionCall",
                          "src": "3118:18:84",
                          "tryCall": false,
                          "typeDescriptions": {
                            "typeIdentifier": "t_uint256",
                            "typeString": "uint256"
                          }
                        }
                      ],
                      "expression": {
                        "argumentTypes": [
                          {
                            "typeIdentifier": "t_uint256",
                            "typeString": "uint256"
                          }
                        ],
                        "expression": {
                          "id": 33473,
                          "name": "abi",
                          "nodeType": "Identifier",
                          "overloadedDeclarations": [],
                          "referencedDeclaration": -1,
                          "src": "3107:3:84",
                          "typeDescriptions": {
                            "typeIdentifier": "t_magic_abi",
                            "typeString": "abi"
                          }
                        },
                        "id": 33474,
                        "isConstant": false,
                        "isLValue": false,
                        "isPure": true,
                        "lValueRequested": false,
                        "memberName": "encode",
                        "nodeType": "MemberAccess",
                        "src": "3107:10:84",
                        "typeDescriptions": {
                          "typeIdentifier": "t_function_abiencode_pure$__$returns$_t_bytes_memory_ptr_$",
                          "typeString": "function () pure returns (bytes memory)"
                        }
                      },
                      "id": 33478,
                      "isConstant": false,
                      "isLValue": false,
                      "isPure": false,
                      "kind": "functionCall",
                      "lValueRequested": false,
                      "names": [],
                      "nodeType": "FunctionCall",
                      "src": "3107:30:84",
                      "tryCall": false,
                      "typeDescriptions": {
                        "typeIdentifier": "t_bytes_memory_ptr",
                        "typeString": "bytes memory"
                      }
                    },
                    "functionReturnParameters": 33224,
                    "id": 33479,
                    "nodeType": "Return",
                    "src": "3100:37:84"
                  }
                },
                {
                  "condition": {
                    "commonType": {
                      "typeIdentifier": "t_uint256",
                      "typeString": "uint256"
                    },
                    "id": 33483,
                    "isConstant": false,
                    "isLValue": false,
                    "isPure": false,
                    "lValueRequested": false,
                    "leftExpression": {
                      "id": 33481,
                      "name": "blockType",
                      "nodeType": "Identifier",
                      "overloadedDeclarations": [],
                      "referencedDeclaration": 33226,
                      "src": "3147:9:84",
                      "typeDescriptions": {
                        "typeIdentifier": "t_uint256",
                        "typeString": "uint256"
                      }
                    },
                    "nodeType": "BinaryOperation",
                    "operator": "==",
                    "rightExpression": {
                      "id": 33482,
                      "name": "BlackFlowerID",
                      "nodeType": "Identifier",
                      "overloadedDeclarations": [],
                      "referencedDeclaration": 29135,
                      "src": "3160:13:84",
                      "typeDescriptions": {
                        "typeIdentifier": "t_uint256",
                        "typeString": "uint256"
                      }
                    },
                    "src": "3147:26:84",
                    "typeDescriptions": {
                      "typeIdentifier": "t_bool",
                      "typeString": "bool"
                    }
                  },
                  "id": 33491,
                  "nodeType": "IfStatement",
                  "src": "3143:69:84",
                  "trueBody": {
                    "expression": {
                      "arguments": [
                        {
                          "arguments": [
                            {
                              "id": 33487,
                              "name": "coord",
                              "nodeType": "Identifier",
                              "overloadedDeclarations": [],
                              "referencedDeclaration": 33229,
                              "src": "3205:5:84",
                              "typeDescriptions": {
                                "typeIdentifier": "t_struct$_VoxelCoord_$5927_memory_ptr",
                                "typeString": "struct VoxelCoord memory"
                              }
                            }
                          ],
                          "expression": {
                            "argumentTypes": [
                              {
                                "typeIdentifier": "t_struct$_VoxelCoord_$5927_memory_ptr",
                                "typeString": "struct VoxelCoord memory"
                              }
                            ],
                            "id": 33486,
                            "name": "BlackFlower",
                            "nodeType": "Identifier",
                            "overloadedDeclarations": [],
                            "referencedDeclaration": 33903,
                            "src": "3193:11:84",
                            "typeDescriptions": {
                              "typeIdentifier": "t_function_internal_pure$_t_struct$_VoxelCoord_$5927_memory_ptr_$returns$_t_uint256_$",
                              "typeString": "function (struct VoxelCoord memory) pure returns (uint256)"
                            }
                          },
                          "id": 33488,
                          "isConstant": false,
                          "isLValue": false,
                          "isPure": false,
                          "kind": "functionCall",
                          "lValueRequested": false,
                          "names": [],
                          "nodeType": "FunctionCall",
                          "src": "3193:18:84",
                          "tryCall": false,
                          "typeDescriptions": {
                            "typeIdentifier": "t_uint256",
                            "typeString": "uint256"
                          }
                        }
                      ],
                      "expression": {
                        "argumentTypes": [
                          {
                            "typeIdentifier": "t_uint256",
                            "typeString": "uint256"
                          }
                        ],
                        "expression": {
                          "id": 33484,
                          "name": "abi",
                          "nodeType": "Identifier",
                          "overloadedDeclarations": [],
                          "referencedDeclaration": -1,
                          "src": "3182:3:84",
                          "typeDescriptions": {
                            "typeIdentifier": "t_magic_abi",
                            "typeString": "abi"
                          }
                        },
                        "id": 33485,
                        "isConstant": false,
                        "isLValue": false,
                        "isPure": true,
                        "lValueRequested": false,
                        "memberName": "encode",
                        "nodeType": "MemberAccess",
                        "src": "3182:10:84",
                        "typeDescriptions": {
                          "typeIdentifier": "t_function_abiencode_pure$__$returns$_t_bytes_memory_ptr_$",
                          "typeString": "function () pure returns (bytes memory)"
                        }
                      },
                      "id": 33489,
                      "isConstant": false,
                      "isLValue": false,
                      "isPure": false,
                      "kind": "functionCall",
                      "lValueRequested": false,
                      "names": [],
                      "nodeType": "FunctionCall",
                      "src": "3182:30:84",
                      "tryCall": false,
                      "typeDescriptions": {
                        "typeIdentifier": "t_bytes_memory_ptr",
                        "typeString": "bytes memory"
                      }
                    },
                    "functionReturnParameters": 33224,
                    "id": 33490,
                    "nodeType": "Return",
                    "src": "3175:37:84"
                  }
                },
                {
                  "condition": {
                    "commonType": {
                      "typeIdentifier": "t_uint256",
                      "typeString": "uint256"
                    },
                    "id": 33494,
                    "isConstant": false,
                    "isLValue": false,
                    "isPure": false,
                    "lValueRequested": false,
                    "leftExpression": {
                      "id": 33492,
                      "name": "blockType",
                      "nodeType": "Identifier",
                      "overloadedDeclarations": [],
                      "referencedDeclaration": 33226,
                      "src": "3222:9:84",
                      "typeDescriptions": {
                        "typeIdentifier": "t_uint256",
                        "typeString": "uint256"
                      }
                    },
                    "nodeType": "BinaryOperation",
                    "operator": "==",
                    "rightExpression": {
                      "id": 33493,
                      "name": "KelpID",
                      "nodeType": "Identifier",
                      "overloadedDeclarations": [],
                      "referencedDeclaration": 29143,
                      "src": "3235:6:84",
                      "typeDescriptions": {
                        "typeIdentifier": "t_uint256",
                        "typeString": "uint256"
                      }
                    },
                    "src": "3222:19:84",
                    "typeDescriptions": {
                      "typeIdentifier": "t_bool",
                      "typeString": "bool"
                    }
                  },
                  "id": 33502,
                  "nodeType": "IfStatement",
                  "src": "3218:55:84",
                  "trueBody": {
                    "expression": {
                      "arguments": [
                        {
                          "arguments": [
                            {
                              "id": 33498,
                              "name": "coord",
                              "nodeType": "Identifier",
                              "overloadedDeclarations": [],
                              "referencedDeclaration": 33229,
                              "src": "3266:5:84",
                              "typeDescriptions": {
                                "typeIdentifier": "t_struct$_VoxelCoord_$5927_memory_ptr",
                                "typeString": "struct VoxelCoord memory"
                              }
                            }
                          ],
                          "expression": {
                            "argumentTypes": [
                              {
                                "typeIdentifier": "t_struct$_VoxelCoord_$5927_memory_ptr",
                                "typeString": "struct VoxelCoord memory"
                              }
                            ],
                            "id": 33497,
                            "name": "Kelp",
                            "nodeType": "Identifier",
                            "overloadedDeclarations": [],
                            "referencedDeclaration": 33917,
                            "src": "3261:4:84",
                            "typeDescriptions": {
                              "typeIdentifier": "t_function_internal_pure$_t_struct$_VoxelCoord_$5927_memory_ptr_$returns$_t_uint256_$",
                              "typeString": "function (struct VoxelCoord memory) pure returns (uint256)"
                            }
                          },
                          "id": 33499,
                          "isConstant": false,
                          "isLValue": false,
                          "isPure": false,
                          "kind": "functionCall",
                          "lValueRequested": false,
                          "names": [],
                          "nodeType": "FunctionCall",
                          "src": "3261:11:84",
                          "tryCall": false,
                          "typeDescriptions": {
                            "typeIdentifier": "t_uint256",
                            "typeString": "uint256"
                          }
                        }
                      ],
                      "expression": {
                        "argumentTypes": [
                          {
                            "typeIdentifier": "t_uint256",
                            "typeString": "uint256"
                          }
                        ],
                        "expression": {
                          "id": 33495,
                          "name": "abi",
                          "nodeType": "Identifier",
                          "overloadedDeclarations": [],
                          "referencedDeclaration": -1,
                          "src": "3250:3:84",
                          "typeDescriptions": {
                            "typeIdentifier": "t_magic_abi",
                            "typeString": "abi"
                          }
                        },
                        "id": 33496,
                        "isConstant": false,
                        "isLValue": false,
                        "isPure": true,
                        "lValueRequested": false,
                        "memberName": "encode",
                        "nodeType": "MemberAccess",
                        "src": "3250:10:84",
                        "typeDescriptions": {
                          "typeIdentifier": "t_function_abiencode_pure$__$returns$_t_bytes_memory_ptr_$",
                          "typeString": "function () pure returns (bytes memory)"
                        }
                      },
                      "id": 33500,
                      "isConstant": false,
                      "isLValue": false,
                      "isPure": false,
                      "kind": "functionCall",
                      "lValueRequested": false,
                      "names": [],
                      "nodeType": "FunctionCall",
                      "src": "3250:23:84",
                      "tryCall": false,
                      "typeDescriptions": {
                        "typeIdentifier": "t_bytes_memory_ptr",
                        "typeString": "bytes memory"
                      }
                    },
                    "functionReturnParameters": 33224,
                    "id": 33501,
                    "nodeType": "Return",
                    "src": "3243:30:84"
                  }
                },
                {
                  "condition": {
                    "commonType": {
                      "typeIdentifier": "t_uint256",
                      "typeString": "uint256"
                    },
                    "id": 33505,
                    "isConstant": false,
                    "isLValue": false,
                    "isPure": false,
                    "lValueRequested": false,
                    "leftExpression": {
                      "id": 33503,
                      "name": "blockType",
                      "nodeType": "Identifier",
                      "overloadedDeclarations": [],
                      "referencedDeclaration": 33226,
                      "src": "3283:9:84",
                      "typeDescriptions": {
                        "typeIdentifier": "t_uint256",
                        "typeString": "uint256"
                      }
                    },
                    "nodeType": "BinaryOperation",
                    "operator": "==",
                    "rightExpression": {
                      "id": 33504,
                      "name": "WoolID",
                      "nodeType": "Identifier",
                      "overloadedDeclarations": [],
                      "referencedDeclaration": 29151,
                      "src": "3296:6:84",
                      "typeDescriptions": {
                        "typeIdentifier": "t_uint256",
                        "typeString": "uint256"
                      }
                    },
                    "src": "3283:19:84",
                    "typeDescriptions": {
                      "typeIdentifier": "t_bool",
                      "typeString": "bool"
                    }
                  },
                  "id": 33513,
                  "nodeType": "IfStatement",
                  "src": "3279:55:84",
                  "trueBody": {
                    "expression": {
                      "arguments": [
                        {
                          "arguments": [
                            {
                              "id": 33509,
                              "name": "coord",
                              "nodeType": "Identifier",
                              "overloadedDeclarations": [],
                              "referencedDeclaration": 33229,
                              "src": "3327:5:84",
                              "typeDescriptions": {
                                "typeIdentifier": "t_struct$_VoxelCoord_$5927_memory_ptr",
                                "typeString": "struct VoxelCoord memory"
                              }
                            }
                          ],
                          "expression": {
                            "argumentTypes": [
                              {
                                "typeIdentifier": "t_struct$_VoxelCoord_$5927_memory_ptr",
                                "typeString": "struct VoxelCoord memory"
                              }
                            ],
                            "id": 33508,
                            "name": "Wool",
                            "nodeType": "Identifier",
                            "overloadedDeclarations": [],
                            "referencedDeclaration": 33931,
                            "src": "3322:4:84",
                            "typeDescriptions": {
                              "typeIdentifier": "t_function_internal_pure$_t_struct$_VoxelCoord_$5927_memory_ptr_$returns$_t_uint256_$",
                              "typeString": "function (struct VoxelCoord memory) pure returns (uint256)"
                            }
                          },
                          "id": 33510,
                          "isConstant": false,
                          "isLValue": false,
                          "isPure": false,
                          "kind": "functionCall",
                          "lValueRequested": false,
                          "names": [],
                          "nodeType": "FunctionCall",
                          "src": "3322:11:84",
                          "tryCall": false,
                          "typeDescriptions": {
                            "typeIdentifier": "t_uint256",
                            "typeString": "uint256"
                          }
                        }
                      ],
                      "expression": {
                        "argumentTypes": [
                          {
                            "typeIdentifier": "t_uint256",
                            "typeString": "uint256"
                          }
                        ],
                        "expression": {
                          "id": 33506,
                          "name": "abi",
                          "nodeType": "Identifier",
                          "overloadedDeclarations": [],
                          "referencedDeclaration": -1,
                          "src": "3311:3:84",
                          "typeDescriptions": {
                            "typeIdentifier": "t_magic_abi",
                            "typeString": "abi"
                          }
                        },
                        "id": 33507,
                        "isConstant": false,
                        "isLValue": false,
                        "isPure": true,
                        "lValueRequested": false,
                        "memberName": "encode",
                        "nodeType": "MemberAccess",
                        "src": "3311:10:84",
                        "typeDescriptions": {
                          "typeIdentifier": "t_function_abiencode_pure$__$returns$_t_bytes_memory_ptr_$",
                          "typeString": "function () pure returns (bytes memory)"
                        }
                      },
                      "id": 33511,
                      "isConstant": false,
                      "isLValue": false,
                      "isPure": false,
                      "kind": "functionCall",
                      "lValueRequested": false,
                      "names": [],
                      "nodeType": "FunctionCall",
                      "src": "3311:23:84",
                      "tryCall": false,
                      "typeDescriptions": {
                        "typeIdentifier": "t_bytes_memory_ptr",
                        "typeString": "bytes memory"
                      }
                    },
                    "functionReturnParameters": 33224,
                    "id": 33512,
                    "nodeType": "Return",
                    "src": "3304:30:84"
                  }
                },
                {
                  "condition": {
                    "commonType": {
                      "typeIdentifier": "t_uint256",
                      "typeString": "uint256"
                    },
                    "id": 33516,
                    "isConstant": false,
                    "isLValue": false,
                    "isPure": false,
                    "lValueRequested": false,
                    "leftExpression": {
                      "id": 33514,
                      "name": "blockType",
                      "nodeType": "Identifier",
                      "overloadedDeclarations": [],
                      "referencedDeclaration": 33226,
                      "src": "3344:9:84",
                      "typeDescriptions": {
                        "typeIdentifier": "t_uint256",
                        "typeString": "uint256"
                      }
                    },
                    "nodeType": "BinaryOperation",
                    "operator": "==",
                    "rightExpression": {
                      "id": 33515,
                      "name": "SnowID",
                      "nodeType": "Identifier",
                      "overloadedDeclarations": [],
                      "referencedDeclaration": 29287,
                      "src": "3357:6:84",
                      "typeDescriptions": {
                        "typeIdentifier": "t_uint256",
                        "typeString": "uint256"
                      }
                    },
                    "src": "3344:19:84",
                    "typeDescriptions": {
                      "typeIdentifier": "t_bool",
                      "typeString": "bool"
                    }
                  },
                  "id": 33524,
                  "nodeType": "IfStatement",
                  "src": "3340:55:84",
                  "trueBody": {
                    "expression": {
                      "arguments": [
                        {
                          "arguments": [
                            {
                              "id": 33520,
                              "name": "coord",
                              "nodeType": "Identifier",
                              "overloadedDeclarations": [],
                              "referencedDeclaration": 33229,
                              "src": "3388:5:84",
                              "typeDescriptions": {
                                "typeIdentifier": "t_struct$_VoxelCoord_$5927_memory_ptr",
                                "typeString": "struct VoxelCoord memory"
                              }
                            }
                          ],
                          "expression": {
                            "argumentTypes": [
                              {
                                "typeIdentifier": "t_struct$_VoxelCoord_$5927_memory_ptr",
                                "typeString": "struct VoxelCoord memory"
                              }
                            ],
                            "id": 33519,
                            "name": "Snow",
                            "nodeType": "Identifier",
                            "overloadedDeclarations": [],
                            "referencedDeclaration": 33945,
                            "src": "3383:4:84",
                            "typeDescriptions": {
                              "typeIdentifier": "t_function_internal_pure$_t_struct$_VoxelCoord_$5927_memory_ptr_$returns$_t_uint256_$",
                              "typeString": "function (struct VoxelCoord memory) pure returns (uint256)"
                            }
                          },
                          "id": 33521,
                          "isConstant": false,
                          "isLValue": false,
                          "isPure": false,
                          "kind": "functionCall",
                          "lValueRequested": false,
                          "names": [],
                          "nodeType": "FunctionCall",
                          "src": "3383:11:84",
                          "tryCall": false,
                          "typeDescriptions": {
                            "typeIdentifier": "t_uint256",
                            "typeString": "uint256"
                          }
                        }
                      ],
                      "expression": {
                        "argumentTypes": [
                          {
                            "typeIdentifier": "t_uint256",
                            "typeString": "uint256"
                          }
                        ],
                        "expression": {
                          "id": 33517,
                          "name": "abi",
                          "nodeType": "Identifier",
                          "overloadedDeclarations": [],
                          "referencedDeclaration": -1,
                          "src": "3372:3:84",
                          "typeDescriptions": {
                            "typeIdentifier": "t_magic_abi",
                            "typeString": "abi"
                          }
                        },
                        "id": 33518,
                        "isConstant": false,
                        "isLValue": false,
                        "isPure": true,
                        "lValueRequested": false,
                        "memberName": "encode",
                        "nodeType": "MemberAccess",
                        "src": "3372:10:84",
                        "typeDescriptions": {
                          "typeIdentifier": "t_function_abiencode_pure$__$returns$_t_bytes_memory_ptr_$",
                          "typeString": "function () pure returns (bytes memory)"
                        }
                      },
                      "id": 33522,
                      "isConstant": false,
                      "isLValue": false,
                      "isPure": false,
                      "kind": "functionCall",
                      "lValueRequested": false,
                      "names": [],
                      "nodeType": "FunctionCall",
                      "src": "3372:23:84",
                      "tryCall": false,
                      "typeDescriptions": {
                        "typeIdentifier": "t_bytes_memory_ptr",
                        "typeString": "bytes memory"
                      }
                    },
                    "functionReturnParameters": 33224,
                    "id": 33523,
                    "nodeType": "Return",
                    "src": "3365:30:84"
                  }
                },
                {
                  "condition": {
                    "commonType": {
                      "typeIdentifier": "t_uint256",
                      "typeString": "uint256"
                    },
                    "id": 33527,
                    "isConstant": false,
                    "isLValue": false,
                    "isPure": false,
                    "lValueRequested": false,
                    "leftExpression": {
                      "id": 33525,
                      "name": "blockType",
                      "nodeType": "Identifier",
                      "overloadedDeclarations": [],
                      "referencedDeclaration": 33226,
                      "src": "3405:9:84",
                      "typeDescriptions": {
                        "typeIdentifier": "t_uint256",
                        "typeString": "uint256"
                      }
                    },
                    "nodeType": "BinaryOperation",
                    "operator": "==",
                    "rightExpression": {
                      "id": 33526,
                      "name": "ClayID",
                      "nodeType": "Identifier",
                      "overloadedDeclarations": [],
                      "referencedDeclaration": 29295,
                      "src": "3418:6:84",
                      "typeDescriptions": {
                        "typeIdentifier": "t_uint256",
                        "typeString": "uint256"
                      }
                    },
                    "src": "3405:19:84",
                    "typeDescriptions": {
                      "typeIdentifier": "t_bool",
                      "typeString": "bool"
                    }
                  },
                  "id": 33535,
                  "nodeType": "IfStatement",
                  "src": "3401:55:84",
                  "trueBody": {
                    "expression": {
                      "arguments": [
                        {
                          "arguments": [
                            {
                              "id": 33531,
                              "name": "coord",
                              "nodeType": "Identifier",
                              "overloadedDeclarations": [],
                              "referencedDeclaration": 33229,
                              "src": "3449:5:84",
                              "typeDescriptions": {
                                "typeIdentifier": "t_struct$_VoxelCoord_$5927_memory_ptr",
                                "typeString": "struct VoxelCoord memory"
                              }
                            }
                          ],
                          "expression": {
                            "argumentTypes": [
                              {
                                "typeIdentifier": "t_struct$_VoxelCoord_$5927_memory_ptr",
                                "typeString": "struct VoxelCoord memory"
                              }
                            ],
                            "id": 33530,
                            "name": "Clay",
                            "nodeType": "Identifier",
                            "overloadedDeclarations": [],
                            "referencedDeclaration": 33959,
                            "src": "3444:4:84",
                            "typeDescriptions": {
                              "typeIdentifier": "t_function_internal_pure$_t_struct$_VoxelCoord_$5927_memory_ptr_$returns$_t_uint256_$",
                              "typeString": "function (struct VoxelCoord memory) pure returns (uint256)"
                            }
                          },
                          "id": 33532,
                          "isConstant": false,
                          "isLValue": false,
                          "isPure": false,
                          "kind": "functionCall",
                          "lValueRequested": false,
                          "names": [],
                          "nodeType": "FunctionCall",
                          "src": "3444:11:84",
                          "tryCall": false,
                          "typeDescriptions": {
                            "typeIdentifier": "t_uint256",
                            "typeString": "uint256"
                          }
                        }
                      ],
                      "expression": {
                        "argumentTypes": [
                          {
                            "typeIdentifier": "t_uint256",
                            "typeString": "uint256"
                          }
                        ],
                        "expression": {
                          "id": 33528,
                          "name": "abi",
                          "nodeType": "Identifier",
                          "overloadedDeclarations": [],
                          "referencedDeclaration": -1,
                          "src": "3433:3:84",
                          "typeDescriptions": {
                            "typeIdentifier": "t_magic_abi",
                            "typeString": "abi"
                          }
                        },
                        "id": 33529,
                        "isConstant": false,
                        "isLValue": false,
                        "isPure": true,
                        "lValueRequested": false,
                        "memberName": "encode",
                        "nodeType": "MemberAccess",
                        "src": "3433:10:84",
                        "typeDescriptions": {
                          "typeIdentifier": "t_function_abiencode_pure$__$returns$_t_bytes_memory_ptr_$",
                          "typeString": "function () pure returns (bytes memory)"
                        }
                      },
                      "id": 33533,
                      "isConstant": false,
                      "isLValue": false,
                      "isPure": false,
                      "kind": "functionCall",
                      "lValueRequested": false,
                      "names": [],
                      "nodeType": "FunctionCall",
                      "src": "3433:23:84",
                      "tryCall": false,
                      "typeDescriptions": {
                        "typeIdentifier": "t_bytes_memory_ptr",
                        "typeString": "bytes memory"
                      }
                    },
                    "functionReturnParameters": 33224,
                    "id": 33534,
                    "nodeType": "Return",
                    "src": "3426:30:84"
                  }
                },
                {
                  "condition": {
                    "commonType": {
                      "typeIdentifier": "t_uint256",
                      "typeString": "uint256"
                    },
                    "id": 33538,
                    "isConstant": false,
                    "isLValue": false,
                    "isPure": false,
                    "lValueRequested": false,
                    "leftExpression": {
                      "id": 33536,
                      "name": "blockType",
                      "nodeType": "Identifier",
                      "overloadedDeclarations": [],
                      "referencedDeclaration": 33226,
                      "src": "3466:9:84",
                      "typeDescriptions": {
                        "typeIdentifier": "t_uint256",
                        "typeString": "uint256"
                      }
                    },
                    "nodeType": "BinaryOperation",
                    "operator": "==",
                    "rightExpression": {
                      "id": 33537,
                      "name": "BedrockID",
                      "nodeType": "Identifier",
                      "overloadedDeclarations": [],
                      "referencedDeclaration": 29303,
                      "src": "3479:9:84",
                      "typeDescriptions": {
                        "typeIdentifier": "t_uint256",
                        "typeString": "uint256"
                      }
                    },
                    "src": "3466:22:84",
                    "typeDescriptions": {
                      "typeIdentifier": "t_bool",
                      "typeString": "bool"
                    }
                  },
                  "id": 33546,
                  "nodeType": "IfStatement",
                  "src": "3462:61:84",
                  "trueBody": {
                    "expression": {
                      "arguments": [
                        {
                          "arguments": [
                            {
                              "id": 33542,
                              "name": "coord",
                              "nodeType": "Identifier",
                              "overloadedDeclarations": [],
                              "referencedDeclaration": 33229,
                              "src": "3516:5:84",
                              "typeDescriptions": {
                                "typeIdentifier": "t_struct$_VoxelCoord_$5927_memory_ptr",
                                "typeString": "struct VoxelCoord memory"
                              }
                            }
                          ],
                          "expression": {
                            "argumentTypes": [
                              {
                                "typeIdentifier": "t_struct$_VoxelCoord_$5927_memory_ptr",
                                "typeString": "struct VoxelCoord memory"
                              }
                            ],
                            "id": 33541,
                            "name": "Bedrock",
                            "nodeType": "Identifier",
                            "overloadedDeclarations": [],
                            "referencedDeclaration": 33973,
                            "src": "3508:7:84",
                            "typeDescriptions": {
                              "typeIdentifier": "t_function_internal_pure$_t_struct$_VoxelCoord_$5927_memory_ptr_$returns$_t_uint256_$",
                              "typeString": "function (struct VoxelCoord memory) pure returns (uint256)"
                            }
                          },
                          "id": 33543,
                          "isConstant": false,
                          "isLValue": false,
                          "isPure": false,
                          "kind": "functionCall",
                          "lValueRequested": false,
                          "names": [],
                          "nodeType": "FunctionCall",
                          "src": "3508:14:84",
                          "tryCall": false,
                          "typeDescriptions": {
                            "typeIdentifier": "t_uint256",
                            "typeString": "uint256"
                          }
                        }
                      ],
                      "expression": {
                        "argumentTypes": [
                          {
                            "typeIdentifier": "t_uint256",
                            "typeString": "uint256"
                          }
                        ],
                        "expression": {
                          "id": 33539,
                          "name": "abi",
                          "nodeType": "Identifier",
                          "overloadedDeclarations": [],
                          "referencedDeclaration": -1,
                          "src": "3497:3:84",
                          "typeDescriptions": {
                            "typeIdentifier": "t_magic_abi",
                            "typeString": "abi"
                          }
                        },
                        "id": 33540,
                        "isConstant": false,
                        "isLValue": false,
                        "isPure": true,
                        "lValueRequested": false,
                        "memberName": "encode",
                        "nodeType": "MemberAccess",
                        "src": "3497:10:84",
                        "typeDescriptions": {
                          "typeIdentifier": "t_function_abiencode_pure$__$returns$_t_bytes_memory_ptr_$",
                          "typeString": "function () pure returns (bytes memory)"
                        }
                      },
                      "id": 33544,
                      "isConstant": false,
                      "isLValue": false,
                      "isPure": false,
                      "kind": "functionCall",
                      "lValueRequested": false,
                      "names": [],
                      "nodeType": "FunctionCall",
                      "src": "3497:26:84",
                      "tryCall": false,
                      "typeDescriptions": {
                        "typeIdentifier": "t_bytes_memory_ptr",
                        "typeString": "bytes memory"
                      }
                    },
                    "functionReturnParameters": 33224,
                    "id": 33545,
                    "nodeType": "Return",
                    "src": "3490:33:84"
                  }
                },
                {
                  "expression": {
                    "arguments": [
                      {
                        "arguments": [
                          {
                            "hexValue": "30",
                            "id": 33551,
                            "isConstant": false,
                            "isLValue": false,
                            "isPure": true,
                            "kind": "number",
                            "lValueRequested": false,
                            "nodeType": "Literal",
                            "src": "3555:1:84",
                            "typeDescriptions": {
                              "typeIdentifier": "t_rational_0_by_1",
                              "typeString": "int_const 0"
                            },
                            "value": "0"
                          }
                        ],
                        "expression": {
                          "argumentTypes": [
                            {
                              "typeIdentifier": "t_rational_0_by_1",
                              "typeString": "int_const 0"
                            }
                          ],
                          "id": 33550,
                          "isConstant": false,
                          "isLValue": false,
                          "isPure": true,
                          "lValueRequested": false,
                          "nodeType": "ElementaryTypeNameExpression",
                          "src": "3547:7:84",
                          "typeDescriptions": {
                            "typeIdentifier": "t_type$_t_uint256_$",
                            "typeString": "type(uint256)"
                          },
                          "typeName": {
                            "id": 33549,
                            "name": "uint256",
                            "nodeType": "ElementaryTypeName",
                            "src": "3547:7:84",
                            "typeDescriptions": {}
                          }
                        },
                        "id": 33552,
                        "isConstant": false,
                        "isLValue": false,
                        "isPure": true,
                        "kind": "typeConversion",
                        "lValueRequested": false,
                        "names": [],
                        "nodeType": "FunctionCall",
                        "src": "3547:10:84",
                        "tryCall": false,
                        "typeDescriptions": {
                          "typeIdentifier": "t_uint256",
                          "typeString": "uint256"
                        }
                      }
                    ],
                    "expression": {
                      "argumentTypes": [
                        {
                          "typeIdentifier": "t_uint256",
                          "typeString": "uint256"
                        }
                      ],
                      "expression": {
                        "id": 33547,
                        "name": "abi",
                        "nodeType": "Identifier",
                        "overloadedDeclarations": [],
                        "referencedDeclaration": -1,
                        "src": "3536:3:84",
                        "typeDescriptions": {
                          "typeIdentifier": "t_magic_abi",
                          "typeString": "abi"
                        }
                      },
                      "id": 33548,
                      "isConstant": false,
                      "isLValue": false,
                      "isPure": true,
                      "lValueRequested": false,
                      "memberName": "encode",
                      "nodeType": "MemberAccess",
                      "src": "3536:10:84",
                      "typeDescriptions": {
                        "typeIdentifier": "t_function_abiencode_pure$__$returns$_t_bytes_memory_ptr_$",
                        "typeString": "function () pure returns (bytes memory)"
                      }
                    },
                    "id": 33553,
                    "isConstant": false,
                    "isLValue": false,
                    "isPure": true,
                    "kind": "functionCall",
                    "lValueRequested": false,
                    "names": [],
                    "nodeType": "FunctionCall",
                    "src": "3536:22:84",
                    "tryCall": false,
                    "typeDescriptions": {
                      "typeIdentifier": "t_bytes_memory_ptr",
                      "typeString": "bytes memory"
                    }
                  },
                  "functionReturnParameters": 33224,
                  "id": 33554,
                  "nodeType": "Return",
                  "src": "3529:29:84"
                }
              ]
            },
            "baseFunctions": [
              4953
            ],
            "functionSelector": "09c5eabe",
            "implemented": true,
            "kind": "function",
            "modifiers": [],
            "name": "execute",
            "nameLocation": "1426:7:84",
            "parameters": {
              "id": 33221,
              "nodeType": "ParameterList",
              "parameters": [
                {
                  "constant": false,
                  "id": 33220,
                  "mutability": "mutable",
                  "name": "arguments",
                  "nameLocation": "1447:9:84",
                  "nodeType": "VariableDeclaration",
                  "scope": 33556,
                  "src": "1434:22:84",
                  "stateVariable": false,
                  "storageLocation": "memory",
                  "typeDescriptions": {
                    "typeIdentifier": "t_bytes_memory_ptr",
                    "typeString": "bytes"
                  },
                  "typeName": {
                    "id": 33219,
                    "name": "bytes",
                    "nodeType": "ElementaryTypeName",
                    "src": "1434:5:84",
                    "typeDescriptions": {
                      "typeIdentifier": "t_bytes_storage_ptr",
                      "typeString": "bytes"
                    }
                  },
                  "visibility": "internal"
                }
              ],
              "src": "1433:24:84"
            },
            "returnParameters": {
              "id": 33224,
              "nodeType": "ParameterList",
              "parameters": [
                {
                  "constant": false,
                  "id": 33223,
                  "mutability": "mutable",
                  "name": "",
                  "nameLocation": "-1:-1:-1",
                  "nodeType": "VariableDeclaration",
                  "scope": 33556,
                  "src": "1479:12:84",
                  "stateVariable": false,
                  "storageLocation": "memory",
                  "typeDescriptions": {
                    "typeIdentifier": "t_bytes_memory_ptr",
                    "typeString": "bytes"
                  },
                  "typeName": {
                    "id": 33222,
                    "name": "bytes",
                    "nodeType": "ElementaryTypeName",
                    "src": "1479:5:84",
                    "typeDescriptions": {
                      "typeIdentifier": "t_bytes_storage_ptr",
                      "typeString": "bytes"
                    }
                  },
                  "visibility": "internal"
                }
              ],
              "src": "1478:14:84"
            },
            "scope": 33974,
            "stateMutability": "pure",
            "virtual": false,
            "visibility": "public"
          },
          {
            "id": 33581,
            "nodeType": "FunctionDefinition",
            "src": "3567:174:84",
            "nodes": [],
            "body": {
              "id": 33580,
              "nodeType": "Block",
              "src": "3663:78:84",
              "nodes": [],
              "statements": [
                {
                  "expression": {
                    "arguments": [
                      {
                        "arguments": [
                          {
                            "arguments": [
                              {
                                "id": 33571,
                                "name": "blockType",
                                "nodeType": "Identifier",
                                "overloadedDeclarations": [],
                                "referencedDeclaration": 33558,
                                "src": "3706:9:84",
                                "typeDescriptions": {
                                  "typeIdentifier": "t_uint256",
                                  "typeString": "uint256"
                                }
                              },
                              {
                                "id": 33572,
                                "name": "coord",
                                "nodeType": "Identifier",
                                "overloadedDeclarations": [],
                                "referencedDeclaration": 33561,
                                "src": "3717:5:84",
                                "typeDescriptions": {
                                  "typeIdentifier": "t_struct$_VoxelCoord_$5927_memory_ptr",
                                  "typeString": "struct VoxelCoord memory"
                                }
                              }
                            ],
                            "expression": {
                              "argumentTypes": [
                                {
                                  "typeIdentifier": "t_uint256",
                                  "typeString": "uint256"
                                },
                                {
                                  "typeIdentifier": "t_struct$_VoxelCoord_$5927_memory_ptr",
                                  "typeString": "struct VoxelCoord memory"
                                }
                              ],
                              "expression": {
                                "id": 33569,
                                "name": "abi",
                                "nodeType": "Identifier",
                                "overloadedDeclarations": [],
                                "referencedDeclaration": -1,
                                "src": "3695:3:84",
                                "typeDescriptions": {
                                  "typeIdentifier": "t_magic_abi",
                                  "typeString": "abi"
                                }
                              },
                              "id": 33570,
                              "isConstant": false,
                              "isLValue": false,
                              "isPure": true,
                              "lValueRequested": false,
                              "memberName": "encode",
                              "nodeType": "MemberAccess",
                              "src": "3695:10:84",
                              "typeDescriptions": {
                                "typeIdentifier": "t_function_abiencode_pure$__$returns$_t_bytes_memory_ptr_$",
                                "typeString": "function () pure returns (bytes memory)"
                              }
                            },
                            "id": 33573,
                            "isConstant": false,
                            "isLValue": false,
                            "isPure": false,
                            "kind": "functionCall",
                            "lValueRequested": false,
                            "names": [],
                            "nodeType": "FunctionCall",
                            "src": "3695:28:84",
                            "tryCall": false,
                            "typeDescriptions": {
                              "typeIdentifier": "t_bytes_memory_ptr",
                              "typeString": "bytes memory"
                            }
                          }
                        ],
                        "expression": {
                          "argumentTypes": [
                            {
                              "typeIdentifier": "t_bytes_memory_ptr",
                              "typeString": "bytes memory"
                            }
                          ],
                          "id": 33568,
                          "name": "execute",
                          "nodeType": "Identifier",
                          "overloadedDeclarations": [],
                          "referencedDeclaration": 33556,
                          "src": "3687:7:84",
                          "typeDescriptions": {
                            "typeIdentifier": "t_function_internal_pure$_t_bytes_memory_ptr_$returns$_t_bytes_memory_ptr_$",
                            "typeString": "function (bytes memory) pure returns (bytes memory)"
                          }
                        },
                        "id": 33574,
                        "isConstant": false,
                        "isLValue": false,
                        "isPure": false,
                        "kind": "functionCall",
                        "lValueRequested": false,
                        "names": [],
                        "nodeType": "FunctionCall",
                        "src": "3687:37:84",
                        "tryCall": false,
                        "typeDescriptions": {
                          "typeIdentifier": "t_bytes_memory_ptr",
                          "typeString": "bytes memory"
                        }
                      },
                      {
                        "components": [
                          {
                            "id": 33576,
                            "isConstant": false,
                            "isLValue": false,
                            "isPure": true,
                            "lValueRequested": false,
                            "nodeType": "ElementaryTypeNameExpression",
                            "src": "3727:7:84",
                            "typeDescriptions": {
                              "typeIdentifier": "t_type$_t_uint256_$",
                              "typeString": "type(uint256)"
                            },
                            "typeName": {
                              "id": 33575,
                              "name": "uint256",
                              "nodeType": "ElementaryTypeName",
                              "src": "3727:7:84",
                              "typeDescriptions": {}
                            }
                          }
                        ],
                        "id": 33577,
                        "isConstant": false,
                        "isInlineArray": false,
                        "isLValue": false,
                        "isPure": true,
                        "lValueRequested": false,
                        "nodeType": "TupleExpression",
                        "src": "3726:9:84",
                        "typeDescriptions": {
                          "typeIdentifier": "t_type$_t_uint256_$",
                          "typeString": "type(uint256)"
                        }
                      }
                    ],
                    "expression": {
                      "argumentTypes": [
                        {
                          "typeIdentifier": "t_bytes_memory_ptr",
                          "typeString": "bytes memory"
                        },
                        {
                          "typeIdentifier": "t_type$_t_uint256_$",
                          "typeString": "type(uint256)"
                        }
                      ],
                      "expression": {
                        "id": 33566,
                        "name": "abi",
                        "nodeType": "Identifier",
                        "overloadedDeclarations": [],
                        "referencedDeclaration": -1,
                        "src": "3676:3:84",
                        "typeDescriptions": {
                          "typeIdentifier": "t_magic_abi",
                          "typeString": "abi"
                        }
                      },
                      "id": 33567,
                      "isConstant": false,
                      "isLValue": false,
                      "isPure": true,
                      "lValueRequested": false,
                      "memberName": "decode",
                      "nodeType": "MemberAccess",
                      "src": "3676:10:84",
                      "typeDescriptions": {
                        "typeIdentifier": "t_function_abidecode_pure$__$returns$__$",
                        "typeString": "function () pure"
                      }
                    },
                    "id": 33578,
                    "isConstant": false,
                    "isLValue": false,
                    "isPure": false,
                    "kind": "functionCall",
                    "lValueRequested": false,
                    "names": [],
                    "nodeType": "FunctionCall",
                    "src": "3676:60:84",
                    "tryCall": false,
                    "typeDescriptions": {
                      "typeIdentifier": "t_uint256",
                      "typeString": "uint256"
                    }
                  },
                  "functionReturnParameters": 33565,
                  "id": 33579,
                  "nodeType": "Return",
                  "src": "3669:67:84"
                }
              ]
            },
            "functionSelector": "86bcb2ec",
            "implemented": true,
            "kind": "function",
            "modifiers": [],
            "name": "executeTyped",
            "nameLocation": "3576:12:84",
            "parameters": {
              "id": 33562,
              "nodeType": "ParameterList",
              "parameters": [
                {
                  "constant": false,
                  "id": 33558,
                  "mutability": "mutable",
                  "name": "blockType",
                  "nameLocation": "3597:9:84",
                  "nodeType": "VariableDeclaration",
                  "scope": 33581,
                  "src": "3589:17:84",
                  "stateVariable": false,
                  "storageLocation": "default",
                  "typeDescriptions": {
                    "typeIdentifier": "t_uint256",
                    "typeString": "uint256"
                  },
                  "typeName": {
                    "id": 33557,
                    "name": "uint256",
                    "nodeType": "ElementaryTypeName",
                    "src": "3589:7:84",
                    "typeDescriptions": {
                      "typeIdentifier": "t_uint256",
                      "typeString": "uint256"
                    }
                  },
                  "visibility": "internal"
                },
                {
                  "constant": false,
                  "id": 33561,
                  "mutability": "mutable",
                  "name": "coord",
                  "nameLocation": "3626:5:84",
                  "nodeType": "VariableDeclaration",
                  "scope": 33581,
                  "src": "3608:23:84",
                  "stateVariable": false,
                  "storageLocation": "memory",
                  "typeDescriptions": {
                    "typeIdentifier": "t_struct$_VoxelCoord_$5927_memory_ptr",
                    "typeString": "struct VoxelCoord"
                  },
                  "typeName": {
                    "id": 33560,
                    "nodeType": "UserDefinedTypeName",
                    "pathNode": {
                      "id": 33559,
                      "name": "VoxelCoord",
                      "nodeType": "IdentifierPath",
                      "referencedDeclaration": 5927,
                      "src": "3608:10:84"
                    },
                    "referencedDeclaration": 5927,
                    "src": "3608:10:84",
                    "typeDescriptions": {
                      "typeIdentifier": "t_struct$_VoxelCoord_$5927_storage_ptr",
                      "typeString": "struct VoxelCoord"
                    }
                  },
                  "visibility": "internal"
                }
              ],
              "src": "3588:44:84"
            },
            "returnParameters": {
              "id": 33565,
              "nodeType": "ParameterList",
              "parameters": [
                {
                  "constant": false,
                  "id": 33564,
                  "mutability": "mutable",
                  "name": "",
                  "nameLocation": "-1:-1:-1",
                  "nodeType": "VariableDeclaration",
                  "scope": 33581,
                  "src": "3654:7:84",
                  "stateVariable": false,
                  "storageLocation": "default",
                  "typeDescriptions": {
                    "typeIdentifier": "t_uint256",
                    "typeString": "uint256"
                  },
                  "typeName": {
                    "id": 33563,
                    "name": "uint256",
                    "nodeType": "ElementaryTypeName",
                    "src": "3654:7:84",
                    "typeDescriptions": {
                      "typeIdentifier": "t_uint256",
                      "typeString": "uint256"
                    }
                  },
                  "visibility": "internal"
                }
              ],
              "src": "3653:9:84"
            },
            "scope": 33974,
            "stateMutability": "pure",
            "virtual": false,
            "visibility": "public"
          },
          {
            "id": 33595,
            "nodeType": "FunctionDefinition",
            "src": "3771:111:84",
            "nodes": [],
            "body": {
              "id": 33594,
              "nodeType": "Block",
              "src": "3841:41:84",
              "nodes": [],
              "statements": [
                {
                  "expression": {
                    "arguments": [
                      {
                        "id": 33591,
                        "name": "coord",
                        "nodeType": "Identifier",
                        "overloadedDeclarations": [],
                        "referencedDeclaration": 33584,
                        "src": "3871:5:84",
                        "typeDescriptions": {
                          "typeIdentifier": "t_struct$_VoxelCoord_$5927_memory_ptr",
                          "typeString": "struct VoxelCoord memory"
                        }
                      }
                    ],
                    "expression": {
                      "argumentTypes": [
                        {
                          "typeIdentifier": "t_struct$_VoxelCoord_$5927_memory_ptr",
                          "typeString": "struct VoxelCoord memory"
                        }
                      ],
                      "expression": {
                        "id": 33589,
                        "name": "LibTerrain",
                        "nodeType": "Identifier",
                        "overloadedDeclarations": [],
                        "referencedDeclaration": 28871,
                        "src": "3854:10:84",
                        "typeDescriptions": {
                          "typeIdentifier": "t_type$_t_contract$_LibTerrain_$28871_$",
                          "typeString": "type(library LibTerrain)"
                        }
                      },
                      "id": 33590,
                      "isConstant": false,
                      "isLValue": false,
                      "isPure": false,
                      "lValueRequested": false,
                      "memberName": "Grass",
                      "nodeType": "MemberAccess",
                      "referencedDeclaration": 27885,
                      "src": "3854:16:84",
                      "typeDescriptions": {
                        "typeIdentifier": "t_function_internal_pure$_t_struct$_VoxelCoord_$5927_memory_ptr_$returns$_t_uint256_$",
                        "typeString": "function (struct VoxelCoord memory) pure returns (uint256)"
                      }
                    },
                    "id": 33592,
                    "isConstant": false,
                    "isLValue": false,
                    "isPure": false,
                    "kind": "functionCall",
                    "lValueRequested": false,
                    "names": [],
                    "nodeType": "FunctionCall",
                    "src": "3854:23:84",
                    "tryCall": false,
                    "typeDescriptions": {
                      "typeIdentifier": "t_uint256",
                      "typeString": "uint256"
                    }
                  },
                  "functionReturnParameters": 33588,
                  "id": 33593,
                  "nodeType": "Return",
                  "src": "3847:30:84"
                }
              ]
            },
            "functionSelector": "096d22b1",
            "implemented": true,
            "kind": "function",
            "modifiers": [],
            "name": "Grass",
            "nameLocation": "3780:5:84",
            "parameters": {
              "id": 33585,
              "nodeType": "ParameterList",
              "parameters": [
                {
                  "constant": false,
                  "id": 33584,
                  "mutability": "mutable",
                  "name": "coord",
                  "nameLocation": "3804:5:84",
                  "nodeType": "VariableDeclaration",
                  "scope": 33595,
                  "src": "3786:23:84",
                  "stateVariable": false,
                  "storageLocation": "memory",
                  "typeDescriptions": {
                    "typeIdentifier": "t_struct$_VoxelCoord_$5927_memory_ptr",
                    "typeString": "struct VoxelCoord"
                  },
                  "typeName": {
                    "id": 33583,
                    "nodeType": "UserDefinedTypeName",
                    "pathNode": {
                      "id": 33582,
                      "name": "VoxelCoord",
                      "nodeType": "IdentifierPath",
                      "referencedDeclaration": 5927,
                      "src": "3786:10:84"
                    },
                    "referencedDeclaration": 5927,
                    "src": "3786:10:84",
                    "typeDescriptions": {
                      "typeIdentifier": "t_struct$_VoxelCoord_$5927_storage_ptr",
                      "typeString": "struct VoxelCoord"
                    }
                  },
                  "visibility": "internal"
                }
              ],
              "src": "3785:25:84"
            },
            "returnParameters": {
              "id": 33588,
              "nodeType": "ParameterList",
              "parameters": [
                {
                  "constant": false,
                  "id": 33587,
                  "mutability": "mutable",
                  "name": "",
                  "nameLocation": "-1:-1:-1",
                  "nodeType": "VariableDeclaration",
                  "scope": 33595,
                  "src": "3832:7:84",
                  "stateVariable": false,
                  "storageLocation": "default",
                  "typeDescriptions": {
                    "typeIdentifier": "t_uint256",
                    "typeString": "uint256"
                  },
                  "typeName": {
                    "id": 33586,
                    "name": "uint256",
                    "nodeType": "ElementaryTypeName",
                    "src": "3832:7:84",
                    "typeDescriptions": {
                      "typeIdentifier": "t_uint256",
                      "typeString": "uint256"
                    }
                  },
                  "visibility": "internal"
                }
              ],
              "src": "3831:9:84"
            },
            "scope": 33974,
            "stateMutability": "pure",
            "virtual": false,
            "visibility": "public"
          },
          {
            "id": 33609,
            "nodeType": "FunctionDefinition",
            "src": "3886:109:84",
            "nodes": [],
            "body": {
              "id": 33608,
              "nodeType": "Block",
              "src": "3955:40:84",
              "nodes": [],
              "statements": [
                {
                  "expression": {
                    "arguments": [
                      {
                        "id": 33605,
                        "name": "coord",
                        "nodeType": "Identifier",
                        "overloadedDeclarations": [],
                        "referencedDeclaration": 33598,
                        "src": "3984:5:84",
                        "typeDescriptions": {
                          "typeIdentifier": "t_struct$_VoxelCoord_$5927_memory_ptr",
                          "typeString": "struct VoxelCoord memory"
                        }
                      }
                    ],
                    "expression": {
                      "argumentTypes": [
                        {
                          "typeIdentifier": "t_struct$_VoxelCoord_$5927_memory_ptr",
                          "typeString": "struct VoxelCoord memory"
                        }
                      ],
                      "expression": {
                        "id": 33603,
                        "name": "LibTerrain",
                        "nodeType": "Identifier",
                        "overloadedDeclarations": [],
                        "referencedDeclaration": 28871,
                        "src": "3968:10:84",
                        "typeDescriptions": {
                          "typeIdentifier": "t_type$_t_contract$_LibTerrain_$28871_$",
                          "typeString": "type(library LibTerrain)"
                        }
                      },
                      "id": 33604,
                      "isConstant": false,
                      "isLValue": false,
                      "isPure": false,
                      "lValueRequested": false,
                      "memberName": "Dirt",
                      "nodeType": "MemberAccess",
                      "referencedDeclaration": 27999,
                      "src": "3968:15:84",
                      "typeDescriptions": {
                        "typeIdentifier": "t_function_internal_pure$_t_struct$_VoxelCoord_$5927_memory_ptr_$returns$_t_uint256_$",
                        "typeString": "function (struct VoxelCoord memory) pure returns (uint256)"
                      }
                    },
                    "id": 33606,
                    "isConstant": false,
                    "isLValue": false,
                    "isPure": false,
                    "kind": "functionCall",
                    "lValueRequested": false,
                    "names": [],
                    "nodeType": "FunctionCall",
                    "src": "3968:22:84",
                    "tryCall": false,
                    "typeDescriptions": {
                      "typeIdentifier": "t_uint256",
                      "typeString": "uint256"
                    }
                  },
                  "functionReturnParameters": 33602,
                  "id": 33607,
                  "nodeType": "Return",
                  "src": "3961:29:84"
                }
              ]
            },
            "functionSelector": "d7170261",
            "implemented": true,
            "kind": "function",
            "modifiers": [],
            "name": "Dirt",
            "nameLocation": "3895:4:84",
            "parameters": {
              "id": 33599,
              "nodeType": "ParameterList",
              "parameters": [
                {
                  "constant": false,
                  "id": 33598,
                  "mutability": "mutable",
                  "name": "coord",
                  "nameLocation": "3918:5:84",
                  "nodeType": "VariableDeclaration",
                  "scope": 33609,
                  "src": "3900:23:84",
                  "stateVariable": false,
                  "storageLocation": "memory",
                  "typeDescriptions": {
                    "typeIdentifier": "t_struct$_VoxelCoord_$5927_memory_ptr",
                    "typeString": "struct VoxelCoord"
                  },
                  "typeName": {
                    "id": 33597,
                    "nodeType": "UserDefinedTypeName",
                    "pathNode": {
                      "id": 33596,
                      "name": "VoxelCoord",
                      "nodeType": "IdentifierPath",
                      "referencedDeclaration": 5927,
                      "src": "3900:10:84"
                    },
                    "referencedDeclaration": 5927,
                    "src": "3900:10:84",
                    "typeDescriptions": {
                      "typeIdentifier": "t_struct$_VoxelCoord_$5927_storage_ptr",
                      "typeString": "struct VoxelCoord"
                    }
                  },
                  "visibility": "internal"
                }
              ],
              "src": "3899:25:84"
            },
            "returnParameters": {
              "id": 33602,
              "nodeType": "ParameterList",
              "parameters": [
                {
                  "constant": false,
                  "id": 33601,
                  "mutability": "mutable",
                  "name": "",
                  "nameLocation": "-1:-1:-1",
                  "nodeType": "VariableDeclaration",
                  "scope": 33609,
                  "src": "3946:7:84",
                  "stateVariable": false,
                  "storageLocation": "default",
                  "typeDescriptions": {
                    "typeIdentifier": "t_uint256",
                    "typeString": "uint256"
                  },
                  "typeName": {
                    "id": 33600,
                    "name": "uint256",
                    "nodeType": "ElementaryTypeName",
                    "src": "3946:7:84",
                    "typeDescriptions": {
                      "typeIdentifier": "t_uint256",
                      "typeString": "uint256"
                    }
                  },
                  "visibility": "internal"
                }
              ],
              "src": "3945:9:84"
            },
            "scope": 33974,
            "stateMutability": "pure",
            "virtual": false,
            "visibility": "public"
          },
          {
            "id": 33623,
            "nodeType": "FunctionDefinition",
            "src": "3999:113:84",
            "nodes": [],
            "body": {
              "id": 33622,
              "nodeType": "Block",
              "src": "4067:45:84",
              "nodes": [],
              "statements": [
                {
                  "expression": {
                    "arguments": [
                      {
                        "id": 33619,
                        "name": "coord",
                        "nodeType": "Identifier",
                        "overloadedDeclarations": [],
                        "referencedDeclaration": 33612,
                        "src": "4101:5:84",
                        "typeDescriptions": {
                          "typeIdentifier": "t_struct$_VoxelCoord_$5927_memory_ptr",
                          "typeString": "struct VoxelCoord memory"
                        }
                      }
                    ],
                    "expression": {
                      "argumentTypes": [
                        {
                          "typeIdentifier": "t_struct$_VoxelCoord_$5927_memory_ptr",
                          "typeString": "struct VoxelCoord memory"
                        }
                      ],
                      "expression": {
                        "id": 33617,
                        "name": "LibTerrain",
                        "nodeType": "Identifier",
                        "overloadedDeclarations": [],
                        "referencedDeclaration": 28871,
                        "src": "4080:10:84",
                        "typeDescriptions": {
                          "typeIdentifier": "t_type$_t_contract$_LibTerrain_$28871_$",
                          "typeString": "type(library LibTerrain)"
                        }
                      },
                      "id": 33618,
                      "isConstant": false,
                      "isLValue": false,
                      "isPure": false,
                      "lValueRequested": false,
                      "memberName": "Structure",
                      "nodeType": "MemberAccess",
                      "referencedDeclaration": 28306,
                      "src": "4080:20:84",
                      "typeDescriptions": {
                        "typeIdentifier": "t_function_internal_pure$_t_struct$_VoxelCoord_$5927_memory_ptr_$returns$_t_uint256_$",
                        "typeString": "function (struct VoxelCoord memory) pure returns (uint256)"
                      }
                    },
                    "id": 33620,
                    "isConstant": false,
                    "isLValue": false,
                    "isPure": false,
                    "kind": "functionCall",
                    "lValueRequested": false,
                    "names": [],
                    "nodeType": "FunctionCall",
                    "src": "4080:27:84",
                    "tryCall": false,
                    "typeDescriptions": {
                      "typeIdentifier": "t_uint256",
                      "typeString": "uint256"
                    }
                  },
                  "functionReturnParameters": 33616,
                  "id": 33621,
                  "nodeType": "Return",
                  "src": "4073:34:84"
                }
              ]
            },
            "functionSelector": "e46d4664",
            "implemented": true,
            "kind": "function",
            "modifiers": [],
            "name": "Log",
            "nameLocation": "4008:3:84",
            "parameters": {
              "id": 33613,
              "nodeType": "ParameterList",
              "parameters": [
                {
                  "constant": false,
                  "id": 33612,
                  "mutability": "mutable",
                  "name": "coord",
                  "nameLocation": "4030:5:84",
                  "nodeType": "VariableDeclaration",
                  "scope": 33623,
                  "src": "4012:23:84",
                  "stateVariable": false,
                  "storageLocation": "memory",
                  "typeDescriptions": {
                    "typeIdentifier": "t_struct$_VoxelCoord_$5927_memory_ptr",
                    "typeString": "struct VoxelCoord"
                  },
                  "typeName": {
                    "id": 33611,
                    "nodeType": "UserDefinedTypeName",
                    "pathNode": {
                      "id": 33610,
                      "name": "VoxelCoord",
                      "nodeType": "IdentifierPath",
                      "referencedDeclaration": 5927,
                      "src": "4012:10:84"
                    },
                    "referencedDeclaration": 5927,
                    "src": "4012:10:84",
                    "typeDescriptions": {
                      "typeIdentifier": "t_struct$_VoxelCoord_$5927_storage_ptr",
                      "typeString": "struct VoxelCoord"
                    }
                  },
                  "visibility": "internal"
                }
              ],
              "src": "4011:25:84"
            },
            "returnParameters": {
              "id": 33616,
              "nodeType": "ParameterList",
              "parameters": [
                {
                  "constant": false,
                  "id": 33615,
                  "mutability": "mutable",
                  "name": "",
                  "nameLocation": "-1:-1:-1",
                  "nodeType": "VariableDeclaration",
                  "scope": 33623,
                  "src": "4058:7:84",
                  "stateVariable": false,
                  "storageLocation": "default",
                  "typeDescriptions": {
                    "typeIdentifier": "t_uint256",
                    "typeString": "uint256"
                  },
                  "typeName": {
                    "id": 33614,
                    "name": "uint256",
                    "nodeType": "ElementaryTypeName",
                    "src": "4058:7:84",
                    "typeDescriptions": {
                      "typeIdentifier": "t_uint256",
                      "typeString": "uint256"
                    }
                  },
                  "visibility": "internal"
                }
              ],
              "src": "4057:9:84"
            },
            "scope": 33974,
            "stateMutability": "pure",
            "virtual": false,
            "visibility": "public"
          },
          {
            "id": 33637,
            "nodeType": "FunctionDefinition",
            "src": "4116:111:84",
            "nodes": [],
            "body": {
              "id": 33636,
              "nodeType": "Block",
              "src": "4186:41:84",
              "nodes": [],
              "statements": [
                {
                  "expression": {
                    "arguments": [
                      {
                        "id": 33633,
                        "name": "coord",
                        "nodeType": "Identifier",
                        "overloadedDeclarations": [],
                        "referencedDeclaration": 33626,
                        "src": "4216:5:84",
                        "typeDescriptions": {
                          "typeIdentifier": "t_struct$_VoxelCoord_$5927_memory_ptr",
                          "typeString": "struct VoxelCoord memory"
                        }
                      }
                    ],
                    "expression": {
                      "argumentTypes": [
                        {
                          "typeIdentifier": "t_struct$_VoxelCoord_$5927_memory_ptr",
                          "typeString": "struct VoxelCoord memory"
                        }
                      ],
                      "expression": {
                        "id": 33631,
                        "name": "LibTerrain",
                        "nodeType": "Identifier",
                        "overloadedDeclarations": [],
                        "referencedDeclaration": 28871,
                        "src": "4199:10:84",
                        "typeDescriptions": {
                          "typeIdentifier": "t_type$_t_contract$_LibTerrain_$28871_$",
                          "typeString": "type(library LibTerrain)"
                        }
                      },
                      "id": 33632,
                      "isConstant": false,
                      "isLValue": false,
                      "isPure": false,
                      "lValueRequested": false,
                      "memberName": "Stone",
                      "nodeType": "MemberAccess",
                      "referencedDeclaration": 27701,
                      "src": "4199:16:84",
                      "typeDescriptions": {
                        "typeIdentifier": "t_function_internal_pure$_t_struct$_VoxelCoord_$5927_memory_ptr_$returns$_t_uint256_$",
                        "typeString": "function (struct VoxelCoord memory) pure returns (uint256)"
                      }
                    },
                    "id": 33634,
                    "isConstant": false,
                    "isLValue": false,
                    "isPure": false,
                    "kind": "functionCall",
                    "lValueRequested": false,
                    "names": [],
                    "nodeType": "FunctionCall",
                    "src": "4199:23:84",
                    "tryCall": false,
                    "typeDescriptions": {
                      "typeIdentifier": "t_uint256",
                      "typeString": "uint256"
                    }
                  },
                  "functionReturnParameters": 33630,
                  "id": 33635,
                  "nodeType": "Return",
                  "src": "4192:30:84"
                }
              ]
            },
            "functionSelector": "35e69f35",
            "implemented": true,
            "kind": "function",
            "modifiers": [],
            "name": "Stone",
            "nameLocation": "4125:5:84",
            "parameters": {
              "id": 33627,
              "nodeType": "ParameterList",
              "parameters": [
                {
                  "constant": false,
                  "id": 33626,
                  "mutability": "mutable",
                  "name": "coord",
                  "nameLocation": "4149:5:84",
                  "nodeType": "VariableDeclaration",
                  "scope": 33637,
                  "src": "4131:23:84",
                  "stateVariable": false,
                  "storageLocation": "memory",
                  "typeDescriptions": {
                    "typeIdentifier": "t_struct$_VoxelCoord_$5927_memory_ptr",
                    "typeString": "struct VoxelCoord"
                  },
                  "typeName": {
                    "id": 33625,
                    "nodeType": "UserDefinedTypeName",
                    "pathNode": {
                      "id": 33624,
                      "name": "VoxelCoord",
                      "nodeType": "IdentifierPath",
                      "referencedDeclaration": 5927,
                      "src": "4131:10:84"
                    },
                    "referencedDeclaration": 5927,
                    "src": "4131:10:84",
                    "typeDescriptions": {
                      "typeIdentifier": "t_struct$_VoxelCoord_$5927_storage_ptr",
                      "typeString": "struct VoxelCoord"
                    }
                  },
                  "visibility": "internal"
                }
              ],
              "src": "4130:25:84"
            },
            "returnParameters": {
              "id": 33630,
              "nodeType": "ParameterList",
              "parameters": [
                {
                  "constant": false,
                  "id": 33629,
                  "mutability": "mutable",
                  "name": "",
                  "nameLocation": "-1:-1:-1",
                  "nodeType": "VariableDeclaration",
                  "scope": 33637,
                  "src": "4177:7:84",
                  "stateVariable": false,
                  "storageLocation": "default",
                  "typeDescriptions": {
                    "typeIdentifier": "t_uint256",
                    "typeString": "uint256"
                  },
                  "typeName": {
                    "id": 33628,
                    "name": "uint256",
                    "nodeType": "ElementaryTypeName",
                    "src": "4177:7:84",
                    "typeDescriptions": {
                      "typeIdentifier": "t_uint256",
                      "typeString": "uint256"
                    }
                  },
                  "visibility": "internal"
                }
              ],
              "src": "4176:9:84"
            },
            "scope": 33974,
            "stateMutability": "pure",
            "virtual": false,
            "visibility": "public"
          },
          {
            "id": 33651,
            "nodeType": "FunctionDefinition",
            "src": "4231:109:84",
            "nodes": [],
            "body": {
              "id": 33650,
              "nodeType": "Block",
              "src": "4300:40:84",
              "nodes": [],
              "statements": [
                {
                  "expression": {
                    "arguments": [
                      {
                        "id": 33647,
                        "name": "coord",
                        "nodeType": "Identifier",
                        "overloadedDeclarations": [],
                        "referencedDeclaration": 33640,
                        "src": "4329:5:84",
                        "typeDescriptions": {
                          "typeIdentifier": "t_struct$_VoxelCoord_$5927_memory_ptr",
                          "typeString": "struct VoxelCoord memory"
                        }
                      }
                    ],
                    "expression": {
                      "argumentTypes": [
                        {
                          "typeIdentifier": "t_struct$_VoxelCoord_$5927_memory_ptr",
                          "typeString": "struct VoxelCoord memory"
                        }
                      ],
                      "expression": {
                        "id": 33645,
                        "name": "LibTerrain",
                        "nodeType": "Identifier",
                        "overloadedDeclarations": [],
                        "referencedDeclaration": 28871,
                        "src": "4313:10:84",
                        "typeDescriptions": {
                          "typeIdentifier": "t_type$_t_contract$_LibTerrain_$28871_$",
                          "typeString": "type(library LibTerrain)"
                        }
                      },
                      "id": 33646,
                      "isConstant": false,
                      "isLValue": false,
                      "isPure": false,
                      "lValueRequested": false,
                      "memberName": "Sand",
                      "nodeType": "MemberAccess",
                      "referencedDeclaration": 27237,
                      "src": "4313:15:84",
                      "typeDescriptions": {
                        "typeIdentifier": "t_function_internal_pure$_t_struct$_VoxelCoord_$5927_memory_ptr_$returns$_t_uint256_$",
                        "typeString": "function (struct VoxelCoord memory) pure returns (uint256)"
                      }
                    },
                    "id": 33648,
                    "isConstant": false,
                    "isLValue": false,
                    "isPure": false,
                    "kind": "functionCall",
                    "lValueRequested": false,
                    "names": [],
                    "nodeType": "FunctionCall",
                    "src": "4313:22:84",
                    "tryCall": false,
                    "typeDescriptions": {
                      "typeIdentifier": "t_uint256",
                      "typeString": "uint256"
                    }
                  },
                  "functionReturnParameters": 33644,
                  "id": 33649,
                  "nodeType": "Return",
                  "src": "4306:29:84"
                }
              ]
            },
            "functionSelector": "eca4c278",
            "implemented": true,
            "kind": "function",
            "modifiers": [],
            "name": "Sand",
            "nameLocation": "4240:4:84",
            "parameters": {
              "id": 33641,
              "nodeType": "ParameterList",
              "parameters": [
                {
                  "constant": false,
                  "id": 33640,
                  "mutability": "mutable",
                  "name": "coord",
                  "nameLocation": "4263:5:84",
                  "nodeType": "VariableDeclaration",
                  "scope": 33651,
                  "src": "4245:23:84",
                  "stateVariable": false,
                  "storageLocation": "memory",
                  "typeDescriptions": {
                    "typeIdentifier": "t_struct$_VoxelCoord_$5927_memory_ptr",
                    "typeString": "struct VoxelCoord"
                  },
                  "typeName": {
                    "id": 33639,
                    "nodeType": "UserDefinedTypeName",
                    "pathNode": {
                      "id": 33638,
                      "name": "VoxelCoord",
                      "nodeType": "IdentifierPath",
                      "referencedDeclaration": 5927,
                      "src": "4245:10:84"
                    },
                    "referencedDeclaration": 5927,
                    "src": "4245:10:84",
                    "typeDescriptions": {
                      "typeIdentifier": "t_struct$_VoxelCoord_$5927_storage_ptr",
                      "typeString": "struct VoxelCoord"
                    }
                  },
                  "visibility": "internal"
                }
              ],
              "src": "4244:25:84"
            },
            "returnParameters": {
              "id": 33644,
              "nodeType": "ParameterList",
              "parameters": [
                {
                  "constant": false,
                  "id": 33643,
                  "mutability": "mutable",
                  "name": "",
                  "nameLocation": "-1:-1:-1",
                  "nodeType": "VariableDeclaration",
                  "scope": 33651,
                  "src": "4291:7:84",
                  "stateVariable": false,
                  "storageLocation": "default",
                  "typeDescriptions": {
                    "typeIdentifier": "t_uint256",
                    "typeString": "uint256"
                  },
                  "typeName": {
                    "id": 33642,
                    "name": "uint256",
                    "nodeType": "ElementaryTypeName",
                    "src": "4291:7:84",
                    "typeDescriptions": {
                      "typeIdentifier": "t_uint256",
                      "typeString": "uint256"
                    }
                  },
                  "visibility": "internal"
                }
              ],
              "src": "4290:9:84"
            },
            "scope": 33974,
            "stateMutability": "pure",
            "virtual": false,
            "visibility": "public"
          },
          {
            "id": 33665,
            "nodeType": "FunctionDefinition",
            "src": "4344:111:84",
            "nodes": [],
            "body": {
              "id": 33664,
              "nodeType": "Block",
              "src": "4414:41:84",
              "nodes": [],
              "statements": [
                {
                  "expression": {
                    "arguments": [
                      {
                        "id": 33661,
                        "name": "coord",
                        "nodeType": "Identifier",
                        "overloadedDeclarations": [],
                        "referencedDeclaration": 33654,
                        "src": "4444:5:84",
                        "typeDescriptions": {
                          "typeIdentifier": "t_struct$_VoxelCoord_$5927_memory_ptr",
                          "typeString": "struct VoxelCoord memory"
                        }
                      }
                    ],
                    "expression": {
                      "argumentTypes": [
                        {
                          "typeIdentifier": "t_struct$_VoxelCoord_$5927_memory_ptr",
                          "typeString": "struct VoxelCoord memory"
                        }
                      ],
                      "expression": {
                        "id": 33659,
                        "name": "LibTerrain",
                        "nodeType": "Identifier",
                        "overloadedDeclarations": [],
                        "referencedDeclaration": 28871,
                        "src": "4427:10:84",
                        "typeDescriptions": {
                          "typeIdentifier": "t_type$_t_contract$_LibTerrain_$28871_$",
                          "typeString": "type(library LibTerrain)"
                        }
                      },
                      "id": 33660,
                      "isConstant": false,
                      "isLValue": false,
                      "isPure": false,
                      "lValueRequested": false,
                      "memberName": "Water",
                      "nodeType": "MemberAccess",
                      "referencedDeclaration": 27139,
                      "src": "4427:16:84",
                      "typeDescriptions": {
                        "typeIdentifier": "t_function_internal_pure$_t_struct$_VoxelCoord_$5927_memory_ptr_$returns$_t_uint256_$",
                        "typeString": "function (struct VoxelCoord memory) pure returns (uint256)"
                      }
                    },
                    "id": 33662,
                    "isConstant": false,
                    "isLValue": false,
                    "isPure": false,
                    "kind": "functionCall",
                    "lValueRequested": false,
                    "names": [],
                    "nodeType": "FunctionCall",
                    "src": "4427:23:84",
                    "tryCall": false,
                    "typeDescriptions": {
                      "typeIdentifier": "t_uint256",
                      "typeString": "uint256"
                    }
                  },
                  "functionReturnParameters": 33658,
                  "id": 33663,
                  "nodeType": "Return",
                  "src": "4420:30:84"
                }
              ]
            },
            "functionSelector": "ae763fa8",
            "implemented": true,
            "kind": "function",
            "modifiers": [],
            "name": "Water",
            "nameLocation": "4353:5:84",
            "parameters": {
              "id": 33655,
              "nodeType": "ParameterList",
              "parameters": [
                {
                  "constant": false,
                  "id": 33654,
                  "mutability": "mutable",
                  "name": "coord",
                  "nameLocation": "4377:5:84",
                  "nodeType": "VariableDeclaration",
                  "scope": 33665,
                  "src": "4359:23:84",
                  "stateVariable": false,
                  "storageLocation": "memory",
                  "typeDescriptions": {
                    "typeIdentifier": "t_struct$_VoxelCoord_$5927_memory_ptr",
                    "typeString": "struct VoxelCoord"
                  },
                  "typeName": {
                    "id": 33653,
                    "nodeType": "UserDefinedTypeName",
                    "pathNode": {
                      "id": 33652,
                      "name": "VoxelCoord",
                      "nodeType": "IdentifierPath",
                      "referencedDeclaration": 5927,
                      "src": "4359:10:84"
                    },
                    "referencedDeclaration": 5927,
                    "src": "4359:10:84",
                    "typeDescriptions": {
                      "typeIdentifier": "t_struct$_VoxelCoord_$5927_storage_ptr",
                      "typeString": "struct VoxelCoord"
                    }
                  },
                  "visibility": "internal"
                }
              ],
              "src": "4358:25:84"
            },
            "returnParameters": {
              "id": 33658,
              "nodeType": "ParameterList",
              "parameters": [
                {
                  "constant": false,
                  "id": 33657,
                  "mutability": "mutable",
                  "name": "",
                  "nameLocation": "-1:-1:-1",
                  "nodeType": "VariableDeclaration",
                  "scope": 33665,
                  "src": "4405:7:84",
                  "stateVariable": false,
                  "storageLocation": "default",
                  "typeDescriptions": {
                    "typeIdentifier": "t_uint256",
                    "typeString": "uint256"
                  },
                  "typeName": {
                    "id": 33656,
                    "name": "uint256",
                    "nodeType": "ElementaryTypeName",
                    "src": "4405:7:84",
                    "typeDescriptions": {
                      "typeIdentifier": "t_uint256",
                      "typeString": "uint256"
                    }
                  },
                  "visibility": "internal"
                }
              ],
              "src": "4404:9:84"
            },
            "scope": 33974,
            "stateMutability": "pure",
            "virtual": false,
            "visibility": "public"
          },
          {
            "id": 33679,
            "nodeType": "FunctionDefinition",
            "src": "4459:115:84",
            "nodes": [],
            "body": {
              "id": 33678,
              "nodeType": "Block",
              "src": "4531:43:84",
              "nodes": [],
              "statements": [
                {
                  "expression": {
                    "arguments": [
                      {
                        "id": 33675,
                        "name": "coord",
                        "nodeType": "Identifier",
                        "overloadedDeclarations": [],
                        "referencedDeclaration": 33668,
                        "src": "4563:5:84",
                        "typeDescriptions": {
                          "typeIdentifier": "t_struct$_VoxelCoord_$5927_memory_ptr",
                          "typeString": "struct VoxelCoord memory"
                        }
                      }
                    ],
                    "expression": {
                      "argumentTypes": [
                        {
                          "typeIdentifier": "t_struct$_VoxelCoord_$5927_memory_ptr",
                          "typeString": "struct VoxelCoord memory"
                        }
                      ],
                      "expression": {
                        "id": 33673,
                        "name": "LibTerrain",
                        "nodeType": "Identifier",
                        "overloadedDeclarations": [],
                        "referencedDeclaration": 28871,
                        "src": "4544:10:84",
                        "typeDescriptions": {
                          "typeIdentifier": "t_type$_t_contract$_LibTerrain_$28871_$",
                          "typeString": "type(library LibTerrain)"
                        }
                      },
                      "id": 33674,
                      "isConstant": false,
                      "isLValue": false,
                      "isPure": false,
                      "lValueRequested": false,
                      "memberName": "Diamond",
                      "nodeType": "MemberAccess",
                      "referencedDeclaration": 27355,
                      "src": "4544:18:84",
                      "typeDescriptions": {
                        "typeIdentifier": "t_function_internal_pure$_t_struct$_VoxelCoord_$5927_memory_ptr_$returns$_t_uint256_$",
                        "typeString": "function (struct VoxelCoord memory) pure returns (uint256)"
                      }
                    },
                    "id": 33676,
                    "isConstant": false,
                    "isLValue": false,
                    "isPure": false,
                    "kind": "functionCall",
                    "lValueRequested": false,
                    "names": [],
                    "nodeType": "FunctionCall",
                    "src": "4544:25:84",
                    "tryCall": false,
                    "typeDescriptions": {
                      "typeIdentifier": "t_uint256",
                      "typeString": "uint256"
                    }
                  },
                  "functionReturnParameters": 33672,
                  "id": 33677,
                  "nodeType": "Return",
                  "src": "4537:32:84"
                }
              ]
            },
            "functionSelector": "17ab6daf",
            "implemented": true,
            "kind": "function",
            "modifiers": [],
            "name": "Diamond",
            "nameLocation": "4468:7:84",
            "parameters": {
              "id": 33669,
              "nodeType": "ParameterList",
              "parameters": [
                {
                  "constant": false,
                  "id": 33668,
                  "mutability": "mutable",
                  "name": "coord",
                  "nameLocation": "4494:5:84",
                  "nodeType": "VariableDeclaration",
                  "scope": 33679,
                  "src": "4476:23:84",
                  "stateVariable": false,
                  "storageLocation": "memory",
                  "typeDescriptions": {
                    "typeIdentifier": "t_struct$_VoxelCoord_$5927_memory_ptr",
                    "typeString": "struct VoxelCoord"
                  },
                  "typeName": {
                    "id": 33667,
                    "nodeType": "UserDefinedTypeName",
                    "pathNode": {
                      "id": 33666,
                      "name": "VoxelCoord",
                      "nodeType": "IdentifierPath",
                      "referencedDeclaration": 5927,
                      "src": "4476:10:84"
                    },
                    "referencedDeclaration": 5927,
                    "src": "4476:10:84",
                    "typeDescriptions": {
                      "typeIdentifier": "t_struct$_VoxelCoord_$5927_storage_ptr",
                      "typeString": "struct VoxelCoord"
                    }
                  },
                  "visibility": "internal"
                }
              ],
              "src": "4475:25:84"
            },
            "returnParameters": {
              "id": 33672,
              "nodeType": "ParameterList",
              "parameters": [
                {
                  "constant": false,
                  "id": 33671,
                  "mutability": "mutable",
                  "name": "",
                  "nameLocation": "-1:-1:-1",
                  "nodeType": "VariableDeclaration",
                  "scope": 33679,
                  "src": "4522:7:84",
                  "stateVariable": false,
                  "storageLocation": "default",
                  "typeDescriptions": {
                    "typeIdentifier": "t_uint256",
                    "typeString": "uint256"
                  },
                  "typeName": {
                    "id": 33670,
                    "name": "uint256",
                    "nodeType": "ElementaryTypeName",
                    "src": "4522:7:84",
                    "typeDescriptions": {
                      "typeIdentifier": "t_uint256",
                      "typeString": "uint256"
                    }
                  },
                  "visibility": "internal"
                }
              ],
              "src": "4521:9:84"
            },
            "scope": 33974,
            "stateMutability": "pure",
            "virtual": false,
            "visibility": "public"
          },
          {
            "id": 33693,
            "nodeType": "FunctionDefinition",
            "src": "4578:109:84",
            "nodes": [],
            "body": {
              "id": 33692,
              "nodeType": "Block",
              "src": "4647:40:84",
              "nodes": [],
              "statements": [
                {
                  "expression": {
                    "arguments": [
                      {
                        "id": 33689,
                        "name": "coord",
                        "nodeType": "Identifier",
                        "overloadedDeclarations": [],
                        "referencedDeclaration": 33682,
                        "src": "4676:5:84",
                        "typeDescriptions": {
                          "typeIdentifier": "t_struct$_VoxelCoord_$5927_memory_ptr",
                          "typeString": "struct VoxelCoord memory"
                        }
                      }
                    ],
                    "expression": {
                      "argumentTypes": [
                        {
                          "typeIdentifier": "t_struct$_VoxelCoord_$5927_memory_ptr",
                          "typeString": "struct VoxelCoord memory"
                        }
                      ],
                      "expression": {
                        "id": 33687,
                        "name": "LibTerrain",
                        "nodeType": "Identifier",
                        "overloadedDeclarations": [],
                        "referencedDeclaration": 28871,
                        "src": "4660:10:84",
                        "typeDescriptions": {
                          "typeIdentifier": "t_type$_t_contract$_LibTerrain_$28871_$",
                          "typeString": "type(library LibTerrain)"
                        }
                      },
                      "id": 33688,
                      "isConstant": false,
                      "isLValue": false,
                      "isPure": false,
                      "lValueRequested": false,
                      "memberName": "Coal",
                      "nodeType": "MemberAccess",
                      "referencedDeclaration": 27486,
                      "src": "4660:15:84",
                      "typeDescriptions": {
                        "typeIdentifier": "t_function_internal_pure$_t_struct$_VoxelCoord_$5927_memory_ptr_$returns$_t_uint256_$",
                        "typeString": "function (struct VoxelCoord memory) pure returns (uint256)"
                      }
                    },
                    "id": 33690,
                    "isConstant": false,
                    "isLValue": false,
                    "isPure": false,
                    "kind": "functionCall",
                    "lValueRequested": false,
                    "names": [],
                    "nodeType": "FunctionCall",
                    "src": "4660:22:84",
                    "tryCall": false,
                    "typeDescriptions": {
                      "typeIdentifier": "t_uint256",
                      "typeString": "uint256"
                    }
                  },
                  "functionReturnParameters": 33686,
                  "id": 33691,
                  "nodeType": "Return",
                  "src": "4653:29:84"
                }
              ]
            },
            "functionSelector": "f4363c64",
            "implemented": true,
            "kind": "function",
            "modifiers": [],
            "name": "Coal",
            "nameLocation": "4587:4:84",
            "parameters": {
              "id": 33683,
              "nodeType": "ParameterList",
              "parameters": [
                {
                  "constant": false,
                  "id": 33682,
                  "mutability": "mutable",
                  "name": "coord",
                  "nameLocation": "4610:5:84",
                  "nodeType": "VariableDeclaration",
                  "scope": 33693,
                  "src": "4592:23:84",
                  "stateVariable": false,
                  "storageLocation": "memory",
                  "typeDescriptions": {
                    "typeIdentifier": "t_struct$_VoxelCoord_$5927_memory_ptr",
                    "typeString": "struct VoxelCoord"
                  },
                  "typeName": {
                    "id": 33681,
                    "nodeType": "UserDefinedTypeName",
                    "pathNode": {
                      "id": 33680,
                      "name": "VoxelCoord",
                      "nodeType": "IdentifierPath",
                      "referencedDeclaration": 5927,
                      "src": "4592:10:84"
                    },
                    "referencedDeclaration": 5927,
                    "src": "4592:10:84",
                    "typeDescriptions": {
                      "typeIdentifier": "t_struct$_VoxelCoord_$5927_storage_ptr",
                      "typeString": "struct VoxelCoord"
                    }
                  },
                  "visibility": "internal"
                }
              ],
              "src": "4591:25:84"
            },
            "returnParameters": {
              "id": 33686,
              "nodeType": "ParameterList",
              "parameters": [
                {
                  "constant": false,
                  "id": 33685,
                  "mutability": "mutable",
                  "name": "",
                  "nameLocation": "-1:-1:-1",
                  "nodeType": "VariableDeclaration",
                  "scope": 33693,
                  "src": "4638:7:84",
                  "stateVariable": false,
                  "storageLocation": "default",
                  "typeDescriptions": {
                    "typeIdentifier": "t_uint256",
                    "typeString": "uint256"
                  },
                  "typeName": {
                    "id": 33684,
                    "name": "uint256",
                    "nodeType": "ElementaryTypeName",
                    "src": "4638:7:84",
                    "typeDescriptions": {
                      "typeIdentifier": "t_uint256",
                      "typeString": "uint256"
                    }
                  },
                  "visibility": "internal"
                }
              ],
              "src": "4637:9:84"
            },
            "scope": 33974,
            "stateMutability": "pure",
            "virtual": false,
            "visibility": "public"
          },
          {
            "id": 33707,
            "nodeType": "FunctionDefinition",
            "src": "4691:116:84",
            "nodes": [],
            "body": {
              "id": 33706,
              "nodeType": "Block",
              "src": "4762:45:84",
              "nodes": [],
              "statements": [
                {
                  "expression": {
                    "arguments": [
                      {
                        "id": 33703,
                        "name": "coord",
                        "nodeType": "Identifier",
                        "overloadedDeclarations": [],
                        "referencedDeclaration": 33696,
                        "src": "4796:5:84",
                        "typeDescriptions": {
                          "typeIdentifier": "t_struct$_VoxelCoord_$5927_memory_ptr",
                          "typeString": "struct VoxelCoord memory"
                        }
                      }
                    ],
                    "expression": {
                      "argumentTypes": [
                        {
                          "typeIdentifier": "t_struct$_VoxelCoord_$5927_memory_ptr",
                          "typeString": "struct VoxelCoord memory"
                        }
                      ],
                      "expression": {
                        "id": 33701,
                        "name": "LibTerrain",
                        "nodeType": "Identifier",
                        "overloadedDeclarations": [],
                        "referencedDeclaration": 28871,
                        "src": "4775:10:84",
                        "typeDescriptions": {
                          "typeIdentifier": "t_type$_t_contract$_LibTerrain_$28871_$",
                          "typeString": "type(library LibTerrain)"
                        }
                      },
                      "id": 33702,
                      "isConstant": false,
                      "isLValue": false,
                      "isPure": false,
                      "lValueRequested": false,
                      "memberName": "Structure",
                      "nodeType": "MemberAccess",
                      "referencedDeclaration": 28306,
                      "src": "4775:20:84",
                      "typeDescriptions": {
                        "typeIdentifier": "t_function_internal_pure$_t_struct$_VoxelCoord_$5927_memory_ptr_$returns$_t_uint256_$",
                        "typeString": "function (struct VoxelCoord memory) pure returns (uint256)"
                      }
                    },
                    "id": 33704,
                    "isConstant": false,
                    "isLValue": false,
                    "isPure": false,
                    "kind": "functionCall",
                    "lValueRequested": false,
                    "names": [],
                    "nodeType": "FunctionCall",
                    "src": "4775:27:84",
                    "tryCall": false,
                    "typeDescriptions": {
                      "typeIdentifier": "t_uint256",
                      "typeString": "uint256"
                    }
                  },
                  "functionReturnParameters": 33700,
                  "id": 33705,
                  "nodeType": "Return",
                  "src": "4768:34:84"
                }
              ]
            },
            "functionSelector": "94d6c851",
            "implemented": true,
            "kind": "function",
            "modifiers": [],
            "name": "Leaves",
            "nameLocation": "4700:6:84",
            "parameters": {
              "id": 33697,
              "nodeType": "ParameterList",
              "parameters": [
                {
                  "constant": false,
                  "id": 33696,
                  "mutability": "mutable",
                  "name": "coord",
                  "nameLocation": "4725:5:84",
                  "nodeType": "VariableDeclaration",
                  "scope": 33707,
                  "src": "4707:23:84",
                  "stateVariable": false,
                  "storageLocation": "memory",
                  "typeDescriptions": {
                    "typeIdentifier": "t_struct$_VoxelCoord_$5927_memory_ptr",
                    "typeString": "struct VoxelCoord"
                  },
                  "typeName": {
                    "id": 33695,
                    "nodeType": "UserDefinedTypeName",
                    "pathNode": {
                      "id": 33694,
                      "name": "VoxelCoord",
                      "nodeType": "IdentifierPath",
                      "referencedDeclaration": 5927,
                      "src": "4707:10:84"
                    },
                    "referencedDeclaration": 5927,
                    "src": "4707:10:84",
                    "typeDescriptions": {
                      "typeIdentifier": "t_struct$_VoxelCoord_$5927_storage_ptr",
                      "typeString": "struct VoxelCoord"
                    }
                  },
                  "visibility": "internal"
                }
              ],
              "src": "4706:25:84"
            },
            "returnParameters": {
              "id": 33700,
              "nodeType": "ParameterList",
              "parameters": [
                {
                  "constant": false,
                  "id": 33699,
                  "mutability": "mutable",
                  "name": "",
                  "nameLocation": "-1:-1:-1",
                  "nodeType": "VariableDeclaration",
                  "scope": 33707,
                  "src": "4753:7:84",
                  "stateVariable": false,
                  "storageLocation": "default",
                  "typeDescriptions": {
                    "typeIdentifier": "t_uint256",
                    "typeString": "uint256"
                  },
                  "typeName": {
                    "id": 33698,
                    "name": "uint256",
                    "nodeType": "ElementaryTypeName",
                    "src": "4753:7:84",
                    "typeDescriptions": {
                      "typeIdentifier": "t_uint256",
                      "typeString": "uint256"
                    }
                  },
                  "visibility": "internal"
                }
              ],
              "src": "4752:9:84"
            },
            "scope": 33974,
            "stateMutability": "pure",
            "virtual": false,
            "visibility": "public"
          },
          {
            "id": 33721,
            "nodeType": "FunctionDefinition",
            "src": "4811:120:84",
            "nodes": [],
            "body": {
              "id": 33720,
              "nodeType": "Block",
              "src": "4885:46:84",
              "nodes": [],
              "statements": [
                {
                  "expression": {
                    "arguments": [
                      {
                        "id": 33717,
                        "name": "coord",
                        "nodeType": "Identifier",
                        "overloadedDeclarations": [],
                        "referencedDeclaration": 33710,
                        "src": "4920:5:84",
                        "typeDescriptions": {
                          "typeIdentifier": "t_struct$_VoxelCoord_$5927_memory_ptr",
                          "typeString": "struct VoxelCoord memory"
                        }
                      }
                    ],
                    "expression": {
                      "argumentTypes": [
                        {
                          "typeIdentifier": "t_struct$_VoxelCoord_$5927_memory_ptr",
                          "typeString": "struct VoxelCoord memory"
                        }
                      ],
                      "expression": {
                        "id": 33715,
                        "name": "LibTerrain",
                        "nodeType": "Identifier",
                        "overloadedDeclarations": [],
                        "referencedDeclaration": 28871,
                        "src": "4898:10:84",
                        "typeDescriptions": {
                          "typeIdentifier": "t_type$_t_contract$_LibTerrain_$28871_$",
                          "typeString": "type(library LibTerrain)"
                        }
                      },
                      "id": 33716,
                      "isConstant": false,
                      "isLValue": false,
                      "isPure": false,
                      "lValueRequested": false,
                      "memberName": "SmallPlant",
                      "nodeType": "MemberAccess",
                      "referencedDeclaration": 28084,
                      "src": "4898:21:84",
                      "typeDescriptions": {
                        "typeIdentifier": "t_function_internal_pure$_t_struct$_VoxelCoord_$5927_memory_ptr_$returns$_t_uint256_$",
                        "typeString": "function (struct VoxelCoord memory) pure returns (uint256)"
                      }
                    },
                    "id": 33718,
                    "isConstant": false,
                    "isLValue": false,
                    "isPure": false,
                    "kind": "functionCall",
                    "lValueRequested": false,
                    "names": [],
                    "nodeType": "FunctionCall",
                    "src": "4898:28:84",
                    "tryCall": false,
                    "typeDescriptions": {
                      "typeIdentifier": "t_uint256",
                      "typeString": "uint256"
                    }
                  },
                  "functionReturnParameters": 33714,
                  "id": 33719,
                  "nodeType": "Return",
                  "src": "4891:35:84"
                }
              ]
            },
            "functionSelector": "f41d4a58",
            "implemented": true,
            "kind": "function",
            "modifiers": [],
            "name": "RedFlower",
            "nameLocation": "4820:9:84",
            "parameters": {
              "id": 33711,
              "nodeType": "ParameterList",
              "parameters": [
                {
                  "constant": false,
                  "id": 33710,
                  "mutability": "mutable",
                  "name": "coord",
                  "nameLocation": "4848:5:84",
                  "nodeType": "VariableDeclaration",
                  "scope": 33721,
                  "src": "4830:23:84",
                  "stateVariable": false,
                  "storageLocation": "memory",
                  "typeDescriptions": {
                    "typeIdentifier": "t_struct$_VoxelCoord_$5927_memory_ptr",
                    "typeString": "struct VoxelCoord"
                  },
                  "typeName": {
                    "id": 33709,
                    "nodeType": "UserDefinedTypeName",
                    "pathNode": {
                      "id": 33708,
                      "name": "VoxelCoord",
                      "nodeType": "IdentifierPath",
                      "referencedDeclaration": 5927,
                      "src": "4830:10:84"
                    },
                    "referencedDeclaration": 5927,
                    "src": "4830:10:84",
                    "typeDescriptions": {
                      "typeIdentifier": "t_struct$_VoxelCoord_$5927_storage_ptr",
                      "typeString": "struct VoxelCoord"
                    }
                  },
                  "visibility": "internal"
                }
              ],
              "src": "4829:25:84"
            },
            "returnParameters": {
              "id": 33714,
              "nodeType": "ParameterList",
              "parameters": [
                {
                  "constant": false,
                  "id": 33713,
                  "mutability": "mutable",
                  "name": "",
                  "nameLocation": "-1:-1:-1",
                  "nodeType": "VariableDeclaration",
                  "scope": 33721,
                  "src": "4876:7:84",
                  "stateVariable": false,
                  "storageLocation": "default",
                  "typeDescriptions": {
                    "typeIdentifier": "t_uint256",
                    "typeString": "uint256"
                  },
                  "typeName": {
                    "id": 33712,
                    "name": "uint256",
                    "nodeType": "ElementaryTypeName",
                    "src": "4876:7:84",
                    "typeDescriptions": {
                      "typeIdentifier": "t_uint256",
                      "typeString": "uint256"
                    }
                  },
                  "visibility": "internal"
                }
              ],
              "src": "4875:9:84"
            },
            "scope": 33974,
            "stateMutability": "pure",
            "virtual": false,
            "visibility": "public"
          },
          {
            "id": 33735,
            "nodeType": "FunctionDefinition",
            "src": "4935:121:84",
            "nodes": [],
            "body": {
              "id": 33734,
              "nodeType": "Block",
              "src": "5010:46:84",
              "nodes": [],
              "statements": [
                {
                  "expression": {
                    "arguments": [
                      {
                        "id": 33731,
                        "name": "coord",
                        "nodeType": "Identifier",
                        "overloadedDeclarations": [],
                        "referencedDeclaration": 33724,
                        "src": "5045:5:84",
                        "typeDescriptions": {
                          "typeIdentifier": "t_struct$_VoxelCoord_$5927_memory_ptr",
                          "typeString": "struct VoxelCoord memory"
                        }
                      }
                    ],
                    "expression": {
                      "argumentTypes": [
                        {
                          "typeIdentifier": "t_struct$_VoxelCoord_$5927_memory_ptr",
                          "typeString": "struct VoxelCoord memory"
                        }
                      ],
                      "expression": {
                        "id": 33729,
                        "name": "LibTerrain",
                        "nodeType": "Identifier",
                        "overloadedDeclarations": [],
                        "referencedDeclaration": 28871,
                        "src": "5023:10:84",
                        "typeDescriptions": {
                          "typeIdentifier": "t_type$_t_contract$_LibTerrain_$28871_$",
                          "typeString": "type(library LibTerrain)"
                        }
                      },
                      "id": 33730,
                      "isConstant": false,
                      "isLValue": false,
                      "isPure": false,
                      "lValueRequested": false,
                      "memberName": "SmallPlant",
                      "nodeType": "MemberAccess",
                      "referencedDeclaration": 28084,
                      "src": "5023:21:84",
                      "typeDescriptions": {
                        "typeIdentifier": "t_function_internal_pure$_t_struct$_VoxelCoord_$5927_memory_ptr_$returns$_t_uint256_$",
                        "typeString": "function (struct VoxelCoord memory) pure returns (uint256)"
                      }
                    },
                    "id": 33732,
                    "isConstant": false,
                    "isLValue": false,
                    "isPure": false,
                    "kind": "functionCall",
                    "lValueRequested": false,
                    "names": [],
                    "nodeType": "FunctionCall",
                    "src": "5023:28:84",
                    "tryCall": false,
                    "typeDescriptions": {
                      "typeIdentifier": "t_uint256",
                      "typeString": "uint256"
                    }
                  },
                  "functionReturnParameters": 33728,
                  "id": 33733,
                  "nodeType": "Return",
                  "src": "5016:35:84"
                }
              ]
            },
            "functionSelector": "55b97448",
            "implemented": true,
            "kind": "function",
            "modifiers": [],
            "name": "GrassPlant",
            "nameLocation": "4944:10:84",
            "parameters": {
              "id": 33725,
              "nodeType": "ParameterList",
              "parameters": [
                {
                  "constant": false,
                  "id": 33724,
                  "mutability": "mutable",
                  "name": "coord",
                  "nameLocation": "4973:5:84",
                  "nodeType": "VariableDeclaration",
                  "scope": 33735,
                  "src": "4955:23:84",
                  "stateVariable": false,
                  "storageLocation": "memory",
                  "typeDescriptions": {
                    "typeIdentifier": "t_struct$_VoxelCoord_$5927_memory_ptr",
                    "typeString": "struct VoxelCoord"
                  },
                  "typeName": {
                    "id": 33723,
                    "nodeType": "UserDefinedTypeName",
                    "pathNode": {
                      "id": 33722,
                      "name": "VoxelCoord",
                      "nodeType": "IdentifierPath",
                      "referencedDeclaration": 5927,
                      "src": "4955:10:84"
                    },
                    "referencedDeclaration": 5927,
                    "src": "4955:10:84",
                    "typeDescriptions": {
                      "typeIdentifier": "t_struct$_VoxelCoord_$5927_storage_ptr",
                      "typeString": "struct VoxelCoord"
                    }
                  },
                  "visibility": "internal"
                }
              ],
              "src": "4954:25:84"
            },
            "returnParameters": {
              "id": 33728,
              "nodeType": "ParameterList",
              "parameters": [
                {
                  "constant": false,
                  "id": 33727,
                  "mutability": "mutable",
                  "name": "",
                  "nameLocation": "-1:-1:-1",
                  "nodeType": "VariableDeclaration",
                  "scope": 33735,
                  "src": "5001:7:84",
                  "stateVariable": false,
                  "storageLocation": "default",
                  "typeDescriptions": {
                    "typeIdentifier": "t_uint256",
                    "typeString": "uint256"
                  },
                  "typeName": {
                    "id": 33726,
                    "name": "uint256",
                    "nodeType": "ElementaryTypeName",
                    "src": "5001:7:84",
                    "typeDescriptions": {
                      "typeIdentifier": "t_uint256",
                      "typeString": "uint256"
                    }
                  },
                  "visibility": "internal"
                }
              ],
              "src": "5000:9:84"
            },
            "scope": 33974,
            "stateMutability": "pure",
            "virtual": false,
            "visibility": "public"
          },
          {
            "id": 33749,
            "nodeType": "FunctionDefinition",
            "src": "5060:123:84",
            "nodes": [],
            "body": {
              "id": 33748,
              "nodeType": "Block",
              "src": "5137:46:84",
              "nodes": [],
              "statements": [
                {
                  "expression": {
                    "arguments": [
                      {
                        "id": 33745,
                        "name": "coord",
                        "nodeType": "Identifier",
                        "overloadedDeclarations": [],
                        "referencedDeclaration": 33738,
                        "src": "5172:5:84",
                        "typeDescriptions": {
                          "typeIdentifier": "t_struct$_VoxelCoord_$5927_memory_ptr",
                          "typeString": "struct VoxelCoord memory"
                        }
                      }
                    ],
                    "expression": {
                      "argumentTypes": [
                        {
                          "typeIdentifier": "t_struct$_VoxelCoord_$5927_memory_ptr",
                          "typeString": "struct VoxelCoord memory"
                        }
                      ],
                      "expression": {
                        "id": 33743,
                        "name": "LibTerrain",
                        "nodeType": "Identifier",
                        "overloadedDeclarations": [],
                        "referencedDeclaration": 28871,
                        "src": "5150:10:84",
                        "typeDescriptions": {
                          "typeIdentifier": "t_type$_t_contract$_LibTerrain_$28871_$",
                          "typeString": "type(library LibTerrain)"
                        }
                      },
                      "id": 33744,
                      "isConstant": false,
                      "isLValue": false,
                      "isPure": false,
                      "lValueRequested": false,
                      "memberName": "SmallPlant",
                      "nodeType": "MemberAccess",
                      "referencedDeclaration": 28084,
                      "src": "5150:21:84",
                      "typeDescriptions": {
                        "typeIdentifier": "t_function_internal_pure$_t_struct$_VoxelCoord_$5927_memory_ptr_$returns$_t_uint256_$",
                        "typeString": "function (struct VoxelCoord memory) pure returns (uint256)"
                      }
                    },
                    "id": 33746,
                    "isConstant": false,
                    "isLValue": false,
                    "isPure": false,
                    "kind": "functionCall",
                    "lValueRequested": false,
                    "names": [],
                    "nodeType": "FunctionCall",
                    "src": "5150:28:84",
                    "tryCall": false,
                    "typeDescriptions": {
                      "typeIdentifier": "t_uint256",
                      "typeString": "uint256"
                    }
                  },
                  "functionReturnParameters": 33742,
                  "id": 33747,
                  "nodeType": "Return",
                  "src": "5143:35:84"
                }
              ]
            },
            "functionSelector": "ed7eec3b",
            "implemented": true,
            "kind": "function",
            "modifiers": [],
            "name": "OrangeFlower",
            "nameLocation": "5069:12:84",
            "parameters": {
              "id": 33739,
              "nodeType": "ParameterList",
              "parameters": [
                {
                  "constant": false,
                  "id": 33738,
                  "mutability": "mutable",
                  "name": "coord",
                  "nameLocation": "5100:5:84",
                  "nodeType": "VariableDeclaration",
                  "scope": 33749,
                  "src": "5082:23:84",
                  "stateVariable": false,
                  "storageLocation": "memory",
                  "typeDescriptions": {
                    "typeIdentifier": "t_struct$_VoxelCoord_$5927_memory_ptr",
                    "typeString": "struct VoxelCoord"
                  },
                  "typeName": {
                    "id": 33737,
                    "nodeType": "UserDefinedTypeName",
                    "pathNode": {
                      "id": 33736,
                      "name": "VoxelCoord",
                      "nodeType": "IdentifierPath",
                      "referencedDeclaration": 5927,
                      "src": "5082:10:84"
                    },
                    "referencedDeclaration": 5927,
                    "src": "5082:10:84",
                    "typeDescriptions": {
                      "typeIdentifier": "t_struct$_VoxelCoord_$5927_storage_ptr",
                      "typeString": "struct VoxelCoord"
                    }
                  },
                  "visibility": "internal"
                }
              ],
              "src": "5081:25:84"
            },
            "returnParameters": {
              "id": 33742,
              "nodeType": "ParameterList",
              "parameters": [
                {
                  "constant": false,
                  "id": 33741,
                  "mutability": "mutable",
                  "name": "",
                  "nameLocation": "-1:-1:-1",
                  "nodeType": "VariableDeclaration",
                  "scope": 33749,
                  "src": "5128:7:84",
                  "stateVariable": false,
                  "storageLocation": "default",
                  "typeDescriptions": {
                    "typeIdentifier": "t_uint256",
                    "typeString": "uint256"
                  },
                  "typeName": {
                    "id": 33740,
                    "name": "uint256",
                    "nodeType": "ElementaryTypeName",
                    "src": "5128:7:84",
                    "typeDescriptions": {
                      "typeIdentifier": "t_uint256",
                      "typeString": "uint256"
                    }
                  },
                  "visibility": "internal"
                }
              ],
              "src": "5127:9:84"
            },
            "scope": 33974,
            "stateMutability": "pure",
            "virtual": false,
            "visibility": "public"
          },
          {
            "id": 33763,
            "nodeType": "FunctionDefinition",
            "src": "5187:124:84",
            "nodes": [],
            "body": {
              "id": 33762,
              "nodeType": "Block",
              "src": "5265:46:84",
              "nodes": [],
              "statements": [
                {
                  "expression": {
                    "arguments": [
                      {
                        "id": 33759,
                        "name": "coord",
                        "nodeType": "Identifier",
                        "overloadedDeclarations": [],
                        "referencedDeclaration": 33752,
                        "src": "5300:5:84",
                        "typeDescriptions": {
                          "typeIdentifier": "t_struct$_VoxelCoord_$5927_memory_ptr",
                          "typeString": "struct VoxelCoord memory"
                        }
                      }
                    ],
                    "expression": {
                      "argumentTypes": [
                        {
                          "typeIdentifier": "t_struct$_VoxelCoord_$5927_memory_ptr",
                          "typeString": "struct VoxelCoord memory"
                        }
                      ],
                      "expression": {
                        "id": 33757,
                        "name": "LibTerrain",
                        "nodeType": "Identifier",
                        "overloadedDeclarations": [],
                        "referencedDeclaration": 28871,
                        "src": "5278:10:84",
                        "typeDescriptions": {
                          "typeIdentifier": "t_type$_t_contract$_LibTerrain_$28871_$",
                          "typeString": "type(library LibTerrain)"
                        }
                      },
                      "id": 33758,
                      "isConstant": false,
                      "isLValue": false,
                      "isPure": false,
                      "lValueRequested": false,
                      "memberName": "SmallPlant",
                      "nodeType": "MemberAccess",
                      "referencedDeclaration": 28084,
                      "src": "5278:21:84",
                      "typeDescriptions": {
                        "typeIdentifier": "t_function_internal_pure$_t_struct$_VoxelCoord_$5927_memory_ptr_$returns$_t_uint256_$",
                        "typeString": "function (struct VoxelCoord memory) pure returns (uint256)"
                      }
                    },
                    "id": 33760,
                    "isConstant": false,
                    "isLValue": false,
                    "isPure": false,
                    "kind": "functionCall",
                    "lValueRequested": false,
                    "names": [],
                    "nodeType": "FunctionCall",
                    "src": "5278:28:84",
                    "tryCall": false,
                    "typeDescriptions": {
                      "typeIdentifier": "t_uint256",
                      "typeString": "uint256"
                    }
                  },
                  "functionReturnParameters": 33756,
                  "id": 33761,
                  "nodeType": "Return",
                  "src": "5271:35:84"
                }
              ]
            },
            "functionSelector": "5ebd349c",
            "implemented": true,
            "kind": "function",
            "modifiers": [],
            "name": "MagentaFlower",
            "nameLocation": "5196:13:84",
            "parameters": {
              "id": 33753,
              "nodeType": "ParameterList",
              "parameters": [
                {
                  "constant": false,
                  "id": 33752,
                  "mutability": "mutable",
                  "name": "coord",
                  "nameLocation": "5228:5:84",
                  "nodeType": "VariableDeclaration",
                  "scope": 33763,
                  "src": "5210:23:84",
                  "stateVariable": false,
                  "storageLocation": "memory",
                  "typeDescriptions": {
                    "typeIdentifier": "t_struct$_VoxelCoord_$5927_memory_ptr",
                    "typeString": "struct VoxelCoord"
                  },
                  "typeName": {
                    "id": 33751,
                    "nodeType": "UserDefinedTypeName",
                    "pathNode": {
                      "id": 33750,
                      "name": "VoxelCoord",
                      "nodeType": "IdentifierPath",
                      "referencedDeclaration": 5927,
                      "src": "5210:10:84"
                    },
                    "referencedDeclaration": 5927,
                    "src": "5210:10:84",
                    "typeDescriptions": {
                      "typeIdentifier": "t_struct$_VoxelCoord_$5927_storage_ptr",
                      "typeString": "struct VoxelCoord"
                    }
                  },
                  "visibility": "internal"
                }
              ],
              "src": "5209:25:84"
            },
            "returnParameters": {
              "id": 33756,
              "nodeType": "ParameterList",
              "parameters": [
                {
                  "constant": false,
                  "id": 33755,
                  "mutability": "mutable",
                  "name": "",
                  "nameLocation": "-1:-1:-1",
                  "nodeType": "VariableDeclaration",
                  "scope": 33763,
                  "src": "5256:7:84",
                  "stateVariable": false,
                  "storageLocation": "default",
                  "typeDescriptions": {
                    "typeIdentifier": "t_uint256",
                    "typeString": "uint256"
                  },
                  "typeName": {
                    "id": 33754,
                    "name": "uint256",
                    "nodeType": "ElementaryTypeName",
                    "src": "5256:7:84",
                    "typeDescriptions": {
                      "typeIdentifier": "t_uint256",
                      "typeString": "uint256"
                    }
                  },
                  "visibility": "internal"
                }
              ],
              "src": "5255:9:84"
            },
            "scope": 33974,
            "stateMutability": "pure",
            "virtual": false,
            "visibility": "public"
          },
          {
            "id": 33777,
            "nodeType": "FunctionDefinition",
            "src": "5315:126:84",
            "nodes": [],
            "body": {
              "id": 33776,
              "nodeType": "Block",
              "src": "5395:46:84",
              "nodes": [],
              "statements": [
                {
                  "expression": {
                    "arguments": [
                      {
                        "id": 33773,
                        "name": "coord",
                        "nodeType": "Identifier",
                        "overloadedDeclarations": [],
                        "referencedDeclaration": 33766,
                        "src": "5430:5:84",
                        "typeDescriptions": {
                          "typeIdentifier": "t_struct$_VoxelCoord_$5927_memory_ptr",
                          "typeString": "struct VoxelCoord memory"
                        }
                      }
                    ],
                    "expression": {
                      "argumentTypes": [
                        {
                          "typeIdentifier": "t_struct$_VoxelCoord_$5927_memory_ptr",
                          "typeString": "struct VoxelCoord memory"
                        }
                      ],
                      "expression": {
                        "id": 33771,
                        "name": "LibTerrain",
                        "nodeType": "Identifier",
                        "overloadedDeclarations": [],
                        "referencedDeclaration": 28871,
                        "src": "5408:10:84",
                        "typeDescriptions": {
                          "typeIdentifier": "t_type$_t_contract$_LibTerrain_$28871_$",
                          "typeString": "type(library LibTerrain)"
                        }
                      },
                      "id": 33772,
                      "isConstant": false,
                      "isLValue": false,
                      "isPure": false,
                      "lValueRequested": false,
                      "memberName": "SmallPlant",
                      "nodeType": "MemberAccess",
                      "referencedDeclaration": 28084,
                      "src": "5408:21:84",
                      "typeDescriptions": {
                        "typeIdentifier": "t_function_internal_pure$_t_struct$_VoxelCoord_$5927_memory_ptr_$returns$_t_uint256_$",
                        "typeString": "function (struct VoxelCoord memory) pure returns (uint256)"
                      }
                    },
                    "id": 33774,
                    "isConstant": false,
                    "isLValue": false,
                    "isPure": false,
                    "kind": "functionCall",
                    "lValueRequested": false,
                    "names": [],
                    "nodeType": "FunctionCall",
                    "src": "5408:28:84",
                    "tryCall": false,
                    "typeDescriptions": {
                      "typeIdentifier": "t_uint256",
                      "typeString": "uint256"
                    }
                  },
                  "functionReturnParameters": 33770,
                  "id": 33775,
                  "nodeType": "Return",
                  "src": "5401:35:84"
                }
              ]
            },
            "functionSelector": "627b74cd",
            "implemented": true,
            "kind": "function",
            "modifiers": [],
            "name": "LightBlueFlower",
            "nameLocation": "5324:15:84",
            "parameters": {
              "id": 33767,
              "nodeType": "ParameterList",
              "parameters": [
                {
                  "constant": false,
                  "id": 33766,
                  "mutability": "mutable",
                  "name": "coord",
                  "nameLocation": "5358:5:84",
                  "nodeType": "VariableDeclaration",
                  "scope": 33777,
                  "src": "5340:23:84",
                  "stateVariable": false,
                  "storageLocation": "memory",
                  "typeDescriptions": {
                    "typeIdentifier": "t_struct$_VoxelCoord_$5927_memory_ptr",
                    "typeString": "struct VoxelCoord"
                  },
                  "typeName": {
                    "id": 33765,
                    "nodeType": "UserDefinedTypeName",
                    "pathNode": {
                      "id": 33764,
                      "name": "VoxelCoord",
                      "nodeType": "IdentifierPath",
                      "referencedDeclaration": 5927,
                      "src": "5340:10:84"
                    },
                    "referencedDeclaration": 5927,
                    "src": "5340:10:84",
                    "typeDescriptions": {
                      "typeIdentifier": "t_struct$_VoxelCoord_$5927_storage_ptr",
                      "typeString": "struct VoxelCoord"
                    }
                  },
                  "visibility": "internal"
                }
              ],
              "src": "5339:25:84"
            },
            "returnParameters": {
              "id": 33770,
              "nodeType": "ParameterList",
              "parameters": [
                {
                  "constant": false,
                  "id": 33769,
                  "mutability": "mutable",
                  "name": "",
                  "nameLocation": "-1:-1:-1",
                  "nodeType": "VariableDeclaration",
                  "scope": 33777,
                  "src": "5386:7:84",
                  "stateVariable": false,
                  "storageLocation": "default",
                  "typeDescriptions": {
                    "typeIdentifier": "t_uint256",
                    "typeString": "uint256"
                  },
                  "typeName": {
                    "id": 33768,
                    "name": "uint256",
                    "nodeType": "ElementaryTypeName",
                    "src": "5386:7:84",
                    "typeDescriptions": {
                      "typeIdentifier": "t_uint256",
                      "typeString": "uint256"
                    }
                  },
                  "visibility": "internal"
                }
              ],
              "src": "5385:9:84"
            },
            "scope": 33974,
            "stateMutability": "pure",
            "virtual": false,
            "visibility": "public"
          },
          {
            "id": 33791,
            "nodeType": "FunctionDefinition",
            "src": "5445:121:84",
            "nodes": [],
            "body": {
              "id": 33790,
              "nodeType": "Block",
              "src": "5520:46:84",
              "nodes": [],
              "statements": [
                {
                  "expression": {
                    "arguments": [
                      {
                        "id": 33787,
                        "name": "coord",
                        "nodeType": "Identifier",
                        "overloadedDeclarations": [],
                        "referencedDeclaration": 33780,
                        "src": "5555:5:84",
                        "typeDescriptions": {
                          "typeIdentifier": "t_struct$_VoxelCoord_$5927_memory_ptr",
                          "typeString": "struct VoxelCoord memory"
                        }
                      }
                    ],
                    "expression": {
                      "argumentTypes": [
                        {
                          "typeIdentifier": "t_struct$_VoxelCoord_$5927_memory_ptr",
                          "typeString": "struct VoxelCoord memory"
                        }
                      ],
                      "expression": {
                        "id": 33785,
                        "name": "LibTerrain",
                        "nodeType": "Identifier",
                        "overloadedDeclarations": [],
                        "referencedDeclaration": 28871,
                        "src": "5533:10:84",
                        "typeDescriptions": {
                          "typeIdentifier": "t_type$_t_contract$_LibTerrain_$28871_$",
                          "typeString": "type(library LibTerrain)"
                        }
                      },
                      "id": 33786,
                      "isConstant": false,
                      "isLValue": false,
                      "isPure": false,
                      "lValueRequested": false,
                      "memberName": "SmallPlant",
                      "nodeType": "MemberAccess",
                      "referencedDeclaration": 28084,
                      "src": "5533:21:84",
                      "typeDescriptions": {
                        "typeIdentifier": "t_function_internal_pure$_t_struct$_VoxelCoord_$5927_memory_ptr_$returns$_t_uint256_$",
                        "typeString": "function (struct VoxelCoord memory) pure returns (uint256)"
                      }
                    },
                    "id": 33788,
                    "isConstant": false,
                    "isLValue": false,
                    "isPure": false,
                    "kind": "functionCall",
                    "lValueRequested": false,
                    "names": [],
                    "nodeType": "FunctionCall",
                    "src": "5533:28:84",
                    "tryCall": false,
                    "typeDescriptions": {
                      "typeIdentifier": "t_uint256",
                      "typeString": "uint256"
                    }
                  },
                  "functionReturnParameters": 33784,
                  "id": 33789,
                  "nodeType": "Return",
                  "src": "5526:35:84"
                }
              ]
            },
            "functionSelector": "e99252bf",
            "implemented": true,
            "kind": "function",
            "modifiers": [],
            "name": "LimeFlower",
            "nameLocation": "5454:10:84",
            "parameters": {
              "id": 33781,
              "nodeType": "ParameterList",
              "parameters": [
                {
                  "constant": false,
                  "id": 33780,
                  "mutability": "mutable",
                  "name": "coord",
                  "nameLocation": "5483:5:84",
                  "nodeType": "VariableDeclaration",
                  "scope": 33791,
                  "src": "5465:23:84",
                  "stateVariable": false,
                  "storageLocation": "memory",
                  "typeDescriptions": {
                    "typeIdentifier": "t_struct$_VoxelCoord_$5927_memory_ptr",
                    "typeString": "struct VoxelCoord"
                  },
                  "typeName": {
                    "id": 33779,
                    "nodeType": "UserDefinedTypeName",
                    "pathNode": {
                      "id": 33778,
                      "name": "VoxelCoord",
                      "nodeType": "IdentifierPath",
                      "referencedDeclaration": 5927,
                      "src": "5465:10:84"
                    },
                    "referencedDeclaration": 5927,
                    "src": "5465:10:84",
                    "typeDescriptions": {
                      "typeIdentifier": "t_struct$_VoxelCoord_$5927_storage_ptr",
                      "typeString": "struct VoxelCoord"
                    }
                  },
                  "visibility": "internal"
                }
              ],
              "src": "5464:25:84"
            },
            "returnParameters": {
              "id": 33784,
              "nodeType": "ParameterList",
              "parameters": [
                {
                  "constant": false,
                  "id": 33783,
                  "mutability": "mutable",
                  "name": "",
                  "nameLocation": "-1:-1:-1",
                  "nodeType": "VariableDeclaration",
                  "scope": 33791,
                  "src": "5511:7:84",
                  "stateVariable": false,
                  "storageLocation": "default",
                  "typeDescriptions": {
                    "typeIdentifier": "t_uint256",
                    "typeString": "uint256"
                  },
                  "typeName": {
                    "id": 33782,
                    "name": "uint256",
                    "nodeType": "ElementaryTypeName",
                    "src": "5511:7:84",
                    "typeDescriptions": {
                      "typeIdentifier": "t_uint256",
                      "typeString": "uint256"
                    }
                  },
                  "visibility": "internal"
                }
              ],
              "src": "5510:9:84"
            },
            "scope": 33974,
            "stateMutability": "pure",
            "virtual": false,
            "visibility": "public"
          },
          {
            "id": 33805,
            "nodeType": "FunctionDefinition",
            "src": "5570:121:84",
            "nodes": [],
            "body": {
              "id": 33804,
              "nodeType": "Block",
              "src": "5645:46:84",
              "nodes": [],
              "statements": [
                {
                  "expression": {
                    "arguments": [
                      {
                        "id": 33801,
                        "name": "coord",
                        "nodeType": "Identifier",
                        "overloadedDeclarations": [],
                        "referencedDeclaration": 33794,
                        "src": "5680:5:84",
                        "typeDescriptions": {
                          "typeIdentifier": "t_struct$_VoxelCoord_$5927_memory_ptr",
                          "typeString": "struct VoxelCoord memory"
                        }
                      }
                    ],
                    "expression": {
                      "argumentTypes": [
                        {
                          "typeIdentifier": "t_struct$_VoxelCoord_$5927_memory_ptr",
                          "typeString": "struct VoxelCoord memory"
                        }
                      ],
                      "expression": {
                        "id": 33799,
                        "name": "LibTerrain",
                        "nodeType": "Identifier",
                        "overloadedDeclarations": [],
                        "referencedDeclaration": 28871,
                        "src": "5658:10:84",
                        "typeDescriptions": {
                          "typeIdentifier": "t_type$_t_contract$_LibTerrain_$28871_$",
                          "typeString": "type(library LibTerrain)"
                        }
                      },
                      "id": 33800,
                      "isConstant": false,
                      "isLValue": false,
                      "isPure": false,
                      "lValueRequested": false,
                      "memberName": "SmallPlant",
                      "nodeType": "MemberAccess",
                      "referencedDeclaration": 28084,
                      "src": "5658:21:84",
                      "typeDescriptions": {
                        "typeIdentifier": "t_function_internal_pure$_t_struct$_VoxelCoord_$5927_memory_ptr_$returns$_t_uint256_$",
                        "typeString": "function (struct VoxelCoord memory) pure returns (uint256)"
                      }
                    },
                    "id": 33802,
                    "isConstant": false,
                    "isLValue": false,
                    "isPure": false,
                    "kind": "functionCall",
                    "lValueRequested": false,
                    "names": [],
                    "nodeType": "FunctionCall",
                    "src": "5658:28:84",
                    "tryCall": false,
                    "typeDescriptions": {
                      "typeIdentifier": "t_uint256",
                      "typeString": "uint256"
                    }
                  },
                  "functionReturnParameters": 33798,
                  "id": 33803,
                  "nodeType": "Return",
                  "src": "5651:35:84"
                }
              ]
            },
            "functionSelector": "033351ae",
            "implemented": true,
            "kind": "function",
            "modifiers": [],
            "name": "PinkFlower",
            "nameLocation": "5579:10:84",
            "parameters": {
              "id": 33795,
              "nodeType": "ParameterList",
              "parameters": [
                {
                  "constant": false,
                  "id": 33794,
                  "mutability": "mutable",
                  "name": "coord",
                  "nameLocation": "5608:5:84",
                  "nodeType": "VariableDeclaration",
                  "scope": 33805,
                  "src": "5590:23:84",
                  "stateVariable": false,
                  "storageLocation": "memory",
                  "typeDescriptions": {
                    "typeIdentifier": "t_struct$_VoxelCoord_$5927_memory_ptr",
                    "typeString": "struct VoxelCoord"
                  },
                  "typeName": {
                    "id": 33793,
                    "nodeType": "UserDefinedTypeName",
                    "pathNode": {
                      "id": 33792,
                      "name": "VoxelCoord",
                      "nodeType": "IdentifierPath",
                      "referencedDeclaration": 5927,
                      "src": "5590:10:84"
                    },
                    "referencedDeclaration": 5927,
                    "src": "5590:10:84",
                    "typeDescriptions": {
                      "typeIdentifier": "t_struct$_VoxelCoord_$5927_storage_ptr",
                      "typeString": "struct VoxelCoord"
                    }
                  },
                  "visibility": "internal"
                }
              ],
              "src": "5589:25:84"
            },
            "returnParameters": {
              "id": 33798,
              "nodeType": "ParameterList",
              "parameters": [
                {
                  "constant": false,
                  "id": 33797,
                  "mutability": "mutable",
                  "name": "",
                  "nameLocation": "-1:-1:-1",
                  "nodeType": "VariableDeclaration",
                  "scope": 33805,
                  "src": "5636:7:84",
                  "stateVariable": false,
                  "storageLocation": "default",
                  "typeDescriptions": {
                    "typeIdentifier": "t_uint256",
                    "typeString": "uint256"
                  },
                  "typeName": {
                    "id": 33796,
                    "name": "uint256",
                    "nodeType": "ElementaryTypeName",
                    "src": "5636:7:84",
                    "typeDescriptions": {
                      "typeIdentifier": "t_uint256",
                      "typeString": "uint256"
                    }
                  },
                  "visibility": "internal"
                }
              ],
              "src": "5635:9:84"
            },
            "scope": 33974,
            "stateMutability": "pure",
            "virtual": false,
            "visibility": "public"
          },
          {
            "id": 33819,
            "nodeType": "FunctionDefinition",
            "src": "5695:121:84",
            "nodes": [],
            "body": {
              "id": 33818,
              "nodeType": "Block",
              "src": "5770:46:84",
              "nodes": [],
              "statements": [
                {
                  "expression": {
                    "arguments": [
                      {
                        "id": 33815,
                        "name": "coord",
                        "nodeType": "Identifier",
                        "overloadedDeclarations": [],
                        "referencedDeclaration": 33808,
                        "src": "5805:5:84",
                        "typeDescriptions": {
                          "typeIdentifier": "t_struct$_VoxelCoord_$5927_memory_ptr",
                          "typeString": "struct VoxelCoord memory"
                        }
                      }
                    ],
                    "expression": {
                      "argumentTypes": [
                        {
                          "typeIdentifier": "t_struct$_VoxelCoord_$5927_memory_ptr",
                          "typeString": "struct VoxelCoord memory"
                        }
                      ],
                      "expression": {
                        "id": 33813,
                        "name": "LibTerrain",
                        "nodeType": "Identifier",
                        "overloadedDeclarations": [],
                        "referencedDeclaration": 28871,
                        "src": "5783:10:84",
                        "typeDescriptions": {
                          "typeIdentifier": "t_type$_t_contract$_LibTerrain_$28871_$",
                          "typeString": "type(library LibTerrain)"
                        }
                      },
                      "id": 33814,
                      "isConstant": false,
                      "isLValue": false,
                      "isPure": false,
                      "lValueRequested": false,
                      "memberName": "SmallPlant",
                      "nodeType": "MemberAccess",
                      "referencedDeclaration": 28084,
                      "src": "5783:21:84",
                      "typeDescriptions": {
                        "typeIdentifier": "t_function_internal_pure$_t_struct$_VoxelCoord_$5927_memory_ptr_$returns$_t_uint256_$",
                        "typeString": "function (struct VoxelCoord memory) pure returns (uint256)"
                      }
                    },
                    "id": 33816,
                    "isConstant": false,
                    "isLValue": false,
                    "isPure": false,
                    "kind": "functionCall",
                    "lValueRequested": false,
                    "names": [],
                    "nodeType": "FunctionCall",
                    "src": "5783:28:84",
                    "tryCall": false,
                    "typeDescriptions": {
                      "typeIdentifier": "t_uint256",
                      "typeString": "uint256"
                    }
                  },
                  "functionReturnParameters": 33812,
                  "id": 33817,
                  "nodeType": "Return",
                  "src": "5776:35:84"
                }
              ]
            },
            "functionSelector": "c072d8b8",
            "implemented": true,
            "kind": "function",
            "modifiers": [],
            "name": "GrayFlower",
            "nameLocation": "5704:10:84",
            "parameters": {
              "id": 33809,
              "nodeType": "ParameterList",
              "parameters": [
                {
                  "constant": false,
                  "id": 33808,
                  "mutability": "mutable",
                  "name": "coord",
                  "nameLocation": "5733:5:84",
                  "nodeType": "VariableDeclaration",
                  "scope": 33819,
                  "src": "5715:23:84",
                  "stateVariable": false,
                  "storageLocation": "memory",
                  "typeDescriptions": {
                    "typeIdentifier": "t_struct$_VoxelCoord_$5927_memory_ptr",
                    "typeString": "struct VoxelCoord"
                  },
                  "typeName": {
                    "id": 33807,
                    "nodeType": "UserDefinedTypeName",
                    "pathNode": {
                      "id": 33806,
                      "name": "VoxelCoord",
                      "nodeType": "IdentifierPath",
                      "referencedDeclaration": 5927,
                      "src": "5715:10:84"
                    },
                    "referencedDeclaration": 5927,
                    "src": "5715:10:84",
                    "typeDescriptions": {
                      "typeIdentifier": "t_struct$_VoxelCoord_$5927_storage_ptr",
                      "typeString": "struct VoxelCoord"
                    }
                  },
                  "visibility": "internal"
                }
              ],
              "src": "5714:25:84"
            },
            "returnParameters": {
              "id": 33812,
              "nodeType": "ParameterList",
              "parameters": [
                {
                  "constant": false,
                  "id": 33811,
                  "mutability": "mutable",
                  "name": "",
                  "nameLocation": "-1:-1:-1",
                  "nodeType": "VariableDeclaration",
                  "scope": 33819,
                  "src": "5761:7:84",
                  "stateVariable": false,
                  "storageLocation": "default",
                  "typeDescriptions": {
                    "typeIdentifier": "t_uint256",
                    "typeString": "uint256"
                  },
                  "typeName": {
                    "id": 33810,
                    "name": "uint256",
                    "nodeType": "ElementaryTypeName",
                    "src": "5761:7:84",
                    "typeDescriptions": {
                      "typeIdentifier": "t_uint256",
                      "typeString": "uint256"
                    }
                  },
                  "visibility": "internal"
                }
              ],
              "src": "5760:9:84"
            },
            "scope": 33974,
            "stateMutability": "pure",
            "virtual": false,
            "visibility": "public"
          },
          {
            "id": 33833,
            "nodeType": "FunctionDefinition",
            "src": "5820:126:84",
            "nodes": [],
            "body": {
              "id": 33832,
              "nodeType": "Block",
              "src": "5900:46:84",
              "nodes": [],
              "statements": [
                {
                  "expression": {
                    "arguments": [
                      {
                        "id": 33829,
                        "name": "coord",
                        "nodeType": "Identifier",
                        "overloadedDeclarations": [],
                        "referencedDeclaration": 33822,
                        "src": "5935:5:84",
                        "typeDescriptions": {
                          "typeIdentifier": "t_struct$_VoxelCoord_$5927_memory_ptr",
                          "typeString": "struct VoxelCoord memory"
                        }
                      }
                    ],
                    "expression": {
                      "argumentTypes": [
                        {
                          "typeIdentifier": "t_struct$_VoxelCoord_$5927_memory_ptr",
                          "typeString": "struct VoxelCoord memory"
                        }
                      ],
                      "expression": {
                        "id": 33827,
                        "name": "LibTerrain",
                        "nodeType": "Identifier",
                        "overloadedDeclarations": [],
                        "referencedDeclaration": 28871,
                        "src": "5913:10:84",
                        "typeDescriptions": {
                          "typeIdentifier": "t_type$_t_contract$_LibTerrain_$28871_$",
                          "typeString": "type(library LibTerrain)"
                        }
                      },
                      "id": 33828,
                      "isConstant": false,
                      "isLValue": false,
                      "isPure": false,
                      "lValueRequested": false,
                      "memberName": "SmallPlant",
                      "nodeType": "MemberAccess",
                      "referencedDeclaration": 28084,
                      "src": "5913:21:84",
                      "typeDescriptions": {
                        "typeIdentifier": "t_function_internal_pure$_t_struct$_VoxelCoord_$5927_memory_ptr_$returns$_t_uint256_$",
                        "typeString": "function (struct VoxelCoord memory) pure returns (uint256)"
                      }
                    },
                    "id": 33830,
                    "isConstant": false,
                    "isLValue": false,
                    "isPure": false,
                    "kind": "functionCall",
                    "lValueRequested": false,
                    "names": [],
                    "nodeType": "FunctionCall",
                    "src": "5913:28:84",
                    "tryCall": false,
                    "typeDescriptions": {
                      "typeIdentifier": "t_uint256",
                      "typeString": "uint256"
                    }
                  },
                  "functionReturnParameters": 33826,
                  "id": 33831,
                  "nodeType": "Return",
                  "src": "5906:35:84"
                }
              ]
            },
            "functionSelector": "87792459",
            "implemented": true,
            "kind": "function",
            "modifiers": [],
            "name": "LightGrayFlower",
            "nameLocation": "5829:15:84",
            "parameters": {
              "id": 33823,
              "nodeType": "ParameterList",
              "parameters": [
                {
                  "constant": false,
                  "id": 33822,
                  "mutability": "mutable",
                  "name": "coord",
                  "nameLocation": "5863:5:84",
                  "nodeType": "VariableDeclaration",
                  "scope": 33833,
                  "src": "5845:23:84",
                  "stateVariable": false,
                  "storageLocation": "memory",
                  "typeDescriptions": {
                    "typeIdentifier": "t_struct$_VoxelCoord_$5927_memory_ptr",
                    "typeString": "struct VoxelCoord"
                  },
                  "typeName": {
                    "id": 33821,
                    "nodeType": "UserDefinedTypeName",
                    "pathNode": {
                      "id": 33820,
                      "name": "VoxelCoord",
                      "nodeType": "IdentifierPath",
                      "referencedDeclaration": 5927,
                      "src": "5845:10:84"
                    },
                    "referencedDeclaration": 5927,
                    "src": "5845:10:84",
                    "typeDescriptions": {
                      "typeIdentifier": "t_struct$_VoxelCoord_$5927_storage_ptr",
                      "typeString": "struct VoxelCoord"
                    }
                  },
                  "visibility": "internal"
                }
              ],
              "src": "5844:25:84"
            },
            "returnParameters": {
              "id": 33826,
              "nodeType": "ParameterList",
              "parameters": [
                {
                  "constant": false,
                  "id": 33825,
                  "mutability": "mutable",
                  "name": "",
                  "nameLocation": "-1:-1:-1",
                  "nodeType": "VariableDeclaration",
                  "scope": 33833,
                  "src": "5891:7:84",
                  "stateVariable": false,
                  "storageLocation": "default",
                  "typeDescriptions": {
                    "typeIdentifier": "t_uint256",
                    "typeString": "uint256"
                  },
                  "typeName": {
                    "id": 33824,
                    "name": "uint256",
                    "nodeType": "ElementaryTypeName",
                    "src": "5891:7:84",
                    "typeDescriptions": {
                      "typeIdentifier": "t_uint256",
                      "typeString": "uint256"
                    }
                  },
                  "visibility": "internal"
                }
              ],
              "src": "5890:9:84"
            },
            "scope": 33974,
            "stateMutability": "pure",
            "virtual": false,
            "visibility": "public"
          },
          {
            "id": 33847,
            "nodeType": "FunctionDefinition",
            "src": "5950:121:84",
            "nodes": [],
            "body": {
              "id": 33846,
              "nodeType": "Block",
              "src": "6025:46:84",
              "nodes": [],
              "statements": [
                {
                  "expression": {
                    "arguments": [
                      {
                        "id": 33843,
                        "name": "coord",
                        "nodeType": "Identifier",
                        "overloadedDeclarations": [],
                        "referencedDeclaration": 33836,
                        "src": "6060:5:84",
                        "typeDescriptions": {
                          "typeIdentifier": "t_struct$_VoxelCoord_$5927_memory_ptr",
                          "typeString": "struct VoxelCoord memory"
                        }
                      }
                    ],
                    "expression": {
                      "argumentTypes": [
                        {
                          "typeIdentifier": "t_struct$_VoxelCoord_$5927_memory_ptr",
                          "typeString": "struct VoxelCoord memory"
                        }
                      ],
                      "expression": {
                        "id": 33841,
                        "name": "LibTerrain",
                        "nodeType": "Identifier",
                        "overloadedDeclarations": [],
                        "referencedDeclaration": 28871,
                        "src": "6038:10:84",
                        "typeDescriptions": {
                          "typeIdentifier": "t_type$_t_contract$_LibTerrain_$28871_$",
                          "typeString": "type(library LibTerrain)"
                        }
                      },
                      "id": 33842,
                      "isConstant": false,
                      "isLValue": false,
                      "isPure": false,
                      "lValueRequested": false,
                      "memberName": "SmallPlant",
                      "nodeType": "MemberAccess",
                      "referencedDeclaration": 28084,
                      "src": "6038:21:84",
                      "typeDescriptions": {
                        "typeIdentifier": "t_function_internal_pure$_t_struct$_VoxelCoord_$5927_memory_ptr_$returns$_t_uint256_$",
                        "typeString": "function (struct VoxelCoord memory) pure returns (uint256)"
                      }
                    },
                    "id": 33844,
                    "isConstant": false,
                    "isLValue": false,
                    "isPure": false,
                    "kind": "functionCall",
                    "lValueRequested": false,
                    "names": [],
                    "nodeType": "FunctionCall",
                    "src": "6038:28:84",
                    "tryCall": false,
                    "typeDescriptions": {
                      "typeIdentifier": "t_uint256",
                      "typeString": "uint256"
                    }
                  },
                  "functionReturnParameters": 33840,
                  "id": 33845,
                  "nodeType": "Return",
                  "src": "6031:35:84"
                }
              ]
            },
            "functionSelector": "810effe2",
            "implemented": true,
            "kind": "function",
            "modifiers": [],
            "name": "CyanFlower",
            "nameLocation": "5959:10:84",
            "parameters": {
              "id": 33837,
              "nodeType": "ParameterList",
              "parameters": [
                {
                  "constant": false,
                  "id": 33836,
                  "mutability": "mutable",
                  "name": "coord",
                  "nameLocation": "5988:5:84",
                  "nodeType": "VariableDeclaration",
                  "scope": 33847,
                  "src": "5970:23:84",
                  "stateVariable": false,
                  "storageLocation": "memory",
                  "typeDescriptions": {
                    "typeIdentifier": "t_struct$_VoxelCoord_$5927_memory_ptr",
                    "typeString": "struct VoxelCoord"
                  },
                  "typeName": {
                    "id": 33835,
                    "nodeType": "UserDefinedTypeName",
                    "pathNode": {
                      "id": 33834,
                      "name": "VoxelCoord",
                      "nodeType": "IdentifierPath",
                      "referencedDeclaration": 5927,
                      "src": "5970:10:84"
                    },
                    "referencedDeclaration": 5927,
                    "src": "5970:10:84",
                    "typeDescriptions": {
                      "typeIdentifier": "t_struct$_VoxelCoord_$5927_storage_ptr",
                      "typeString": "struct VoxelCoord"
                    }
                  },
                  "visibility": "internal"
                }
              ],
              "src": "5969:25:84"
            },
            "returnParameters": {
              "id": 33840,
              "nodeType": "ParameterList",
              "parameters": [
                {
                  "constant": false,
                  "id": 33839,
                  "mutability": "mutable",
                  "name": "",
                  "nameLocation": "-1:-1:-1",
                  "nodeType": "VariableDeclaration",
                  "scope": 33847,
                  "src": "6016:7:84",
                  "stateVariable": false,
                  "storageLocation": "default",
                  "typeDescriptions": {
                    "typeIdentifier": "t_uint256",
                    "typeString": "uint256"
                  },
                  "typeName": {
                    "id": 33838,
                    "name": "uint256",
                    "nodeType": "ElementaryTypeName",
                    "src": "6016:7:84",
                    "typeDescriptions": {
                      "typeIdentifier": "t_uint256",
                      "typeString": "uint256"
                    }
                  },
                  "visibility": "internal"
                }
              ],
              "src": "6015:9:84"
            },
            "scope": 33974,
            "stateMutability": "pure",
            "virtual": false,
            "visibility": "public"
          },
          {
            "id": 33861,
            "nodeType": "FunctionDefinition",
            "src": "6075:123:84",
            "nodes": [],
            "body": {
              "id": 33860,
              "nodeType": "Block",
              "src": "6152:46:84",
              "nodes": [],
              "statements": [
                {
                  "expression": {
                    "arguments": [
                      {
                        "id": 33857,
                        "name": "coord",
                        "nodeType": "Identifier",
                        "overloadedDeclarations": [],
                        "referencedDeclaration": 33850,
                        "src": "6187:5:84",
                        "typeDescriptions": {
                          "typeIdentifier": "t_struct$_VoxelCoord_$5927_memory_ptr",
                          "typeString": "struct VoxelCoord memory"
                        }
                      }
                    ],
                    "expression": {
                      "argumentTypes": [
                        {
                          "typeIdentifier": "t_struct$_VoxelCoord_$5927_memory_ptr",
                          "typeString": "struct VoxelCoord memory"
                        }
                      ],
                      "expression": {
                        "id": 33855,
                        "name": "LibTerrain",
                        "nodeType": "Identifier",
                        "overloadedDeclarations": [],
                        "referencedDeclaration": 28871,
                        "src": "6165:10:84",
                        "typeDescriptions": {
                          "typeIdentifier": "t_type$_t_contract$_LibTerrain_$28871_$",
                          "typeString": "type(library LibTerrain)"
                        }
                      },
                      "id": 33856,
                      "isConstant": false,
                      "isLValue": false,
                      "isPure": false,
                      "lValueRequested": false,
                      "memberName": "SmallPlant",
                      "nodeType": "MemberAccess",
                      "referencedDeclaration": 28084,
                      "src": "6165:21:84",
                      "typeDescriptions": {
                        "typeIdentifier": "t_function_internal_pure$_t_struct$_VoxelCoord_$5927_memory_ptr_$returns$_t_uint256_$",
                        "typeString": "function (struct VoxelCoord memory) pure returns (uint256)"
                      }
                    },
                    "id": 33858,
                    "isConstant": false,
                    "isLValue": false,
                    "isPure": false,
                    "kind": "functionCall",
                    "lValueRequested": false,
                    "names": [],
                    "nodeType": "FunctionCall",
                    "src": "6165:28:84",
                    "tryCall": false,
                    "typeDescriptions": {
                      "typeIdentifier": "t_uint256",
                      "typeString": "uint256"
                    }
                  },
                  "functionReturnParameters": 33854,
                  "id": 33859,
                  "nodeType": "Return",
                  "src": "6158:35:84"
                }
              ]
            },
            "functionSelector": "e0ce03f7",
            "implemented": true,
            "kind": "function",
            "modifiers": [],
            "name": "PurpleFlower",
            "nameLocation": "6084:12:84",
            "parameters": {
              "id": 33851,
              "nodeType": "ParameterList",
              "parameters": [
                {
                  "constant": false,
                  "id": 33850,
                  "mutability": "mutable",
                  "name": "coord",
                  "nameLocation": "6115:5:84",
                  "nodeType": "VariableDeclaration",
                  "scope": 33861,
                  "src": "6097:23:84",
                  "stateVariable": false,
                  "storageLocation": "memory",
                  "typeDescriptions": {
                    "typeIdentifier": "t_struct$_VoxelCoord_$5927_memory_ptr",
                    "typeString": "struct VoxelCoord"
                  },
                  "typeName": {
                    "id": 33849,
                    "nodeType": "UserDefinedTypeName",
                    "pathNode": {
                      "id": 33848,
                      "name": "VoxelCoord",
                      "nodeType": "IdentifierPath",
                      "referencedDeclaration": 5927,
                      "src": "6097:10:84"
                    },
                    "referencedDeclaration": 5927,
                    "src": "6097:10:84",
                    "typeDescriptions": {
                      "typeIdentifier": "t_struct$_VoxelCoord_$5927_storage_ptr",
                      "typeString": "struct VoxelCoord"
                    }
                  },
                  "visibility": "internal"
                }
              ],
              "src": "6096:25:84"
            },
            "returnParameters": {
              "id": 33854,
              "nodeType": "ParameterList",
              "parameters": [
                {
                  "constant": false,
                  "id": 33853,
                  "mutability": "mutable",
                  "name": "",
                  "nameLocation": "-1:-1:-1",
                  "nodeType": "VariableDeclaration",
                  "scope": 33861,
                  "src": "6143:7:84",
                  "stateVariable": false,
                  "storageLocation": "default",
                  "typeDescriptions": {
                    "typeIdentifier": "t_uint256",
                    "typeString": "uint256"
                  },
                  "typeName": {
                    "id": 33852,
                    "name": "uint256",
                    "nodeType": "ElementaryTypeName",
                    "src": "6143:7:84",
                    "typeDescriptions": {
                      "typeIdentifier": "t_uint256",
                      "typeString": "uint256"
                    }
                  },
                  "visibility": "internal"
                }
              ],
              "src": "6142:9:84"
            },
            "scope": 33974,
            "stateMutability": "pure",
            "virtual": false,
            "visibility": "public"
          },
          {
            "id": 33875,
            "nodeType": "FunctionDefinition",
            "src": "6202:121:84",
            "nodes": [],
            "body": {
              "id": 33874,
              "nodeType": "Block",
              "src": "6277:46:84",
              "nodes": [],
              "statements": [
                {
                  "expression": {
                    "arguments": [
                      {
                        "id": 33871,
                        "name": "coord",
                        "nodeType": "Identifier",
                        "overloadedDeclarations": [],
                        "referencedDeclaration": 33864,
                        "src": "6312:5:84",
                        "typeDescriptions": {
                          "typeIdentifier": "t_struct$_VoxelCoord_$5927_memory_ptr",
                          "typeString": "struct VoxelCoord memory"
                        }
                      }
                    ],
                    "expression": {
                      "argumentTypes": [
                        {
                          "typeIdentifier": "t_struct$_VoxelCoord_$5927_memory_ptr",
                          "typeString": "struct VoxelCoord memory"
                        }
                      ],
                      "expression": {
                        "id": 33869,
                        "name": "LibTerrain",
                        "nodeType": "Identifier",
                        "overloadedDeclarations": [],
                        "referencedDeclaration": 28871,
                        "src": "6290:10:84",
                        "typeDescriptions": {
                          "typeIdentifier": "t_type$_t_contract$_LibTerrain_$28871_$",
                          "typeString": "type(library LibTerrain)"
                        }
                      },
                      "id": 33870,
                      "isConstant": false,
                      "isLValue": false,
                      "isPure": false,
                      "lValueRequested": false,
                      "memberName": "SmallPlant",
                      "nodeType": "MemberAccess",
                      "referencedDeclaration": 28084,
                      "src": "6290:21:84",
                      "typeDescriptions": {
                        "typeIdentifier": "t_function_internal_pure$_t_struct$_VoxelCoord_$5927_memory_ptr_$returns$_t_uint256_$",
                        "typeString": "function (struct VoxelCoord memory) pure returns (uint256)"
                      }
                    },
                    "id": 33872,
                    "isConstant": false,
                    "isLValue": false,
                    "isPure": false,
                    "kind": "functionCall",
                    "lValueRequested": false,
                    "names": [],
                    "nodeType": "FunctionCall",
                    "src": "6290:28:84",
                    "tryCall": false,
                    "typeDescriptions": {
                      "typeIdentifier": "t_uint256",
                      "typeString": "uint256"
                    }
                  },
                  "functionReturnParameters": 33868,
                  "id": 33873,
                  "nodeType": "Return",
                  "src": "6283:35:84"
                }
              ]
            },
            "functionSelector": "cabbf69d",
            "implemented": true,
            "kind": "function",
            "modifiers": [],
            "name": "BlueFlower",
            "nameLocation": "6211:10:84",
            "parameters": {
              "id": 33865,
              "nodeType": "ParameterList",
              "parameters": [
                {
                  "constant": false,
                  "id": 33864,
                  "mutability": "mutable",
                  "name": "coord",
                  "nameLocation": "6240:5:84",
                  "nodeType": "VariableDeclaration",
                  "scope": 33875,
                  "src": "6222:23:84",
                  "stateVariable": false,
                  "storageLocation": "memory",
                  "typeDescriptions": {
                    "typeIdentifier": "t_struct$_VoxelCoord_$5927_memory_ptr",
                    "typeString": "struct VoxelCoord"
                  },
                  "typeName": {
                    "id": 33863,
                    "nodeType": "UserDefinedTypeName",
                    "pathNode": {
                      "id": 33862,
                      "name": "VoxelCoord",
                      "nodeType": "IdentifierPath",
                      "referencedDeclaration": 5927,
                      "src": "6222:10:84"
                    },
                    "referencedDeclaration": 5927,
                    "src": "6222:10:84",
                    "typeDescriptions": {
                      "typeIdentifier": "t_struct$_VoxelCoord_$5927_storage_ptr",
                      "typeString": "struct VoxelCoord"
                    }
                  },
                  "visibility": "internal"
                }
              ],
              "src": "6221:25:84"
            },
            "returnParameters": {
              "id": 33868,
              "nodeType": "ParameterList",
              "parameters": [
                {
                  "constant": false,
                  "id": 33867,
                  "mutability": "mutable",
                  "name": "",
                  "nameLocation": "-1:-1:-1",
                  "nodeType": "VariableDeclaration",
                  "scope": 33875,
                  "src": "6268:7:84",
                  "stateVariable": false,
                  "storageLocation": "default",
                  "typeDescriptions": {
                    "typeIdentifier": "t_uint256",
                    "typeString": "uint256"
                  },
                  "typeName": {
                    "id": 33866,
                    "name": "uint256",
                    "nodeType": "ElementaryTypeName",
                    "src": "6268:7:84",
                    "typeDescriptions": {
                      "typeIdentifier": "t_uint256",
                      "typeString": "uint256"
                    }
                  },
                  "visibility": "internal"
                }
              ],
              "src": "6267:9:84"
            },
            "scope": 33974,
            "stateMutability": "pure",
            "virtual": false,
            "visibility": "public"
          },
          {
            "id": 33889,
            "nodeType": "FunctionDefinition",
            "src": "6327:122:84",
            "nodes": [],
            "body": {
              "id": 33888,
              "nodeType": "Block",
              "src": "6403:46:84",
              "nodes": [],
              "statements": [
                {
                  "expression": {
                    "arguments": [
                      {
                        "id": 33885,
                        "name": "coord",
                        "nodeType": "Identifier",
                        "overloadedDeclarations": [],
                        "referencedDeclaration": 33878,
                        "src": "6438:5:84",
                        "typeDescriptions": {
                          "typeIdentifier": "t_struct$_VoxelCoord_$5927_memory_ptr",
                          "typeString": "struct VoxelCoord memory"
                        }
                      }
                    ],
                    "expression": {
                      "argumentTypes": [
                        {
                          "typeIdentifier": "t_struct$_VoxelCoord_$5927_memory_ptr",
                          "typeString": "struct VoxelCoord memory"
                        }
                      ],
                      "expression": {
                        "id": 33883,
                        "name": "LibTerrain",
                        "nodeType": "Identifier",
                        "overloadedDeclarations": [],
                        "referencedDeclaration": 28871,
                        "src": "6416:10:84",
                        "typeDescriptions": {
                          "typeIdentifier": "t_type$_t_contract$_LibTerrain_$28871_$",
                          "typeString": "type(library LibTerrain)"
                        }
                      },
                      "id": 33884,
                      "isConstant": false,
                      "isLValue": false,
                      "isPure": false,
                      "lValueRequested": false,
                      "memberName": "SmallPlant",
                      "nodeType": "MemberAccess",
                      "referencedDeclaration": 28084,
                      "src": "6416:21:84",
                      "typeDescriptions": {
                        "typeIdentifier": "t_function_internal_pure$_t_struct$_VoxelCoord_$5927_memory_ptr_$returns$_t_uint256_$",
                        "typeString": "function (struct VoxelCoord memory) pure returns (uint256)"
                      }
                    },
                    "id": 33886,
                    "isConstant": false,
                    "isLValue": false,
                    "isPure": false,
                    "kind": "functionCall",
                    "lValueRequested": false,
                    "names": [],
                    "nodeType": "FunctionCall",
                    "src": "6416:28:84",
                    "tryCall": false,
                    "typeDescriptions": {
                      "typeIdentifier": "t_uint256",
                      "typeString": "uint256"
                    }
                  },
                  "functionReturnParameters": 33882,
                  "id": 33887,
                  "nodeType": "Return",
                  "src": "6409:35:84"
                }
              ]
            },
            "functionSelector": "fa6b73bd",
            "implemented": true,
            "kind": "function",
            "modifiers": [],
            "name": "GreenFlower",
            "nameLocation": "6336:11:84",
            "parameters": {
              "id": 33879,
              "nodeType": "ParameterList",
              "parameters": [
                {
                  "constant": false,
                  "id": 33878,
                  "mutability": "mutable",
                  "name": "coord",
                  "nameLocation": "6366:5:84",
                  "nodeType": "VariableDeclaration",
                  "scope": 33889,
                  "src": "6348:23:84",
                  "stateVariable": false,
                  "storageLocation": "memory",
                  "typeDescriptions": {
                    "typeIdentifier": "t_struct$_VoxelCoord_$5927_memory_ptr",
                    "typeString": "struct VoxelCoord"
                  },
                  "typeName": {
                    "id": 33877,
                    "nodeType": "UserDefinedTypeName",
                    "pathNode": {
                      "id": 33876,
                      "name": "VoxelCoord",
                      "nodeType": "IdentifierPath",
                      "referencedDeclaration": 5927,
                      "src": "6348:10:84"
                    },
                    "referencedDeclaration": 5927,
                    "src": "6348:10:84",
                    "typeDescriptions": {
                      "typeIdentifier": "t_struct$_VoxelCoord_$5927_storage_ptr",
                      "typeString": "struct VoxelCoord"
                    }
                  },
                  "visibility": "internal"
                }
              ],
              "src": "6347:25:84"
            },
            "returnParameters": {
              "id": 33882,
              "nodeType": "ParameterList",
              "parameters": [
                {
                  "constant": false,
                  "id": 33881,
                  "mutability": "mutable",
                  "name": "",
                  "nameLocation": "-1:-1:-1",
                  "nodeType": "VariableDeclaration",
                  "scope": 33889,
                  "src": "6394:7:84",
                  "stateVariable": false,
                  "storageLocation": "default",
                  "typeDescriptions": {
                    "typeIdentifier": "t_uint256",
                    "typeString": "uint256"
                  },
                  "typeName": {
                    "id": 33880,
                    "name": "uint256",
                    "nodeType": "ElementaryTypeName",
                    "src": "6394:7:84",
                    "typeDescriptions": {
                      "typeIdentifier": "t_uint256",
                      "typeString": "uint256"
                    }
                  },
                  "visibility": "internal"
                }
              ],
              "src": "6393:9:84"
            },
            "scope": 33974,
            "stateMutability": "pure",
            "virtual": false,
            "visibility": "public"
          },
          {
            "id": 33903,
            "nodeType": "FunctionDefinition",
            "src": "6453:122:84",
            "nodes": [],
            "body": {
              "id": 33902,
              "nodeType": "Block",
              "src": "6529:46:84",
              "nodes": [],
              "statements": [
                {
                  "expression": {
                    "arguments": [
                      {
                        "id": 33899,
                        "name": "coord",
                        "nodeType": "Identifier",
                        "overloadedDeclarations": [],
                        "referencedDeclaration": 33892,
                        "src": "6564:5:84",
                        "typeDescriptions": {
                          "typeIdentifier": "t_struct$_VoxelCoord_$5927_memory_ptr",
                          "typeString": "struct VoxelCoord memory"
                        }
                      }
                    ],
                    "expression": {
                      "argumentTypes": [
                        {
                          "typeIdentifier": "t_struct$_VoxelCoord_$5927_memory_ptr",
                          "typeString": "struct VoxelCoord memory"
                        }
                      ],
                      "expression": {
                        "id": 33897,
                        "name": "LibTerrain",
                        "nodeType": "Identifier",
                        "overloadedDeclarations": [],
                        "referencedDeclaration": 28871,
                        "src": "6542:10:84",
                        "typeDescriptions": {
                          "typeIdentifier": "t_type$_t_contract$_LibTerrain_$28871_$",
                          "typeString": "type(library LibTerrain)"
                        }
                      },
                      "id": 33898,
                      "isConstant": false,
                      "isLValue": false,
                      "isPure": false,
                      "lValueRequested": false,
                      "memberName": "SmallPlant",
                      "nodeType": "MemberAccess",
                      "referencedDeclaration": 28084,
                      "src": "6542:21:84",
                      "typeDescriptions": {
                        "typeIdentifier": "t_function_internal_pure$_t_struct$_VoxelCoord_$5927_memory_ptr_$returns$_t_uint256_$",
                        "typeString": "function (struct VoxelCoord memory) pure returns (uint256)"
                      }
                    },
                    "id": 33900,
                    "isConstant": false,
                    "isLValue": false,
                    "isPure": false,
                    "kind": "functionCall",
                    "lValueRequested": false,
                    "names": [],
                    "nodeType": "FunctionCall",
                    "src": "6542:28:84",
                    "tryCall": false,
                    "typeDescriptions": {
                      "typeIdentifier": "t_uint256",
                      "typeString": "uint256"
                    }
                  },
                  "functionReturnParameters": 33896,
                  "id": 33901,
                  "nodeType": "Return",
                  "src": "6535:35:84"
                }
              ]
            },
            "functionSelector": "302edc21",
            "implemented": true,
            "kind": "function",
            "modifiers": [],
            "name": "BlackFlower",
            "nameLocation": "6462:11:84",
            "parameters": {
              "id": 33893,
              "nodeType": "ParameterList",
              "parameters": [
                {
                  "constant": false,
                  "id": 33892,
                  "mutability": "mutable",
                  "name": "coord",
                  "nameLocation": "6492:5:84",
                  "nodeType": "VariableDeclaration",
                  "scope": 33903,
                  "src": "6474:23:84",
                  "stateVariable": false,
                  "storageLocation": "memory",
                  "typeDescriptions": {
                    "typeIdentifier": "t_struct$_VoxelCoord_$5927_memory_ptr",
                    "typeString": "struct VoxelCoord"
                  },
                  "typeName": {
                    "id": 33891,
                    "nodeType": "UserDefinedTypeName",
                    "pathNode": {
                      "id": 33890,
                      "name": "VoxelCoord",
                      "nodeType": "IdentifierPath",
                      "referencedDeclaration": 5927,
                      "src": "6474:10:84"
                    },
                    "referencedDeclaration": 5927,
                    "src": "6474:10:84",
                    "typeDescriptions": {
                      "typeIdentifier": "t_struct$_VoxelCoord_$5927_storage_ptr",
                      "typeString": "struct VoxelCoord"
                    }
                  },
                  "visibility": "internal"
                }
              ],
              "src": "6473:25:84"
            },
            "returnParameters": {
              "id": 33896,
              "nodeType": "ParameterList",
              "parameters": [
                {
                  "constant": false,
                  "id": 33895,
                  "mutability": "mutable",
                  "name": "",
                  "nameLocation": "-1:-1:-1",
                  "nodeType": "VariableDeclaration",
                  "scope": 33903,
                  "src": "6520:7:84",
                  "stateVariable": false,
                  "storageLocation": "default",
                  "typeDescriptions": {
                    "typeIdentifier": "t_uint256",
                    "typeString": "uint256"
                  },
                  "typeName": {
                    "id": 33894,
                    "name": "uint256",
                    "nodeType": "ElementaryTypeName",
                    "src": "6520:7:84",
                    "typeDescriptions": {
                      "typeIdentifier": "t_uint256",
                      "typeString": "uint256"
                    }
                  },
                  "visibility": "internal"
                }
              ],
              "src": "6519:9:84"
            },
            "scope": 33974,
            "stateMutability": "pure",
            "virtual": false,
            "visibility": "public"
          },
          {
            "id": 33917,
            "nodeType": "FunctionDefinition",
            "src": "6579:115:84",
            "nodes": [],
            "body": {
              "id": 33916,
              "nodeType": "Block",
              "src": "6648:46:84",
              "nodes": [],
              "statements": [
                {
                  "expression": {
                    "arguments": [
                      {
                        "id": 33913,
                        "name": "coord",
                        "nodeType": "Identifier",
                        "overloadedDeclarations": [],
                        "referencedDeclaration": 33906,
                        "src": "6683:5:84",
                        "typeDescriptions": {
                          "typeIdentifier": "t_struct$_VoxelCoord_$5927_memory_ptr",
                          "typeString": "struct VoxelCoord memory"
                        }
                      }
                    ],
                    "expression": {
                      "argumentTypes": [
                        {
                          "typeIdentifier": "t_struct$_VoxelCoord_$5927_memory_ptr",
                          "typeString": "struct VoxelCoord memory"
                        }
                      ],
                      "expression": {
                        "id": 33911,
                        "name": "LibTerrain",
                        "nodeType": "Identifier",
                        "overloadedDeclarations": [],
                        "referencedDeclaration": 28871,
                        "src": "6661:10:84",
                        "typeDescriptions": {
                          "typeIdentifier": "t_type$_t_contract$_LibTerrain_$28871_$",
                          "typeString": "type(library LibTerrain)"
                        }
                      },
                      "id": 33912,
                      "isConstant": false,
                      "isLValue": false,
                      "isPure": false,
                      "lValueRequested": false,
                      "memberName": "SmallPlant",
                      "nodeType": "MemberAccess",
                      "referencedDeclaration": 28084,
                      "src": "6661:21:84",
                      "typeDescriptions": {
                        "typeIdentifier": "t_function_internal_pure$_t_struct$_VoxelCoord_$5927_memory_ptr_$returns$_t_uint256_$",
                        "typeString": "function (struct VoxelCoord memory) pure returns (uint256)"
                      }
                    },
                    "id": 33914,
                    "isConstant": false,
                    "isLValue": false,
                    "isPure": false,
                    "kind": "functionCall",
                    "lValueRequested": false,
                    "names": [],
                    "nodeType": "FunctionCall",
                    "src": "6661:28:84",
                    "tryCall": false,
                    "typeDescriptions": {
                      "typeIdentifier": "t_uint256",
                      "typeString": "uint256"
                    }
                  },
                  "functionReturnParameters": 33910,
                  "id": 33915,
                  "nodeType": "Return",
                  "src": "6654:35:84"
                }
              ]
            },
            "functionSelector": "7183fcce",
            "implemented": true,
            "kind": "function",
            "modifiers": [],
            "name": "Kelp",
            "nameLocation": "6588:4:84",
            "parameters": {
              "id": 33907,
              "nodeType": "ParameterList",
              "parameters": [
                {
                  "constant": false,
                  "id": 33906,
                  "mutability": "mutable",
                  "name": "coord",
                  "nameLocation": "6611:5:84",
                  "nodeType": "VariableDeclaration",
                  "scope": 33917,
                  "src": "6593:23:84",
                  "stateVariable": false,
                  "storageLocation": "memory",
                  "typeDescriptions": {
                    "typeIdentifier": "t_struct$_VoxelCoord_$5927_memory_ptr",
                    "typeString": "struct VoxelCoord"
                  },
                  "typeName": {
                    "id": 33905,
                    "nodeType": "UserDefinedTypeName",
                    "pathNode": {
                      "id": 33904,
                      "name": "VoxelCoord",
                      "nodeType": "IdentifierPath",
                      "referencedDeclaration": 5927,
                      "src": "6593:10:84"
                    },
                    "referencedDeclaration": 5927,
                    "src": "6593:10:84",
                    "typeDescriptions": {
                      "typeIdentifier": "t_struct$_VoxelCoord_$5927_storage_ptr",
                      "typeString": "struct VoxelCoord"
                    }
                  },
                  "visibility": "internal"
                }
              ],
              "src": "6592:25:84"
            },
            "returnParameters": {
              "id": 33910,
              "nodeType": "ParameterList",
              "parameters": [
                {
                  "constant": false,
                  "id": 33909,
                  "mutability": "mutable",
                  "name": "",
                  "nameLocation": "-1:-1:-1",
                  "nodeType": "VariableDeclaration",
                  "scope": 33917,
                  "src": "6639:7:84",
                  "stateVariable": false,
                  "storageLocation": "default",
                  "typeDescriptions": {
                    "typeIdentifier": "t_uint256",
                    "typeString": "uint256"
                  },
                  "typeName": {
                    "id": 33908,
                    "name": "uint256",
                    "nodeType": "ElementaryTypeName",
                    "src": "6639:7:84",
                    "typeDescriptions": {
                      "typeIdentifier": "t_uint256",
                      "typeString": "uint256"
                    }
                  },
                  "visibility": "internal"
                }
              ],
              "src": "6638:9:84"
            },
            "scope": 33974,
            "stateMutability": "pure",
            "virtual": false,
            "visibility": "public"
          },
          {
            "id": 33931,
            "nodeType": "FunctionDefinition",
            "src": "6698:114:84",
            "nodes": [],
            "body": {
              "id": 33930,
              "nodeType": "Block",
              "src": "6767:45:84",
              "nodes": [],
              "statements": [
                {
                  "expression": {
                    "arguments": [
                      {
                        "id": 33927,
                        "name": "coord",
                        "nodeType": "Identifier",
                        "overloadedDeclarations": [],
                        "referencedDeclaration": 33920,
                        "src": "6801:5:84",
                        "typeDescriptions": {
                          "typeIdentifier": "t_struct$_VoxelCoord_$5927_memory_ptr",
                          "typeString": "struct VoxelCoord memory"
                        }
                      }
                    ],
                    "expression": {
                      "argumentTypes": [
                        {
                          "typeIdentifier": "t_struct$_VoxelCoord_$5927_memory_ptr",
                          "typeString": "struct VoxelCoord memory"
                        }
                      ],
                      "expression": {
                        "id": 33925,
                        "name": "LibTerrain",
                        "nodeType": "Identifier",
                        "overloadedDeclarations": [],
                        "referencedDeclaration": 28871,
                        "src": "6780:10:84",
                        "typeDescriptions": {
                          "typeIdentifier": "t_type$_t_contract$_LibTerrain_$28871_$",
                          "typeString": "type(library LibTerrain)"
                        }
                      },
                      "id": 33926,
                      "isConstant": false,
                      "isLValue": false,
                      "isPure": false,
                      "lValueRequested": false,
                      "memberName": "Structure",
                      "nodeType": "MemberAccess",
                      "referencedDeclaration": 28306,
                      "src": "6780:20:84",
                      "typeDescriptions": {
                        "typeIdentifier": "t_function_internal_pure$_t_struct$_VoxelCoord_$5927_memory_ptr_$returns$_t_uint256_$",
                        "typeString": "function (struct VoxelCoord memory) pure returns (uint256)"
                      }
                    },
                    "id": 33928,
                    "isConstant": false,
                    "isLValue": false,
                    "isPure": false,
                    "kind": "functionCall",
                    "lValueRequested": false,
                    "names": [],
                    "nodeType": "FunctionCall",
                    "src": "6780:27:84",
                    "tryCall": false,
                    "typeDescriptions": {
                      "typeIdentifier": "t_uint256",
                      "typeString": "uint256"
                    }
                  },
                  "functionReturnParameters": 33924,
                  "id": 33929,
                  "nodeType": "Return",
                  "src": "6773:34:84"
                }
              ]
            },
            "functionSelector": "b2f30942",
            "implemented": true,
            "kind": "function",
            "modifiers": [],
            "name": "Wool",
            "nameLocation": "6707:4:84",
            "parameters": {
              "id": 33921,
              "nodeType": "ParameterList",
              "parameters": [
                {
                  "constant": false,
                  "id": 33920,
                  "mutability": "mutable",
                  "name": "coord",
                  "nameLocation": "6730:5:84",
                  "nodeType": "VariableDeclaration",
                  "scope": 33931,
                  "src": "6712:23:84",
                  "stateVariable": false,
                  "storageLocation": "memory",
                  "typeDescriptions": {
                    "typeIdentifier": "t_struct$_VoxelCoord_$5927_memory_ptr",
                    "typeString": "struct VoxelCoord"
                  },
                  "typeName": {
                    "id": 33919,
                    "nodeType": "UserDefinedTypeName",
                    "pathNode": {
                      "id": 33918,
                      "name": "VoxelCoord",
                      "nodeType": "IdentifierPath",
                      "referencedDeclaration": 5927,
                      "src": "6712:10:84"
                    },
                    "referencedDeclaration": 5927,
                    "src": "6712:10:84",
                    "typeDescriptions": {
                      "typeIdentifier": "t_struct$_VoxelCoord_$5927_storage_ptr",
                      "typeString": "struct VoxelCoord"
                    }
                  },
                  "visibility": "internal"
                }
              ],
              "src": "6711:25:84"
            },
            "returnParameters": {
              "id": 33924,
              "nodeType": "ParameterList",
              "parameters": [
                {
                  "constant": false,
                  "id": 33923,
                  "mutability": "mutable",
                  "name": "",
                  "nameLocation": "-1:-1:-1",
                  "nodeType": "VariableDeclaration",
                  "scope": 33931,
                  "src": "6758:7:84",
                  "stateVariable": false,
                  "storageLocation": "default",
                  "typeDescriptions": {
                    "typeIdentifier": "t_uint256",
                    "typeString": "uint256"
                  },
                  "typeName": {
                    "id": 33922,
                    "name": "uint256",
                    "nodeType": "ElementaryTypeName",
                    "src": "6758:7:84",
                    "typeDescriptions": {
                      "typeIdentifier": "t_uint256",
                      "typeString": "uint256"
                    }
                  },
                  "visibility": "internal"
                }
              ],
              "src": "6757:9:84"
            },
            "scope": 33974,
            "stateMutability": "pure",
            "virtual": false,
            "visibility": "public"
          },
          {
            "id": 33945,
            "nodeType": "FunctionDefinition",
            "src": "6816:109:84",
            "nodes": [],
            "body": {
              "id": 33944,
              "nodeType": "Block",
              "src": "6885:40:84",
              "nodes": [],
              "statements": [
                {
                  "expression": {
                    "arguments": [
                      {
                        "id": 33941,
                        "name": "coord",
                        "nodeType": "Identifier",
                        "overloadedDeclarations": [],
                        "referencedDeclaration": 33934,
                        "src": "6914:5:84",
                        "typeDescriptions": {
                          "typeIdentifier": "t_struct$_VoxelCoord_$5927_memory_ptr",
                          "typeString": "struct VoxelCoord memory"
                        }
                      }
                    ],
                    "expression": {
                      "argumentTypes": [
                        {
                          "typeIdentifier": "t_struct$_VoxelCoord_$5927_memory_ptr",
                          "typeString": "struct VoxelCoord memory"
                        }
                      ],
                      "expression": {
                        "id": 33939,
                        "name": "LibTerrain",
                        "nodeType": "Identifier",
                        "overloadedDeclarations": [],
                        "referencedDeclaration": 28871,
                        "src": "6898:10:84",
                        "typeDescriptions": {
                          "typeIdentifier": "t_type$_t_contract$_LibTerrain_$28871_$",
                          "typeString": "type(library LibTerrain)"
                        }
                      },
                      "id": 33940,
                      "isConstant": false,
                      "isLValue": false,
                      "isPure": false,
                      "lValueRequested": false,
                      "memberName": "Snow",
                      "nodeType": "MemberAccess",
                      "referencedDeclaration": 27621,
                      "src": "6898:15:84",
                      "typeDescriptions": {
                        "typeIdentifier": "t_function_internal_pure$_t_struct$_VoxelCoord_$5927_memory_ptr_$returns$_t_uint256_$",
                        "typeString": "function (struct VoxelCoord memory) pure returns (uint256)"
                      }
                    },
                    "id": 33942,
                    "isConstant": false,
                    "isLValue": false,
                    "isPure": false,
                    "kind": "functionCall",
                    "lValueRequested": false,
                    "names": [],
                    "nodeType": "FunctionCall",
                    "src": "6898:22:84",
                    "tryCall": false,
                    "typeDescriptions": {
                      "typeIdentifier": "t_uint256",
                      "typeString": "uint256"
                    }
                  },
                  "functionReturnParameters": 33938,
                  "id": 33943,
                  "nodeType": "Return",
                  "src": "6891:29:84"
                }
              ]
            },
            "functionSelector": "25cd4d47",
            "implemented": true,
            "kind": "function",
            "modifiers": [],
            "name": "Snow",
            "nameLocation": "6825:4:84",
            "parameters": {
              "id": 33935,
              "nodeType": "ParameterList",
              "parameters": [
                {
                  "constant": false,
                  "id": 33934,
                  "mutability": "mutable",
                  "name": "coord",
                  "nameLocation": "6848:5:84",
                  "nodeType": "VariableDeclaration",
                  "scope": 33945,
                  "src": "6830:23:84",
                  "stateVariable": false,
                  "storageLocation": "memory",
                  "typeDescriptions": {
                    "typeIdentifier": "t_struct$_VoxelCoord_$5927_memory_ptr",
                    "typeString": "struct VoxelCoord"
                  },
                  "typeName": {
                    "id": 33933,
                    "nodeType": "UserDefinedTypeName",
                    "pathNode": {
                      "id": 33932,
                      "name": "VoxelCoord",
                      "nodeType": "IdentifierPath",
                      "referencedDeclaration": 5927,
                      "src": "6830:10:84"
                    },
                    "referencedDeclaration": 5927,
                    "src": "6830:10:84",
                    "typeDescriptions": {
                      "typeIdentifier": "t_struct$_VoxelCoord_$5927_storage_ptr",
                      "typeString": "struct VoxelCoord"
                    }
                  },
                  "visibility": "internal"
                }
              ],
              "src": "6829:25:84"
            },
            "returnParameters": {
              "id": 33938,
              "nodeType": "ParameterList",
              "parameters": [
                {
                  "constant": false,
                  "id": 33937,
                  "mutability": "mutable",
                  "name": "",
                  "nameLocation": "-1:-1:-1",
                  "nodeType": "VariableDeclaration",
                  "scope": 33945,
                  "src": "6876:7:84",
                  "stateVariable": false,
                  "storageLocation": "default",
                  "typeDescriptions": {
                    "typeIdentifier": "t_uint256",
                    "typeString": "uint256"
                  },
                  "typeName": {
                    "id": 33936,
                    "name": "uint256",
                    "nodeType": "ElementaryTypeName",
                    "src": "6876:7:84",
                    "typeDescriptions": {
                      "typeIdentifier": "t_uint256",
                      "typeString": "uint256"
                    }
                  },
                  "visibility": "internal"
                }
              ],
              "src": "6875:9:84"
            },
            "scope": 33974,
            "stateMutability": "pure",
            "virtual": false,
            "visibility": "public"
          },
          {
            "id": 33959,
            "nodeType": "FunctionDefinition",
            "src": "6929:109:84",
            "nodes": [],
            "body": {
              "id": 33958,
              "nodeType": "Block",
              "src": "6998:40:84",
              "nodes": [],
              "statements": [
                {
                  "expression": {
                    "arguments": [
                      {
                        "id": 33955,
                        "name": "coord",
                        "nodeType": "Identifier",
                        "overloadedDeclarations": [],
                        "referencedDeclaration": 33948,
                        "src": "7027:5:84",
                        "typeDescriptions": {
                          "typeIdentifier": "t_struct$_VoxelCoord_$5927_memory_ptr",
                          "typeString": "struct VoxelCoord memory"
                        }
                      }
                    ],
                    "expression": {
                      "argumentTypes": [
                        {
                          "typeIdentifier": "t_struct$_VoxelCoord_$5927_memory_ptr",
                          "typeString": "struct VoxelCoord memory"
                        }
                      ],
                      "expression": {
                        "id": 33953,
                        "name": "LibTerrain",
                        "nodeType": "Identifier",
                        "overloadedDeclarations": [],
                        "referencedDeclaration": 28871,
                        "src": "7011:10:84",
                        "typeDescriptions": {
                          "typeIdentifier": "t_type$_t_contract$_LibTerrain_$28871_$",
                          "typeString": "type(library LibTerrain)"
                        }
                      },
                      "id": 33954,
                      "isConstant": false,
                      "isLValue": false,
                      "isPure": false,
                      "lValueRequested": false,
                      "memberName": "Clay",
                      "nodeType": "MemberAccess",
                      "referencedDeclaration": 27802,
                      "src": "7011:15:84",
                      "typeDescriptions": {
                        "typeIdentifier": "t_function_internal_pure$_t_struct$_VoxelCoord_$5927_memory_ptr_$returns$_t_uint256_$",
                        "typeString": "function (struct VoxelCoord memory) pure returns (uint256)"
                      }
                    },
                    "id": 33956,
                    "isConstant": false,
                    "isLValue": false,
                    "isPure": false,
                    "kind": "functionCall",
                    "lValueRequested": false,
                    "names": [],
                    "nodeType": "FunctionCall",
                    "src": "7011:22:84",
                    "tryCall": false,
                    "typeDescriptions": {
                      "typeIdentifier": "t_uint256",
                      "typeString": "uint256"
                    }
                  },
                  "functionReturnParameters": 33952,
                  "id": 33957,
                  "nodeType": "Return",
                  "src": "7004:29:84"
                }
              ]
            },
            "functionSelector": "05d5d596",
            "implemented": true,
            "kind": "function",
            "modifiers": [],
            "name": "Clay",
            "nameLocation": "6938:4:84",
            "parameters": {
              "id": 33949,
              "nodeType": "ParameterList",
              "parameters": [
                {
                  "constant": false,
                  "id": 33948,
                  "mutability": "mutable",
                  "name": "coord",
                  "nameLocation": "6961:5:84",
                  "nodeType": "VariableDeclaration",
                  "scope": 33959,
                  "src": "6943:23:84",
                  "stateVariable": false,
                  "storageLocation": "memory",
                  "typeDescriptions": {
                    "typeIdentifier": "t_struct$_VoxelCoord_$5927_memory_ptr",
                    "typeString": "struct VoxelCoord"
                  },
                  "typeName": {
                    "id": 33947,
                    "nodeType": "UserDefinedTypeName",
                    "pathNode": {
                      "id": 33946,
                      "name": "VoxelCoord",
                      "nodeType": "IdentifierPath",
                      "referencedDeclaration": 5927,
                      "src": "6943:10:84"
                    },
                    "referencedDeclaration": 5927,
                    "src": "6943:10:84",
                    "typeDescriptions": {
                      "typeIdentifier": "t_struct$_VoxelCoord_$5927_storage_ptr",
                      "typeString": "struct VoxelCoord"
                    }
                  },
                  "visibility": "internal"
                }
              ],
              "src": "6942:25:84"
            },
            "returnParameters": {
              "id": 33952,
              "nodeType": "ParameterList",
              "parameters": [
                {
                  "constant": false,
                  "id": 33951,
                  "mutability": "mutable",
                  "name": "",
                  "nameLocation": "-1:-1:-1",
                  "nodeType": "VariableDeclaration",
                  "scope": 33959,
                  "src": "6989:7:84",
                  "stateVariable": false,
                  "storageLocation": "default",
                  "typeDescriptions": {
                    "typeIdentifier": "t_uint256",
                    "typeString": "uint256"
                  },
                  "typeName": {
                    "id": 33950,
                    "name": "uint256",
                    "nodeType": "ElementaryTypeName",
                    "src": "6989:7:84",
                    "typeDescriptions": {
                      "typeIdentifier": "t_uint256",
                      "typeString": "uint256"
                    }
                  },
                  "visibility": "internal"
                }
              ],
              "src": "6988:9:84"
            },
            "scope": 33974,
            "stateMutability": "pure",
            "virtual": false,
            "visibility": "public"
          },
          {
            "id": 33973,
            "nodeType": "FunctionDefinition",
            "src": "7042:115:84",
            "nodes": [],
            "body": {
              "id": 33972,
              "nodeType": "Block",
              "src": "7114:43:84",
              "nodes": [],
              "statements": [
                {
                  "expression": {
                    "arguments": [
                      {
                        "id": 33969,
                        "name": "coord",
                        "nodeType": "Identifier",
                        "overloadedDeclarations": [],
                        "referencedDeclaration": 33962,
                        "src": "7146:5:84",
                        "typeDescriptions": {
                          "typeIdentifier": "t_struct$_VoxelCoord_$5927_memory_ptr",
                          "typeString": "struct VoxelCoord memory"
                        }
                      }
                    ],
                    "expression": {
                      "argumentTypes": [
                        {
                          "typeIdentifier": "t_struct$_VoxelCoord_$5927_memory_ptr",
                          "typeString": "struct VoxelCoord memory"
                        }
                      ],
                      "expression": {
                        "id": 33967,
                        "name": "LibTerrain",
                        "nodeType": "Identifier",
                        "overloadedDeclarations": [],
                        "referencedDeclaration": 28871,
                        "src": "7127:10:84",
                        "typeDescriptions": {
                          "typeIdentifier": "t_type$_t_contract$_LibTerrain_$28871_$",
                          "typeString": "type(library LibTerrain)"
                        }
                      },
                      "id": 33968,
                      "isConstant": false,
                      "isLValue": false,
                      "isPure": false,
                      "lValueRequested": false,
                      "memberName": "Bedrock",
                      "nodeType": "MemberAccess",
                      "referencedDeclaration": 27173,
                      "src": "7127:18:84",
                      "typeDescriptions": {
                        "typeIdentifier": "t_function_internal_pure$_t_struct$_VoxelCoord_$5927_memory_ptr_$returns$_t_uint256_$",
                        "typeString": "function (struct VoxelCoord memory) pure returns (uint256)"
                      }
                    },
                    "id": 33970,
                    "isConstant": false,
                    "isLValue": false,
                    "isPure": false,
                    "kind": "functionCall",
                    "lValueRequested": false,
                    "names": [],
                    "nodeType": "FunctionCall",
                    "src": "7127:25:84",
                    "tryCall": false,
                    "typeDescriptions": {
                      "typeIdentifier": "t_uint256",
                      "typeString": "uint256"
                    }
                  },
                  "functionReturnParameters": 33966,
                  "id": 33971,
                  "nodeType": "Return",
                  "src": "7120:32:84"
                }
              ]
            },
            "functionSelector": "1c1f4ce2",
            "implemented": true,
            "kind": "function",
            "modifiers": [],
            "name": "Bedrock",
            "nameLocation": "7051:7:84",
            "parameters": {
              "id": 33963,
              "nodeType": "ParameterList",
              "parameters": [
                {
                  "constant": false,
                  "id": 33962,
                  "mutability": "mutable",
                  "name": "coord",
                  "nameLocation": "7077:5:84",
                  "nodeType": "VariableDeclaration",
                  "scope": 33973,
                  "src": "7059:23:84",
                  "stateVariable": false,
                  "storageLocation": "memory",
                  "typeDescriptions": {
                    "typeIdentifier": "t_struct$_VoxelCoord_$5927_memory_ptr",
                    "typeString": "struct VoxelCoord"
                  },
                  "typeName": {
                    "id": 33961,
                    "nodeType": "UserDefinedTypeName",
                    "pathNode": {
                      "id": 33960,
                      "name": "VoxelCoord",
                      "nodeType": "IdentifierPath",
                      "referencedDeclaration": 5927,
                      "src": "7059:10:84"
                    },
                    "referencedDeclaration": 5927,
                    "src": "7059:10:84",
                    "typeDescriptions": {
                      "typeIdentifier": "t_struct$_VoxelCoord_$5927_storage_ptr",
                      "typeString": "struct VoxelCoord"
                    }
                  },
                  "visibility": "internal"
                }
              ],
              "src": "7058:25:84"
            },
            "returnParameters": {
              "id": 33966,
              "nodeType": "ParameterList",
              "parameters": [
                {
                  "constant": false,
                  "id": 33965,
                  "mutability": "mutable",
                  "name": "",
                  "nameLocation": "-1:-1:-1",
                  "nodeType": "VariableDeclaration",
                  "scope": 33973,
                  "src": "7105:7:84",
                  "stateVariable": false,
                  "storageLocation": "default",
                  "typeDescriptions": {
                    "typeIdentifier": "t_uint256",
                    "typeString": "uint256"
                  },
                  "typeName": {
                    "id": 33964,
                    "name": "uint256",
                    "nodeType": "ElementaryTypeName",
                    "src": "7105:7:84",
                    "typeDescriptions": {
                      "typeIdentifier": "t_uint256",
                      "typeString": "uint256"
                    }
                  },
                  "visibility": "internal"
                }
              ],
              "src": "7104:9:84"
            },
            "scope": 33974,
            "stateMutability": "pure",
            "virtual": false,
            "visibility": "public"
          }
        ],
        "abstract": false,
        "baseContracts": [
          {
            "baseName": {
              "id": 33204,
              "name": "System",
              "nodeType": "IdentifierPath",
              "referencedDeclaration": 4204,
              "src": "1324:6:84"
            },
            "id": 33205,
            "nodeType": "InheritanceSpecifier",
            "src": "1324:6:84"
          }
        ],
        "canonicalName": "OccurrenceSystem",
        "contractDependencies": [],
        "contractKind": "contract",
        "fullyImplemented": true,
        "linearizedBaseContracts": [
          33974,
          4204,
          4954,
          39813
        ],
        "name": "OccurrenceSystem",
        "nameLocation": "1304:16:84",
        "scope": 33975,
        "usedErrors": []
      }
    ],
    "license": "GPL-3.0"
  },
  "id": 84
}